// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/dots/dotsfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/dots/dotsfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/dots/dotsfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/LoginBgImage.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/list-style-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 style=%27margin: auto; background: none; display: block; shape-rendering: auto;%27 width=%27200px%27 height=%27200px%27 viewBox=%270 0 100 100%27 preserveAspectRatio=%27xMidYMid%27%3E%3Ccircle cx=%2750%27 cy=%2750%27 r=%2732%27 stroke-width=%278%27 stroke=%27%23000%27 stroke-dasharray=%2750.26548245743669 50.26548245743669%27 fill=%27none%27 stroke-linecap=%27round%27 transform=%27rotate%28311.967 50 50%29%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 repeatCount=%27indefinite%27 dur=%270.72s%27 keyTimes=%270;1%27 values=%270 50 50;360 50 50%27/%3E%3C/circle%3E%3C%21-- %5Bldio%5D generated by https://loading.io/ --%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiM0MDE5NmQiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMi42MDY3IiByPSIxMS41IiBzdHJva2U9IiM0OEQzOEEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDEyLjgwNjZDMyA3LjgzNjA4IDcuMDI5NDQgMy44MDY2NCAxMiAzLjgwNjY0QzE2Ljk3MDYgMy44MDY2NCAyMSA3LjgzNjA4IDIxIDEyLjgwNjZDMjEgMTcuNzc3MiAxNi45NzA2IDIxLjgwNjYgMTIgMjEuODA2NkM3LjAyOTQ0IDIxLjgwNjYgMyAxNy43NzcyIDMgMTIuODA2NloiIGZpbGw9IiM0OEQzOEEiLz4KPHBhdGggZD0iTTEwLjkxNSAxNC43MjYxTDE1Ljc1MzUgOS42NjAwM0MxNi4wNDQ0IDkuMzU1NTEgMTYuNTE1OSA5LjM1NTUxIDE2LjgwNjggOS42NjAwM0MxNy4wOTc2IDkuOTY0NTUgMTcuMDk3NiAxMC40NTgzIDE2LjgwNjggMTAuNzYyOEwxMC45MTUgMTYuOTMxNkw3LjQ5MzAzIDEzLjM0ODdDNy4yMDIxOSAxMy4wNDQyIDcuMjAyMTkgMTIuNTUwNSA3LjQ5MzAzIDEyLjI0NTlDNy43ODM4OCAxMS45NDE0IDguMjU1NDIgMTEuOTQxNCA4LjU0NjI3IDEyLjI0NTlMMTAuOTE1IDE0LjcyNjFaIiBmaWxsPSIjRENGRkVDIi8+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjEyIiBjeT0iMTEuODI1NiIgcng9IjYiIHJ5PSI1Ljg4NDA3IiBmaWxsPSIjQ0FDQUNBIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMyIgeT0iMiIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE5Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDIuOTk5NTFWMjAuOTk5NUgyMVYyLjk5OTUxSDNaTTEwLjYyMTQgMTUuOTY1Mkw3LjI2NzA5IDEyLjYxMDlMOC4wNjI2MSAxMS44MTU0TDEwLjU3ODUgMTQuMzMxM0wxNi4xNzcyIDguMTExNDVMMTcuMDEzNCA4Ljg2NDA3TDEwLjYyMTYgMTUuOTY1M0wxMC42MjE0IDE1Ljk2NTJaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggZD0iTTEyIDIwLjk5OTVDMTYuOTcwNiAyMC45OTk1IDIxIDE2Ljk3MDEgMjEgMTEuOTk5NUMyMSA3LjAyODk1IDE2Ljk3MDYgMi45OTk1MSAxMiAyLjk5OTUxQzcuMDI5NDQgMi45OTk1MSAzIDcuMDI4OTUgMyAxMS45OTk1QzMgMTYuOTcwMSA3LjAyOTQ0IDIwLjk5OTUgMTIgMjAuOTk5NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPC9nPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNDQUNBQ0EiLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNGNzY4NUIiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yOTI3ODcgMC4zMDUyODhDMC40ODAzMTQgMC4xMTc4MTcgMC43MzQ2MjIgMC4wMTI1MDE4IDAuOTk5Nzg2IDAuMDEyNTAxOEMxLjI2NDk1IDAuMDEyNTAxOCAxLjUxOTI2IDAuMTE3ODE3IDEuNzA2NzkgMC4zMDUyODhMNC45OTk3OSAzLjU5ODI5TDguMjkyNzkgMC4zMDUyODhDOC4zODUwMyAwLjIwOTc3OCA4LjQ5NTM4IDAuMTMzNTk2IDguNjE3MzggMC4wODExODY5QzguNzM5MzkgMC4wMjg3Nzc5IDguODcwNjEgMC4wMDExOTE1NyA5LjAwMzM5IDMuNzc1NzFlLTA1QzkuMTM2MTYgLTAuMDAxMTE2MDYgOS4yNjc4NCAwLjAyNDE4NTQgOS4zOTA3NCAwLjA3NDQ2NjNDOS41MTM2NCAwLjEyNDc0NyA5LjYyNTI5IDAuMTk5IDkuNzE5MTggMC4yOTI4OTNDOS44MTMwNyAwLjM4Njc4NiA5Ljg4NzMzIDAuNDk4NDM4IDkuOTM3NjEgMC42MjEzMzRDOS45ODc4OSAwLjc0NDIzMSAxMC4wMTMyIDAuODc1OTEgMTAuMDEyIDEuMDA4NjlDMTAuMDEwOSAxLjE0MTQ3IDkuOTgzMyAxLjI3MjY5IDkuOTMwODkgMS4zOTQ2OUM5Ljg3ODQ4IDEuNTE2NyA5LjgwMjMgMS42MjcwNCA5LjcwNjc5IDEuNzE5MjlMNS43MDY3OSA1LjcxOTI5QzUuNTE5MjYgNS45MDY3NiA1LjI2NDk1IDYuMDEyMDcgNC45OTk3OSA2LjAxMjA3QzQuNzM0NjIgNi4wMTIwNyA0LjQ4MDMxIDUuOTA2NzYgNC4yOTI3OSA1LjcxOTI5TDAuMjkyNzg3IDEuNzE5MjlDMC4xMDUzMTYgMS41MzE3NiAwIDEuMjc3NDUgMCAxLjAxMjI5QzAgMC43NDcxMjQgMC4xMDUzMTYgMC40OTI4MTYgMC4yOTI3ODcgMC4zMDUyODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#dotsfontregular" });
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primaryColor: #000000;
    --blackColor: #000000;
    --successColor: #48d38a;
    --negativeColor: #f7685b;
    --textColor: #979797;
    --theadColor: #f9f9f9;
    --tdColor: #ffffff;
    --whiteColor: #ffffff;
    --whiteAlt: #ffffff;
    --offWhite: #f9f9f9;
    --offWhiteTrans: rgba(219, 220, 224, 0.3);
    --borderOff: rgba(219, 220, 224, 0.5);
    --offText: rgba(0, 0, 0, 0.5);
    --bgOffset: #f4f4f4;
    --placeHolder: #979797;
    /* --offBlue: #eff1ff; */
    --offBlue: #F4F4F4;
    --boxShadow: rgba(64, 25, 109, 0.07);
    --offBlueTran: rgba(223, 227, 255, 0.3);
    --primaryAlt: #000000;
    --offGreen: rgba(72, 211, 138, 0.5);
    --ctaOffBlue: rgba(0, 0, 0, 0.3);
    --overlay: rgba(0, 0, 0, 0.35);
    --successColorTrans: #dcffec;
    --lightBlue: #1dcbef;
    --textColorLightGrey: #cacaca;
    --tooltip-background-color: #fff;
    --buttonBackgroundColor: #f9f9f9;
    /* --tooltip-margin: 30px; */
    --tooltip-arrow-size: 6px;
    --manuge-user-heading: #979797;
    --input-prefix-border: #121212;
    --card-border: 1px solid rgba(219, 220, 224, 0.5);
    --card-box-shadow: 15px 30px 40px rgba(0, 0, 0, 0.07);
    --card-wrapper-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
    --card-mini-wrapper-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
}

.kuda-dark--theme {
    --primaryColor: #ffffff;
    --blackColor: #ffffff;
    --successColor: #48d38a;
    --negativeColor: #f7685b;
    --textColor: #ffffff;
    --theadColor: rgba(219, 220, 224, 0.04);
    --tdColor: rgba(219, 220, 224, 0.003);
    --whiteColor: #121212;
    --whiteAlt: #181818;
    --offWhite: rgba(219, 220, 224, 0.03);
    --offWhiteTrans: rgba(219, 220, 224, 0.04);
    --borderOff: rgba(219, 220, 224, 0.13);
    --offText: rgba(255, 255, 255, 0.8);
    --bgOffset: rgba(244, 244, 244, 0.04);
    --placeHolder: rgba(255, 255, 255, 0.25);
    --offBlue: #181818;
    --boxShadow: rgba(64, 25, 109, 0.02);
    --offBlueTran: rgba(219, 220, 224, 0.05);
    --primaryAlt: #000000;
    --offGreen: rgba(72, 211, 138, 0.1);
    --ctaOffBlue: rgba(64, 25, 109, 0.1);
    --overlay: rgba(0, 0, 0, 0.6);
    --successColorTrans: rgba(72, 211, 138, 0.1);
    --buttonBackgroundColor: #000000;
    --manuge-user-heading: #CBC3E3;
}

.kuda-dark--theme {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
}

.kuda-dark--theme .react-loading-skeleton {
    background-color: #222222 !important;
    background-image: linear-gradient(90deg, #222222, #242424, #262626) !important;
}

/* Anti Alias */

* {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: none !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -moz-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* DOTS */

@font-face {
    font-family: "dotsfont";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
}

html {
    scroll-behavior: smooth;
}

/* Body defaults */

html,
body {
    font-family: "Muli", sans-serif;
    font-size: 16px;
    color: #979797;
    color: var(--textColor);
}

a {
    text-decoration: none;
    color: inherit;
}

input {
    /* Remove First */
    appearance: none;
}

::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-weight: 500 !important;
}

::-moz-placeholder {
    /* Firefox 19+ */
    font-weight: 500 !important;
}

:-ms-input-placeholder {
    /* IE 10+ */
    font-weight: 500 !important;
}

:-moz-placeholder {
    /* Firefox 18- */
    font-weight: 500 !important;
}

/* CONTAINER */

.container {
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    margin-right: auto;
    margin-left: auto;
}

@media (min-width: 576px) {
    .container {
        max-width: 580px;
    }
}



@media (min-width: 768px) {
    .container {
        max-width: 700px;
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 789px;
    }

    .payments-container {
        max-width: 900px;
    }

    .shareholders-container {
        max-width: 831px;
    }

    .kuda-signup--container {
        max-width: 957px !important;
    }

    .c-apps {
        margin-top: 35px;
    }
}

.new-container {
    width: 100%;
}
@media (min-width: 992px) {
    .new-container{
       max-width: 100%;
    }

}
@media (min-width: 768px) {
    .new-container{
       max-width: 100%;
    }
}

@media (min-width: 576px) {
    .new-container{
       max-width: 100%;
    }
}

.increase-max--width {
    max-width: 950px;
}

.max-width-lg {
    max-width: 900px;
}

.max-width-full {
    max-width: 100% !important;
}

.auth-layout--header+.kuda-preview {
    max-width: 1420px;
    padding-left: 60px;
    padding-right: 60px;
    min-height: calc(100vh - 90px);
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

/* Text font sizing */

h1 {
    font-size: 2.375rem;
    line-height: 1.2;
}

h2 {
    font-size: 2rem;
    line-height: 1.4;
}

h3 {
    font-size: 1.8rem;
    line-height: 1.5;
}

h4 {
    font-size: 1.42rem;
    line-height: 1.5;
}

h5 {
    font-size: 1.32rem;
    line-height: 1.5;
}

h6 {
    font-size: 1.2rem;
    line-height: 1.5;
}

p {
    font-size: 1rem;
    line-height: 1.5;
}

.text-lg {
    font-size: 2.5rem !important;
    line-height: 1.38;
}

.text-md {
    font-size: 2.15rem;
    line-height: 1.4;
}

.text-smd {
    font-size: 0.9375rem;
    line-height: 20px;
}

.text-sm {
    font-size: 0.8125rem;
}

.text-xlxs {
    font-size: 0.75rem;
}

.text-xs {
    font-size: 0.64rem !important;
}

.text-subheading {
    font-size: 1.13rem;
    line-height: 1.5;
}

.text-subheading-md {
    font-size: 1.25rem;
    line-height: 1.35;
}

.text-subheading-sm {
    font-size: 1.05rem;
    line-height: 1.35;
}

.page-heading-title {
    color: #000000;
    color: var(--primaryColor);
    font-size: 28px;
    font-weight: 800;
}

.text-normal {
    font-weight: 400 !important;
}

.text-underline {
    text-decoration: underline;
}

.color-primary {
    color: #000000;
    color: var(--primaryColor);
}

.color-negative {
    color: #f7685b;
    color: var(--negativeColor);
}

.color-secondary {
    color: #48d38a !important;
    color: var(--successColor) !important;
}

.color-white {
    color: #ffffff;
    color: var(--whiteColor);
}

.color-black {
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.color-normal {
    color: #333333;
}

.color-faded {
    color: rgba(0, 0, 0, 0.5);
    color: var(--offText);
}

.color-light {
    color: rgb(0, 0, 0, 0.7);
}

.color-green {
    color: #48d38a;
    color: var(--successColor);
}

.color-light--text {
    color: #979797;
    color: var(--textColor);
}

.color-cream {
    color: #fff5db;
}

.bg-cream {
    background-color: #fff5db;
}

.bg-green {
    background: #48d38a !important;
    background: var(--successColor) !important;
}
.bg-blue {
    background: #1dcbef;
    background: var(--lightBlue);
}
.bg-red {
    background: #f7685b;
    background: var(--negativeColor);
}
.bg-black {
    background: #000000;
    background: var(--primaryColor);
}
.bg-offWhite {
    background: #f9f9f9;
    background: var(--offWhite);
}

.bg-yellow {
    background: #FFC83E;
}

.text-semi-bold {
    font-weight: 600;
}

.text-bold {
    font-weight: 700;
}

.text-xbold {
    font-weight: 800;
}

.text-xlbold {
    font-weight: 900;
}

.text-light {
    font-weight: 300;
}

.text-normal {
    font-weight: 400;
}

.no-box--shadow {
    box-shadow: none !important;
}

/* BUTTON */

button {
    /* outline: none; */
    border: 0;
}

.invoice-icon svg {
    height: 24.99px !important;
}

.disabled {
    opacity: 0.73;
    pointer-events: none;
}

.disabled-opacity--low {
    opacity: 0.33;
    pointer-events: none;
}

.disabled-grey {
    opacity: 0.5;
    pointer-events: none;
}

.disabled-color--grey {
    color: #979797 !important;
}

.disabled-color--grey svg {
    fill: rgb(151, 151, 151, 1) !important;
}

.kuda-nav {
    margin-left: -30px;
}

.kuda-cta {
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    border-radius: 10px;
    justify-content: center;
    cursor: pointer;
    background: #000000;
    background: var(--primaryColor);
    color: #ffffff;
    color: var(--whiteAlt);
    height: 48px;
    transition: transform 0.6s;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}

.addAction {
    margin-bottom: 8px;
}

.kuda-cta--table {
    /* max-width: 64px; */
    height: 24px;
    font-size: 13px;
}

.kuda-cta-sm {
    font-size: 10px;
    padding: 3px 13px !important;
    height: 19px;
}

.kuda-cta-md {
    max-width: 135px;
    width: 100%;
}

.kuda-cta--fit {
    max-width: fit-content !important;
}

.kuda-cta-lg {
    max-width: 152px;
    width: 100%;
}

.kuda-cta-long {
    width: 100%;
    max-width: 242px;
}

.kuda-cta-wide {
    width: 100% !important;
    max-width: 100% !important;
}

.kuda-cta-white {
    background: #f9f9f9;
    background: var(--offWhite);
    border: 1px solid #000000;
    border: 1px solid var(--primaryColor);
    color: #000000;
    color: var(--primaryColor);
}

.kuda-cta-red {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid #f7685b;
    border: 1px solid var(--negativeColor);
    color: #f7685b;
    color: var(--negativeColor);
}

.kuda-cta-bgRed {
    background: #f7685b;
    background: var(--negativeColor);
    border: 1px solid transparent;
    color: #ffffff;
    color: var(--whiteAlt);
}

.kuda-primary-cta {
    background-color: #48d38a;
    background-color: var(--successColor);
}

.kuda-tertiary-cta {
    background-color: #F4F4F4;
    background-color: var(--offBlue);
    color: #000000;
    color: var(--primaryColor);
}

.transaction-right .kuda-dropdown {
    position: static;
}

.white-cta {
    background: #f9f9f9;
    background: var(--offWhite);
    border: 1px solid rgba(0, 0, 0, 0.3);
    border: 1px solid var(--ctaOffBlue);
    color: #000000;
    color: var(--primaryColor);
}

.kuda-cta:hover {
    transform: translate3d(0px, -3px, 0px);
}

.kuda-cta-primary-light {
    background: #F4F4F4;
    background: var(--offBlue);
    color: #000000;
    color: var(--primaryColor);
}

.kuda-cta-loan {
    background: #1dcbef;
    background: var(--lightBlue);
    color: #ffffff;
    color: var(--whiteColor);
}

.kuda-cta-loan-light {
    background: var(--offLoan);
    color: #1dcbef;
    color: var(--lightBlue);
    border: 1px solid #1dcbef;
    border: 1px solid var(--lightBlue);
}

.kuda-cta-secondary-light {
    background: #dcffec;
    background: var(--successColorTrans);
    color: #48d38a;
    color: var(--successColor);
}

.kuda-cta-warning-light {
    background: #f9f9f9;
    background: var(--offWhite);
    border: 1px solid rgba(247, 104, 91, 0.3);
    color: #f7685b !important;
    color: var(--negativeColor) !important;
}

.kuda-cta-warning {
    background: #f7685b !important;
    background: var(--negativeColor) !important;
    color: #ffffff;
    color: var(--whiteColor);
}

.kuda-cta-xl {
    max-width: 255px;
}

.goal-actions .kuda-cta:not(:last-child) {
    margin-right: 20px;
}

.goal-actions {
    margin-top: 22px;
}

.single-savings .goal-actions {
    margin-top: 15px;
}

/* HEADER LAYOUT */

.kuda-header {
    position: fixed;
    width: 100%;
    height: 70px;
    left: 0;
    top: 0px;
    background: #ffffff;
    background: var(--whiteAlt);
    box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.05);
    /* z-index: 99; */
}

.kuda-header--wrap {
    max-width: 1500px;
    margin: 0 auto;
    display: block;
    padding-left: 60px;
    padding-right: 60px;
}

.kuda-nav--icon a,
.kuda-nav--icon p {
    display: flex;
    align-items: center;
    margin-right: 55px;
    color: #979797;
    color: var(--textColor);
    font-size: 0.875rem;
}

.kuda-nav--icon a span,
.kuda-nav--icon p span {
    display: flex;
}

.kuda-nav--icon:last-child a,
.kuda-nav--icon:last-child p {
    margin-right: 0;
    /* cursor: not-allowed; */
}

.kuda-nav--icon svg {
    margin-right: 10px;
    width: 25px;
    height: auto;
}
.kuda-nav--icon-api{
    cursor: pointer;
}
.kuda-nav--icon-api svg{
    width: auto;
}
.kuda-nav--icon-api .drop-icon {
    margin-bottom: 3px;
}
.kuda-brand svg {
    height: 20px;
    width: auto;
}

.kuda-brand,
.kuda-account {
    min-width: 100px;
}

img,
.balance-summary {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
}

/********** PROFILE IMAGE ***********/

.member-profile img {
    border-radius: 100px;
    background: #e8e8e8;
    object-fit: fill;
}

.member-profile {
    margin-right: 15px;
    height: 30px;
    width: 30px;
    background-size: cover;
    border-radius: 100px;
    background-position: top;
    background-color: #e8e8e8;
}

.kuda-menu--text {
    font-size: 0.875rem;
}

/* COMPONENT SIZING */

.h-100 {
    height: 100%;
}

.column--100 {
    width: 100% !important;
}

.column--90 {
    width: 90%;
}

.column--80 {
    width: 80%;
}

.column--50 {
    width: 50%;
}

.column--33 {
    width: 33.33333%;
}

/* kudabank Sections */

.kuda-preview {
    margin-top: 70px;
    /* padding: 63px 40px; */
    padding: 34px 24px;
}

.balance-icon {
    margin-right: 10px;
}

.balance-summary {
    height: 60px;
}

.denomination-icon {
    position: relative;
    top: -8px;
    margin-right: 3px;
}

/* Tab animations */

@keyframes kudaFadeInUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes kudaFadeInUpMini {
    0% {
        transform: translateY(9px);
        -webkit-transform: translateY(9px);
        -moz-transform: translateY(9px);
        -ms-transform: translateY(9px);
        -o-transform: translateY(9px);
    }

    100% {
        transform: translateY(0);
    }
}

.fadeIn {
    animation-name: fadeIn;
    animation-duration: 0.3s !important;
}

.kudaFadeInUp {
    animation-name: kudaFadeInUp;
}

.kudaFadeInUpMini {
    animation-name: kudaFadeInUpMini;
}

body {
    -webkit-backface-visibility: hidden;
    counter-reset: Count-Value;
}

.animated {
    animation-duration: 0.8s;
    animation-fill-mode: both;
    position: relative;
}

.dropdown-menu {
    animation-duration: 0.3s;
}

.kuda-dark--theme .animated {
    animation-fill-mode: none;
}

.kuda-transaction--tabs {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    display: flex;
    height: 52px;
    min-height: 48px;
    align-items: center;
    justify-content: space-between;
    margin-top: 35px;
    padding-right: 3px;
    padding-left: 3px;
}

.kuda-transaction--tabs>li {
    min-width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 1rem;
    color: #000000;
    color: var(--blackColor);
    height: calc(100% + 2px);
    position: relative;
    cursor: pointer;
    width: 50%;
}

.payoneerTab li {
    min-width: 50%;
}

.kuda-payment--tabs>li {
    min-width: 25%;
}

.kuda-transaction--tabs>li:after {
    opacity: 0;
    transition: opacity 1s;
}

.kuda-transaction--tabs>li[aria-selected="true"]:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 2px;
    display: block;
    background: #000000;
    background: var(--primaryColor);
    bottom: 1px;
    opacity: 1;
    border-radius: 5px;
    left: 0;
}

.link:after {
    opacity: 0;
    transition: opacity 1s;
}

.link.active:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 2px;
    display: block;
    background: #000000;
    background: var(--primaryColor);
    bottom: 1px;
    opacity: 1;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    left: 0;
}

.kuda-search {
    width: 100%;
    margin-top: 23px;
    position: relative;
}

.kuda-search--field {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    width: 100%;
    height: 52px;
    outline: 0;
    padding: 10px 20px 10px 52px;
    display: flex;
    align-items: center;
    color: #000000;
    color: var(--blackColor);
}

.search-toggle--icon {
    width: calc(100% - 110px) !important;
}

.toggle-icon--button {
    background: #ffffff;
    background: var(--whiteAlt);
    border-radius: 5px;
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: transform 0.6s;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgb(0 0 0 / 5%);
    padding-left: 12px;
    padding-right: 12px;
    font-size: 0.925rem;
}

.toggle-icon--button.active {
    background: #000000;
    background: var(--primaryAlt);
    color: #ffffff;
    color: var(--whiteAlt);
    border-color: #000000;
    border-color: var(--primaryAlt);
}

.toggle-icon--button.active svg path {
    fill: #ffffff !important;
    fill: var(--whiteAlt) !important;
}

.toggle-icon--button:hover {
    transform: translate3d(0px, -3px, 0px);
}

/* TABLE DROPDOWN */

.dropbtn {
    border: none;
    cursor: pointer;
}

.dropdown {
    position: relative;
    display: block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background: #ffffff;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    z-index: 1;
}

.dropdown-content div {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    border-bottom: 1px solid #eee;
}

.dropdown-content a:hover {
    background-color: #f1f1f1;
}

.dropdown.show .dropdown-content {
    display: block;
}

/* .dropdown.show .dropbtn {
  background-color: #3e8e41;
} */

/* TABLE DROPDOWN END */

/* Icons */

.bulk-payments--link,
.request-payment--link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.request-payment--link a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0px 18px;
    font-size: 1rem;
}

.request-payment--link a span {
    font-size: 1rem;
}

.searchIcon svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
}

.toggleIcon {
    width: auto;
    margin-left: 12px;
    margin-top: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.kuda-search--field::placeholder {
    font-weight: 600;
    color: #979797;
    color: var(--placeHolder);
}

.kuda-result--heading {
    background: #f9f9f9;
    background: var(--offWhite);
    width: 100%;
    height: 23px;
    font-size: 0.6875rem;
    display: flex;
    align-items: center;
}

.displayResults {
    margin-top: 23px;
}

.displayWrap>* {
    padding-left: 38px;
    padding-right: 38px;
}

.displayWrap>.bank-summary--result {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.viewSavingsSummary .displayWrap>div>* {
    padding-left: 20px;
    padding-right: 20px;
}

.viewSavingsSummary .displayWrap>* {
    padding-left: 0px;
    padding-right: 0px;
}

.transaction-avatar {
    width: 40px;
    height: 40px;
    display: block;
    min-width: 40px;
    background: #e8e8e8;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.kuda-transaction--details {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    padding: 0 20px 0 0;
}

.transaction-title {
    margin-left: 14px;
}

.transaction-title {
    color: #000000;
    color: var(--blackColor);
    font-size: 0.815rem;
    font-weight: 700;
    height: 100%;
    padding: 1px 0px;
}

.transaction-narration--wrap {
    width: 70%;
}

.kuda-result--item {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
    border-bottom: 1px solid var(--offWhiteTrans);
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
}

.transaction-result--item {
    padding-left: 30px !important;
    padding-right: 30px !important;
}

.transaction-pin--wrap .pin-input {
    margin-top: 10px !important;
    margin-bottom: 5px !important;
    margin-left: 0 !important;
    margin-left: initial !important;
    margin-right: 0 !important;
    margin-right: initial !important;
}

.transaction-date {
    font-weight: 300;
    color: #bebebe;
    font-size: 0.7rem;
}

.kuda-nav--icon a.active,
.kuda-nav--icon a[aria-current="page"] {
    color: #000000 !important;
    color: var(--primaryColor) !important;
}

.kuda-result--item {
    align-items: center;
}

.transaction-amount {
    display: flex;
    align-items: center;
}

.transaction-price {
    margin-right: 25px;
    position: relative;
    top: -1px;
    color: #000000;
    color: var(--blackColor);
    font-weight: 700;
    display: flex;
    transform: translateY(-0.35px);
    -webkit-transform: translateY(-0.35px);
    -moz-transform: translateY(-0.35px);
    -ms-transform: translateY(-0.35px);
    -o-transform: translateY(-0.35px);
}

.positive {
    color: #48d38a;
    color: var(--successColor);
}

.positive:before {
    content: "+";
}

.savings--inner .positive:before,
.single-savings .positive:before {
    content: none;
}

.summary-card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding: 20px 20px 32px;
    width: calc(50% - 10px);
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
}

.savings-progress {
    width: calc(100% - 40px);
    height: 2px;
    background: rgba(219, 220, 224, 0.3);
    background: var(--offWhiteTrans);
    position: absolute;
    bottom: 17px;
    left: 20px;
    border-radius: 5px;
}

.saving-summary {
    margin-top: 23px;
}

.summary-card>div {
    display: flex;
    justify-content: space-between;
}

.summary-card>div:first-child {
    margin-bottom: 20px;
}

.saving-plan {
    background: #F4F4F4;
    background: var(--offBlue);
    border-radius: 5px;
    height: 23px;
    font-size: 0.6875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 81px;
    font-weight: 600;
    color: #000000;
    color: var(--primaryAlt);
}

.save-cta {
    font-weight: 800;
    font-size: 1.25rem;
    color: #000000;
    color: var(--primaryColor);
    margin-top: 15px;
}

.save-title {
    font-size: 0.815rem;
}

.react-tabs__tab-panel {
    opacity: 0;
    transform: translateY(18px);
}

.kuda-signup--wrap {
    display: flex;
    width: 100% !important;
    padding: 46px 0px 49px !important;
    align-items: center;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
}

.signup-app--heading {
    max-width: 454px;
}

.kuda-signup--right {
    max-width: 509.3px;
    margin-left: auto;
}

.kuda-signup--left {
    padding: 50px 50px 50px 78px;
}

.kuda-preview {
    transition: transform 0.8s;
    transform: translateY(18px) !important;
    min-height: calc(100vh - 120px);
    -webkit-transform: translateY(18px) !important;
    -moz-transform: translateY(18px) !important;
    -ms-transform: translateY(18px) !important;
    -o-transform: translateY(18px) !important;
}

.kuda-page--transition .kuda-preview {
    transform: translateY(0px) !important;
    transition: transform 0.8s;
    -webkit-transform: translateY(0px) !important;
    -moz-transform: translateY(0px) !important;
    -ms-transform: translateY(0px) !important;
    -o-transform: translateY(0px) !important;
    -webkit-transition: transform 0.8s;
    -moz-transition: transform 0.8s;
    -ms-transition: transform 0.8s;
    -o-transition: transform 0.8s;
}

.react-tabs__tab-panel--selected {
    opacity: 1;
    transform: translateY(0px);
    transition: transform 0.8s, opacity 0.6s;
}


.kuda-nav--icon .filled {
    display: none;
}

.kuda-nav--icon .active .kuda-nav--icon svg,
.kuda-nav--icon a[aria-current="page"] .kuda-nav--icon svg {
    display: none;
}

.kuda-nav--icon .active .filled,
.kuda-nav--icon a[aria-current="page"] .filled {
    display: inline-flex;
}

.kuda-nav--icon .active svg:not(.filled),
.kuda-nav--icon a[aria-current="page"] svg:not(.filled) {
    display: none;
}
.kuda-nav--icon-api-active{
    color: #000000;
}
.menu-wrap--disabled {
    opacity: 0.5;
}
.kuda-nav--account-active{
    border-bottom: 6px solid #000000;
    color: #000000;

}
.kuda-onboarding--home {
    /* border: 1px solid red; */
    max-width: 450px;
    margin: auto;
    text-align: center;
}

.kuda-layout---card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding: 60px;
    position: relative;
}

.kuda-add--options>* {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 5px;
    padding: 20px 25px;
    max-width: 370px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    display: block;
    border-color: transparent;
    transition: border 0.2s;
    -webkit-transition: border 0.2s;
    -moz-transition: border 0.2s;
    -ms-transition: border 0.2s;
    -o-transition: border 0.2s;
}

.kuda-dark--theme .kuda-add--options>* {
    transition: none !important;
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -ms-transition: none !important;
    -o-transition: none !important;
}

.kuda-add--options>*:hover {
    border-color: #d5d8f2;
}

.kuda-add--options>* {
    margin-bottom: 20px;
}

.kuda-add--options {
    margin-top: 35px;
}

.add-icon {
    margin-bottom: 17px;
}

.card-heading {
    font-size: 0.98rem;
}

.back,
.back-to {
    cursor: pointer;
}

.back p {
    display: flex;
    align-items: center;
    color: #000000;
    color: var(--primaryAlt);
}

.back svg {
    margin-right: 9px;
    height: 11px;
    width: auto;
    position: relative;
    top: -1px;
    transform: translateY(0.7px);
}

.kuda-add--options p {
    font-size: 0.825rem;
}

.kuda-layout---card .back {
    position: absolute;
    top: 30px;
    left: 30px;
}

.kuda-subtext {
    max-width: 336px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: 20px;
}

.formCard,
.kuda-deposit--wrap,
.kuda-card--wrap {
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: var(--card-border);
    box-shadow: 15px 30px 40px rgba(0, 0, 0, 0.07);
    box-shadow: var(--card-box-shadow);
    border-radius: 5px;
    padding: 35px 55px 40px;
    max-width: 380px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

.kuda-transfer--form,
.kuda-deposit--wrap {
    margin-top: 25px;
}

.kuda-card--wrap {
    margin-top: 35px;
    background-color: #ffffff;
    background-color: var(--whiteAlt);
}

.mobile-input {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    position: relative;
}

.formInput {
    border: 0;
    /* border-bottom: 1px solid var(--offWhiteTrans); */
    outline: none;
    padding-top: 13px;
    padding-bottom: 13px;
    padding-left: 13px;
    font-weight: 600;
    border-radius: 0;
    background: none;
    width: 100%;
}

.mobile-input .formInput {
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
    border-bottom: 1px solid var(--offWhiteTrans);
}

.deposit--icons img {
    width: 38px;
    height: 38px;
    object-fit: cover;
    border-radius: 100px;
}

.kuda-deposit--text {
    margin-top: 15px;
}

.kuda-deposit--wrap,
.kuda-card--wrap {
    max-width: 420px;
    padding-left: 40px;
    padding-right: 40px;
}

.kuda-deposit--options:not(:last-child) {
    padding-bottom: 25px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
    border-bottom: 1px solid var(--offWhiteTrans);
}

.kuda-deposit--options:not(:first-child) {
    padding-top: 25px;
}

.kuda-deposit--text * {
    font-size: 0.938rem;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 100vh;
    background: rgba(0, 0, 0, 0.35);
    background: var(--overlay);
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100vw;
    margin-left: -50vw !important;
    left: 50% !important;
    z-index: 1000;
    transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;
    visibility: hidden;
    padding: 25px 20px;
    /* padding-left: 280px; */
    -moz-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;
    -ms-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;
    -o-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;
}

.modal-content {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-radius: 5px;
    padding: 42px 48px 54px;
    width: 100%;
    max-width: 517px;
    position: relative;
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
}

.modal-content::-webkit-scrollbar {
    display: none;
    /* Safari and Chrome */
}

.small-modal .modal-content {
    max-width: 455px;
}

.modal-content.sm {
    max-width: 560px;
}

.transaction-header {
    background: #F4F4F4 !important;
    border-radius: 4px;
    padding: 20px;
    margin-top: 38px;
    display: flex;
    margin-bottom: 23px;
}

.transaction-icon {
    margin-right: 15px;
    width: 43px;
    height: 43px;
    min-width: 43px;
    overflow: hidden;
    border-radius: 100px;
}

.transaction-additional--details {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
    border-bottom: 1px solid var(--offWhiteTrans);
    padding-top: 15px;
}

.transaction-right {
    text-align: right;
    position: relative;
}

.generateReceipt {
    margin-top: 37px;
    max-width: 192px;
    margin-bottom: 0;
}

.closeModal svg {
    height: 29px;
    width: auto;
}

.balance-title {
    margin-top: 2px;
}

.kuda-heading--illustration svg {
    width: 98px;
    height: 98px;
    display: block;
    margin: 0 auto;
}

.kuda-card-content {
    margin-top: 25px;
}

.card-fields {
    margin-top: 30px;
}

.card-fields>div {
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 60px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
    border-bottom: 1px solid var(--offWhiteTrans);
    align-items: center;
}

.card-text {
    font-size: 0.82rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    color: #000000;
    color: var(--blackColor);
    pointer-events: none;
}

.card-fields .card-type {
    width: 100%;
    border: 0;
    outline: none;
    padding-right: calc(50% + 15px);
    font-size: 0.82rem;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.accept {
    margin: 60px 0 0;
}

.card-fields+.accept {
    margin-top: 50px;
}

.add-amount {
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin-top: 10px;
    position: relative;
}

.add-amount.sm {
    max-width: 300px;
}

.denomination {
    background: #F4F4F4;
    background: var(--offBlue);
    border: 1px solid #121212;
    border: 1px solid var(--input-prefix-border);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    font-weight: 600;
    color: #000000;
    color: var(--blackColor);
    font-size: 1rem;
    position: absolute;
    top: 0px;
    left: 0px;
}

.amount-input {
    height: 100%;
    width: calc(100%);
    border: none;
    outline: none;
    padding: 9px 12px;
    border-radius: 5px;
    padding-left: 54px;
    min-height: 46px;
    background-color: #ffffff;
    background-color: var(--whiteColor);
    color: #000000;
    color: var(--blackColor);
}

.amount-input::placeholder {
    font-weight: 600;
    color: #979797 !important;
    color: var(--placeHolder) !important;
}

.card-group:not(:last-child) {
    margin-bottom: 24px;
}

.kuda-add--cardForm {
    margin-bottom: 52px;
}

.kuda-dropdown-header {
    display: flex;
    align-items: center;
    height: 46px;
    cursor: pointer;
}

.kuda-dropdown-title, .kuda-dropdown-placeholder {
    width: calc(100% - 42px);
    color: #000000;
    color: var(--blackColor);
    font-weight: 600;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    margin-top: 0;
    -webkit-hyphens: auto;
    hyphens: auto;
    padding-right: 20px;
    height: auto;
    line-height: 1.5;
}

.kuda-bank-dropdown-title, .kuda-bank-dropdown-placeholder {
    width: calc(100% - 42px);
    color: #000000;
    color: var(--blackColor);
    font-weight: 600;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 2px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    margin-top: 0;
    -webkit-hyphens: auto;
    hyphens: auto;
    padding-right: 20px;
    height: auto;
    line-height: 1.5;
}

.kuda-dropdown-placeholder, .kuda-bank-dropdown-placeholder {
    color: #979797;
    color: var(--textColor)
}
.kuda-dropdown-icon {
    width: 42px;
    display: flex;
    justify-content: center;
}
.kuda-dropdown-bank-logo{
    height: 32px;
    width: 32px;
}
.kuda-dropdown-bank-logo img{
    max-width: 100%;
    max-height: 100%;
}
.kuda-dropdown-icon {
    width: 42px;
    display: flex;
    justify-content: center;
}

.kuda-dropdown-list {
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-radius: 5px;
    padding: 11px 16px 5px;
    margin-top: 5px;
    cursor: pointer;
    top: -6px;
    width: calc(100% + 4px);
    left: -2px;
    position: absolute;
    z-index: 9999;
}

.kuda-dropdown-item {
    padding: 15px 0;
    color: #000000;
    color: var(--blackColor);
    display: flex;
    align-items: center;
}

input {
    font-weight: 600;
}

.savings-active .color-primary {
    color: #48d38a !important;
    color: var(--successColor) !important;
}

.savings-active .kuda-cta {
    background: #48d38a !important;
    background: var(--successColor) !important;
}

.savings-active .kuda-transaction--tabs>li[aria-selected="true"]:after {
    background: #48d38a !important;
    background: var(--successColor) !important;
}

.savings-active .denomination-icon path {
    fill: #48d38a !important;
    fill: var(--successColor) !important;
}

.save-now {
    min-height: 162px;
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(72, 211, 138, 0.5);
    border: 1px solid var(--offGreen);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.other-card .saving-plan {
    background: #dcffec;
    background: var(--successColorTrans);
    color: #48d38a;
    color: var(--successColor);
}

.other-card .save-cta {
    color: #48d38a !important;
    color: var(--successColor) !important;
}

/* AUTH PAGE */

.kuda-auth--wrap {
    max-width: 440px;
    width: 100%;
}

.kuda-auth--layout {
    height: 100%;
}

.kuda-auth--wrap p {
    font-size: 0.925rem;
}

.margin-bottom--spacer {
    margin-bottom: 12px;
}

.kuda-auth--layout {
    width: 100%;
}

.kuda-auth--illustration {
    position: relative;
    width: 50%;
    height: 100vh;
    display: grid;
    place-items: center;
}

.kuda-auth--illustration div {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    height: 604px;
    width: 503px;
}

/* .kuda-auth--illustration svg {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
} */

.auth-layout-wrap>div:last-child {
    width: calc(100% - 530px);
}

.saveAction,
.savings-active .addAction {
    display: none;
}

.savings-active .saveAction {
    display: flex;
}

.kuda-savingsIcon,
.savings-active .kuda-bankIcon {
    display: none;
}

.savings-active .kuda-savingsIcon {
    display: inline-flex;
}

.auth-wrap {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-radius: 5px;
    padding: 50px 70px 70px;
}

.business-reg-card {

    box-shadow: 15px 30px 40px 15px 30px 40px rgba(0, 0, 0, 0.07);

    box-shadow: 15px 30px 40px var(--card-box-shadow);

}


.kuda-auth--tabs {
    display: flex;
    width: auto;
    position: relative;
    left: 4px;
}

.kuda-auth--tabs li {
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 8px 20px;
    color: #000000;
    color: var(--blackColor);
    cursor: pointer;
    border-bottom: 0 !important;
    font-size: 11px;
}

.kuda-auth--tabs li[aria-selected="true"] {
    background: #000000;
    background: var(--primaryColor);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    color: #ffffff;
    color: var(--whiteColor);
}

.kuda-auth--tabs li:first-child {
    margin-right: 3px;
}

.kuda-form--layout {
    margin-top: 29px;
}

.kuda-form--layout .add-amount.md {
    max-width: 320px;
}

.mobile-input.sm {
    max-width: 359px;
}

.kuda-form--layout ::placeholder {
    color: #979797;
    color: var(--placeHolder);
}

.forgot-label {
    font-size: 13px;
    margin-top: 24px;
}

.login-button {
    margin-top: 27px;
    font-size: 1rem;
    max-width: 152px;
}

.register-link {
    font-size: 0.9375rem;
    color: #48d38a;
    color: var(--successColor);
}

.kuda-inner--heading {
    font-size: 1.75rem;
}

.normal-input {
    padding-left: 12px;
}

.kuda-dropdown {
    position: relative;
    z-index: 9;
}

/* KUDA PAYMENTS */

.kuda-payment--tabs li {
    min-width: 33.33%;
    outline: none;
}

.kuda-payment--tabs.sme-payments--tabs li {
    min-width: 20%;
    outline: none;
}

.schedule-payment--switch {
    width: 100%;
}

.schedule-payment--item {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.schedule-option--wrapper {
    height: auto !important;
    /* border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-top: 20px; */
}

.schedule-option {
    margin-left: 0 !important;
}

.payment-request--title {
    max-width: 300px;
    margin: auto;
}

.payment-request--title h5 {
    margin-bottom: 10px;
    font-size: 17px;
}

.make-payment--link {
    margin-top: 20px !important;
    border: 1px solid #000000 !important;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 15px;
    max-width: 327px !important;
}

.copy-link--wrap {
    background: #f9f9f9;
    border-radius: 4px;
    padding: 22px 32px;
    max-width: 335px;
    margin: auto;
}

.single-recent--link {
    border-bottom: none;
}

.single-recent--link .transaction-price {
    background: #ffffff;
    background: var(--whiteAlt);
    font-size: 11px;
    padding: 5px 19px;
    margin-right: 0px;
    border-radius: 4px;
}

.single-recent--link .transaction-price.canceled {
    color: #f7685b;
    border: 1px solid #f7685b;
}

.single-recent--link .transaction-price.expired {
    color: #979797;
    border: 1px solid #979797;
}

.single-recent--link .transaction-price.pending {
    color: #ffc83e;
    border: 1px solid #ffc83e;
}

.single-recent--link .transaction-price.claimed {
    color: #000000;
    border: 1px solid #000000;
}

.divider {
    opacity: 0.2;
    border-bottom: 1px solid #dbdce0;
    width: auto;
    height: 0px;
}

.recent-links--wrap {
    margin-top: 50px;
}

.confirm-payment--link {
    max-width: 320px;
    margin: auto;
}

.confirm-payment--link .transaction-additional--details {
    border-bottom: none;
}

.confirm-payment--link .divider {
    opacity: 0.25;
    border: 1px solid #000000;
}

.pin-details--wrap {
    max-width: 90px;
    margin: auto;
}

.modal-message--img {
    max-width: 100px;
    margin: auto;
}

.bulk-select--radio {
    height: auto !important;
}

.bulk-select--radio .kuda-radio--wrapper {
    width: 100% !important;
}

.bulk-additional--details {
    border-bottom: none !important;
    margin-bottom: 2px !important;
    padding-bottom: 0px;
    padding-left: 9px;
    background: #f9f9f9;
}

.bulk-confirm-item {
    border-bottom: 1px solid #dbdce0;
    padding-bottom: 8px;
}

.csv-upload--span {
    right: -1px;
    left: auto;
    left: initial;
}

.upload-csv--wrap {
    margin-bottom: 15px !important;
}

.upload-csv--wrap .add-amount {
    min-width: 342px;
    max-width: 342px;
}

.upload-csv--wrap .add-amount span {
    font-size: 1.5rem !important;
    font-weight: 400;
}

.view-bank--code a {
    font-weight: 700;
    color: rgba(72, 211, 138, 0.5);
    color: var(--offGreen);
}

table.bulk-beneficiary--table {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    font-size: 12px;
    margin-top: 40px;
}

.bulk-beneficiary--table td {
    border-bottom: 1px solid #ddd;
    padding: 11px;
    color: #000000;
    color: var(--blackColor);
}

.bulk-beneficiary--table th {
    border-bottom: none;
    padding: 11px;
}

.bulk-beneficiary--table tr:nth-child(even) {
    background: #f9fafe;
}

.bulk-beneficiary--table tbody tr:nth-child(1) {
    border-bottom: 1px solid #ddd;
}

.bulk-beneficiary--table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #fff;
    color: #000000;
    font-weight: 700;
    font-size: 12px;
}

.payment-success--info {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding-bottom: 30px;
    margin-top: 40px;
}

.bulk-success-modal {
    height: auto;
    overflow-y: scroll;
    /* padding-right: 20px; */
}

.kuda-failure--modal .kuda-modal-illustration {
    margin-bottom: 20px !important;
}

.failure-response--message {
    max-width: 300px;
    line-height: 20px;
}

.kuda-failure--modal .failure-response--message {
    margin-bottom: 41px;
    max-width: 300px;
}

.invoice-card--wrap {
    max-width: 100% !important;
    padding-left: 27px !important;
    padding-right: 27px !important;
}

.invoice-details--card {
    background: #ffffff;
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 0px 30px 40px var(--boxShadow);
    border-radius: 5px;
    padding: 0px 0px 43px;
    max-width: 657px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-top: 39px;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
}

.lavendar-background {
    background: rgb(223, 227, 255, 0.3);
}

.lavendar-background p {
    font-size: 0.75rem;
}

.invoice-details--card>div {
    padding: 10px 25px;
}

.invoice-table--wrap table {
    border-collapse: collapse;
    width: 100%;
}

.invoice-logo--wrap {
    padding: 25px 10px;
    border: 2px dashed rgb(0, 0, 0, 0.2);
    border-radius: 5px;
    max-width: 205px;
}

.invoice-logo--wrap p {
    font-size: 0.625rem;
}

.invoice-table--wrap table thead,
.invoice-table--wrap table tbody tr {
    padding: 30px 0px;
    text-align: left;
    border-bottom: 1px solid #dbdce0;
}

.invoice-header--left h4 {
    font-size: 1.75rem;
}

.invoice-count--wrap div.flex {
    max-width: 172.2px;
}

.invoice-count--wrap .invoice-count-sn {
    background: #000000;
    background: var(--primaryAlt);
    padding: 14px 16px;
    color: #ffffff;
    color: var(--whiteAlt);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.invoice-count--wrap .invoice-count-num {
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 14px 16px 16px 40px;
    text-align: right;
}

.invoice-personal-left {
    padding: 26px 40px;
    max-width: 50%;
    border-right: 1px solid #ddd;
}

.invoice-personal--details ul {
    list-style: none;
    width: 50%;
    max-width: 50%;
}

.invoice-personal-right {
    padding: 26px 10px 26px 40px;
    max-width: 50%;
}

.invoice-personal--details ul li::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    color: #000000;
    /* Change the color */
    font-weight: bold;
    /* If you want it to be bold */
    display: inline-block;
    /* Needed to add space between the bullet and the text */
    width: 1em;
    /* Also needed for space (tweak if needed) */
    margin-left: -1em;
    /* Also needed for space (tweak if needed) */
}

.invoice-add--customer {
    border: none !important;
    padding: 41px 14px !important;
}

/* .invoice-personal--details ul */

/* PAYMENTS END */

.transaction-pin {
    width: auto;
    max-width: none !important;
}

.transaction-pin input {
    margin-right: 5px;
    color: #000000;
    color: var(--blackColor);
    font-weight: 400;
    width: auto !important;
}

.transaction-name.text-smd {
    color: #979797;
}

.schedule-payment--switch .toggle {
    height: 32px !important;
}

.toggle-state--wrapper {
    padding-right: 15px;
    padding-left: 10px;
}

.card-main--heading {
    font-size: 1.25rem;
    margin-bottom: 35px;
}

.card-payment-heading {
    font-size: 1.25rem;
    margin-bottom: 40px;
}

.cursor-pointer {
    cursor: pointer;
}

/********* BENEFICIARY DROPDOWN ********/

.no-avatar {
    background: #48d38a;
    background: var(--successColor);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    border-radius: 100px;
    border: 0.5px solid #fff;
    position: relative;
    z-index: 99;
    width: 100%;
    height: 100%;
}

.avatar-wrap {
    border: 1px solid #48d38a;
    border: 1px solid var(--successColor);
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    margin-right: 17px;
    border-radius: 100px;
}

.kuda-dropdown-item:not(:last-child) {
    border-bottom: 1px solid #f4f4f4;
    border-bottom: 1px solid var(--bgOffset);
    padding-bottom: 15px;
}

.modal-active .kuda-dropdown-list {
    top: -6px;
    position: absolute;
    width: calc(100% + 4px);
    left: -2px;
}

.dropdown-details {
    display: flex;
    flex-direction: column;
}

.dropdown-details {
    display: flex;
    flex-direction: column;
}

.dropdown-item--title {
    font-size: 0.925rem;
}

.dropdown-item--subtitle {
    font-size: 0.78rem;
    color: rgba(0, 0, 0, 0.5);
    color: var(--offText);
}

.kuda-searchbox input {
    height: 40px;
    border: 0;
    padding-left: 40px;
    width: 100%;
    outline: none;
    background-color: #ffffff;
    background-color: var(--whiteColor);
    color: #000000;
    color: var(--blackColor);
}

.kuda-searchbox {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    padding: 7px 15px;
    background: #ffffff;
    background: var(--whiteColor);
    border-bottom: 1px solid #f4f4f4;
    border-bottom: 1px solid var(--bgOffset);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.kuda-searchbox svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    object-fit: cover;
}

input[type = 'search']::-webkit-search-cancel-button{
	/* color: var(--primaryColor); */
	/* background-color: var(--primaryColor); */
    /* background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMjIxNzggOC4yMjE4M0M3LjYzNTk5IDguODA3NjEgNy42MzU5OSA5Ljc1NzM2IDguMjIxNzggMTAuMzQzMUwxMy44Nzg2IDE2TDguMjIxNzggMjEuNjU2OUM3LjYzNTk5IDIyLjI0MjYgNy42MzU5OSAyMy4xOTI0IDguMjIxNzggMjMuNzc4MkM4LjgwNzU2IDI0LjM2NCA5Ljc1NzMxIDI0LjM2NCAxMC4zNDMxIDIzLjc3ODJMMTYgMTguMTIxM0wyMS42NTY4IDIzLjc3ODJDMjIuMjQyNiAyNC4zNjQgMjMuMTkyMyAyNC4zNjQgMjMuNzc4MSAyMy43NzgyQzI0LjM2MzkgMjMuMTkyNCAyNC4zNjM5IDIyLjI0MjYgMjMuNzc4MSAyMS42NTY5TDE4LjEyMTMgMTZMMjMuNzc4MSAxMC4zNDMxQzI0LjM2MzkgOS43NTczNiAyNC4zNjM5IDguODA3NjEgMjMuNzc4MSA4LjIyMTgzQzIzLjE5MjMgNy42MzYwNCAyMi4yNDI2IDcuNjM2MDQgMjEuNjU2OCA4LjIyMTgzTDE2IDEzLjg3ODdMMTAuMzQzMSA4LjIyMTgzQzkuNzU3MzEgNy42MzYwNCA4LjgwNzU2IDcuNjM2MDQgOC4yMjE3OCA4LjIyMTgzWiIgZmlsbD0iIzRENEQ0RCIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmNvbG9yLWJ1cm4iLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMjIxNzggOC4yMjE4M0M3LjYzNTk5IDguODA3NjEgNy42MzU5OSA5Ljc1NzM2IDguMjIxNzggMTAuMzQzMUwxMy44Nzg2IDE2TDguMjIxNzggMjEuNjU2OUM3LjYzNTk5IDIyLjI0MjYgNy42MzU5OSAyMy4xOTI0IDguMjIxNzggMjMuNzc4MkM4LjgwNzU2IDI0LjM2NCA5Ljc1NzMxIDI0LjM2NCAxMC4zNDMxIDIzLjc3ODJMMTYgMTguMTIxM0wyMS42NTY4IDIzLjc3ODJDMjIuMjQyNiAyNC4zNjQgMjMuMTkyMyAyNC4zNjQgMjMuNzc4MSAyMy43NzgyQzI0LjM2MzkgMjMuMTkyNCAyNC4zNjM5IDIyLjI0MjYgMjMuNzc4MSAyMS42NTY5TDE4LjEyMTMgMTZMMjMuNzc4MSAxMC4zNDMxQzI0LjM2MzkgOS43NTczNiAyNC4zNjM5IDguODA3NjEgMjMuNzc4MSA4LjIyMTgzQzIzLjE5MjMgNy42MzYwNCAyMi4yNDI2IDcuNjM2MDQgMjEuNjU2OCA4LjIyMTgzTDE2IDEzLjg3ODdMMTAuMzQzMSA4LjIyMTgzQzkuNzU3MzEgNy42MzYwNCA4LjgwNzU2IDcuNjM2MDQgOC4yMjE3OCA4LjIyMTgzWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC40Ii8+PC9zdmc+"); */
	/* background-color: black; */
	/* height: 10px;
	width: 10px; */
	-webkit-appearance: none;
}


.avatar-wrap.has-image {
    border: none;
}

.payment-wrap .kuda-card--wrap {
    max-width: 533px;
    padding-left: 57px;
    padding-right: 57px;
    padding-top: 40px;
    position: relative;
}

.payment-wrap .kuda-card--wrap.kuda-bill--wrap {
    padding-left: 85px;
    padding-right: 85px;
}

.kuda-savings .kuda-card--wrap,
.kuda-cards .kuda-card--wrap {
    max-width: 533px;
    padding: 45px 77px;
}

.kuda-cards .kuda-card--wrap .kuda-add--cardForm:not(.kuda-inner--cardFix) {
    margin-bottom: 0;
}

.kuda-cards .kuda-card--wrap:not(.kuda-activate--wrap) {
    padding-top: 54px;
    padding-bottom: 75px;
}

.main-modal-active .kuda-header {
    z-index: -1 !important;
}

.transaction-confirm-action {
    margin: 40px auto 47px;
    max-width: 289px;
}

.transaction-create--pin {
    max-width: 225px;
}

.upload-docs--wrap {
    max-width: 600px;
    margin: auto;
}

.upload-docs--wrap.sm {
    max-width: 300px;
}

.upload-item {
    width: 100%;
}

.upload-item-md {
    width: 100%;
    max-width: 300px;
}

.upload-btn--item {
    width: 100%;
}

.upload-item>.label-wrap {
    margin-bottom: 10px !important;
}

.upload-btn-wrap {
    border-radius: 5px;
    padding: 14px 18px;
    width: 100%;
    border: 1px dashed rgb(0, 0, 0, 0.2);
    min-height: 46px;
    max-height: 46px;
    font-size: 0.925rem;
    font-weight: 600;
    position: relative;

}
.upload-btn-wrap.file-uploaded {
    padding: 14px 46px;

}
.smaller-upload-btn-wrap{
     border-radius: 5px;
    padding: 7px 19px;
    width: 100%;
    border: 1px dashed rgb(0, 0, 0, 0.2);
    min-height: 48px;
    font-size: 0.925rem;
    font-weight: 600;
}
.upload-btn__disabled-state{
    opacity: 0.3;
}

.no-border--upload {
    border: none;
    border-radius: 0;
    padding: 0;
    /* width: 0; */
}

#myProgress {
    width: 100%;
    background-color: #ddd;
    /* max-width: 218px; */
    margin-right: 5px;
}

#myBar {
    width: 37%;
    /* max-width: 218px; */
    height: 2px;
    background: rgb(72, 211, 138);
}

#myBar.green {
    background-color: #48d38a !important;
}

#myBar.purple {
    background-color: #000000 !important;
}

#myBar.red {
    background-color: #f7685b !important;
}

.upload-btn-wrap div:nth-child(1) {
    /* max-width: 218px; */
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
}

.upload-btn-wrap label.color-green {
    cursor: pointer;
}

.add-signatory--wrap {
    background: #ffffff;
    background: var(--whiteColor);
    box-shadow: none !important;
    border-radius: 10px !important;
    border: 2px dashed #000000 !important;
    max-width: 342px;
    margin: auto;
    height: 48px !important;
}

table.kuda-signatory--table {
    border-collapse: collapse;
    width: 100%;
    padding: 0rem 0rem 0rem 1rem;
}

.kuda-signatory--table td {
    padding: 16px 0px;
    background: #ffffff;
    background: var(--tdColor);
    border-bottom: none;
    color: #000000;
    text-align: left;
    /* vertical-align: middle; */
}

.kuda-signatory--table tr.table-row--border {
    /* background-color: #f2f2f2; */
    border-bottom: 1px solid rgba(219, 220, 224, 0.5);
    /* box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05); */
}

.kuda-signatory--table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #f9f9f9;
    background-color: var(--theadColor);
    border: none;
    color: #000000;
}

tr.table-row--border td:nth-child(1),
table.kuda-signatory--table thead tr th:nth-child(1) {
    padding-left: 15px;
}

tr.table-row--border td:nth-child(5),
table.kuda-signatory--table thead tr th:nth-child(5) {
    padding-right: 15px;
}

tr.table-row--border td:nth-child(2) {
    color: #000000;
    color: var(--primaryAlt);
}

.kuda-signatory--table tr td:first-child:before {
    counter-increment: Count-Value;
    content: counter(Count-Value);
}

.kuda-limit-table tr td:first-child:before {
    counter-increment: none !important;
    content: "" !important;
}

.kuda-signatory--table.no-numbering tr td:first-child:before {
    counter-increment: none;
    content: none;
    display: table-header-group;
}

.signatory-input--wrap {
    max-width: 460px;
    justify-content: space-between;
    margin: auto;
}

.signatory-input--wrap div.card-group {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

.pin-input input {
    background: #f9f9f9;
    background: var(--offWhite);
    border-radius: 3px;
    border: 0;
    width: calc(25% - 5px);
    height: 44px;
    max-width: 44px;
    outline: none;
    text-align: center;
}

.pin-input {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    max-width: 196px;
    margin-left: auto;
    margin-right: auto;
}

/* Analytics Card */

.analytics-card--section {
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
}

.analytics-card--section p>span {
    color: rgb(0, 0, 0, 0.3) !important;
}

.analytics-percentage {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
    font-weight: 700;
}

.analytics-progress--bar {
    position: relative;
    display: block;
    height: 100%;
    overflow: hidden;
}

.analytics-color--wrapper {
    position: absolute;
    /* border: 1px solid red; */
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.analytics-transaction--price {
    font-weight: 400 !important;
}

.analytics-spending--wrap,
.analytics-others--wrap {
    /* max-width: 358px; */
    max-width: 100%;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05) !important;
    padding: 10px 0px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    border-radius: 5px;
    width: 358px;
    margin-right: 13px;
}

.analytics-others--wrap {
    /* max-width: 345px; */
    /* width: 345px; */
    max-width: 100%;
    width: 100%;
    margin-right: 0px;
    padding: 20px;
}

.analytics-transaction--details {
    padding-bottom: 15px !important;
    padding-top: 15px !important;
}

.analytics-card--item {
    padding-top: 0;
    padding-bottom: 0;
    box-sizing: content-box;
    position: relative;
}

/* KUDA MODAL */

.message-response {
    max-width: 190px;
    text-align: center;
    margin: 0 auto;
    line-height: 1.5;
}

.withdrawal-response {
    max-width: 320px;
    line-height: 1.5;
}

.notice-content {
    max-width: 315px;
    margin-left: auto;
    margin-right: auto;
}

/* .withdrawal-response {
  max-width: 180px;
} */

.spend-response {
    max-width: 256px;
}

.withdrawal-auth--code {
    font-size: 1.63rem;
    text-align: center;
    letter-spacing: 5px;
    margin: 20px auto -16px;
}

.withdrawal-illustration {
    margin-top: 8px !important;
    margin-bottom: 21px !important;
}

.recharge-response {
    margin-bottom: 65px;
}

.kuda-modal-illustration {
    display: flex;
    justify-content: center;
    margin: 42px auto 38px;
}

/* KUDA TOGGLE */

.toggle {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    box-sizing: border-box;
    align-self: center;
    -webkit-user-select: none;
    user-select: none;
}

.toggle input[type="checkbox"] {
    display: none;
}

.toggle input[disabled]~.toggle-icon {
    pointer-events: none;
}

.toggle-icon {
    z-index: 0;
    margin: 0;
    padding: 0;
    appearance: none;
    border: none;
    position: relative;
    transition: 0.3s;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
}

.toggle-icon:after,
.toggle-icon:before {
    content: "";
}

.toggle-icon:after {
    background: #fff;
    position: absolute;
    z-index: 2;
    transform: translateX(0);
    transition-duration: 0.3s;
}

.toggle {
    width: 52px;
    border-radius: 16px;
    height: 32px;
}

.toggle input[type="checkbox"]:checked+.toggle-icon {
    background: #48d38a;
    background: var(--successColor);
}

.toggle input[type="checkbox"]:checked+.toggle-icon:before {
    transform: scale(0);
}

.toggle input[type="checkbox"]:checked+.toggle-icon:after {
    transform: translateX(24px);
}

.toggle-icon {
    width: 56px;
    border-radius: 16px;
    height: 32px;
    background: rgba(219, 220, 224, 0.3);
    background: var(--offWhiteTrans);
}

.toggle-icon:before {
    position: absolute;
    left: 2px;
    top: 2px;
    width: 48px;
    height: 28px;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 1;
    transition-duration: 0.3s;
    transform: scale(1);
}

.toggle-icon:after {
    height: 24px;
    width: 24px;
    top: 4px;
    left: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: 14px;
}

.kuda-savings--header .toggle-icon:after {
    height: 16px;
    width: 16px;
}

.kuda-savings--header .toggle-icon,
.toggle {
    height: 20px;
    width: 38px;
}

.kuda-savings--header .toggle-icon {
    width: 38px;
}

.kuda-savings--header .toggle input[type="checkbox"]:checked+.toggle-icon:after {
    transform: translateX(15.5px);
}

.kuda-savings--header .toggle-icon:after {
    top: 2px;
    left: 3px;
}

.kuda-savings--header .toggle {
    margin-left: 20px;
}

.optional-heading {
    margin: 25px 0;
    display: flex;
    align-items: center;
}

.optional-title {
    font-size: 0.93rem;
}

.payment-wrap .modal-backdrop {
    margin-top: -300px;
}

.bill-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    height: 60px;
    padding: 10px 25px;
    background-color: #ffffff;
    background-color: var(--whiteColor);
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border: 1px solid gray;
}

.bill-item:not(:last-child) {
    margin-bottom: 20px;
}

.bill-item-wrap {
    display: flex;
    align-items: center;
}

.bill-item--icon {
    margin-right: 18px;
    display: flex;
}

.kuda-bills--nav {
    margin-top: 35px;
}

.hasImage img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.hasImage {
    background: none !important;
    border-radius: 100px;
    overflow: hidden;
    border: none;
    padding: 4px;
}

.card-label {
    font-size: 13px;
}

/* BACK TO */

.backArrow {
    margin-right: 9px;
}

.card-nav {
    position: relative;
}

.back-to {
    position: absolute;
    font-size: 12px;
    display: flex;
    align-items: center;
    top: 24px;
    left: 32px;
    cursor: pointer;
}

.has--subheading h5 {
    margin-bottom: 15px;
}

.backArrow {
    margin-right: 9px;
    display: flex;
}

.svg-wrap--md {
    width: 35px !important;
    height: 35px !important;
}

.backArrow svg {
    height: 11px;
    width: auto;
    position: relative;
    transform: translateY(-0.8px);
}

.card-account--summary {
    padding: 18px;
    background: rgba(223, 227, 255, 0.3);
    background: var(--offBlueTran);
    border-radius: 10px;
    margin-bottom: 28px;
}

h5.text-xs {
    font-size: 0.6rem;
}

.card-50 {
    width: 50%;
}

.card-summary--icon {
    margin-right: 8px;
}

.card-account--summary>div:not(:last-child) {
    border-right: 0.7px solid rgba(0, 0, 0, 0.2);
    align-items: center;
}

.card-account--summary>div:last-child {
    padding-left: 10%;
}

.card-summary-text h5.text-xs {
    line-height: 1;
}

.kuda-savings .savings--inner {
    max-width: 490px;
    margin: 0 auto;
}

.percentage-summary {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    height: 46px;
    position: relative;
    min-height: 46px;
    top: -1px;
    overflow: hidden;
}

.percentage-input {
    text-align: center;
    height: 100%;
    width: 100%;
    border: none;
    outline: 0;
    border-radius: 0px;
    background: #ffffff;
    background: var(--whiteAlt);
}

.percentage-toggle {
    position: absolute;
    left: 10px;
    top: calc(50% + 2px);
    height: auto;
    transform: translateY(-50%);
    cursor: pointer;
}

.next {
    left: auto;
    right: 10px;
}

.percentage-save {
    width: 100%;
    margin-right: 25px;
    height: auto;
}

.main-modal-active {
    overflow: hidden;
}

.kuda-savings .transaction-price {
    margin-right: 0;
}

.transaction-name {
    margin-top: 3px;
}

.transaction-date {
    margin-bottom: 1px;
}

.kuda-savings .transaction-avatar svg {
    width: 100%;
    height: 100%;
}

.spendSave-response {
    margin-bottom: 25px;
    max-width: 255px;
}

.kuda-hamburger {
    position: relative;
    display: inline-block;
    width: 23px;
    height: auto;
    top: 3px;
}


.kuda-hamburger .kuda-hamburger--inner {
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    transition-duration: 75ms;
}

.kuda-hamburger .kuda-hamburger--inner:after,
.kuda-hamburger .kuda-hamburger--inner:before {
    position: absolute;
    width: 20px;
    height: 2px;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform;
    border-radius: 4px;
    background-color: #000000;
    background-color: var(--primaryAlt);
}


.kuda-hamburger .kuda-hamburger--inner:after,
.kuda-hamburger .kuda-hamburger--inner:before {
    display: block;
    content: "";
}

.kuda-hamburger .kuda-hamburger--inner:before {
    top: -9px;
}

.kuda-hamburger .kuda-hamburger--inner:before {
    transition: top 75ms ease 0.12s, opacity 75ms ease;
}

.inner-savings--panel {
    max-width: 312px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.kuda-savings .kuda-card--wrap .card-main--heading {
    margin-bottom: 32px;
}

.kuda-image--drop {
    background: #dcffec;
    background: var(--successColorTrans);
    border-radius: 10px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.kuda-image--drop svg {
    height: 71px;
    width: auto;
}

.fileInput {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 9;
}

.kuda-personalize--card {
    position: relative;
}

.imgPreview {
    position: relative;
    height: 170px;
}

.personalize-text {
    font-size: 1.07rem;
    margin-top: 29px;
    font-weight: 600;
}

.imgPreview img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

.flexible-summary {
    margin-top: 35px;
}

.review-summary {
    margin-top: 20px;
}

.single-fixed {
    margin-top: 8px;
}

.review-summary .card-type,
.review-summary .card-text {
    font-size: 1rem;
}

.review-summary.card-fields>div {
    height: 56px;
}

.review-summary {
    max-width: 335px;
    margin-left: auto;
    margin-right: auto;
}

.kuda-prev span {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 1;
}

.view-goal .kuda-inner--heading {
    display: none;
}

.view-goal .kuda-savings .kuda-card--wrap {
    margin-top: 0;
}

.react-datepicker-wrapper {
    width: 100%;
}

.kuda-savings--header {
    max-width: 381px;
    margin: 0 auto;
}

.single-savings .review-summary,
.single-savings .displayResults {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

.single-saving--header {
    font-size: 1.08rem;
    margin-bottom: 3px;
}

.single-savings .review-summary.card-fields>div {
    height: 64px;
    margin-bottom: 22px;
}

.single-saving--subheader {
    font-size: 0.75rem;
    color: #979797;
    color: var(--textColor);
}

.single-savings .displayResults {
    margin-top: 26px;
}

.summary-progress {
    border-bottom: 0 !important;
    height: auto !important;
}

/* PROGRESS BAR */

.summary-progress--bar {
    background: #f9f9f9;
    background: var(--offWhite);
    height: 4px !important;
    border: none !important;
    border-radius: 7px;
}

.summary-progress--bg {
    width: 0;
    background: #48d38a;
    background: var(--successColor);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: 7px;
    transition: width 1.5s;
    max-width: 100%;
}

.summary-progress {
    margin-bottom: 7px !important;
    margin-top: 32px;
}

.savings-total--summary {
    margin-bottom: 26px !important;
}

/* DATE PICKER */

.react-datepicker__day,
.react-datepicker__time-name {
    color: #444444 !important;
}

.react-datepicker-popper {
    width: 100% !important;
}

.react-datepicker,
.react-datepicker__month-container {
    width: calc(100% + 4px) !important;
    position: relative;
    left: -2px;
}

.react-datepicker {
    font-family: "Muli", sans-serif !important;
    font-size: 0.9rem !important;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
    line-height: 2.5rem !important;
}

.react-datepicker__header {
    background: none !important;
    border-bottom: 0 !important;
}

.react-datepicker__current-month {
    margin-bottom: 7px !important;
}

.react-datepicker {
    border: 1px solid #f4f4f4 !important;
    border: 1px solid var(--bgOffset) !important;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    border-bottom-color: #f4f4f4 !important;
    border-bottom-color: var(--bgOffset) !important;
}

.react-datepicker__navigation--previous {
    border-right-color: #000 !important;
}

.react-datepicker__navigation--next {
    border-left-color: #000 !important;
}

.react-datepicker__header {
    padding-top: 20px !important;
}

.react-datepicker__day-name {
    font-size: 12px !important;
    font-weight: 700 !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
    margin-top: 15px !important;
    line-height: 1rem !important;
}

.react-datepicker__day-name,
.react-datepicker__day:hover,
.react-datepicker__time-name {
    border-radius: 100px !important;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
    background: none !important;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range {
    border-radius: 100px !important;
    background: none !important;
}

.react-datepicker__navigation {
    outline: none !important;
}

.react-datepicker__day {
    position: relative !important;
    z-index: 2 !important;
}

.react-datepicker__day:before {
    background: #f4f4f4 !important;
    background: var(--bgOffset) !important;
    content: "" !important;
    position: absolute !important;
    width: 34px !important;
    height: 34px !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    border-radius: 100px !important;
    z-index: -1 !important;
    opacity: 0 !important;
}

.react-datepicker__day:hover:before {
    opacity: 1 !important;
}

.react-datepicker__day.react-datepicker__day--selected:before {
    opacity: 1 !important;
}

.react-datepicker__day.react-datepicker__day--selected:before {
    background: #48d38a !important;
    background: var(--successColor) !important;
}

.react-datepicker__navigation {
    top: 20px !important;
}

.react-datepicker__day--outside-month {
    opacity: 0.09 !important;
    pointer-events: none !important;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
    width: 13% !important;
}
.edit-savings--form {
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
}

.date-picker--field {
    z-index: 999;
}

.kuda-savings .kuda-card--wrap .card-main--heading+.card-main--subheading {
    margin-bottom: 32px;
    margin-top: -22px;
}

.single-fixed:last-child {
    margin-bottom: 44px;
}

.fixed-separator {
    justify-content: center !important;
    height: 75px !important;
    border-bottom: 0 !important;
    margin-bottom: -28px !important;
}

.fixed-summary {
    margin-top: -10px;
}

.kuda-card--progress {
    position: absolute;
    top: 0;
    height: 3px;
    left: 2.4px;
    background: #000000;
    background: var(--primaryColor);
    border-radius: 3px;
    display: flex;
    width: 10%;
    transition: width 1s;
    max-width: calc(100% - 2.4px);
}

.wrap-has--progress {
    position: relative;
}

/* ACCOUNT DROPDOWN */

.kuda-account--dropdown {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -50px;
    padding: 15px;
    background: #fff;
    box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.05);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    visibility: hidden;
    opacity: 0;
    cursor: pointer;
}

.kuda-account {
    position: relative;
    cursor: pointer;
    height: 70px;
}

li.kuda-account--item {
    text-align: center;
    cursor: pointer;
}

.kuda-account:hover .kuda-account--dropdown {
    bottom: -46px;
    visibility: visible;
    opacity: 1;
    transition: all 0.5s;
}

.form-loading {
    position: relative;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    opacity: 0.8;
    pointer-events: none;
}

.form-loading span {
    opacity: 0;
    visibility: hidden;
}

.kuda-cta span {
    pointer-events: none;
}

.form-loading:after {
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: 30px 30px;
}

.secondary-button.form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.secondary-button-no-border.form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
/******* KUDA ATM LAYOUT *******/

.kuda-atm--wrap {
    display: block;
    width: 100%;
    background: #40196D;
    border-radius: 10px;
    height: 172px;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
}

.black-strip {
    width: 100%;
    height: 30px;
    position: absolute;
    top: 25px;
    background-color: #0b0e00;
}

.kuda-atm--details {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: calc(100% - 55px);
    padding-top: 10px;
    padding-left: 15px;
}

.cvc-strip {
    height: 18px;
    background: linear-gradient(180deg, #b3b3b3 -21486%, #cdcdcd -15412.82%, #dfdfdf -9339.64%, #e6e6e6 -5072%);
    max-width: 132px;
    color: #000000;
    color: var(--primaryColor);
    font-size: 11px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding-top: 3px;
    font-weight: 700;
    padding-right: 5px;
}

.card-pin {
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    color: var(--whiteColor);
    margin-top: 9px;
    max-width: 146px;
}

.card-expiry {
    max-width: 144px;
    font-size: 12px;
    color: #ffffff;
    color: var(--whiteColor);
    font-weight: 700;
    display: flex;
    justify-content: flex-end;
    margin-top: 7px;
}

.valid-thru svg {
    height: calc(100% - 3px);
    width: auto;
    margin-right: 5px;
}

.valid-thru {
    display: block;
    width: 22px;
    margin-right: 5px;
}

.asterisks {
    margin-right: 6px;
}

.badge {
    padding: 3px 10px;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.badge.incomplete {
    color: #ffffff;
    color: var(--whiteAlt);
    background: #7ee1f6;
    border: 1px solid #1dcbef;
    max-height: 20px;
}

.badge.green {
    background: #dcffec;
    color: #48d38a;
}

.card-badge {
    background: #000000;
    background: var(--primaryColor);
    height: 99px;
    right: -22px;
    position: absolute;
    width: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(45deg);
    bottom: -40px;
}

.card-badge svg {
    transform: rotate(-45deg);
    position: relative;
    top: 1px;
    left: -12px;
    height: 11px;
    width: auto;
}

/******* CARD LIMITS *******/

.kuda-cards .percentage-save {
    margin-top: 30px;
    margin-bottom: 30px;
}

.set-card--Limit {
    margin-top: 42px;
}

.cards-inner--wrap {
    padding-left: 100px !important;
    padding-right: 100px !important;
}

.kuda-cards .kuda-cta-lg {
    max-width: 180px;
}

.channels-toggle .toggle-icon {
    width: 42px;
    height: 22px;
    margin-right: 34px;
}

.channels-toggle .toggle-icon:after {
    height: 14px;
    width: 14px;
}

.channels-toggle .toggle input[type="checkbox"]:checked+.toggle-icon:after {
    transform: translateX(20px);
}

.cards-inner--wrap .optional-title {
    position: relative;
    top: 5px;
    font-size: 1.06rem;
}

.channels-toggle {
    margin-top: 35px;
}

.channels-toggle toggle-icon,
.channels-toggle .toggle {
    width: auto;
}

.channels-toggle .toggle {
    display: flex;
    align-items: center;
}

.toggle-state {
    position: absolute;
    right: 0;
    font-weight: 700;
    font-size: 14px;
}

.mt-32 {
    margin-top: 32px;
}

.mt-40 {
    margin-top: 2.5rem;
}

.card-indicatior {
    position: absolute;
    right: -32px;
    top: -3px;
}

.card-indicatior svg {
    height: 18px;
    width: auto;
}

.activate--wrap .card-group {
    margin-top: 35px;
}

/****** PIN *******/

.instructions {
    max-width: 319px;
    margin-left: auto;
    margin-right: auto;
}

.instructions p {
    font-size: 0.95rem;
}

.default-pin--badge {
    background: #f9f9f9;
    background: var(--offWhite);
    border-radius: 4px;
    height: 73px;
    max-width: 238px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.default-pin--badge span {
    font-size: 30px;
    line-height: 28px;
    letter-spacing: 30px;
    width: 100%;
    color: #000000;
    color: var(--blackColor);
    text-align: center;
    margin-left: 30px;
}

.default-pin--badge {
    background: #f9f9f9;
    background: var(--offWhite);
    border-radius: 4px;
    height: 73px;
    max-width: 238px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.default-pin--badge span {
    font-size: 30px;
    line-height: 28px;
    letter-spacing: 30px;
    width: 100%;
    color: #000000;
    color: var(--blackColor);
    text-align: center;
    margin-left: 30px;
}

.activate--wrap+.addAction {
    margin-top: 52px !important;
}

.kuda-activate--wrap {
    padding-bottom: 75px !important;
}

.add-amount.pin {
    height: 48px;
    padding: 15px;
    font-weight: 600 !important;
}

.transaction-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.searchIcon {
    pointer-events: none;
}

.saving-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.saving-icon {
    height: 38px;
    width: 38px;
    border-radius: 100px;
    overflow: hidden;
}

.saving-details.text-right {
    min-width: 80px;
}

.kuda-entry.entry-top {
    position: relative;
    z-index: 1;
}

.kuda-entry .kuda-entry--wrap {
    opacity: 0;
    visibility: hidden;
}

.kuda-entry.kuda-page--transition .kuda-entry--wrap {
    opacity: 1;
    transition: opacity 1s;
    visibility: visible;
}

.kuda-page--loader {
    display: flex;
    justify-items: center;
    align-items: center;
    z-index: 9999;
}

.kuda-page--loader img,
.kuda-page--loader svg {
    width: 230px !important;
    height: auto !important;
    margin-left: 23px;
}

.kuda-loader {
    opacity: 1;
    visibility: visible;
    position: fixed;
    z-index: 9999999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    background-color: var(--whiteColor);
}

.kuda-page--transition .kuda-loader {
    display: none;
}

.kuda-loader:not(.payoneer-loader) path {
    fill: #000000 !important;
    fill: var(--primaryAlt) !important;
}

.save-title {
    width: auto !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    text-overflow: ellipsis !important;
    height: auto;
    line-height: 1.2;
}

.transaction-additional--details .save-title {
    font-size: 0.875rem;
    margin-bottom: 5px !important;
}

.summary-card>div:last-child .saving-details:not(.text-right) {
    width: auto !important;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    padding-right: 10px;
}

.transaction-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.closeModal {
    cursor: pointer;
    position: absolute;
    top: 17px;
    left: 17px;
}

.closeModal.align-right {
    right: 17px;
    left: auto;
    left: initial;
}

.inactivity-buttons .kuda-cta-lg {
    max-width: 166px;
}

.kuda-account--wrap {
    max-width: 890px !important;
    padding: 45px 61px !important;
    margin-left: -98px;
    margin-right: -98px;
}

.kuda-user--wrap {
    max-width: 752px !important;
    padding: 45px 61px !important;
    margin-left: auto;
    margin-right: auto;
}

.kuda-limit--pad {
    padding-left: 26px;
    padding-right: 26px;
    padding-bottom: 26px;
}

/* BLOCK ITEM */

.block-item-wrap {
    display: flex;
    align-items: center;
}

.block-item {
    background: #ffffff;
    background: var(--whiteColor);
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 10px 25px;
    position: relative;
}

.status-icon {
    /* width: 20px;
  height: 20px; */
    /* background: #ffc83e; */
    position: absolute;
    /* border-radius: 50%; */
    right: -1%;
    top: -8%;
    /* font-size: 14px; */
}

.block-item.onboarding-item {
    border: 1px solid rgba(219, 220, 224, 0.5);
}

.block-item:not(:last-child) {
    margin-bottom: 15px;
}

.block-item--icon {
    min-width: 30px;
    margin-right: 15px;
}

.kuda-block--navWrapper {
    display: flex;
    justify-content: space-between;
}

.kuda-block--nav {
    width: calc(50% - 25px);
}

.block-item-wrap {
    font-size: 0.9rem;
}

/***** ACCOUNT IMAGE *****/

.account-image {
    width: 95px;
    height: 95px;
    min-width: 95px;
    min-height: 95px;
    border-radius: 100px;
    position: relative;
    background-size: cover !important;
    background-position: top;
    background: #ffffff;
    background: var(--whiteAlt);
    /* border: 1px solid #411a6e; */
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e8e8e8;
}

.account-image>div {
    width: 100%;
    height: 100%;
    /* min-width: 100px;
  min-height: 100px; */
    display: flex;
    border-radius: 100px;
    position: relative;
    background-size: cover;
    background-position: top;
    background: #000000;
    background: var(--primaryAlt);
    color: #ffffff;
    color: var(--whiteAlt);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 39px;
}

#edit-item {
    position: absolute;
    left: auto;
    right: 12px;
    bottom: -10px;
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 100px;
    margin-left: 15px;
    cursor: pointer;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08) !important;
}

.account-image img {
    border-radius: 100px;
    width: 100%;
    height: 100%;
    object-fit: fill;
}

.kuda-account--summary {
    margin-bottom: 36px;
}

.edit-item {
    /* position: absolute; */
    /* left: auto;
  right: 12px;
  bottom: -10px; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-left: 15px; */
    cursor: pointer;
    /* -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08) !important; */
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08) !important; */
}

.sme-info--card {
    background: #ffffff;
    border: 1px solid #dfe3ff;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    max-width: 100%;
    margin: 0 auto 50px;
    padding: 20px 40px;
}

.company-profile {
    max-width: 752px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;

}
.sme-info--card>ul {
    width: 50%;
}

.vertical-divider {
    width: 1px;
    opacity: 0.2;
    border-right: 1px solid #000000;
    margin: 0px 32px;
}

.sme-info--card ul li {
    font-size: 13px;
}

.sme-info--card ul li:not(:last-child) {
    margin-bottom: 15px;
}

.edit-item svg {
    width: 24px;
    height: 24px;
}

.profile-account {
    display: flex;
    align-items: center;
    /* width: 50%; */
    margin: auto;
    margin-bottom: 20px;
}

.profile-account.md {
    width: 50%;
}

.kuda-account--summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.kuda-account--summary>div {
    width: calc(50% - 23px);
}

.kuda-account--summary---lg>div {
    width: auto !important;
    margin-bottom: 0;
}

.copy-account {
    margin-top: 10px;
}

.copy-account p {
    margin-top: 7px;
    display: flex;
}

.summary-labels .text-sm {
    font-size: 0.78rem;
}

.kuda-tier--holder {
    display: inline-flex;
    align-items: center;
}

.summary-labels {
    width: 100%;
    position: relative;
    margin-left: 23px;
    padding-top: 4px;
}

.summary-labels h1 {
    line-height: 1.3;
    display: flex;
    align-items: center;
    position: relative;
}

.kuda-tier--holder span {
    display: inline-flex;
}

.account-name {
    font-size: 1.25rem;
    /* width: 100%; */
    margin-right: 0.5rem;
}

.kuda-share--earn {
    display: flex;
    background: #000000;
    background: var(--primaryColor);
    align-items: center;
    padding: 22px 27px 25px;
    justify-content: space-between;
    border-radius: 4px;
}

.earn-heading {
    font-size: 1.1rem;
    margin-bottom: 8px;
}

.kuda-invite--cta {
    background: #48d38a;
    background: var(--successColor);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    height: 20px;
    color: #000000;
    color: var(--primaryColor);
    width: 112px;
}

.text-mxs {
    font-size: 0.6875rem;
}

.share-earn--50 {
    width: calc(55% - 7px);
}

.share-earn--100 {
    width: 100%;
}

.earn-denominator {
    font-size: 1rem;
    position: relative;
    top: 4px;
    margin-right: 3px;
}

.earnings {
    display: flex;
    align-items: flex-start;
    font-weight: 800;
    font-size: 2.1rem;
}

.tier-value {
    margin-left: 2px;
}

.kuda-menu--text.active {
    color: #000000 !important;
    color: var(--primaryColor) !important;
}

/******* KUDA PROFILE PAGE *******/

.kuda-profile--center {
    max-width: 325px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 40px;
}

.kuda-profile--form .profile-block {
    margin-bottom: 40px;
}

.no-border {
    border: none;
}

.no-border .hasImage {
    padding: 0;
}

.is-iframe {
    max-width: 435px !important;
    background: none;
    padding: 0;
    border: 0;
    box-shadow: none;
}

.Toaster__alert {
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 30px 40px rgba(64, 25, 109, 0.07) !important;
    box-shadow: 0px 30px 40px var(--boxShadow) !important;
    border-radius: 5px;
    padding: 15px 30px 15px 25px !important;
    max-width: 480px !important;
    margin-left: auto;
    margin-right: auto;
}

.Toaster__manager-bottom {
    bottom: 45px !important;
}

.Toaster__alert_text {
    font-size: 14px;
}

.Toaster__alert_close {
    top: 48% !important;
    transform: translateY(-50%);
    font-size: 1.4rem !important;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    color: #000000 !important;
    color: var(--primaryColor) !important;
    opacity: 1 !important;
}

.Toaster__message-wrapper {
    width: 100%;
    padding: 0 14px !important;
}

.Toaster__manager-top-right{
    top: 101px !important;
    right: 20px !important;
}
/***** EDIT BUTTON *****/

.edit-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 13px;
    background: #000000;
    background: var(--primaryColor);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    height: 26px;
    width: 49px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
}

/******* SECONDARY BUTTON  *****/

.secondary-button {
    /* border: 1px solid var(--primaryColor) !important; */
    border: 1px solid #000000 !important;
    color: #000000 !important;
    color: var(--primaryColor) !important;
    background-color: #f9f9f9 !important;
    background-color: var(--buttonBackgroundColor) !important;
}

.secondary-button-updated {
    border: 1px solid #000000;
    color: #000000 !important;
    color: var(--primaryColor) !important;
    background-color: #f9f9f9 !important;
}

.profile-block .amount-input {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 75px;
}

.empty-summary {
    margin-top: 53px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.empty-heading {
    margin-top: 22px;
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: 900;
}

.payButton {
    display: none;
}

iframe {
    background: none !important;
}

.loading {
    position: relative;
    align-items: center;
    justify-content: center;
}

.loading:after {
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    animation: spin 1s linear infinite;
    display: flex;
    content: "";
    align-items: center;
    justify-content: center;
    margin: auto;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
    }
}

.kuda-dropdown-list {
    max-height: 381px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-top: 56px;
}

.kuda-dropdown-list.no-search {
    padding-top: 20px !important;
}

.kuda-budget--illustration {
    margin-bottom: 25px;
    margin-top: 37px;
}

.budget-response {
    margin-bottom: -0.5rem;
}

.backdrop-init .modal-backdrop {
    visibility: visible;
}

.kuda-duration--summary p {
    font-size: 0.8rem;
}

.kuda-duration--summary {
    margin: -5px auto 45px;
}

.react-datepicker__day--disabled {
    opacity: 0.2;
    pointer-events: none;
}

.react-datepicker__day.react-datepicker__day--selected {
    color: #fff !important;
}

.summary-naira--icon .denomination-icon svg {
    height: 13px;
    margin-right: 2px;
}

.summary-naira--icon .denomination-icon svg path {
    fill: #000000 !important;
    fill: var(--blackColor) !important;
}

.noTransaction {
    margin-bottom: 0 !important;
}

.noTransaction .review-summary.card-fields>div:last-child {
    margin-bottom: 10px !important;
}

.hasTransaction {
    margin-bottom: 25px !important;
}

.single-savings .singleTransaction .transaction-price {
    margin-right: 0 !important;
    top: 1.5px !important;
}

.single-savings .kuda-personalize--card+.flexible-summary {
    margin-top: 22px !important;
}

.kuda-skeleton--loader .card-fields>div {
    border-bottom: 0;
}

.kuda-skeleton--loader .card-text {
    width: 50%;
}

.white-cta.form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.kuda-dark--theme .white-cta.form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

#react-toast .Toaster__alert_text {
    font-family: "Muli", sans-serif !important;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: left !important;
}

.locked svg {
    height: 19px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
    width: auto;
    fill: #979797;
    fill: var(--textColor);
}

.edit-savings--form input {
    cursor: default;
}

.single-savings .kuda-transaction--details {
    min-height: 100% !important;
    height: auto !important;
    align-items: flex-start;
}

.single-savings .transaction-date {
    margin-top: 8px;
}

.single-savings .transaction-name {
    line-height: 1.4;
    margin-top: -0.5px;
    padding-right: 25px;
}

.percentageSave-wrap {
    margin-top: 38px;
}

.transaction-avatar.hasImage {
    padding: 0;
}

.backdrop-init {
    overflow: hidden;
}

.empty-text {
    max-width: 306px;
    text-align: center;
}

.empty-savings--card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-radius: 5px;
    margin-top: 25px;
    max-width: 490px;
    margin-left: auto;
    margin-right: auto;
}

.empty-savings--card .empty-summary {
    margin-top: 30px;
    padding-bottom: 48px;
}

.empty-savings--card .empty-illustration {
    margin-top: 60px;
    margin-bottom: 44px;
}

.empty-text .card-main-subheading {
    color: rgba(0, 0, 0, 0.5);
    color: var(--offText);
}

.kuda-set--status {
    opacity: 0.2;
    pointer-events: none;
}

.kuda-activate--badge {
    max-width: 185px;
    margin-top: 20px;
    font-size: 13px;
    height: 30px;
    border-radius: 5px;
}

.kuda-payment--wrap .react-tabs__tab-panel--selected {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
}

.card-subheading--boxed {
    margin-top: 15px;
    max-width: 319px;
    line-height: 1.4;
    color: #333333 !important;
}

.card-subheading--boxed-lg {
    max-width: 350px;
}

.kuda-edit--layout {
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
}

.edit-account--wrap {
    margin-top: 35px;
}

.saveFields {
    margin-top: 53px;
    margin-bottom: 20px;
}

.boxed-width {
    max-width: 340px;
}

.phone-placeholder {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    color: #000000;
    color: var(--blackColor);
    font-weight: 600;
    pointer-events: none;
}

.edit-phone {
    padding-left: 65px;
}

.kuda-split--wrap {
    display: flex;
    justify-content: space-between;
}

.kuda-split--wrap>div {
    width: calc(50% - 6px);
}

.kuda-select--radio {
    width: 100%;
    display: flex;
    height: 46px;
    justify-content: space-between;
    margin-top: 17px;
}

.radio-select--lg {
    max-width: 306px;
    background: #ffffff;
    padding: 11px 0px !important;
}

.radio-select--lg input {
    display: none;
}

/* RADIO SELECT LARGE */

.radio-select--lg input:not(:checked)+label {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    color: #000000;
    color: var(--blackColor);
}

.radio-select--lg label {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding-left: 40px;
    position: relative;
    color: #48d38a;
    color: var(--successColor);
    font-weight: 600;
    cursor: pointer;
}

.radio-select--lg input:not(:checked)+label .outer {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
    border: 1px solid #ffffff;
    border: 1px solid var(--whiteAlt);
}

.radio-select--lg .outer {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background-color: #000000;
    background-color: var(--primaryAlt);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: -7px !important;
}

.radio-select--lg .inner {
    width: 22px;
    height: 22px;
    border-radius: 100px;
    background-color: white;
    position: absolute;
    border: 2px solid #000000;
}

/* RADIO SELECT OUTLINE */

.radio-select--outline {
    max-width: 186px;
    background: #ffffff;
    padding: 11px 0px !important;
    border: 1px solid #dcffec;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.radio-select--outline input {
    display: none;
}

.radio-select--outline input:not(:checked)+label {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    color: #000000;
    color: var(--blackColor);
}

.radio-select--outline label {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 50px;
    position: relative;
    color: #48d38a;
    color: var(--successColor);
    font-weight: 600;
    cursor: pointer;
}

.radio-select--outline input:not(:checked)+label .outer {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
    border: 1px solid #ffffff;
    border: 1px solid var(--whiteAlt);
}

.radio-select--outline .outer {
    width: 17.1px;
    height: 17.1px;
    border-radius: 100px;
    background-color: #000000;
    background-color: var(--primaryAlt);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    /* left: -7px !important; */
}

.radio-select--outline .inner {
    width: 17.1px;
    height: 17.1px;
    border-radius: 100px;
    background-color: white;
    position: absolute;
    border: 1px solid #48d38a;
}

.kuda-radio--wrapper {
    display: flex;
    width: calc(50% - 30px);
}

.kuda-radio--column {
    flex-direction: column;
    height: auto;
}

.radio-height--md {
    height: 45px;
    width: 186px;
    max-width: 186px;
}

.new-account--wrap .outer {
    left: 0px !important;
}

.new-account--wrap label .column-100 {
    width: 100% !important;
}

.kuda-radio--lgWrap,
.business-radio--wrap {
    width: 391px;
    padding: 11px 15px !important;
}

.kuda-radio--smWrap {
    width: fit-content;
    padding: 11px 0px !important;
}

.kuda-radio--lgWrap input {
    display: none;
}

.kuda-radio--lgWrap label {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 35px;
    position: relative;
    color: #48d38a;
    color: var(--successColor);
    font-weight: 600;
    cursor: pointer;
}

.kuda-radio--lgWrap .outer {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background-color: #ffffff;
    background-color: var(--whiteAlt);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 16px;
}

.kuda-radio--account {
    display: flex;
}

.kuda-radio--account label {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 35px;
    position: relative;
    color: #48d38a;
    color: var(--successColor);
    font-weight: 600;
    cursor: pointer;
}

.kuda-radio--account input {
    display: none;
}

.outer-business {
    width: 13px;
    height: 13px;
    border-radius: 100px;
    background-color: #48d38a;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0px;
    border: 1px solid #48d38a;
}

.inner-business {
    width: 16px;
    height: 16px;
    border-radius: 100px;
    background-color: #48d38a;
    position: absolute;
}

.inner-business,
.outer-business {
    border-radius: 100px;
    position: absolute;
}

.kuda-radio--account input:not(:checked)+label {
    /* background-color: var(--whiteColor) !important; */
    color: #000000;
    color: var(--blackColor);
}

.kuda-radio--account input:not(:checked)+label .outer-business {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    border: 1px solid #48d38a;
    border: 1px solid var(--successColor);
}

.kuda-radio--account input:not(:checked)+label .inner-business {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    border: 1px solid #48d38a;
    border: 1px solid var(--successColor);
}

.kuda-radio--smWrap .outer-green {
    width: 13px;
    height: 13px;
    border-radius: 100px;
    background-color: #ffffff;
    background-color: var(--whiteAlt);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 16px;
}

.outer-start {
    left: 0px !important;
}

.kuda-radio--lgWrap .inner-green {
    width: 10px;
    height: 10px;
    background-color: #48d38a !important;
    position: absolute;
    border: 1px solid #48d38a !important;
}

.kuda-radio--lgWrap input:checked+label .outer .inner {
    width: 16px;
    height: 16px;
    border-radius: 100px;
    background: #48d38a;
    border: 1px solid #48d38a;
    position: absolute;
}

.kuda-radio--lgWrap input:not(:checked)+label {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    color: #000000;
    color: var(--blackColor);
}

.kuda-radio--lgWrap input:not(:checked)+label .outer {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
    border: 1px solid #ffffff;
    border: 1px solid var(--whiteAlt);
}

.kuda-radio--lgWrap input:not(:checked)+label .outer .inner {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
    border: 1px solid #48d38a;
}

.account-avatar-sm {
    background: #000000;
    background: var(--primaryAlt);
    border-radius: 100px;
    min-width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-account--btn {
    background: #DBDCE0 !important;
}

.account-avatar-sm svg {
    width: 50px;
    height: 50px;
}

.kuda-select--radio.justify-content-end {
    justify-content: initial !important;
}

.kuda-radio--wrapper label {
    height: 100%;
    width: 100%;
    background: #dcffec;
    background: var(--successColorTrans);
    border: 1px solid #dcffec;
    border: 1px solid var(--successColorTrans);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 55px;
    position: relative;
    color: #48d38a;
    color: var(--successColor);
    font-weight: 600;
    cursor: pointer;
}

.kuda-radio--wrapper label.font-weight-400 {
    font-weight: 400;
}

.kuda-radio--wrapper input {
    display: none;
}

.outer {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background-color: #48d38a;
    background-color: var(--successColor);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 16px;
}

.outer-small {
    width: 18px;
    height: 18px;
}

.inner {
    width: 10px;
    height: 10px;
    border-radius: 100px;
    background-color: #ffffff;
    background-color: var(--whiteColor);
    position: absolute;
}

.kuda-radio--wrapper input:not(:checked)+label {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    color: #000000;
    color: var(--blackColor);
}

.kuda-radio--wrapper input:not(:checked)+label .outer {
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    border: 1px solid #48d38a;
    border: 1px solid var(--successColor);
}

.limit-fields .card-type,
.limit-fields .card-text {
    font-size: 0.9375rem;
}

.limit-fields>div {
    height: 50px;
}

.limit-fields {
    margin-top: 19px;
}

.limit-fields>div:first-child {
    border-top: 1px solid rgba(219, 220, 224, 0.3);
    border-top: 1px solid var(--offWhiteTrans);
}

.kuda-limit--item:not(:first-of-type) {
    margin-top: 30px;
}

.kuda-inline--button {
    font-weight: bold;
    font-size: 0.9375rem;
    text-align: center;
    text-decoration-line: underline;
    color: #000000;
    color: var(--primaryColor);
}

.top-spacing {
    margin-top: 47px;
}

.top-spacing--md {
    margin-top: 35px;
}

.increase-limit {
    margin-top: 56px;
    background: #000000;
    background: var(--primaryColor);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(0, 0, 0, 0.35);
    box-shadow: 15px 30px 40px var(--overlay);
    border-radius: 10px;
    padding: 30px 72px;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

.increase-limit h1 {
    display: inline-flex;
}

.cta-boxed--btn {
    background: #dfe3ff;
    border-radius: 10px;
}

.kuda-cta--open {
    margin-top: 20px;
}

.cta-boxed--btn>span {
    display: flex;
    align-items: center;
}

.cta-separator {
    margin-left: 11px;
}

.referral-icon {
    display: flex;
    justify-content: center;
}

.share-header--wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 47px;
    margin-bottom: 35px;
}

.share-header--wrap>div {
    width: calc(50% - 24px);
}

.share-header {
    margin-bottom: 14px;
}

.invite-requirements {
    margin: 23px 0;
}

ul.invite-requirements li {
    margin: 9px 0;
}

.kuda-share--earnAlt {
    margin-top: 20px;
    background: #F4F4F4;
    background: var(--offBlue);
}

.referral-entry .earn-status {
    margin-bottom: 12px !important;
}

.referral-entry>div {
    justify-content: space-between;
    align-items: center;
}

.share-items {
    margin-bottom: 12px;
}

.share-icon {
    margin-left: 20px;
}

.share-icon:first-child {
    margin-left: 0;
}

.kuda-cta-full {
    max-width: 100%;
    margin-bottom: 44px;
}

.kuda-referral--card .empty-savings--card {
    max-width: 555px;
    border: 1px solid #dfe3ff;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
}

.kuda-referral--card .empty-summary {
    margin-top: 38px;
    padding-bottom: 70px;
}

.kuda-referral--card .empty-illustration {
    margin-top: 40px;
    margin-bottom: 35px;
}

.kuda-referral--card .kuda-result--item {
    width: calc(100% - 40px);
}

.kuda-referral--card .kuda-transaction--details {
    height: auto;
}

.referral-summary {
    padding-left: 110px;
    padding-right: 110px;
}

.referral-summary .transaction-title {
    margin-left: 0;
}

.kuda-result--heading {
    padding-left: 20px;
    padding-right: 20px;
}

.referral-summary .kuda-result--heading {
    margin-top: -1px;
}

.referral-friends--heading {
    margin-bottom: 33px;
}

.panel__label {
    width: 100%;
    text-align: left;
    padding: 0;
    font-weight: 900;
    cursor: pointer;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
}

.panel__content {
    padding-bottom: 25px;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
}

.panel[aria-expanded="true"] .panel__content {
    opacity: 1;
    transition: opacity 0.8s, max-height 2s;
    max-height: 100vh;
    white-space: pre-line;
}

.panel__label svg {
    transition: all 0.4s;
}

.panel[aria-expanded="true"] .panel__label svg {
    transform: rotate(90deg);
}

.accordion {
    max-width: 456px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 50px;
}

.accordion-two {
    background-color: #fff;
    color: #444;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border-bottom: 1px solid #ddd !important;
    text-align: left;
    outline: none;
    font-size: 15px;
    transition: 0.4s;
    border: none;
}

.accordion-two:after {
    content: "\\002B";
    color: #777;
    font-weight: bold;
    float: right;
    margin-left: 5px;
}

.accordion-active:after {
    content: "\\2212";
}

.accordion-panel {
    padding: 0 18px;
    background-color: white;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
}

.accordion-grey {
    background-color: #fff;
    color: #444;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border-bottom: 1px solid #ddd !important;
    text-align: left;
    outline: none;
    font-size: 13px;
    transition: 0.4s;
    border: none;
}

.sign-out {
    margin-top: 56px;
    margin-bottom: 15px;
}

.signup-form--wrap {
    max-width: 359px;
    width: 100%;
}

.signup-form--wrap.lg {
    max-width: 400px;
}

.isMigrated-wrap {
    width: 241px;
}

.signup-form--md {
    max-width: 420px;
}

.auth-header--full {
    max-width: 100% !important;
}

.auth-header--md {
    max-width: 285px;
    font-weight: 800 !important;
}

.auth-header--lg {
    max-width: 338px;
    font-weight: 800 !important;
}

.confirm-otp--form .transaction-pin {
    max-width: 268px !important;
    margin-top: 30px;
    margin-bottom: 45px;
    width: 100%
}

.confirm-otp--form .transaction-pin input {
    max-width: 49px !important;
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.next-step--checker {
    display: flex;
    justify-content: space-evenly;
    /* max-width: 132px; */
    align-items: center;
    height: fit-content;
    margin-right: 0px;
    margin-top: 5px;
}

.next-step--checker span {
    color: #000000;
    opacity: 0.5;
    font-size: 15px;
}

.step-count--circle {
    width: 11px;
    height: 11px;
    background: #eff1ff;
    border-radius: 50%;
    /* transform: rotate(-90deg); */
    margin-right: 13.6px;
}

.page-icon {
    margin-top: 5rem;
}

.password-set--message {
    max-width: 300px;
    margin: 1rem auto;
    color: #000000;
}

.card-modal-success-message p{
        width: 335px;
        max-width: 100%;
        margin: 1rem auto;
        color: #000000;
        font-size: 0.9375rem;
}

.new-account--wrap {
    /* max-width: 391px; */
    max-width: 100%;
    background: #ffffff;
    border: 1px solid rgba(219, 220, 224, 0.5);
    border-radius: 5px;
    padding: 11px 19px;
    min-height: 51px;
    display: flex;
    align-items: center;
    width: 100% !important;
    margin-top: 17px !important;
}

.add-btn {
    width: 50px;
    height: 50px;
    background: #dfe3ff;
    border-radius: 50%;
    padding: 12px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.kuda-radio--lg {
    display: flex;
}

.text-red {
    color: #f7685b !important;
    color: var(--negativeColor) !important;
}

.request-wrap {
    display: flex;
    justify-content: center;
}

.request-text {
    margin-top: 30px;
    margin-bottom: 32px;
}

.kuda-request--wrap.animated {
    padding-bottom: 4

    8px !important;
}

.deliver-wrap {
    padding-left: 55px !important;
    padding-right: 55px !important;
}

.deliver-wrap .saveFields {
    margin-top: 45px;
    margin-bottom: 0;
}

.no-plus:before {
    content: none;
}

.kuda-activate--wrap h1 {
    margin-bottom: 30px;
}

.kuda-activate--wrap .request-text {
    max-width: 290px;
    margin-left: auto;
    margin-right: auto;
}

.hasErrorMessage .message {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
}

.hasErrorMessage {
    position: relative;
}

.card-group .message {
    opacity: 0;
    transition: opacity 1s;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.hasErrorMessage .message {
    animation-name: fadeIn;
    animation-duration: 1s;
    animation-fill-mode: both;
}

.kuda-request--wrap {
    padding-left: 70px !important;
    padding-right: 70px !important;
}

.request-edge--fix>div {
    margin-left: -70px;
    margin-right: -70px;
    padding-left: 70px;
    padding-right: 70px;
}

.request-edge--fix .card-text {
    right: 70px;
}

.panel__label span {
    line-height: 1.35;
}

.block-spacer {
    margin-bottom: 35px;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
}

.block-buttons .addAction {
    margin-bottom: 0;
}

.notice-modal {
    max-width: 420px !important;
}

.card-blocked .kuda-atm--wrap {
    background: #f7685b;
    background: var(--negativeColor);
}

.bill-item {
    cursor: pointer;
}

.blocked {
    opacity: 0.2;
    pointer-events: none;
}

.bill-item.form-loading span {
    opacity: 1;
    display: block;
    visibility: visible !important;
}

.bill-item.form-loading {
    justify-content: space-between !important;
}

.bill-item .form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    right: -7px;
}

.kuda-dark--theme .bill-item .form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    right: -7px;
}

.bill-item * {
    pointer-events: none;
}

.redUnblock {
    border-color: #f7685b;
    border-color: var(--negativeColor);
}

.deactivate-card {
    position: relative;
    margin-top: 25px;
    height: 24px;
    align-items: center;
    justify-content: center;
    background: #f7685b;
    background: var(--negativeColor);
    border-radius: 4px;
    color: #fff;
    padding-left: 16px;
    padding-right: 16px;
    font-size: 0.75rem;
    cursor: pointer;
    display: inline-flex;
    left: 50%;
    transform: translateX(-50%);
}

.sign-out span {
    cursor: pointer;
}

a.link {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.error-message {
    max-width: 300px;
}

.subscribe-message {
    max-width: 250px !important;
    display: flex;
    margin-left: auto;
    margin-right: auto;
}

.spinner-wrap {
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
    padding: 7px;
    background: #fff;
    border-radius: 100px;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    z-index: 1;
}
.open-api-table-spinner-wrap {
    position: static !important;
}

.table-spinner--wrap {
    position: relative;
    top: auto;
    top: initial;
    left: auto;
    left: initial;
    transform: none;
    transform: initial;
    padding: 0px;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border: none;
    z-index: auto;
    z-index: initial;
}

.loader-inner .spinner-wrap {
    position: relative;
    background: inherit;
    box-shadow: none;
    top: auto;
    top: initial;
    left: auto;
    left: initial;
    transform: none;
}

.spinner {
    width: 22px;
    height: 22px;
    display: block;
    color: #000000;
    color: var(--primaryColor);
}

.table-spinner {
    color: #48d38a !important;
}

/* .table-spinner:after {
  border: 4px solid currentColor;
} */

.spinner:after {
    content: "";
    width: 100%;
    height: 100%;
    display: inline-block;
    border: 2px solid currentColor;
    border-bottom-color: transparent;
    border-radius: 100%;
    background: transparent;
    animation: rotate 0.75s linear infinite;
}

@keyframes rotate {
    100% {
        transform: rotate(359deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 250;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
    }

    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -140;
    }
}

.reloadActive {
    pointer-events: none;
}

.margin-bottom--spacer-sm {
    margin-bottom: 23px;
}

.single-timeline h3 {
    font-size: 0.9375rem;
}

.single-timeline p {
    font-size: 0.8rem;
}

.single-timeline {
    margin-bottom: 40px;
}

.request-timeline {
    position: relative;
    margin-top: 32px;
}

.timeline-wrap {
    height: calc(100% - 35px);
    display: block;
    position: absolute;
    width: 1px;
    border-left: 1px dashed #DBDCE0;
    top: 50%;
    transform: translateY(-50%);
    left: 7px;
}

.timeline-items {
    margin-left: 40px;
}

.timeline-items:last-child .single-timeline {
    margin-bottom: 0;
}

.timeline-items {
    position: relative;
}

.timeline-items:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.timeline-disabled:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.timeline-items:before {
    content: "";
    height: 24px;
    width: 24px;
    background-size: 23px;
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    top: -1px;
    left: -44px;
    position: absolute;
    background-color: #ffffff;
    background-color: var(--whiteColor);
    z-index: 9;
    border-radius: 100px;
}

.timeline-disabled .single-timeline {
    opacity: 0.3;
}

.copy-icon svg {
    height: 100%;
}

.inputLoading {
    position: relative;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center;
    opacity: 0.8;
    pointer-events: none;
}

.inputLoadingSpaced {
    justify-content: space-between !important;
}

.dropdown-border--error {
    box-shadow: none;
    border: 1px solid #f7685b;
    border: 1px solid var(--negativeColor);
}

.inputLoading {
    pointer-events: none;
}

.inputLoading:after {
    position: absolute;
    content: "";
    width: 26px;
    height: 26px;
    display: inline-block;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: 26px 26px;
    right: 15px;
    z-index: 33;
}

.kuda-dark--theme .inputLoading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.error-field {
    border: 1px solid #f7685b !important;
    border: 1px solid var(--negativeColor) !important;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
    border-radius: 5px;
}

.addNewIcon {
    margin-right: 17px;
}

.addNewIcon svg {
    min-width: 24px;
    min-height: 24px;
}

.beneficiary-wrap {
    color: #48d38a;
    color: var(--successColor);
    padding: 7px 17px;
    display: inline-flex;
    background: #dcffec;
    background: var(--successColorTrans);
    font-weight: 700;
    border-radius: 5px;
}

.kuda-beneficiary--name {
    display: flex;
    justify-content: center;
    margin-bottom: -15px;
}

.otp-input input {
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background: #ffffff !important;
    background: var(--whiteColor) !important;
    max-width: 49px;
    height: 46px !important;
}

.otp-input {
    max-width: 220px;
}

.resendCode {
    text-align: center;
    color: #000000;
    color: var(--blackColor);
}

.resendCode span {
    font-weight: 900;
}

.mobile-header--wrap {
    display: none !important;
}

.desktop-header .kuda-menu--text {
    display: flex;
    align-items: center;
    height: 100%;
}

.transaction-additional--details .kuda-dropdown-header {
    height: auto;
}

.transaction-additional--details .kuda-dropdown-title {
    line-height: 1.5;
    font-weight: 800;
    width: 100%;
    padding-left: 0;
    padding-right: 9px;
}

.transaction-additional--details .kuda-dropdown-icon {
    width: auto;
}

.transaction-additional--details .kuda-dropdown-icon svg {
    width: 10px;
    height: auto;
    position: relative;
    top: 2px;
}

.transaction-right .kuda-dropdown-list {
    width: auto;
    left: auto;
    right: 0;
    min-width: 190px;
    max-height: 260px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.transaction-additional--details .kuda-dropdown-item {
    padding: 10px 0;
}

.transaction-additional--details .dropdown-item--title {
    font-size: 0.8rem;
}

.transaction-additional--details .avatar-wrap {
    margin-right: 13px;
}

.kuda-nav--icon p {
    cursor: pointer;
}
 .kuda-menu--text {
    white-space: nowrap;
}

.kuda-entry {
    /* overflow: hidden; */
    -webkit-overflow-scrolling: touch;
    height: 100%;
}

.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #000000;
    width: 120px;
    height: 120px;
    /* Safari */
    animation: spin 2s linear infinite;
}

/* Safari */

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.transaction-additional--details p {
    font-size: 0.9375rem;
}

.modal-transactions .modal-content {
    max-width: 517px;
    background-color: #ffffff;
    background-color: var(--whiteAlt);
}

.modal {
    /* position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; */
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

}

.modal-main {
    position: fixed;
    background: white;
    width: 80%;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.display-block {
    display: block;
}

.display-none {
    display: none;
}

.loanAction {
    background: #1dcbef;
    opacity: 0.4;
}

@keyframes blink {

    /**
       * At the start of the animation the dot
       * has an opacity of .2
       */
    0% {
        opacity: 0.2;
    }

    /**
       * At 20% the dot is fully visible and
       * then fades out slowly
       */
    20% {
        opacity: 1;
    }

    /**
       * Until it reaches an opacity of .2 and
       * the animation can start again
       */
    100% {
        opacity: 0.2;
    }
}

.savings-dot span {
    /**
       * Use the blink animation, which is defined above
       */
    animation-name: blink;
    /**
       * The animation should take 1.2 seconds
       */
    animation-duration: 1.2s;
    /**
       * It will repeat itself forever
       */
    animation-iteration-count: infinite;
    /**
       * This makes sure that the starting style (opacity: .2)
       * of the animation is applied before the animation starts.
       * Otherwise we would see a short flash or would have
       * to set the default styling of the dots to the same
       * as the animation. Same applies for the ending styles.
       */
    animation-fill-mode: both;
}

.savings-dot span:nth-child(2) {
    /**
       * Starts the animation of the third dot
       * with a delay of .2s, otherwise all dots
       * would animate at the same time
       */
    animation-delay: 0.2s;
}

.savings-dot span:nth-child(3) {
    /**
       * Starts the animation of the third dot
       * with a delay of .4s, otherwise all dots
       * would animate at the same time
       */
    animation-delay: 0.4s;
}

.copy span,
.copy svg {
    cursor: copy;
}

.kuda-account--no {
    margin-left: 10px;
}

.no-network .kuda-page--loader {
    display: none;
}

.beneficairy-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 35px;
}

.beneficairy-wrap .toggle-init {
    position: relative;
    left: -20px;
    top: -6px;
}

.beneficairy-wrap .card-main--heading {
    font-size: 1rem;
    color: #000000;
    color: var(--blackColor);
}

.beneficiary-wrap--form {
    margin-top: 25px;
}

.savedCard {
    position: relative;
}

.kuda-form--cards {
    max-width: 100%;
}

.savedIllustration img {
    width: 100%;
    position: relative;
    top: 9px;
}

.savedCards {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}

.savedCard {
    width: calc(50% - 22px);
    margin-bottom: 45px;
}

.savedCard img {
    border-radius: 12px;
}

.empty-card--icon {
    margin-bottom: 36px;
}

.empty-cards {
    max-width: 301px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    min-height: 340px;
}

.kuda-savedCard--items {
    position: absolute;
    bottom: 0;
    padding: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.kuda-savedCard--items p {
    font-size: 0.925rem;
}

.kuda-savedCard--items svg {
    width: auto;
    max-height: 40px;
    margin-left: auto;
    min-height: 21px;
}

.kuda-savedCard--items .no-avatar {
    overflow: visible;
    position: absolute;
    bottom: 5px;
    right: 21px;
    width: auto;
}

.kuda-card--cvc {
    position: absolute;
    top: calc(50% - 10px);
    left: 50%;
    width: calc(100% - 41px);
    display: flex;
    justify-content: space-between;
    transform: translate(-50%, -50%);
}

.savedIllustration {
    background: linear-gradient(292.01deg, rgba(219, 220, 224, 0.3) 12.33%, #ffffff 91.26%);
    background: linear-gradient(292.01deg, var(--offWhiteTrans) 12.33%, var(--whiteColor) 91.26%);
    border: 1px solid rgba(219, 220, 224, 0.3);
    border: 1px solid var(--offWhiteTrans);
    box-shadow: 2px 11px 22px rgba(64, 25, 109, 0.1);
    border-radius: 12px;
    overflow: hidden;
}

.kuda-card--cvc span {
    font-size: 1rem;
}

.kuda-card--actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s;
}

.savedCard:hover .kuda-card--actions {
    opacity: 1;
    visibility: visible;
}

.savedCard:hover {
    cursor: pointer;
}

.kuda-card--actions {
    padding: 30px 35px 40px;
    cursor: default;
    border: 1px solid #d2d6db;
}

.action-items {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    border-bottom: 1px solid rgba(23, 34, 60, 0.1);
}

.card-delete {
    text-align: center;
    margin-top: 22px;
}

.action-items .color-black {
    text-transform: capitalize;
}

.card-delete span {
    cursor: pointer;
}

.action-items p {
    font-size: 0.92rem;
}

.account-image .fileInput {
    height: calc(100% + 10px);
}

.loan-color * {
    color: #1dcbef !important;
}

.loan-color path {
    fill: #1dcbef !important;
}

.kuda-entry--wrap {
    min-height: calc(100vh - 70px);
}

.share-header--wrap .kuda-share--earn {
    padding-bottom: 38px !important;
    padding-top: 28px;
}

.share-header--wrap .kuda-share--earnAlt {
    padding-bottom: 34px !important;
}

.share-header--wrap .earnings.color-white {
    margin-top: 4px;
}

.edit-item.loading {
    position: absolute;
}

.edit-item.loading>svg {
    opacity: 0;
    visibility: hidden;
}

.edit-item.loading:after {
    position: absolute;
    content: "";
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    display: inline-block;
    border: 2px solid rgb(63, 24, 109);
    border-bottom-color: transparent;
    border-radius: 100%;
    background: transparent;
    animation: rotate 0.75s linear infinite;
}

.kuda-notification--panel {
    display: block;
    width: 100%;
    background: #fff;
    height: 100%;
    max-width: 450px;
    margin-left: auto;
}

.emptySearch {
    margin-bottom: -25px;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
}

.basic-dropdown {
    padding-top: 2px;
    padding-bottom: 2px;
}

.flex-skeleton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
}

.fully-rounded {
    width: 70px !important;
    height: 50px;
}

.bg--width {
    width: 50%;
}

.fully-rounded .react-loading-skeleton {
    border-radius: 100px;
    overflow: hidden;
}

.bg--width:not(.fully-rounded) .react-loading-skeleton {
    width: calc(100% - 20px) !important;
    margin-left: auto;
    display: block;
}

.bg--width>span {
    width: 100%;
    display: block;
}

.savings-width {
    height: 100%;
    background-color: #48d38a;
    background-color: var(--successColor);
    border-radius: 5px;
    width: 0;
    transition: width 1s;
}

.closeMenu {
    position: absolute;
    right: 25px;
    top: 24px;
    z-index: 1;
    animation-delay: 0.35s;
    animation-duration: 0.8s !important;
}

.no-result {
    padding: 20px 5px 15px;
    font-size: 0.9rem;
    color: #000000;
    color: var(--blackColor);
    font-weight: 700;
    margin: 20px;
    text-align: center;
}

#RealPassword,
#newPassword,
#confirmPassword,
#TaxNo,
#CacNo {
    position: absolute;
    opacity: 0;
    z-index: 99;
    bottom: 0;
    width: 100%;
}

#RealPassword.active:focus,
#newPassword.active:focus,
#confirmPassword.active:focus,
#TaxNo.active:focus,
#CacNo.active:focus {
    animation-name: blink;
    animation-duration: 800ms;
    animation-iteration-count: infinite;
    opacity: 1;
}

@keyframes blink {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

.center-maturity .text-right {
    display: none;
}

.center-maturity .text-left {
    width: 100%;
    text-align: center;
}

.passwordToggle {
    position: absolute;
    right: 12px;
    top: calc(50% + 2.5px);
    transform: translateY(-50%);
    z-index: 999;
    cursor: pointer;
}

.sme-cta--secondarybutton {
    border: 1px solid #000000 !important;
    background: #ffffff !important;
    background: var(--whiteAlt) !important;
    color: #000000 !important;
    color: var(--primaryColor) !important;
}

.passwordToggle svg {
    height: auto;
    width: 20px;
}

.showPassword #RealPassword,
.showPassword #newPassword,
.showPassword #confirmPassword,
.showPassword #TaxNo,
.showPassword #CacNo {
    opacity: 1;
}

.tokenExpired .kuda-loader {
    display: none !important;
}

.kuda-home-loader--wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.loader-30 {
    width: 78.6px;
}

.loader-40 {
    width: calc(45% - 15px);
    height: 32px;
}

.loader-100 {
    width: 100%;
    height: 32px;
}

.kuda-home-loader--wrap {
    margin-bottom: 30px;
}

.skel-right>span>span {
    display: block;
    margin-left: auto;
}

.loader-40>span:last-child {
    margin-top: 6px !important;
    display: block;
}

.inactive-wrap {
    max-width: 280px;
}

.otp-auth .otp-input {
    max-width: 325px;
}

.otp-auth {
    max-width: 330px;
}

.otp-auth .otp-input input {
    max-width: 46px;
}

.reset-form .kuda-cta.kuda-cta-lg {
    max-width: 200px;
}

.forgot-label .color-primary {
    cursor: pointer;
    font-weight: 700;
}

.kuda-error--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
}

.error-seperator {
    margin-bottom: 40px;
}

.error-seperator+.addAction {
    margin-bottom: -10px;
}

.notice-icon {
    position: relative;
    display: none;
}

.showNotice .notice-icon {
    display: flex;
}

.notice-icon svg {
    height: 19px;
    width: auto;
    margin-left: 7px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.full-label {
    display: flex;
    align-items: center;
    position: relative;
}

.badgeError .beneficiary-wrap {
    color: #f7685b;
    color: var(--negativeColor);
    background: #ffdbdb;
}

.fileError {
    border: 1px solid #f7685b;
    border: 1px solid var(--negativeColor);
    border-radius: 5px;
}

.card-illustration svg {
    width: auto;
    height: 145px;
}

.budgetTab {
    margin-top: 0;
}

.budget-heading--summary {
    margin-top: 30px;
    margin-bottom: 25px;
    display: block;
    margin-right: -220px;
    margin-left: -220px;
}

.budget-cards {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.budget-card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding: 20px;
    width: 25%;
    position: relative;
    min-height: 80px;
}

.budget-card:not(:last-child) {
    margin-right: 20px;
}

.budget-create--bg {
    position: absolute;
    left: 0;
    bottom: -2px;
}

.create-card {
    background: #F4F4F4;
    background: var(--offBlue);
    border-color: rgba(219, 220, 224, 0.5) !important;
    border-color: var(--borderOff) !important;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding-right: 8px;
    cursor: pointer;
    overflow: hidden;
}

.create-card {
    display: flex;
    align-items: center;
    justify-content: center;
}

.budget-create--icon {
    margin-left: 11px;
}

.budget-heading {
    font-size: 0.95rem;
    position: relative;
    z-index: 1;
}

.budget-card .card-main--heading {
    margin-bottom: 0 !important;
    line-height: 1;
}

.budget-card--semiHeading {
    color: #000000;
    color: var(--blackColor);
    font-size: 0.95rem;
    margin-bottom: 9px;
    display: block;
}

.kuda-budgeting .kuda-result--item {
    padding-left: 30px !important;
    padding-right: 30px !important;
    z-index: 1;
}

.DateInput_input {
    color: #000000 !important;
    color: var(--blackColor) !important;
    font-size: 0.935rem !important;
    font-weight: 600 !important;
    border: 0 !important;
}

.CalendarDay {
    vertical-align: middle !important;
    border: none !important;
}

.CalendarDay__selected {
    background: rgb(230, 248, 238) !important;
    position: relative;
    z-index: 2;
    font-weight: 700;
}

.CalendarDay__selected_span,
.CalendarDay__hovered_span {
    background-color: rgba(72, 211, 138, 0.15) !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.CalendarDay__selected:before {
    background: rgba(72, 211, 138, 1) !important;
    content: "" !important;
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    border-radius: 100px !important;
    z-index: -1 !important;
    opacity: 1 !important;
}

.CalendarDay__selected:hover:before {
    background: rgba(72, 211, 138, 1) !important;
    color: #fff !important;
}

.CalendarDay__selected_end {
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
}

.CalendarDay__selected_start {
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
}

.CalendarDay__default {
    position: relative !important;
    z-index: 9;
}

.CalendarDay__default:hover {
    background: rgb(230, 248, 238) !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.CalendarDay__default:hover:before {
    background-color: rgba(72, 211, 138, 0.1) !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
    content: "" !important;
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    border-radius: 100px !important;
    z-index: -1 !important;
    opacity: 1 !important;
}

.DateRangePickerInput {
    display: flex !important;
    align-items: center !important;
    width: auto !important;
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid #f4f4f4 !important;
    border: 1px solid var(--bgOffset) !important;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
    border-radius: 5px;
    padding-right: 10px;
    border-radius: 5px !important;
}

.DateRangePickerInput>* {
    width: auto !important;
    display: flex !important;
}

.DateInput_input {
    width: 113px !important;
}

.DateInput_input {
    padding-right: 0;
}

.DateInput_input {
    padding-right: 0 !important;
}

.DateRangePicker_picker {
    border: 1px solid #f4f4f4 !important;
    border: 1px solid var(--bgOffset) !important;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
    padding-bottom: 25px;
    border-radius: 3px;
    z-index: 9 !important;
}

.DateInput_fangStroke {
    stroke: #f4f4f4 !important;
    stroke: var(--bgOffset) !important;
}

.DateInput_fang {
    margin-top: -12px;
}

.DateInput_input__focused {
    border-bottom: 0 !important;
}

.DateRangePicker_picker {
    margin-top: -13px;
}

.CalendarMonth_table {
    margin-top: 18px;
}

.CalendarMonth_caption {
    font-size: 0.9rem !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
    font-weight: 700 !important;
}

.kuda-budget--filter {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.CalendarDay__lastDayOfWeek.CalendarDay__selected_start {
    border-top-right-radius: 100px !important;
    border-bottom-left-radius: 0 !important;
}

.CalendarDay__firstDayOfWeek.CalendarDay__selected_end {
    border-bottom-left-radius: 100px !important;
    border-top-right-radius: 0 !important;
}

.CalendarDay__firstDayOfWeek.CalendarDay__selected_start {
    border-radius: 0px !important;
    border-top-left-radius: 20px !important;
}

.CalendarDay__selected_start_no_selected_end.CalendarDay__selected_start:not(.CalendarDay__selected_start_in_hovered_span) {
    border-radius: 100px !important;
}

.CalendarDay__selected:hover {
    color: #ffffff !important;
    color: var(--whiteColor) !important;
}

.CalendarDay__selected:hover:before {
    background: rgba(72, 211, 138, 1) !important;
}

.CalendarDay__firstDayOfWeek.CalendarDay__selected_start.CalendarDay__firstDayOfWeek_3 {
    border-bottom-left-radius: 20px !important;
}

/* .CalendarDay__default[aria-label*="It’s available"]:not(:hover) {
    border-radius: 100px!important
} */

.customIcon {
    display: flex;
    align-items: center;
    position: relative;
    top: 1px;
    height: 100%;
}

.DateRangePickerInput_calendarIcon {
    height: 100%;
    padding-left: 10px !important;
    padding-right: 0 !important;
}

.kuda-budget--filter .kuda-search--field {
    height: 48px;
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.kuda-budget--filter .DateRangePickerInput {
    height: 48px;
    display: flex;
    align-items: center !important;
    width: 350px !important;
}

.kuda-analytics--filter .DateRangePickerInput {
    height: 48px;
    display: flex;
    align-items: center !important;
    width: 613px !important;
}

.filter-field {
    width: calc(100% - 294px);
    position: relative;
}

.DayPickerKeyboardShortcuts_show {
    display: none;
}

.is-timeline--active:after {
    content: "";
    height: 55px;
    width: 1px;
    position: absolute;
    background: #48d38a;
    background: var(--successColor);
    top: 15px;
    left: -33px;
    z-index: 0;
}

.DateRangePickerInput,
.DateInput_input {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
}

.text-center br {
    content: "";
    margin: 2em;
    display: block;
    font-size: 24%;
}

.save-categories span {
    box-shadow: 0px 4px 14px rgba(64, 25, 109, 0.15);
    border-radius: 100px;
    background: none;
    width: 85px;
    height: 85px;
}

.save-categories span svg {
    width: 100%;
    height: 100%;
}

.save-categories span:not(:last-child) {
    margin-right: 20px;
}

.icons--kuda span {
    width: 70px;
    height: 70px;
    display: flex;
}

.icons--kuda a:not(:last-child) {
    margin-right: 20px;
}

.icons--kuda {
    margin-top: 40px;
    justify-content: center;
}

.kuda-flex {
    display: flex;
}

.share-modal--width .modal-content {
    max-width: 520px;
}

.DayPicker__withBorder {
    border: none !important;
    box-shadow: none !important;
}

.setBudget-card {
    background: #F4F4F4;
    background: var(--offBlue);
}

.kuda-budgeting:not(.category-budget) .transaction-price {
    top: 0;
    text-align: right;
}

.kuda-budgeting:not(.category-budget) .transaction-percentage {
    font-size: 0.7rem;
    color: #979797;
    color: var(--textColor);
}

.kuda-budgeting:not(.category-budget) .transaction-price {
    height: 38px;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
}

.budget-percentage--color {
    position: absolute;
    height: calc(100% - 0px);
    z-index: -1;
    left: 0px;
    top: 0;
    width: 0;
    transition: width 1s;
}

.budget-card--header {
    display: flex;
    justify-content: center;
}

.budget-card--header .card-main--heading {
    display: flex;
    align-items: center;
    margin: 33px 0 0;
}

.budget-card--header .card-main--heading img {
    height: 39px;
    margin-right: 13px;
    width: 39px;
}

.budget-card--header+.budget-heading--summary .budget-card {
    width: 33.33%;
}

.budget-card--header+.budget-heading--summary {
    margin-right: -90px;
    margin-left: -90px;
}

.budget-heading--summary .category-budget--highlighted .card-main--heading {
    font-size: 0.9rem !important;
}

.card-overspent {
    background: #ffdbdb;
}

.card-overspent * {
    color: #f7685b;
    color: var(--negativeColor);
}

.budget-card .savings-progress {
    bottom: 15px;
}

.category-budget--highlighted .card-main--heading {
    margin-top: -1px !important;
}

.category-budget--highlighted .budget-card--semiHeading {
    margin-top: -1px !important;
}

.kuda-budget--filter.single-budget--view .DateRangePickerInput,
.kuda-budget--filter.single-budget--view .DateRangePicker {
    width: 100% !important;
}

.plan-budget--wrap {
    max-width: 100%;
}

.plan-budget--wrap .card-main--heading {
    margin-bottom: 10px;
    width: 100%;
}

.spend-progress--box {
    width: 100%;
    margin-top: 61px;
    background: #f4f4f4;
    background: var(--bgOffset);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    min-height: 40px;
    position: relative;
    display: flex;
    align-items: center;
}

.spend-progress--bg {
    position: absolute;
    width: 0;
    transition: width 1s;
    background: linear-gradient(180deg, #48d38a 11.25%, #78ecbe 138.75%);
    background: linear-gradient(180deg, var(--successColor) 11.25%, #78ecbe 138.75%);
    border: 1px solid #48d38a;
    border: 1px solid var(--successColor);
    box-shadow: 0px 5px 10px rgba(72, 211, 138, 0.5);
    box-shadow: 0px 5px 10px var(--offGreen);
    border-radius: 5px;
    height: calc(100% + 2px);
    top: -1px;
    left: -1px;
}

span.progressVaue {
    position: relative;
    z-index: 1;
    padding-left: 10px;
    padding-right: 10px;
    color: #fff;
    font-weight: 900;
}

.spend-day--tick {
    position: absolute;
    right: 0;
    opacity: 0;
    transition: opacity 1s;
}

.spend-day--tick {
    width: 75px;
    height: 26px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -20px;
}

.spend-progress--bg {
    max-width: calc(100% + 2px);
}

.create-budget--button {
    max-width: 240px;
    margin-top: 30px;
}

.spend-progress--label {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.text-uppercase {
    text-transform: uppercase;
}

.plan-budget--wrap .recharts-wrapper {
    width: auto !important;
}

.plan-budget--wrap .recharts-wrapper {
    display: flex;
    align-items: center;
}

.plan-budget--wrap .recharts-wrapper {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}

.plan-budget--wrap svg.recharts-surface {
    margin-left: 0 !important;
    min-width: 260px;
}

.plan-budget--wrap svg.recharts-surface {
    width: calc(80% - 250px);
    margin-left: -50px !important;
    overflow: visible;
}

.plan-budget--wrap .recharts-layer image {
    width: 40px;
    height: 40px;
}

.plan-budget--wrap .recharts-pie-labels text {
    font-weight: 700;
    font-size: 1rem;
}

.plan-budget--wrap text.fake {
    opacity: 0;
}

.image-tracker {
    position: absolute;
    width: 40px;
    height: 40px;
}

.chart-holder {
    position: relative;
}

.freeTransfer--wrap {
    width: 100%;
    border: 1px solid #DBDCE0;
    box-shadow: 5px 7px 10px 0px rgba(0, 0, 0, 0.10);
    border-radius: 5px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.7rem;
    justify-content: center;
    padding: 7px 12px;
    display: flex;
    align-items: center;
    margin-top: -15px;
    margin-bottom: 10px;
    max-width: 203px;
    font-weight: 600;
}

.freeTransfer--wrap span {
    font-size: 0.875rem;
    margin-left: 6px;
    line-height: 1.09;
}

.kuda-payment--balance {
    font-size: 0.6875rem;
    margin-top: 10px;
}

.recharts-layer image,
.recharts-pie-labels text {
    animation: fadein 0.7s ease-in alternate forwards;
}

@keyframes fadein {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.kuda-tran--holder {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.kuda-item--chart .savings-progress {
    margin-top: 0px !important;
    height: 5px;
    margin-left: auto;
    width: calc(100% - 65px);
    display: block;
    position: static;
    margin-right: 0;
}

.kuda-item--chart {
    flex-direction: column;
}

.kuda-item--chart .transaction-price {
    margin-right: 0;
}

.kuda-item--chart .transaction-avatar {
    position: relative;
    top: 7px;
}

.edit-budget {
    margin-top: 30px;
    display: flex;
    width: 100%;
    max-width: 132px;
    height: 41px;
}

.edit-budget--wrap {
    display: flex;
    justify-content: center;
    align-items: center;
}

.kuda-calendar--control {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 37px;
    min-height: 48px;
    margin-right: 8px;
    min-width: 37px;
    cursor: pointer;
}

.next-calendar--control {
    margin-right: 0;
    margin-left: 8px;
}

.create-budget--modal .modal-content {
    max-width: 700px !important;
}

.create-budget--modal h4 {
    font-size: 1.25rem;
}

.create-budget--modal .block-spacer {
    margin-bottom: 11px;
    max-width: 420px;
}

.create-budget--modal .kuda-cta {
    max-width: 220px !important;
}

.create-budget--modal .createBalance {
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    max-width: 210px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 21px;
    font-size: 1rem;
    font-weight: 600;
}

.create-budget--modal .transaction-title {
    justify-content: center !important;
    margin-top: 0;
    margin-left: 17px;
}

.create-budget--modal .transaction-name {
    margin-top: 0;
    font-size: 0.9375rem;
    font-weight: 400;
}

.kuda-budget--form .kuda-result--heading {
    text-align: center !important;
    justify-content: center;
    color: #000000;
    color: var(--blackColor);
}

.kuda-budget--form {
    max-width: 424px;
    margin-left: auto;
    margin-right: auto;
    height: calc(100vh - 485px) !important;
}

.create-budget--modal .modal-content {
    height: calc(100vh - 140px);
}

.kuda-budget--form .transaction-amount input {
    width: 120px;
    background: #ffffff;
    background: var(--whiteColor);
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    text-align: center;
    padding: 5px;
}

.kuda-budget--form+.block-buttons {
    margin-top: 25px !important;
}

.create-budget--modal .kuda-result--heading {
    max-width: 426px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: 30px;
    justify-content: center;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
    background: rgba(151, 151, 151, 0.22) !important;
}

.ps__thumb-y {
    background: rgba(151, 151, 151, 0.22) !important;
    right: 0 !important;
}

.ps__rail-y:hover>.ps__thumb-y,
.ps__rail-y:focus>.ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
    width: 6px !important;
    background: rgba(151, 151, 151, 0.22) !important;
}

.ps__rail-y {
    width: 6px !important;
    right: 0 !important;
    left: auto !important;
}

.budget-skeleton .budget-cards>span {
    border-radius: 5px;
    margin-right: 20px;
    width: 25%;
    position: relative;
    min-height: 80px;
}

.edit--budget .block-buttons {
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
}

.edit--budget .kuda-cta {
    max-width: 156px !important;
}

.kuda-cta-warning-light.form-loading:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.overview-budget--wrap {
    max-width: 100%;
}

/* .overview-budget--wrap .recharts-surface, .overview-budget--wrap .recharts-wrapper {
    width: 100%!important;
    height: 100%!important;
} */

/* .recharts-responsive-container {
    height: 100%;
    max-height: 276px;
} */

.highlight-bar-charts {
    height: 276px;
    min-height: 276px;
}

.recharts-text {
    font-size: 11px;
    font-weight: 700;
    color: #979797;
    color: var(--textColor);
}

/* .recharts-default-tooltip {
    background: var(--whiteColor) !important;
    border: 1px solid var(--borderOff) !important;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05) !important;
    border-radius: 5px !important;
} */

.recharts-cartesian-axis-tick line,
.recharts-cartesian-grid-vertical line {
    visibility: hidden;
}

.recharts-tooltip-label {
    font-size: 11px;
    font-weight: 900;
    color: #000000;
    color: var(--blackColor);
}

.recharts-tooltip-item-list {
    font-size: 11px;
    font-weight: 600;
}

.recharts-tooltip-item-list .recharts-tooltip-item-value {
    font-weight: 700;
}

.kuda-wrap--wrap--holder {
    display: flex;
    justify-content: space-between;
}

.kuda-wrap--wrap--holder>div {
    width: calc(50% - 10px);
    margin: 0;
}

.history {
    margin-bottom: 40px;
}

.recharts-surface {
    overflow: visible;
}

.history {
    display: flex;
    justify-content: space-between;
}

.budget-heading--summary .history .card-main--heading {
    margin-bottom: 0px;
    font-size: 1rem !important;
    font-weight: 900;
}

.history .card-main-subheading {
    font-size: 0.7rem;
}

.history-text * {
    text-align: left;
}

.kuda-history--items .kuda-transaction--tabs {
    margin-top: 0;
    min-width: 185px;
    margin-left: auto;
    height: 38px;
    min-height: 38px;
    box-shadow: none;
    border-radius: 5px;
}

.kuda-history--items .kuda-transaction--tabs>li {
    font-size: 0.7rem;
}

.kuda-history--items .kuda-transaction--tabs>li:not(.active) {
    color: #979797 !important;
    color: var(--textColor) !important;
}

.recharts-tooltip-item-name,
.recharts-tooltip-item-separator {
    display: none;
}

.history line[stroke-dasharray="0 0"] {
    stroke: rgba(151, 151, 151, 0.2) !important;
}

.recharts-yAxis .recharts-cartesian-axis-tick:last-child {
    transform: translateY(-8px);
}

/* .recharts-tooltip-cursor {
    stroke: var(--successColor);
} */

/* .lineChart .recharts-tooltip-cursor {
    stroke: none !important;
    fill: var(--borderOff) !important;
} */

.plan-budget--wrap .history {
    margin-bottom: 0;
}

.category-budget .budget-card {
    width: 50%;
}

.category-budget .budget-cards {
    margin-top: 30px;
    margin-bottom: 25px;
}

.carteGrid {
    stroke: rgba(151, 151, 151, 0.2);
}

.lineChart .recharts-tooltip-item-name,
.lineChart .recharts-tooltip-item-separator {
    display: inline-block !important;
    text-transform: capitalize;
}

/* .lineChart .recharts-tooltip-item-list li:first-child .recharts-tooltip-item-value {
    color: var(--successColor);
    margin-left: 3px;
} */

.lineChart .recharts-tooltip-item-list li:first-child {
    padding-bottom: 0 !important;
}

.lineChart .recharts-tooltip-item-list li:last-child .recharts-tooltip-item-value {
    color: #f7685b;
    color: var(--negativeColor);
    margin-left: 3px;
}

.lineChart .recharts-tooltip-item-list li:last-child .recharts-tooltip-item-value:before {
    content: "-";
}

.budgeting-home .next-calendar--control {
    margin-right: 8px;
}

.yAxis .recharts-cartesian-axis-tick:first-child {
    visibility: hidden;
}

/* .recharts-dot {
    fill: #fff;
    stroke: var(--successColor);
    stroke-width: 2.5px;
} */

.DayPickerNavigation_button {
    background: none !important;
    line-height: 1.7rem;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 21px;
    padding: 0;
    border: 0.45rem solid transparent !important;
    z-index: 1;
    height: 10px !important;
    width: 10px !important;
    text-indent: -999em;
    overflow: hidden;
    border-left-color: #cccccc !important;
    border-radius: 0 !important;
    right: 26px !important;
    outline: 0;
    padding: 0 !important;
}

.DayPickerNavigation_leftButton__horizontalDefault {
    transform: scaleX(-1);
    left: 26px !important;
}

.kuda-history--items .kuda-transaction--tabs li.preventDefault {
    color: rgba(219, 220, 224, 0.3) !important;
    color: var(--offWhiteTrans) !important;
    pointer-events: none;
}

.tabs {
    position: relative;
    z-index: 1;
}

.date-wrap {
    display: flex;
    width: 100%;
}

.DateRangePicker_picker__portal {
    background-color: rgba(64, 25, 109, 0.4) !important;
    z-index: 99 !important;
}

.kuda-budgeting .kuda-card--wrap {
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
}

.closeCreateModal {
    position: absolute;
    top: 17px;
    left: 17px;
    cursor: pointer;
}

.pin-input input:not(:placeholder-shown) {
    font-family: "dotsfont";
}

.not-pin-input input:not(:placeholder-shown) {
    font-family: inherit !important;
}

.has-checkBox .toggle {
    top: -6px;
    right: 15px;
}

.kuda-mask--balance .balance-summary:not(.percentage-save) {
    filter: blur(10.5px);
}

.kuda-mask--balance .kuda-payment--balance,
.kuda-mask--balance .balance-cardless {
    filter: blur(6px);
    cursor: pointer;
}

.balance-summary {
    cursor: pointer;
}

.balance-summary {
    transition-duration: 250ms;
    transition-property: filter, filter, opacity;
}

.skeleton-ui .balance-summary {
    filter: blur(0) !important;
}

.kuda-prev path {
    fill: #000000;
    fill: var(--primaryAlt);
}

.profile-block .amount-input {
    background-color: #ffffff;
    background-color: var(--whiteAlt);
}

.showPassword input[readonly] {
    opacity: 0;
}

.kuda-dayLight--toggle {
    position: absolute;
    left: -32px;
    width: auto;
    display: flex;
}

.kuda-header--actions .kuda-dayLight--toggle {
    left: -38px;
}

.kuda-dayLight--toggle svg {
    height: 18px;
    width: auto;
    pointer-events: none;
}

.kuda-dayLight--toggle>span {
    display: flex;
}

.overview-budget--wrap .empty-summary {
    margin-bottom: 50px;
}

/**** DARK MODE ****/

/* .kuda-dark--theme .color-primary, .kuda-dark--theme .kuda-cta:not(.kuda-cta-warning-light), .kuda-dark--theme .save-cta, .kuda-dark--theme .DateRangePickerInput_arrow, .kuda-dark--theme .kuda-nav--icon a.active, .kuda-dark--theme .kuda-nav--icon a[aria-current="page"], .kuda-dark--theme .kuda-menu--text.active, .kuda-dark--theme .react-datepicker__day, .kuda-dark--theme .react-datepicker__time-name {
    color: var(--blackColor) !important;
} */

.kuda-dark--theme .savings-active .denomination-icon path {
    fill: #48d38a !important;
    fill: var(--successColor) !important;
}

.kuda-dark--theme .kuda-brand path,
.kuda-dark--theme .searchIcon path,
.kuda-dark--theme .kuda-nav-arrow path,
.kuda-dark--theme .customIcon path,
.kuda-dark--theme .kuda-calendar--control path,
.kuda-dark--theme header .kuda-nav--icon path[fill="#000000"],
.kuda-dark--theme .kuda-nav--icon circle[fill="#000000"],
.kuda-dark--theme .kuda-nav--icon rect[fill="#000000"],
.kuda-dark--theme .denomination-icon path,
.kuda-dark--theme .closeModal path,
.kuda-dark--theme .kuda-dropdown-icon path,
.kuda-dark--theme .closeCreateModal path,
.kuda-dark--theme .closeMenu rect,
.kuda-dark--theme .kuda-card--cvc span ellipse {
    fill: #000000 !important;
    fill: var(--blackColor) !important;
}

.kuda-dark--theme .kuda-nav--icon path[fill="white"],
.kuda-dark--theme .kuda-nav--icon circle[stroke="white"],
.kuda-dark--theme .kuda-nav--icon rect[fill="white"] {
    fill: #000000;
}

.kuda-dark--theme .kuda-nav--icon circle[fill="white"].kd-no-c {
    fill: #000;
}

.kuda-dark--theme .kuda-nav--icon [d="M13 1V13L23.5 19"] {
    stroke: #000000;
}

.kuda-dark--theme .link.active:after,
.kuda-dark--theme .kuda-transaction--tabs>li[aria-selected="true"]:after,
.kuda-dark--theme .account-title.active:after {
    background: rgba(255, 255, 255, 0.9);
}

.kuda-dark--theme .bill-item {
    border-color: rgba(244, 244, 244, 0.04);
}

.kuda-dark--theme .bill-item,
.kuda-dark--theme .block-item,
.kuda-dark--theme .kuda-share--earn,
.kuda-dark--theme .profile-block .add-amount,
.kuda-dark--theme .budget-percentage--color,
.kuda-dark--theme .transaction-header,
.kuda-dark--theme .percentage-input {
    background-color: rgba(219, 220, 224, 0.3) !important;
    background-color: var(--offWhiteTrans) !important;
}

.kuda-dark--theme circle[fill="#DBDCE0"],
.kuda-dark--theme circle[fill="#F5F5F8"] {
    fill: rgba(219, 220, 224, 0.3) !important;
    fill: var(--offWhiteTrans) !important;
}

.kuda-dark--theme .setBudget-card,
.kuda-dark--theme .DateRangePicker_picker {
    background-color: #ffffff !important;
    background-color: var(--whiteAlt) !important;
}

.kuda-dark--theme .kuda-share--earn *,
.kuda-dark--theme .formInput,
.kuda-dark--theme .percentage-input {
    color: #000000;
    color: var(--blackColor);
}

.kuda-dark--theme .whiteStroke {
    stroke: #000000;
    stroke: var(--blackColor);
}

.kuda-dark--theme .color-normal,
.kuda-dark--theme .card-subheading--boxed {
    color: rgba(255, 255, 255, 0.8) !important;
}

.kuda-dark--theme .passwordToggle svg {
    stroke: rgba(255, 255, 255, 0.8) !important;
}

.kuda-dark--theme .Toaster__alert {
    background-color: #222222 !important;
}

.kuda-dark--theme .Toaster__alert * {
    color: #ffffff !important;
}

.kuda-dark--theme .savedIllustration {
    background: none;
}

.kuda-dark--theme .back-to path,
.kuda-dark--theme .back path {
    fill: #ffffff;
}

.kuda-dark--theme .react-datepicker {
    background: #ffffff;
    background: var(--whiteColor);
}

.kuda-dark--theme .kuda-card--actions,
.kuda-dark--theme .action-items {
    background: #222222;
    border-color: rgba(219, 220, 224, 0.03);
}

.kuda-dark--theme .kuda-tertiary-cta,
.kuda-dark--theme .white-cta,
.kuda-dark--theme .kuda-cta-white {
    border: 1px solid rgba(219, 220, 224, 0.03);
}

.kuda-dark--theme .kuda-mobile--menu ul.kuda-menu--wrap {
    background: #ffffff;
    background: var(--whiteAlt);
}

.kuda-dark--theme .kuda-tertiary-cta,
.kuda-dark--theme .saving-plan {
    background-color: rgba(219, 220, 224, 0.3) !important;
    background-color: var(--offWhiteTrans) !important;
}

.kuda-dark--theme .DayPicker__horizontal,
.kuda-dark--theme .CalendarMonth,
.kuda-dark--theme .CalendarMonthGrid,
.kuda-dark--theme .CalendarDay__default {
    background: none !important;
}

.kuda-dark--theme .DateInput_fangShape {
    fill: #292929;
}

.kuda-dark--theme .react-datepicker__current-month,
.kuda-dark--theme .react-datepicker-time__header,
.kuda-dark--theme .react-datepicker-year-header {
    color: #000000;
    color: var(--blackColor);
}

.kuda-dark--theme .kuda-dayLight--toggle path,
.kuda-dark--theme .kuda-dayLight--toggle line,
.kuda-dark--theme .kuda-dayLight--toggle circle {
    stroke: #ffffff !important;
    opacity: 0.5;
}

.kuda-dark--theme .CalendarDay__selected {
    background: rgb(33, 51, 41) !important;
}

.kuda-dark--theme .kuda-nav--icon path[fill="#000000"],
.kuda-dark--theme .plan-budget--wrap .recharts-pie-labels text {
    fill: #ffffff;
}

.kuda-tran--items {
    max-width: 202px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.kuda-dark--theme .loan-color path {
    fill: #1dcbef !important;
}

.kuda-dark--theme .transaction-percentage span {
    color: #979797 !important;
    color: var(--textColor) !important;
}

.kuda-dark--theme .card-overspent * {
    color: #f7685b !important;
    color: var(--negativeColor) !important;
}

.kuda-quick--statement {
    display: flex;
    margin-bottom: 8px;
}

.kuda-dark--theme .savings-active .color-primary {
    color: #48d38a !important;
    color: var(--successColor) !important;
}

.kuda-dark--theme .pin-input input {
    color: #000000;
    color: var(--blackColor);
}

.kuda-dark--theme .kuda-modal-illustration g[clip-path="url(#__lottie_element_50)"] path[fill="rgb(64,24,108)"],
.kuda-dark--theme .kuda-modal-illustration g[clip-path="url(#__lottie_element_69)"] path[fill="rgb(64,24,108)"] {
    fill: #fff;
}

.kuda-dark--theme .CalendarDay__selected_span,
.kuda-dark--theme .CalendarDay__hovered_span {
    background-color: rgba(72, 211, 138, 0.15) !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.kuda-dark--theme .CalendarDay {
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.kuda-modal-illustration>div svg {
    height: 93px !important;
    width: auto !important;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

/* Change Autocomplete styles in Chrome*/

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-text-fill-color: #000000;
    -webkit-text-fill-color: var(--blackColor);
    -webkit-box-shadow: 0 0 0px 1000px #ffffff inset;
    -webkit-box-shadow: 0 0 0px 1000px var(--whiteColor) inset;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
    color: #000000;
    color: var(--blackColor);
}

.kuda-dark--theme .kuda-layout---card .kuda-card--wrap,
.kuda-dark--theme .kuda-layout---card .formCard,
.kuda-dark--theme .kuda-layout---card .kuda-deposit--wrap,
.kuda-dark--theme .profile-block .amount-input {
    background: rgba(219, 220, 224, 0.3);
    background: var(--offWhiteTrans);
}

.kuda-dark--theme .CalendarDay__blocked_out_of_range {
    opacity: 0.2;
}

.progressRing circle {
    transition: stroke-dashoffset 1.4s;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
}

.progressRing {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    transform: scale(1.225);
}

.event-none {
    pointer-events: none;
}

.kuda-dark--theme .progressRing circle {
    stroke: #ffffff;
}

.kuda-dark--theme .progressRing {
    transform: scale(1.26);
}

.add-card--layout {
    max-width: 450px;
}

.add-card--layout .kuda-radio--wrapper {
    width: calc(50% - 8px);
}

.add-card--layout .kuda-radio--wrapper label {
    padding-left: 51px;
}

.add-card--layout .outer {
    left: 14px;
}

.bottom-spacer {
    margin-bottom: 29px;
}

.bottom-spacer--lg {
    margin-bottom: 48px;
}

.bottom-spacer--xl {
    margin-bottom: 56px !important;
}

.bottom-spacer--md {
    margin-bottom: 40px !important;
}
.top-spacer--md {
    margin-top: 40px !important;
}

.fund-card--modal .transaction-additional--details {
    align-items: flex-end;
}

.kuda-card--brand {
    padding-bottom: 5px;
    display: flex;
}

.fund-card--modal .modal-content {
    max-width: 450px;
}

.kuda-card--brand svg {
    width: 33px;
    height: auto;
}

.color-blue {
    color: #1dcbef;
    color: var(--lightBlue);
}

.kuda-budget--illustration svg {
    height: 86px;
    width: 86px;
}

.payoneerLoader {
    flex-direction: column;
    justify-content: center;
}

.payoneerLoader>div {
    display: flex;
    justify-content: center;
}

.infinite-path {
    position: relative;
    overflow: hidden;
    /* width: 230px; */
    width: 100%;
    /* max-width: 230px; */
    height: 3px;
    background-color: rgba(219, 220, 224, 0.3);
    background-color: var(--offWhiteTrans);
    margin: auto;
    border-radius: 10px;
    margin-top: 35px;
    margin-bottom: 0px;
}

.shape {
    position: absolute;
    left: 0;
    background-color: #000000;
    width: 100px;
    height: 3px;
    display: block;
    top: 0;
    transition: all 1s ease-in-out;
    animation: ani 1.7s infinite;
    animation-delay: 1s;
}
.shape-modal {
    position: absolute;
    left: 0;
    background-color: #000000;
    width: 100px;
    height: 3px;
    display: block;
    top: 0;
    transition: all 1s ease-in-out;
    animation: aniModal 1.7s infinite;
    animation-delay: 1s;
}

.kuda-dark--theme .shape {
    background-color: #ffffff;
}

@keyframes ani {
    0% {
        left: -70px;
    }

    50% {
        left: 210px;
    }

    100% {
        left: -70px;
    }
}

@keyframes aniModal {
    0% {
        left: -70px;
    }

    50% {
        left: 484px;
    }

    100% {
        left: -70px;
    }
}
.payoneerLoader h5 {
    font-size: 1.25rem;
}

.kuda-default--radio [type="radio"]:checked,
.kuda-default--radio [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}

.kuda-default--radio [type="radio"]:checked+label,
.kuda-default--radio [type="radio"]:not(:checked)+label {
    position: relative;
    padding-left: 42px;
    cursor: pointer;
    line-height: 28px;
    display: inline-block;
}

.kuda-default--radio [type="radio"]:checked+label:before,
.kuda-default--radio [type="radio"]:not(:checked)+label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 27px;
    height: 27px;
    border: 1px solid #c4c4c4;
    border-radius: 100%;
    background: #c4c4c4;
}

.kuda-default--radio [type="radio"]:checked+label:after,
.kuda-default--radio [type="radio"]:not(:checked)+label:after {
    content: "";
    width: 27px;
    height: 27px;
    background: #48d38a;
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100%;
    transition: all 0.2s ease;
}

.kuda-default--radio [type="radio"]:not(:checked)+label:after {
    opacity: 0;
    transform: scale(0);
}

.kuda-default--radio [type="radio"]:checked+label:after {
    opacity: 1;
    transform: scale(1);
}

.kuda-default--radio {
    width: 100%;
    display: flex;
    margin-top: 14px;
}

.kuda-select--currency {
    margin-bottom: 30px;
    margin-top: 35px;
}

.kuda-default--radio label {
    font-size: 0.935rem;
}

.back span {
    display: flex;
    font-size: 13px;
}

.modal-description--icon {
    margin-right: 10px;
    margin-top: 3px;
}

.kuda-no--pin {
    margin-top: 35px;
}

.payoneer-loader {
    display: flex !important;
}

.payoneer-linked--svg svg {
    margin: 0;
    height: 78px !important;
    width: auto;
}

.payoneer-linked--svg {
    margin-bottom: 35px;
}

.payoneer-loader {
    background-color: #ffffff;
    background-color: var(--whiteColor);
}

.kuda-no--pin .addAction {
    margin-bottom: 0;
}

.margin-top--none {
    margin-top: 0 !important;
}

.payoneer-loader {
    align-items: flex-start;
    padding-top: 15%;
}

.add-payoneer {
    position: relative;
}

.payoneerCheck {
    top: 20px;
    left: auto;
    right: 20px;
    transform: none;
    padding: 4px;
    background-color: none !important;
    box-shadow: none;
    border: none;
}

.spinner {
    width: 19px;
    height: 19px;
}

.addInactive {
    pointer-events: none;
}

.call-active .modal .kuda-cta,
.call-active .modal-backdrop {
    pointer-events: none;
}

.kuda-add--cardForm input[readonly] {
    color: rgba(151, 151, 151, 0.75);
    pointer-events: none;
}

.kuda-card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    border: 1px solid var(--borderOff);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    box-shadow: 15px 30px 40px var(--boxShadow);
    border-radius: 5px;
    padding: 60px 70px 65px;
}

.kuda-404--wrap {
    max-width: 501px;
    margin-left: auto;
    margin-right: auto;
}

.kuda-404--illustration {
    margin: 0 auto 43px;
}

.kuda-404--heading {
    font-size: 1.5rem;
}

.kuda-card .inactivity-buttons .addAction {
    max-width: 200px;
}

.has-bottom--margin {
    margin-bottom: 45px;
}

a.transaction-tab[aria-current="page"]:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 2px;
    display: block;
    background: #000000;
    background: var(--primaryColor);
    bottom: 1px;
    opacity: 1;
    border-radius: 5px;
    left: 0;
}

.copyAccount {
    display: flex;
    position: absolute;
    right: 0;
    bottom: 17px;
}

.copyField input {
    padding-right: 59px;
}

.kuda-transfer--form .formInput {
    width: 100%;
}

/*** FOOTER ***/

.kuda-footer--conditions p {
    font-size: 12px;
}

.kuda-socials svg {
    width: 18px;
    height: auto;
}

.kuda-facebook svg {
    width: auto;
    height: 19px;
    position: relative;
    top: -2px;
}

.kuda-medium svg {
    width: auto;
    height: 14px;
}

.kuda-instagram svg {
    width: auto;
    height: 15px;
}

.kuda-socials li a {
    margin-right: 20px;
    height: 100%;
}

.kuda-socials li {
    display: flex;
    align-items: center;
}

.coming-soon--downloads img {
    height: 35px;
    width: auto;
    margin-right: 10px;
    opacity: 0.2;
}

.coming-soon {
    font-size: 15px;
    font-weight: 700;
    color: #000000;
}

footer .container {
    max-width: 1180px;
    padding-left: 60px;
    padding-right: 60px;
}

.available {
    opacity: 1 !important;
}

footer {
    border-top: 1px solid rgba(58, 36, 82, 0.04);
    margin-top: 50px;
}

.anonymous {
    position: absolute;
    top: 0px;
    right: 0;
    border-bottom: 1px solid #000000;
    padding-bottom: 1px;
    cursor: pointer;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

.kuda-dark--theme .kuda-footer--conditions p {
    color: rgba(219, 220, 224, 0.53);
}

.kuda-dark--theme footer {
    border-color: rgba(219, 220, 224, 0.03);
}

.kuda-bills--nav {
    margin-bottom: -10px;
}

.budget-skeleton .budget-cards>span:last-child {
    margin-right: 0;
}

.budget-skeleton .budget-cards {
    padding-bottom: 0;
}

.stealthy {
    left: 0;
    margin: 0;
    max-height: 1px;
    max-width: 1px;
    opacity: 0;
    outline: none;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: -1;
}

.kuda-card--wrap.payment-wrap {
    padding: 40px 57px 43px !important;
    position: relative;
}

.kuda-nav-arrow {
    display: flex;
    align-items: center;
}

.kuda-nav-arrow>* {
    display: flex;
}

.redUnblock .toggle input[type="checkbox"]:checked+.toggle-icon {
    background: #f7685b;
}

.bottom-fix {
    margin-bottom: 35px;
}

.kuda-login--wrap .formInput {
    padding-left: 13px;
    padding-right: 20px;
    line-height: 1;
}

.skeleton-card--top {
    margin-top: 36px;
}

.skeleton-card--top .input-skeleton>span {
    width: 100%;
    display: flex;
}

.account-skeleton .balance-icon {
    overflow: hidden;
    border-radius: 100px;
}

.account-skel--items {
    margin-bottom: 20px;
}

.account-skeleton .balance-icon {
    min-width: 92px;
}

.budget-skeleton .kuda-transaction--tabs li>span {
    display: block;
    height: 10px;
    width: 100%;
    max-width: 130px;
}

.payoneer-content .message-response {
    max-width: 100%;
}

.payoneer-content h4 {
    font-size: 1.25rem;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.5rem !important;
    margin-bottom: 2.1875rem !important;
}

.payoneer-content .kuda-modal-illustration svg {
    width: auto !important;
    height: 52px !important;
}

.payoneer-content .kuda-budget--illustration {
    margin-top: 10px;
    margin-bottom: 2rem;
}

.transaction-additional--details .save-title {
    font-size: 0.875rem;
    margin-bottom: 5px !important;
}

.linked {
    width: 62px !important;
    background: #dcffec;
    border: 1px solid #48d38a;
    box-sizing: border-box;
    box-shadow: 5px 7px 10px rgba(72, 211, 138, 0.1);
    border-radius: 5px;
    color: #48d38a;
    font-weight: bold;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 21px;
    position: absolute;
    right: 25px;
    top: 27px;
}

.no-link--text {
    margin-bottom: 0 !important;
}

.kuda-balance--wrap {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 5px;
    padding: 20px 25px;
    width: calc(50% - 10px);
    cursor: pointer;
    display: block;
    border-color: #ffffff;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    margin-bottom: 20px;
    min-height: 158px;
}

.kuda-balance--wrap .add-icon svg {
    height: 37px;
    width: auto;
}

.currency-wrap {
    width: 37px;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eff1ff;
    border: 1px solid #000000;
    border-radius: 100px;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    -ms-border-radius: 100px;
    -o-border-radius: 100px;
    padding: 3px;
}

.currency-summary--wrap {
    margin-top: auto;
    display: flex;
    flex-direction: column;
}

.is-balance {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    cursor: default;
}

.currency-item {
    font-size: 0.9rem;
    font-weight: 700;
    color: #000000;
    color: var(--primaryColor);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.52);
    border-radius: 100px;
}

.kuda-balance--wrap .add-icon {
    margin-bottom: 13px;
}

.payoneer-modal .modal-content {
    max-width: 417px;
}

.payoneer-modal .generateReceipt {
    max-width: 212px;
}

.modal-content>h4.text-xbold {
    font-size: 1.275rem;
}

.payoneer-modal-heading {
    display: flex;
    margin-top: 1.7rem;
    margin-bottom: 2.2rem;
    align-items: center;
}

.collection-icon {
    margin-right: 18px;
}

.collection-text p {
    line-height: 1.3;
    font-size: 0.9rem;
    color: #000000;
    color: var(--blackColor);
}

.payoneer-dropDown {
    background-color: #ffffff;
    background-color: var(--whiteAlt);
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    height: 40px;
    width: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    cursor: pointer;
}

.kuda-dark--theme .payoneer-dropDown {
    background: #222222 !important;
}

.payoneer-dropDown span {
    display: flex;
}

.more-arrow svg {
    height: 14px;
    width: auto;
}

.kuda-dark--theme .more-arrow path[fill="#000000"] {
    fill: #fff;
}

.pop {
    position: absolute;
    right: 0;
    width: auto;
    height: auto;
    z-index: 1;
    align-items: flex-start;
    top: 0;
}

.position-relative {
    position: relative;
    z-index: 1;
}

.pop>span {
    position: absolute;
    left: 14px;
    top: 12px;
}

.pop .user-icon {
    right: 14px;
    left: auto;
    top: 10px;
}

.other-payoneer--information {
    padding-top: 11px;
    text-align: center;
    margin-left: 40px;
    margin-right: 45px;
}

.unlink {
    margin-left: -54px;
    margin-right: -59px;
    border-top: 1px solid rgba(219, 220, 224, 0.5);
    padding: 13.4px 20px;
    margin-top: 20px;
}

.kuda-dark--theme .unlink {
    border-color: rgba(219, 220, 224, 0.05);
}

.product-skeleton .kuda-search {
    margin-bottom: 25px;
    margin-top: 0;
}

.product-skeleton .kuda-account--summary>div {
    width: calc(50% - 10px) !important;
}

.kuda-card--wrap .kuda-budgeting {
    margin-bottom: auto;
}

.modal-content>.closeModal+h4.text-center {
    font-size: 1.25rem;
}

.isEmpty {
    margin-top: auto;
}

.emptyWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.mini-card--heading {
    font-size: 0.875rem;
}

.copy-title {
    font-size: 0.7rem;
}

.copy-excerpt {
    font-size: 0.7rem;
}

.kuda-form--ussd {
    margin-bottom: 1.5rem;
}

.copy-account--wrap {
    margin-top: -7px;
}

.cursor-copy {
    cursor: copy;
}

.kuda-beneficiary--name {
    margin-top: -20px;
    margin-bottom: 28px;
    display: block;
}

.kuda-beneficiary--name.no-mt {
    margin-top: 5px !important;
}

.beneficiary-wrap {
    background: none !important;
    padding: 0;
    font-size: 0.8rem;
}

.kuda-dropdown-header.inputLoading {
    padding-right: 50px;
}

.kuda-header--wrap .kuda-cta {
    font-size: 15px;
    height: 46px;
    border: 1px solid #000000;
    border: 1px solid var(--primaryAlt);
    width: 175px;
    max-width: 175px;
}

.kuda-dark--theme .skeleton-card--top .kuda-card--wrap {
    background-color: rgba(219, 220, 224, 0);
}

.viewSavingsSummary .transaction-avatar svg {
    width: 100%;
    height: 100%;
}

.viewSavingsSummary .kuda-result--item {
    cursor: default;
}

.intercom-launcher-frame {
    background: #401a6e !important;
}

.break-right {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: auto;
}

.payment-bold--wrap {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.budget-result--holder .transaction-avatar img,
.overview-budget--wrap .transaction-avatar img,
.transaction-icon {
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.07);
    border-radius: 100px;
}

.share-earn--50:first-child {
    width: calc(45% - 7px);
    min-width: 118px;
}

.add-product--wrap {
    background: #ffffff;
    background: var(--whiteAlt);
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 1px 25px 55px;
    max-width: 350px;
    margin: 0 auto;
    margin-top: 40px;
    position: relative;
}

.kuda-dark--theme .add-product--wrap {
    background: rgba(219, 220, 224, 0.3) !important;
    background: var(--offWhiteTrans) !important;
}

.add-product--wrap h4 {
    font-size: 1rem;
}

.add-product--wrap .kuda-budget--illustration svg {
    width: 70px;
    height: 70px;
}

.add-product--wrap .margin-bottom--spacer {
    margin-bottom: 8px;
}

.linked-active {
    padding-bottom: 65px !important;
}

.revoke-content .kuda-modal-illustration svg {
    width: 86px !important;
    height: 86px !important;
}

.revoke-content h4 {
    max-width: 100%;
    line-height: 1.5;
    margin-top: 1.9rem !important;
}

.no-bottom--margin {
    margin-bottom: 0px !important;
}

.small-bottom--margin {
    margin-bottom: 8px;
}

.payoneer-heading {
    max-width: 336px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}

.kuda-dark--theme .payoneer-content svg path[fill="black"] {
    fill: #fff;
}

.kuda-dark--theme .collection-icon circle,
.kuda-dark--theme .kuda-balance--wrap .add-icon circle {
    opacity: 0.4;
}

.collection-info {
    color: #000000 !important;
    color: var(--blackColor) !important;
}

.Toaster__message:not(:last-child) {
    margin-bottom: 15px;
}

.kuda-dark--theme .copyAccount path {
    fill: #fff;
}

.kuda-dark--theme .Toaster__alert {
    background-color: #222222 !important;
}

.kuda-dark--theme .Toaster__alert * {
    color: #ffffff !important;
}

.kuda-dark--theme .transaction-avatar {
    background: #191919;
}

.kuda-dark--theme .animated.closeMenu {
    animation-fill-mode: both;
}

.verifiedName {
    display: flex;
    align-items: center;
}

.verifiedIcon svg {
    height: 13px;
    width: auto;
    margin-left: 6px;
    position: relative;
    top: 1px;
}

.kuda-header--actions {
    position: relative;
    display: flex;
    align-items: center;
}

.kuda-dayLight--toggle {
    cursor: pointer;
}

.DayPickerNavigation_button__disabled {
    opacity: 0.1;
}

.logout-active {
    opacity: 0.3;
}

.kuda-tran--holder .transaction-price {
    transform: none !important;
    -webkit-transform: none !important;
    -moz-transform: none !important;
    -ms-transform: none !important;
    -o-transform: none !important;
}

.error-auth--label {
    padding: 12px 20px;
    background: #ffdbdb;
    display: flex;
    align-items: center;
    border-radius: 5px;
    margin-bottom: 20px;
    margin-top: -10px;
    justify-content: flex-start;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
}

.error-auth--label span {
    display: inline-flex;
}

.auth-error-text {
    color: #f7685b;
    font-weight: 700;
    font-size: 0.8rem;
    margin-left: 7px;
    line-height: 1.3;
}

.auth-error-icon svg {
    height: 18px;
    width: 18px;
}

.kuda-announcement--card,
.kuda-login--header {
    background: #dfe3ff;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    padding: 16px 20px;
    margin-bottom: 18px;
}

.kuda-login--header {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    max-width: 390px;
    padding: 10px 0 !important;
}

.kuda-announcement--card h1 {
    color: #000000;
    font-weight: 900;
    font-size: 2.5rem !important;
}

.kuda-login--header p {
    font-weight: normal;
    font-size: 15px !important;
    line-height: 20px;
    margin-top: 11px;
}

.attempt-response {
    max-width: 330px;
}

.disclaimer {
    margin-top: 21px;
    font-size: 0.785rem !important;
    max-width: 315px;
}

.signout-button {
    margin-top: auto;
}

.kuda-error--wrap .inactive-wrap {
    max-width: 280px;
}

.kuda-error--wrap .kuda-modal-illustration {
    margin: 32px auto 35px;
}

.kuda-error--page {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.kuda-error--page .kuda-404--wrap {
    width: 100%;
}

.kuda-error--wrap {
    width: 100%;
}

.kuda-loader--wrap {
    display: flex;
    justify-content: center;
}

.payoneer-failed {
    position: absolute;
    top: 20px;
    right: 22px;
}

.payoneer-failed svg {
    width: 22px;
    height: 22px;
}

.kuda-external--link svg {
    height: 14px;
    width: auto;
    position: relative;
    transform: translateY(-0.5px);
    margin-left: 5px;
}

.kuda-external--link {
    display: flex;
    align-items: center;
}

.kuda-is--cursor {
    cursor: pointer;
}

.kuda-max--cardWidth {
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
}

.kuda-request--wrap .bill-item {
    height: 65px;
}

.bill-item .text-xs {
    margin-top: 3px;
}

.kuda-small--modal-md {
    max-width: 485px !important;
}

.kuda-small--modal-lg {
    max-width: 500px !important;
}

.card-check,
.analytics-card--section {
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    padding: 25px;
    margin-bottom: 50px;
}

.kuda-dark--theme .card-check {
    border-color: rgba(219, 220, 224, 0.03);
}

.card-check li {
    font-size: 0.875rem;
    line-height: 1.4;
}

.flex.justify-between .kuda-cta-lg-sm {
    max-width: 161px;
}

.card-check li svg {
    margin-right: 10px;
}

.card-check li:not(:last-child) {
    margin-bottom: 6px;
}

.block-item .payoneer-failed {
    top: 50%;
    transform: translateY(-50%);
    display: flex;
}

.block-item .payoneerCheck {
    top: 50%;
    transform: translateY(-50%);
}

.overdraft-text {
    max-width: 360px;
}

.overdraft-wrap .block-buttons {
    margin-top: 25px;
}

.modal-overdraft .modal-content {
    max-width: 517px !important;
}

.modal-overdraft .kuda-budget--form {
    height: calc(100vh - 355px) !important;
}

.modal-overdraft .kuda-modal-illustration svg {
    max-height: 128px;
    width: auto;
}

.modal-overdraft .kuda-modal-illustration {
    margin: 42px auto 20px;
}

.overdraft-other--text {
    font-size: 0.935rem;
}

.overdraft-onboarding {
    max-width: 307px;
    margin-left: auto;
    margin-right: auto;
}

.overdraft-other--text:not(:last-child) {
    margin-bottom: 30px;
}

.no-border--top {
    border-top: 0 !important;
}

.block-md {
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
}

.overdraft-terms {
    margin-top: 30px;
}

.overdraft-wrap .denomination-icon svg {
    height: 12px;
    width: auto;
}

.borrow-progress {
    position: static !important;
    height: 6px;
    margin-top: 25px;
    width: 100%;
}

.borrow-progress .savings-width {
    background-color: #1dcbef;
    position: relative;
}

.kuda-bank--section {
    position: relative;
}

.loan-progress--value {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: #1dcbef;
    background: var(--lightBlue);
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
    border-radius: 100px;
    width: 33px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: 900;
    color: #fff;
    right: -15px;
}

.overdraftResults {
    margin-left: -57px;
    margin-right: -57px;
}

.overdraftResults>div>* {
    padding-left: 30px;
    padding-right: 30px;
}

.overdraftResults .transaction-price {
    margin-right: 0;
}

.overdraftResults .transaction-avatar {
    background: none;
}

.overdraftResults .accept {
    margin-top: 45px;
    margin-bottom: 10px;
}

.overdraft-load--more {
    margin: 50px 0px 10px;
}

.kuda-borrow-card--content .disabled {
    opacity: 0.4;
}

.overdraft-subtext {
    max-width: 308px;
    margin-left: auto;
    margin-right: auto;
}

.overdraft-summary--card {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    padding: 12px 20px;
}

.overdraft-summary--title {
    display: flex;
    align-items: center;
}

.overdraft-summary--icon {
    margin: 12px auto;
    display: flex;
    justify-content: center;
}

.overdraft-summary--icon svg {
    background: #ffffff;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 200px;
}

.new-badge {
    background: #48d38a;
    border: 1px solid #dcffec;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.625rem;
    padding: 1px 5px 1px;
    margin-left: 7px;
}

.text-decoration--underline {
    text-decoration: underline;
    filter: none !important;
    -webkit-filter: none !important;
}

.call-active .modal-content .addAction {
    opacity: 0.9;
}

.kuda-success--modal .addAction {
    opacity: 1 !important;
    pointer-events: auto !important;
}

.kuda-success--modal {
    pointer-events: auto !important;
    left: auto;
    left: initial;
}

.overdraft-terms .accordion {
    padding-left: 10px;
    padding-right: 15px;
}

.kuda-dark--theme .freeTransfer--wrap,
.kuda-dark--theme .kuda-cta-primary-light,
.kuda-dark--theme .kuda-add--options>*,
.kuda-dark--theme .is-balance,
.kuda-dark--theme .Toaster__alert,
.kuda-dark--theme .kuda-balance--wrap,
.kuda-dark--theme .kuda-referral--card .empty-savings--card,
.kuda-dark--theme .kuda-history--items .kuda-transaction--tabs,
.kuda-dark--theme .savedIllustration,
.kuda-dark--theme .payoneer-dropDown,
.kuda-dark--theme .overdraft-summary--card {
    border-color: rgba(219, 220, 224, 0.03) !important;
    box-shadow: 5px 7px 10px rgba(64, 25, 109, 0.02) !important;
    background-color: rgba(219, 220, 224, 0.3) !important;
    background-color: var(--offWhiteTrans) !important;
}

.kuda-dark--theme .overdraft-summary--icon svg,
.kuda-dark--theme .overdraft-summary--icon svg circle {
    background-color: rgba(219, 220, 224, 0.3) !important;
    background-color: var(--offWhiteTrans) !important;
    fill: rgba(219, 220, 224, 0.3) !important;
    fill: var(--offWhiteTrans) !important;
}

.kuda-dark--theme .new-badge {
    border: 1px solid rgb(220 255 236 / 0.3);
}

.kuda-dark--theme .kuda-cta-loan-light {
    background-color: rgba(219, 220, 224, 0.3) !important;
    background-color: var(--offWhiteTrans) !important;
    border-color: rgba(219, 220, 224, 0.06) !important;
}

.maintenance-illustration {
    width: 100%;
    margin: 10px 0 30px;
}

.maintenance-modal .error-message {
    max-width: 380px;
}

.maintenance-modal .modal-content {
    max-width: 520px !important;
}

.kuda-card--badge {
    font-size: 0.75rem;
    background: #48d38a;
    color: #ffffff;
    color: var(--whiteColor);
    padding: 6px 32px;
    border-radius: 4px;
    position: relative;
    top: -2px;
}

.card-check .bottom-spacer {
    margin-bottom: 30px !important;
}

.kuda-cta-lg-md {
    max-width: 170px;
}

.other-delivery--wrap.disabled {
    opacity: 0.38;
}

.kuda-dropdown-list:empty {
    display: none;
}

.kuda-google--search .kuda-dropdown-header {
    z-index: 99999;
    position: relative;
}

.kuda-google--search .kuda-dropdown-list {
    padding-top: 46px;
}

.modal-active .kuda-google--search .kuda-dropdown-header {
    z-index: 999 !important;
}

.bottom-spacer--sm {
    margin-bottom: 20px !important;
}

.block-card--illustration svg {
    width: 60px;
    height: auto;
    box-shadow: 20px 15px 12px rgba(64, 25, 109, 0.1);
}

.card-bg-primary {
    background: #000000;
    background: var(--primaryColor);
}

.card {
    position: relative;
    width: 120px;
    height: 189px;
    perspective: 800px;
}

.card .flippy {
    width: 100%;
    height: 100%;
    perspective: 1000px;
    transform-style: preserve-3d;
    transition: all 1s;
}

.card .front,
.card .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card .front {
    transform: rotateX(0);
}

.card .back {
    transform: rotateX(180deg);
    transform: rotateY(180deg);
}

/* .physical-card svg {
    width: 100%;
    margin: 0;
    position: static;
    transform: none;
    top: auto;
} */

.active-card .card {
    transform: translate3d(-60px, 0, 0);
}

.card {
    transition: transform 0.8s;
    transition-delay: 0.5s;
    z-index: 1;
}

.card-animation--wrap {
    width: 100%;
    display: flex;
    justify-content: center;
}

.card-animation--wrap {
    height: 189px;
    position: relative;
}


.physical-card .flippy svg {
    /* width: 120px; */
    /* height: auto; */
    width: 241.245px;
    height: 379.999px;
    position: absolute;
}

.physical-card .flippy svg.card-back {
    visibility: hidden;
    transition: 0.2s;
    transform: rotateY(-180deg) translate3d(0, 0, 0);
}

.secret-icon {
    margin-left: 12px;
}

.kuda-google--search .dropdown-item--title {
    line-height: 1.5;
    font-size: 0.875rem;
}

.physical-card>svg {
    height: 189px;
    width: auto;
}

.bill-item.disabled {
    opacity: 0.55;
}

.secret-icon svg {
    height: auto;
}

.kuda-google--search .kuda-dropdown-item {
    background-color: transparent !important;
}

.secret-icon svg {
    width: 17px;
    height: auto;
}

.kuda-customer--options {
    border-bottom: 1px solid #dbdce0;
    padding: 15px 0;
}

.c-apps {
    margin: 0;
    padding: 0;
    list-style: none;
    margin: 0 -8px;
    display: flex;
    flex-wrap: wrap;
}

.c-apps__item {
    margin-bottom: 12px;
    padding: 0 8px;
}

.c-apps__link {
    display: block;
    text-decoration: none;
}

.c-apps__link svg,
.c-apps__link img {
    height: 46px;
    width: auto;
    display: block;
}

.briefcase-icon {
    margin-top: 50px;
}

.kuda-get--app {
    min-height: calc(100vh - 70px);
    transform: none !important;
    margin-top: 0;
    padding-top: 140px;
}

.kuda-is--centered {
    margin-left: auto;
    margin-right: auto;
}

.kuda-preview--signup .kuda-auth--layout {
    max-width: 752px;
}

.confirm-card--wrap {
    max-width: 500px;
    margin: auto;
}

.authenticate-card--wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}

.authenticate-acc--wrap {
    margin: 100px 0;
}

.authenticate-icons--wrap {
    max-width: 200px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.manage-users--add {
    max-width: 150px;
    /* margin-left: auto; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.manage-users--add a {
    background: #ffffff;
    border: 1px solid #dfe3ff;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    color: #000000;
    color: var(--primaryAlt);
    font-size: 0.875rem;
    padding: 10px;
    width: 100%;
    border-radius: 4px;
    text-align: center;
}

.users-avatar-sm {
    background: #dfe3ff;
    border-radius: 100px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    color: var(--primaryAlt);
    text-align: center;
}

.access-level--badge {
    border-radius: 100px;
    padding: 6px 19px;
    width: 78px;
    font-size: 0.925rem;
    max-width: 78px;
}

.homepage-error-wrap {
    display: flex;
    margin-top: 200px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.form-group-row {
    display: flex;
    width: 100%;
}

.form-group-row .card-group {
    margin-bottom: 0;
}

.form-group-row .card-group {
    width: calc(50% - 8px);
    margin: 0 !important;
}

.form-group-row {
    display: flex;
    justify-content: space-between;
}

/* MANAGE USERS */

.signatory-header--wrap p {
    font-weight: 800;
    font-size: 20px;
    text-align: center;
    margin-top: 15px;
    color: #000000;
}

.signatory-avatar--wrap {
    background: #dfe3ff;
    border: 0.964286px solid #000000;
    color: #000000;
    font-size: 30px;
    box-shadow: 30px rgba(31, 45, 138, 0.15);
    width: 80px;
    height: 80px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.signatory-header--wrap {
    width: 50%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.signatory-user--contents {
    justify-content: space-around;
}

.signatory-user--item div {
    margin-bottom: 20px;
}

/* MOVING LOADING BAR */

.page-overlay .loader-review {
    position: absolute;
    top: calc(50% + 60px);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    font-family: Arial;
    font-size: 13px;
    text-align: center;
}

/* .loading {
    background-color: "#2e6da4";
    height: 2px;
    margin: 1em;
    overflow: hidden;
    position: relative;
    width: 12em;
} */

.loading-bar {
    animation: sideToside 2s ease-in-out infinite;
    background-color: #000000;
    background-color: var(--primaryAlt);
    height: 100%;
    position: absolute;
    width: 50%;
}

@keyframes sideToside {

    0%,
    100% {
        transform: translateX(-50%);
    }

    50% {
        transform: translateX(150%);
    }
}

.center {
    left: 50%;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
}

.upload-btn-wrap input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    opacity: 0;
}

/* Invited Signatory */

.invite-link--error {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 284px;
    margin: auto;
}

.text-opaque {
    color: #979797;
}

.company-profile .summary-labels {
    margin-left: 0;
}

.company-profile .account-name {
    margin: 0;
}

.dot {
    margin-right: 10px;
}

.no-card--check {
    border: 0;
    padding: 0;
    box-shadow: none;
    margin-bottom: 25px;
}

.isTrue {
    color: #48d38a;
}

.card-check li>span {
    width: 20px;
}

.profile-full--block .amount-input {
    padding-right: 15px;
}

.kuda-nav--icon.disabled *,
.kuda-nav--icon.disabled {
    pointer-events: none !important;
    cursor: default;
}

.transaction-pin .pin-input {
    max-width: 100%;
}

.no-margin {
    margin: 0 !important;
}

/* Added New Card Styling*/

.card-bg-primary {
    background: #000000;
    background: var(--primaryColor);
}

/* .card {
    position: relative;
    width: 120px;
    height: 189px;
    perspective: 800px;
} */

.active-card .flippy {
    transform: rotateY(-180deg) translate3d(-100px, 0, 0);
    -webkit-transform: rotateY(-180deg) translate3d(-100px, 0, 0);
    -moz-transform: rotateY(-180deg) translate3d(-100px, 0, 0);
    -ms-transform: rotateY(-180deg) translate3d(-100px, 0, 0);
    -o-transform: rotateY(-180deg) translate3d(-100px, 0, 0);
}

.active-card .flippy svg.card-face {
    visibility: hidden;
    transition-delay: 0.2s;
}

.active-card .flippy svg.card-back {
    visibility: visible;
    transition-delay: 0.2s;
}

/* .card .flippy {
    width: 100%;
    height: 100%;
    perspective: 1000px;
    transform-style: preserve-3d;
    transition: all 1s;
} */

.card .front,
.card .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card .front {
    transform: rotateX(0);
}

.card .back {
    transform: rotateX(180deg);
    transform: rotateY(180deg);
}

/* .physical-card svg {
    width: 100%;
    margin: 0;
    position: static;
    transform: none;
    top: auto;
} */

/* .active-card .card {
    transform: translate3d(-60px, 0, 0);
} */

/* .card {
    transition: transform 0.8s;
    transition-delay: 0.5s;
    z-index: 1;
} */

.card-animation--wrap {
    width: 100%;
    display: flex;
    justify-content: center;
}

.card-animation--wrap {
    height: 189px;
    position: relative;
}

.card-secret-details {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.2s, transform 1s;
    transition-delay: 0.6s;
    z-index: 0;
}

.secret-wrap:not(:last-child) {
    margin-bottom: 16px;
}

.active-card .card-secret-details {
    transform: translateX(40%);
    opacity: 1;
}

.secret-icon {
    margin-left: 12px;
}

.kuda-google--search .dropdown-item--title {
    line-height: 1.5;
    font-size: 0.875rem;
}

.physical-card>svg {
    height: 189px;
    width: auto;
}

.bill-item.disabled {
    opacity: 0.55;
}

.secret-icon svg {
    height: auto;
}

.kuda-google--search .kuda-dropdown-item {
    background-color: transparent !important;
}

.secret-icon svg {
    width: 17px;
    height: auto;
}

.kuda-no--bg {
    padding: 0 !important;
    background: none !important;
    border: 0 !important;
    box-shadow: none !important;
    margin-top: 0 !important;
}

.kuda-single--slide {
    padding-right: 20%;
}

.kuda-single--slide {
    display: flex;
    flex-direction: column;
    min-width: 80%;
}

.kuda__container {
    display: flex;
}

.kuda-single--slide:first-child {
    padding-left: 20%;
    padding-right: 0;
}

.kuda-overflow--hidden {
    overflow-x: hidden;
}

.kuda__viewport {
    position: relative;
}

.carousel-pagination--wrap .kuda__button {
    position: absolute;
    top: calc(50% - 50px);
    transform: translateY(-50%);
    left: -40px;
    right: auto;
    cursor: pointer;
}

.kuda__button--next {
    left: auto !important;
    right: -40px !important;
}

.kuda-single--slide .request-text {
    opacity: 0;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    -ms-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;
}

.kuda-single--slide.is-selected .request-text {
    opacity: 1;
    transition: opacity 0.6s !important;
    -webkit-transition: opacity 0.6s !important;
    -moz-transition: opacity 0.6s !important;
    -ms-transition: opacity 0.6s !important;
    -o-transition: opacity 0.6s !important;
    transition-delay: 100ms !important;
}

.kuda-single--slide:only-child {
    padding: 0;
}

.kuda-full--slide {
    padding: 0 !important;
    min-width: 100%;
    padding-left: 70px !important;
    padding-right: 70px !important;
}

.kuda-full--slide.is-selected .request-wrap {
    justify-content: center;
}

.select-card--wrap .kuda__button {
    top: 72px;
    transform: none;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    z-index: 9;
}

.kuda__button svg {
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    display: flex;
    border-radius: 5px;
}

.kuda__button[disabled] {
    opacity: 0.4;
    pointer-events: none;
}

.kuda-no-sidePadding {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.kuda-no-sidePadding .kuda__button {
    left: 30px;
}

.kuda-no-sidePadding .kuda__button--next {
    right: 30px !important;
    left: auto;
}

.kuda__dots {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    cursor: pointer;
}

.kuda__dot {
    width: 8px;
    height: 8px;
    display: flex;
    background-color: #dbdce0;
    border-radius: 100px;
    transition: all 0.6s;
    -webkit-transition: all 0.6s;
    -moz-transition: all 0.6s;
    -ms-transition: all 0.6s;
    -o-transition: all 0.6s;
}

.kuda__dot:not(:last-child) {
    margin-right: 8px;
}

.dot-active {
    background-color: #000000;
    background-color: var(--primaryColor);
}

.kuda-arrow--helper {
    position: absolute;
    background-size: contain;
    background-repeat: no-repeat;
    color: #fff;
    height: 38px;
    width: 240px;
    font-size: 0.8125rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 110px;
    left: calc(50% - 7px);
    transform: translateX(-50%);
    z-index: 3;
}

.helper-illustration svg {
    width: 100%;
    height: auto;
    transform: scale(1.4);
    position: relative;
    left: 10%;
    -webkit-transform: scale(1.4);
    -moz-transform: scale(1.4);
    -ms-transform: scale(1.4);
    -o-transform: scale(1.4);
}

.kuda-arrow--helper span {
    position: absolute;
    top: -22px;
    align-items: center;
}

/* Helper animations */

.kudaFadeInUpHelper {
    webkit-animation-name: kudaFadeInUpHelper;
    animation-name: kudaFadeInUpHelper;
}

@keyframes kudaFadeInUpHelper {
    0% {
        opacity: 0;
        margin-top: 10px;
    }

    100% {
        opacity: 1;
        margin-top: 0px;
    }
}

.loan-icon svg {
    height: 34px;
    width: auto;
}

.owe-tab {
    margin-top: 25px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    height: 63px !important;
    border: 0;
}

.kuda-loan--wrap {
    display: flex;
    align-items: center;
}

.loan-icon {
    margin-right: 20px;
    display: flex;
}

.kuda-no--bottom {
    margin-bottom: 0;
}

.channels-toggle.disabled {
    opacity: 0.35;
}

.channels-toggle {
    margin-top: 45px;
}

.channels-toggle .optional-title {
    top: 0;
}

.kuda-no-add--details {
    padding-bottom: 0;
    padding-top: 38px;
    display: flex;
    justify-content: center;
    border-bottom: 0;
}

.virtual-extra--details {
    position: absolute;
    z-index: 1;
    bottom: 11px;
    left: 10px;
}

.card-xs {
    font-size: 0.5rem;
}

.kuda-dark--theme .kuda__button path[fill="#979797"] {
    fill: #ffffff !important;
}

.kuda-dark--theme .kuda__button path[stroke="#F4F4F4"] {
    fill: #212121;
    stroke: #212121;
}

.virtual-extra--details .color-primary {
    color: #000000 !important;
    color: var(--primaryColor) !important;
}

.owe-tab .borrow-progress {
    margin-top: 11px;
    height: 4px;
    margin-bottom: 2px;
}

.no-padding {
    height: auto !important;
    border-bottom: 0 !important;
    margin-bottom: 40px;
}

.margin-right--spacer {
    width: 100%;
    margin-right: 15px;
}

.excerpt {
    max-width: 300px;
    line-height: 1.5;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    margin-bottom: 20px;
}

.kuda-cta-loanAlt {
    border: 1px solid #1dcbef;
    border: 1px solid var(--lightBlue);
    background-color: #f9f9f9;
    background-color: var(--offWhite);
    color: #1dcbef;
    color: var(--lightBlue);
}

.header-left {
    cursor: pointer;
}

.percentage-toggle {
    background: none;
    outline: 0;
}

.percentage-toggle.disabled {
    opacity: 0.5;
}

.left-seperator {
    margin-left: 23px;
}

.call-active.backdrop-init * {
    pointer-events: none;
}

.always-active {
    pointer-events: auto !important;
    opacity: 1 !important;
}

.percentage-summary.disabled {
    opacity: 0.4;
}

.virtual-extra--details .text-xs {
    font-size: 0.6rem;
}

.kuda-single--slide .bill-item-wrap {
    padding-right: 10px;
}

.kuda-borrow-card--content {
    margin-top: 25px;
}

.overdraft-borrow--wrap .kuda-modal-illustration {
    margin-top: 35px;
}

.loan-skeleton {
    margin-top: 25px !important;
}

.kuda-reset--card {
    background: #ffffff;
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;
    padding: 50px;
    border-radius: 5px;
}

.kuda-reset--password {
    width: 100%;
}

.kuda-reset--wrap .kuda-card--wrap {
    max-width: 533px;
    padding: 56px 77px;
    margin-top: 0;
}

.kuda-reset--wrap .kuda-text--top {
    margin-top: 12px;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
}

.kuda-reset--wrap .kuda-buttons {
    margin-top: 35px;
    margin-left: auto;
    margin-right: auto;
    max-width: 198px !important;
}

.kuda-dark--theme .kuda-reset--card {
    border-color: rgba(219, 220, 224, 0.03);
}

.no-card--check {
    border: 0;
    padding: 0;
    box-shadow: none;
    margin-bottom: 25px;
}

.isTrue {
    color: #48d38a;
}

.secret-wrap {
    cursor: copy;
    /* margin: 0 !important; */
}

.migrate-modal--img {
    width: 59px;
    height: 59px;
}

.migrate-modal--img svg {
    width: 100%;
    height: 100%;
}

/*** GENERAL ***/

.is-centered {
    margin-left: auto;
    margin-right: auto;
}

.kuda-has--ellipsis {
    padding-right: 10px;
}

.kuda-has--ellipsis>* {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    -webkit-hyphens: auto;
    hyphens: auto;
}

.kuda-plus--inner {
    font-size: 1.875rem;
    line-height: 1;
    display: block;
    padding-bottom: 5px;
}

.tier-inner--wrap {
    padding-top: 5px;
}

.has-flag {
    border: 0 !important;
    border-radius: 100px;
    overflow: hidden;
    background: rgb(1 33 105 / 0.1);
    padding: 4px;
}

.has-flag img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 100px;
}

.onboarding-info--wrap .utility-upload-wrap {
    min-height: 48px;
}

.kuda-ignore--container {
    width: 100vw;
    position: relative;
    margin-left: -50vw;
    left: 50%;
}

.kuda-started--container {
    max-width: 860px;
}

.kuda-started--container .block-item {
    max-width: 585px;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64 25 109 / 7%);
}

.kuda-started--container .auth-wrap {
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
}

.heading-spacer {
    margin-bottom: 2.1rem;
}

.kuda-started--container .onboarding-info--wrap {
    max-width: 606px;
    width: 100%;
}

.boxed-width--lg {
    max-width: 460px;
}

.react-datepicker__header__dropdown--select {
    padding: 20px 18px 10px;
    display: flex;
    justify-content: space-between;
}

.react-datepicker__header__dropdown>* {
    width: calc(50% - 8px);
}

.react-datepicker__header__dropdown>* select {
    width: 100% !important;
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
    height: 35px;
    padding: 8px 10px;
    outline: 0;
    -o-appearance: none;
    appearance: none;
    background-position: calc(100% - 10px) 50%;
    background-size: 9px;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    padding-right: 30px !important;
}

.upload-limited--docs {
    max-width: 620px;
}

/* .upload-docs--wrap .upload-btn-wrap {
    min-height: 46px;
    max-height: 46px;
} */

.inner-max-label {
    max-width: 220px !important;
    margin: 0 auto;
}

.upload-item .text-smd {
    font-size: 0.915rem;
}

.icon-is--absolute {
    position: absolute;
    right: -38px;
    display: flex;
    top: 50%;
    transform: translateY(-50%);
}

.is-remove--icon {
    right: 18px;
}

.is-success--icon {
        left: 18px;
}

.hasUpload {
    /* padding-right: 30px; */
}

.utility-upload-wrap .hasUpload {
    padding-right: 0;
}

.hasUpload>a,
.hasUpload>p {
    width: 100%;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    -webkit-hyphens: auto;
    hyphens: auto;
    font-size: 0.8125rem;
}

.hasUpload>p {
    padding: 0 22px;
}

.failure-bg {
    height: 2px;
    width: 100%;
    margin-top: 4px;
}

.react-datepicker__header__dropdown--select {
    padding: 20px 18px 10px;
    display: flex;
    justify-content: space-between;
}

.react-datepicker__header__dropdown>* {
    width: calc(50% - 8px);
}

.react-datepicker__header__dropdown>* select {
    width: 100% !important;
    border: 1px solid #f4f4f4;
    border: 1px solid var(--bgOffset);
    box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
    height: 35px;
    padding: 8px 10px;
    outline: 0;
    -o-appearance: none;
    appearance: none;
    background-position: calc(100% - 10px) 50%;
    background-size: 9px;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    padding-right: 30px !important;
}

.kuda-has--flag .kuda-flag {
    position: absolute;
    bottom: 16px;
    pointer-events: none;
}

.kuda-phone--heading {
    margin-bottom: 5px;
}

.react-tel-input .selected-flag {
    padding-left: 0 !important;
}

.react-tel-input {
    font-family: "Muli", sans-serif !important;
    z-index: 10;
}

.react-tel-input .country-list .search {
    padding: 7px 15px !important;
    background: #ffffff !important;
    background: var(--whiteColor) !important;
    border-bottom: 1px solid #f4f4f4 !important;
    border-bottom: 1px solid var(--bgOffset) !important;
    border-top-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
}

.react-tel-input .country-list .search-box {
    height: 40px !important;
    border: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    outline: none !important;
    background-color: #ffffff !important;
    background-color: var(--whiteColor) !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
    text-transform: capitalize !important;
}

.react-tel-input .country-list {
    background: #ffffff !important;
    background: var(--whiteColor) !important;
    border: 1px solid rgba(219, 220, 224, 0.5) !important;
    border: 1px solid var(--borderOff) !important;
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07) !important;
    box-shadow: 15px 30px 40px var(--boxShadow) !important;
    border-radius: 5px !important;
    margin-top: -2px !important;
    width: 100% !important;
}

.react-tel-input .flag-dropdown {
    width: 100% !important;
}

.kuda-has--flag input {
    padding-left: 10px !important;
    /* position: relative !important; */
    z-index: 9 !important;
    margin-left: 40px !important;
    border-bottom: 0 !important;
}

.react-tel-input {
    border-bottom: 1px solid rgba(219, 220, 224, 0.3) !important;
    border-bottom: 1px solid var(--offWhiteTrans) !important;
}

.react-tel-input .country-list .country {
    border-bottom: 1px solid #f4f4f4;
    border-bottom: 1px solid var(--bgOffset);
    padding: 15px 0 15px 38px !important;
    color: #000000 !important;
    color: var(--blackColor) !important;
    width: calc(100% - 32px) !important;
    margin: 0 auto !important;
    background: none !important;
}

.react-tel-input .country-list .flag {
    left: 0 !important;
}

.react-tel-input .country-list .divider {
    border: none !important;
}

.react-datepicker-popper {
    z-index: 99 !important;
}

.react-tel-input .country-list {
    max-height: 250px !important;
}

.block {
    display: block;
}

.kuda-reset--password input {
    padding-left: 0;
}

.kuda-report--transaction {
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    padding: 14px 27px;
}

.color-red {
    color: #f7685b !important;
    color: var(--negativeColor) !important;
}

.transaction-icon svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.transaction-avatar svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.report-icon {
    min-width: 130px;
}

.toggle-icon--button svg {
    height: 20px;
    width: 18px;
    display: flex;
}

.export-modal .modal-content {
    max-width: 530px;
    padding: 42px 50px 54px;
}

.export-modal .kuda-radio--wrapper label {
    padding-left: 42px;
}

.export-modal .kuda-radio--wrapper p {
    font-size: 0.875rem !important;
    line-height: 1;
}

.header-bottom--spacing {
    margin-bottom: 2.5rem;
}

.export-modal .kuda-radio--wrapper .outer {
    left: 13px;
    width: 20px;
    height: 20px;
}

.export-modal .react-datepicker,
.export-modal .react-datepicker__month-container {
    min-width: 380px;
}

.kuda-bulk--table svg {
    height: 17px;
    width: auto;
    display: flex;
}

.kuda-bulk--table td,
.kuda-bulk--table th {
    vertical-align: middle !important;
}

.kuda-signatory--table td {
    font-size: 0.9375rem !important;
    height: 100%;
}

.kuda-bulk--table tr td:first-child:before {
    display: none;
}

.min-id {
    padding-right: 22px;
}

.table-spinner .spinner {
    height: 17px;
    width: 17px;
}

.min-loader--item {
    width: 24px;
    min-width: 24px;
}

.scheduled-empty--state .empty-summary {
    margin: 48px 20px;
}

.analytics-others--wrap .account-avatar-sm {
    background-color: #48d38a;
    background-color: var(--successColor);
    font-size: 0.875rem;
    color: #ffffff;
    color: var(--whiteColor);
    min-width: 40px;
    height: 40px;
}

.no-top--margin {
    margin-top: 0 !important;
}

.kuda-cta-md--alt {
    height: 30px !important;
    padding: 0 !important;
    font-size: 0.825rem;
    max-width: 90px !important;
    border-radius: 5px;
    width: 100%;
}

.schedule-payment--switch .toggle {
    width: auto;
}

.kuda-cta-md--alt {
    height: 30px !important;
    padding: 0 !important;
    font-size: 0.825rem;
    max-width: 90px !important;
    border-radius: 5px;
    width: 100%;
}

.scheduled-icon svg {
    width: 20px !important;
}

.kuda-badge {
    height: 22px;
    font-size: 0.65rem;
    font-weight: 700;
    width: 60px;
    max-width: 100%;
    background-color: #000000;
    background-color: var(--primaryColor);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 10px;
}

.badge-is--success {
    background-color: #dcffec;
    background-color: var(--successColorTrans);
    color: #48d38a;
    color: var(--successColor);
}

.badge-is--pending {
    color: #ffc83e;
    background-color: #fff5db;
}

.badge-is--failed {
    color: #979797;
    background-color: #f9f9f9;
}

.transaction-price {
    position: static;
}

.action-item:not(:last-child) {
    margin-right: 6px;
}

.actions-wrap {
    min-width: 78px;
    justify-content: flex-end;
}

.action-item svg {
    display: flex;
}

.kuda-multi--radio label {
    box-shadow: none !important;
    background-color: none !important;
    background: none !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-color: #dbdce0;
}

.top-toggle-button {
    position: absolute;
    font-size: 13px;
    display: flex;
    align-items: center;
    top: 25px;
    right: 30px;
}

.toggle-top {
    width: 42px;
    border-radius: 16px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    box-sizing: border-box;
    align-self: center;
    -webkit-user-select: none;
    user-select: none;
}

.toggle-top:after {
    height: 15px;
    width: 15px;
    top: 4px;
    left: 4px;
}

.toggle input[type="checkbox"]:checked+.toggle-top:after {
    transform: translateX(20px);
}

.old-account--wrap {
    /* max-width: 391px; */
    max-width: 100%;
    background: #ffffff;
    /* border: 1px solid rgba(219, 220, 224, 0.5); */
    border-radius: 5px;
    padding: 11px 19px;
    min-height: 51px;
    display: flex;
    align-items: center;
    width: 100% !important;
}

.add-users-outer {
    width: 14px !important;
    height: 14px !important;
    border-radius: 100px;
    background-color: #48d38a;
    background-color: var(--successColor);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 16px;
}

.phoneInput {
    border: 0;
    /* border-bottom: 1px solid var(--offWhiteTrans); */
    outline: none;
    padding-top: 13px;
    padding-bottom: 13px;
    padding-left: 13px;
    font-weight: 600;
    border-radius: 0;
    background: none;
    width: 100%;
}

.phoneInput .selected-flag {
    margin-left: 5px;
}

.users-avatar-nw {
    background: #DBDCE0;
    border-radius: 100px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    color: var(--primaryAlt);
    text-align: center;
    border: 1px solid #000000;
    border: 1px solid var(--primaryAlt);
}

.kuda-search-manage-users {
    width: 100%;
    position: relative;
}

.height-52 {
    height: 52px !important;
}

.width-120 {
    width: 120px !important;
}

.nobackground-noborder {
    background: none !important;
    border: none !important;
}

.text-center {
    text-align: center;
}

.addBtn-signatory--wrap .add-signatory--label {
    border-radius: 0 !important;
    padding-left: 20px;
}

.addBtn-signatory--wrap .add-signatory--label .outer {
    left: 0
}

.kuda-multi--radio {
    padding: 15px 5px 0
}

.payment-active .kuda-preview {
    /* max-width: 900px; */
}

.kuda-payment--request {
    max-width: 740px !important;
}

.request-item--wrap {
    width: 100%;
}

.kuda-payment--item---wrap>* {
    padding-left: 30px;
    padding-right: 30px;
}

.has-paymentRequest--list .kuda-card--wrap {
    padding-left: 0;
    padding-right: 0
}

.width-100 {
    width: 100%
}

/* .kuda-result--body .request-item--wrap {
    padding: 15px 0px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
} */

.request-items--parent {
    padding: 20px 0px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
}

.request-action {
    display: block;
    min-width: 90px;
    max-width: 90px;
    width: 90px;
}

.request-amount {
    display: block;
    min-width: 120px;
    max-width: 120px;
    width: 120px;
}

.request-payment {
    display: block;
    width: 100%;
}

.request-item--wrap p:not(.text-sm) {
    font-size: 0.9rem;
}

.request-item--wrap {
    padding: 0 10px;
}

.right-separator--15 {
    margin-right: 15px;
}

.right-separator--20 {
    margin-right: 20px;
}

.kuda-success--modal .card-check {
    margin-bottom: 30px;
    margin-top: 30px;
    padding: 15px;
}

.kuda-success--modal .card-check li {
    font-size: 0.875rem;
}

.request-date {
    display: block;
    min-width: 120px;
    max-width: 120px;
    width: 120px;
}

.request-action {
    text-align: center;
}

.kuda-signatory--table th {
    font-size: 0.875rem;
}

.manage-users--add {
    width: 150px;
    height: 48px;
    max-height: 48px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border-radius: 10px !important;
    -webkit-border-radius: 10px !important;
    -moz-border-radius: 10px !important;
    -ms-border-radius: 10px !important;
    -o-border-radius: 10px !important;
}

.manage-users--add.color-primary {
    background-color: #000000;
    background-color: var(--primaryColor);
    color: #ffffff;
}

.restricted-image {
    padding-top: 24px;
    background: #F4E6FF;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    margin-bottom: 3rem
}

.displayResults {
    position: relative;
}

.displayResults .spinner-wrap {
    top: -6px;
}

.no-prefix:before {
    display: none;
}

.kuda-terms--tab {
    height: 25px;
    min-height: 35px;
}

.kuda-terms--tab>li[aria-selected="true"]:after {
    display: none
}

.kuda-terms--tab>li {
    font-size: 0.875rem !important
}

.kuda-terms--tab {
    background-color: rgba(118, 118, 128, 0.12);
    border-radius: 10px !important;
    align-items: center;
}

.kuda-terms--tab>li[aria-selected="true"] {
    height: 29px;
    background-color: #ffffff;
    border-radius: 8px;
}

.modal-terms .modal-content {
    max-width: 550px
}

.modal-terms .modal-content {
    max-height: calc(100vh - 120px);
    height: 100vh;
}

.modal-terms .kuda-modal--content {
    height: 100%;
}

.no-top--spacing {
    margin-top: 0px !important;
}

.no-top--spacing---10 {
    margin-top: 10px !important;
}

.kuda-terms--wrap {
    margin-top: 30px;
    max-height: calc(100vh - 573px);
    overflow-y: scroll;
}

.kuda-section--heading {
    margin-bottom: 10px;
}

.kuda-spacing--inner {
    margin-bottom: 20px;
}

.kuda-terms--wrap p {
    font-size: 0.825rem;
}

.kuda-terms--wrap .kuda-section--heading {
    font-size: 0.925rem !important;
}

.kuda-terms--wrap .card-main--heading {
    font-size: 0.925rem !important;
}

.kuda-terms--wrap .kuda-spacing--inner:not(:first-child) {
    margin-top: 20px;
}

.bottom--spacing {
    margin-bottom: 20px;
}

.kuda-single--term {
    overflow-x: hidden;
}

.kuda-table table th,
.kuda-table table td {
    border-top: 1px solid #dfe2e5;
    padding: 14px 20px;
    font-size: 0.825rem;
    font-weight: 500;
    vertical-align: baseline;
    vertical-align: initial;
    text-align: left;
    color: #000 !important;
    line-height: 1.4;
}

.kuda-table {
    border: 1px solid #dfe2e5;
    border-radius: 4px;
}

.kuda-table table {
    width: 100%;
}

.kuda-table thead tr {
    background: #ece8f0;
}

.kuda-table thead tr th,
.kuda-table thead tr td {
    border-top: 0;
}

.kuda-table thead td,
.kuda-table thead th {
    vertical-align: baseline;
    vertical-align: initial;
    text-align: left;
    font-weight: 800;
    color: #000;
    padding-top: 15px;
    padding-bottom: 15px;
}

.diclaimer-list li {
    list-style-type: disc;
    margin-left: 22px;
}

.diclaimer-list li:not(:last-child) {
    margin-bottom: 5px;
}

.pin-input input:last-child {
    margin-right: 0;
}

.modal-terms .kuda-radio--wrapper label {
    font-size: 0.925rem !important;
}

.business-account--heading {
    margin-bottom: 25px;
}

.kuda-login--wrap .card-group:not(:last-child) {
    margin-bottom: 20px
}

.kuda-login--wrap .kuda-customer--options:first-child {
    border-top: 1px solid #dbdce0
}

/*** DROP DOWN **/

.dropdown-menu {
    top: 58px !important;
    opacity: 1;
    visibility: visible;
    display: block !important;
    position: absolute;
    padding-top: 0px;
    width: max-content;
    right: 0px;
}

[data-toggle="dropdown"]:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    top: 38px !important;
}

.kuda-dropdown--menu {
    border-radius: 10px;
    white-space: nowrap;
    background: #FFFFFF;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    min-width: 350px;
}

.kuda-nav--menu {
    position: relative;
}

.kuda-nav--menu {
    position: relative;
}

.kuda-dropdown--menu li .menu-link {
    border-radius: 5px;
    padding: 19px 25px;
    font-weight: 500;
    color: #000000;
    font-size: 0.875rem !important;
    display: inline-flex;
    align-items: center;
    font-weight: 600;
}

.kuda-dropdown--menu li {
    margin: 0 !important;
}

.menu-state--active .dropdown-menu {
    opacity: 0 !important;
    visibility: hidden !important;
    top: 44px !important;
}

[data-toggle=dropdown]>.no-link,
[data-toggle=dropdown]>a {
    height: 40px;
    cursor: pointer;
}

.dropDown {
    margin-left: 7px;
}

.kuda-icon--separator svg {
    margin-right: 12px;
    display: block;
    min-width: 22px;
}

.kuda-dropdown--menu li:not(:last-child) {
    border-bottom: 1px solid rgb(219, 220, 224, 50%);
}

.kuda-dropdown--menu .profile-account {
    margin-bottom: 0;
    width: 100%;
}

.kuda-dropdown--menu .kuda-account--summary {
    margin-bottom: 0;
}

.kuda-dropdown--menu .account-image {
    width: 42px;
    height: 42px;
    min-height: 42px;
    min-width: 42px;
    margin-top: 0;
}

.kuda-dropdown--menu .account-image>div {
    font-size: 1.5rem;
}

.kuda-dropdown--menu .summary-labels {
    margin-left: 12px;
}

.kuda-dropdown--menu .account-name {
    font-size: 1.1rem
}

.sign-in--button {
    width: 125px !important;
}

.account-switch--list {
    max-height: calc(100vh - 485px);
    overflow-y: scroll;
}

.kuda-switch--icon---wrap svg {
    height: 30px;
    width: auto;
}

.drop-icon {
    margin-left: 10px;
}

.upload-in--progess {
    padding-right: 48px !important;
}

.disabled-90 {
    opacity: 0.4 !important;
    pointer-events: none;
}

.z-index-1 {
    z-index: 1;
}

.kuda-no--padding {
    padding: 0;
}

.kuda-sample--wrap {
    width: 100%;
}

.kuda-sample--tabs {
    width: 270px;
}

.kuda-sample--body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 640px;
    width: calc(100% - 270px);
}

.kuda-sample--body .react-tabs__tab-panel {
    width: 100%;
}

.kuda-sample--content---holder {
    max-width: 800px !important;
}

.kuda-sample--tabs {
    background-color: #F9F9F9;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    display: flex;
    flex-direction: column;
}

.kuda-sample--body img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    max-height: 550px;
}

.kuda-label--regular {
    font-size: 0.935rem;
}

.reset-pin--wrap .transaction-create--pin {
    max-width: 320px;
}

.doc-button--wrap {
    display: flex;
    width: 100%;
    margin-top: auto;
    padding: 48px 31px 55px;
    justify-content: center;
    height: 100%;
    align-items: flex-end;
    border-top: 1px solid rgb(0, 0, 0, 0.05)
}

.card-padding {
    padding: 0 50px;
}

.no-border--radius {
    border-radius: 0 !important;
}

.payment-skeleton--table>div:not(:last-child) {
    margin-right: 30px;
}

.min-wrap {
    min-width: 45%;
}

.min-wrap span {
    border-radius: 100px;
    display: flex;
}

.kuda-tab--card {
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    margin-top: 22px;
    background-color: #ffffff;
    background-color: var(--whiteAlt);
}

.request-status {
    width: 90px;
    min-width: 90px;
}

.kuda-scheduled--item---wrap .request-date {
    min-width: 125px;
    max-width: 125px;
    width: 125px;
}

.kuda-scheduled--item---wrap .request-action {
    display: block;
    min-width: 54px;
    max-width: 54px;
    width: 54px;
}

.kuda-scheduled--item---wrap .request-amount {
    min-width: 105px;
    max-width: 105px;
    width: 105px;
}

.document-is--sided {
    flex-wrap: wrap;
    margin-right: -20px;
}

.document-is--sided>div {
    width: calc(50% - 20px);
    margin-right: 20px
}

.document-is--sided .hasUpload {
    padding-right: 55px;
}

.document-is--sided .is-success--icon {
    right: 48px
}

.document-is--sided .is-remove--icon {
    right: 15px
}

.inline-sample--wrap {
    border: 1px dashed rgb(0, 0, 0, 0.2);
    min-height: 52px;
    font-size: 0.925rem;
    text-align: center;
    line-height: 1.3;
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    position: relative;
}

.inline-sample--text {
    max-width: 240px;
}

.inline-sample--wrap:before {
    content: "";
    display: block;
    width: 20px;
    position: absolute;
    left: -21px;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
}

.kuda-auth--wrap .kuda-login--wrap .kuda-customer--option .signup-dropdown {
    font-size: 0.875rem !important;
}

.edit-moreOptions--wrap .card-group:not(:last-child) {
    margin-bottom: 21px
}

.edit-moreOptions--wrap .kuda-radio--wrapper input:not(:checked)+label {
    background-color: #f9f9f9 !important;
    background-color: var(--offWhite) !important;
    color: #000000;
    color: var(--blackColor);
    border-color: #f9f9f9 !important;
    border-color: var(--offWhite) !important;
}
.edit-moreOptions--wrap .payments__single-transfer-modal__check-box input:not(:checked)+label{
    background-color: transparent !important;
    border-color: #fff !important;
}



.edit-moreOptions--wrap .kuda-radio--wrapper label {
    border-color: #48d38a !important;
    border-color: var(--successColor) !important;
    box-shadow: none;
    color: #000000;
    color: var(--blackColor);
}

.edit-moreOptions--wrap .inner {
    width: 100%;
    height: 100%;
    background-color: transparent !important;
}

.edit-moreOptions--wrap .inner svg {
    width: 100%;
    height: 100%;
    object-fit: cover
}

.edit-moreOptions--wrap .kuda-radio--wrapper input:not(:checked)+label .inner {
    display: none;
}

.edit-moreOptions--wrap .kuda-select--radio {
    height: 50px;
}

.kuda-get--app .kuda-signup--wrap {
    max-width: 957px !important;
    margin: 0 auto;
}

.kuda-reports--radio .radio-height--md {
    max-width: 50%;
    width: 50%
}

.tier-wrap {
    width: 90px;
    height: 90px;
    border-radius: 200px;
    background: #F4F4F4;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.tier-warning {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 200px;
    box-shadow: 0px 20px 25px rgba(247, 104, 91, 0.3);
}

.kuda-no--transition {
    transform: none !important;
    position: relative;
}

.text-sm--md {
    font-size: 0.9rem;
}

.bottom-spacer--sm---x2 {
    margin-bottom: 26px;
}

.payment-confirmation .edit-moreOptions--wrap .kuda-radio--wrapper {
    width: 100%
}

.bottom-spacer--xs {
    margin-bottom: 12px;
}

.payment-confirmation .kuda-radio--wrapper label {
    font-size: 0.95rem;
    padding-left: 55px;
    height: 50px;
}

.verifiedName.block {
    line-height: 1.25;
}

.analytics-income--expense .analytics-income--item {
    padding: 12px 0 !important;
}

.analytics-income--expense .analytics-income--item:last-child {
    padding-bottom: 0 !important;
}

.analytics-income--expense .analytics-income--item:first-of-type {
    padding-top: 0 !important;
}

.kuda-mask--balance .transaction-price,
.kuda-mask--balance .request-amount {
    filter: blur(3.5px);
    -webkit-filter: blur(3.5px);
}

.profile-disabled {
    position: relative;
    border: 1px solid rgba(247, 104, 91, 0.2);
    cursor: pointer;
}

.kuda-badge--disabled {
    background: #f7685b;
    background: var(--negativeColor);
    color: #ffffff;
    font-size: 0.625rem;
    text-transform: uppercase;
    font-weight: 700;
    padding: 5px 5px 3.5px;
    border-radius: 5px;
    line-height: 1;
    display: block;
    position: absolute;
    top: -8px;
    right: 20px;
    cursor: pointer;
}

.signup-form--wrap,
.account-setup--right {
    padding-top: 12px
}
.approver--tab>li{
    width: 100% !important
}

.width-100-i {
    width: 100% !important;
}

@media only screen and (max-width: 571px) {

    .payment-types-flex:before {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .payment-types-flex:after {
        padding-left: 10px !important;
        content: "";
        display: block;
    }

    .payment-types-flex {
        -ms-overflow-style: -ms-autohiding-scrollbar;
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: mandatory;
        -ms-scroll-snap-points-y: repeat(50%);
        scroll-snap-type: x mandatory;
        justify-content: flex-start !important;
        flex-wrap: nowrap !important;
        overflow-y: scroll;
        scroll-padding-left: 20px;
        -ms-overflow-style: none;
        scrollbar-width: none;
        padding-left: 0px !important;
        padding-right: 0px !important;
        padding-bottom: 10px !important;
    }

    .payment-types-flex::-webkit-scrollbar {
        display: none;
    }

    .payment-types-flex nav {
        min-width: max-content;
    }

}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,qCAAqC;IACrC,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,oCAAoC;IACpC,uCAAuC;IACvC,qBAAqB;IACrB,mCAAmC;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;IACpB,6BAA6B;IAC7B,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;IAC9B,8BAA8B;IAC9B,iDAAiD;IACjD,qDAAqD;IACrD,2DAA2D;IAC3D,oEAAoE;AACxE;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;IACpB,uCAAuC;IACvC,qCAAqC;IACrC,qBAAqB;IACrB,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,sCAAsC;IACtC,mCAAmC;IACnC,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;IAClB,oCAAoC;IACpC,wCAAwC;IACxC,qBAAqB;IACrB,mCAAmC;IACnC,oCAAoC;IACpC,6BAA6B;IAC7B,4CAA4C;IAC5C,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,8EAA8E;AAClF;;AAEA,eAAe;;AAEf;IACI,mCAAmC;IACnC,kCAAkC;IAClC,4CAA4C;IAC5C,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA,SAAS;;AAET;IACI,uBAAuB;IACvB,4CAAsC;IACtC,2LAAgM;AACpM;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,kBAAkB;;AAElB;;IAEI,+BAA+B;IAC/B,eAAe;IACf,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IAGjB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;;AAIA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;AACf;AACA;IACI;OACG,eAAe;IAClB;;AAEJ;AACA;IACI;OACG,eAAe;IAClB;AACJ;;AAEA;IACI;OACG,eAAe;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IAEI,aAAa;IAEb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,qBAAqB;;AAErB;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAA0B;IAA1B,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,cAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAqB;IAArB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA0C;IAA1C,0CAA0C;AAC9C;AACA;IACI,mBAA4B;IAA5B,4BAA4B;AAChC;AACA;IACI,mBAAgC;IAAhC,gCAAgC;AACpC;AACA;IACI,mBAA+B;IAA/B,+BAA+B;AACnC;AACA;IACI,mBAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,WAAW;;AAEX;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAA+B;IAA/B,+BAA+B;IAC/B,cAAsB;IAAtB,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,yBAAqC;IAArC,qCAAqC;IACrC,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,yBAAsC;IAAtC,sCAAsC;IACtC,cAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,mBAAgC;IAAhC,gCAAgC;IAChC,6BAA6B;IAC7B,cAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,yBAAgC;IAAhC,gCAAgC;IAChC,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,oCAAmC;IAAnC,mCAAmC;IACnC,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAA0B;IAA1B,0BAA0B;IAC1B,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAA4B;IAA5B,4BAA4B;IAC5B,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,cAAuB;IAAvB,uBAAuB;IACvB,yBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,mBAAoC;IAApC,oCAAoC;IACpC,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,yCAAyC;IACzC,yBAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,8BAA2C;IAA3C,2CAA2C;IAC3C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,mBAA2B;IAA3B,2BAA2B;IAC3B,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAuB;IAAvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA,qCAAqC;;AAErC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;;AAErB;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;;AAEtB;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA,mBAAmB;;AAsCnB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAYA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAsCA;IACI;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IAEI,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IAII,4BAA4B;AAChC;;AAEA;IAII,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IAII,wBAAwB;IAIxB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IAII,yBAAyB;AAC7B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAwB;IAAxB,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,cAAc;IACd,mBAA+B;IAA/B,+BAA+B;IAC/B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,cAAc;IACd,mBAA+B;IAA/B,+BAA+B;IAC/B,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,2BAA2B;IAC3B,OAAO;AACX;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAAkC;IAAlC,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,cAAsB;IAAtB,sBAAsB;IACtB,qBAA+B;IAA/B,+BAA+B;AACnC;;AAEA;IACI,wBAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,mBAAmB;;AAEnB;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,2CAA2C;IAC3C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH,uBAAuB;;AAEvB,UAAU;;AAEV;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAwB;IAAxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iDAA6C;IAA7C,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAA6B;IAA7B,+BAA6B;IAC7B,0BAA8B;IAA9B,gCAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,oCAAgC;IAAhC,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAA0B;IAA1B,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,0CAA0C;IAC1C,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,+BAA+B;IAC/B,8CAA8C;IAC9C,2CAA2C;IAC3C,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,6CAA6C;IAC7C,0CAA0C;IAC1C,yCAAyC;IACzC,wCAAwC;IACxC,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,wCAAwC;AAC5C;;;AAGA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,cAAc;;AAElB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;IAGI,0CAA0B;IAA1B,0BAA0B;IAC1B,8CAAkC;IAAlC,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,mDAAmD;IACnD,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iDAA6C;IAA7C,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iDAA6C;IAA7C,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,QAAQ;IACR,OAAO;IACP,aAAa;IACb,+BAA0B;IAA1B,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,aAAa;IAEb,mEAAmE;IACnE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,wEAAwE;IACxE,uEAAuE;IACvE,sEAAsE;AAC1E;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,iDAA6C;IAA7C,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,iDAA6C;IAA7C,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;IACR,cAAwB;IAAxB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,yBAAiC;IAAjC,iCAAiC;IACjC,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAA0B;IAA1B,0BAA0B;IAC1B,yBAA4C;IAA5C,4CAA4C;IAC5C,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAwB;IAAxB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAmC;IAAnC,mCAAmC;IACnC,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,yBAAoC;IAApC,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IAGrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IAGrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAsB;IAAtB;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAwB;IAAxB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,8BAA0C;IAA1C,0CAA0C;AAC9C;;AAEA;IACI,8BAA0C;IAA1C,0CAA0C;AAC9C;;AAEA;IACI,wBAAoC;IAApC,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,mBAA2B;IAA3B,2BAA2B;IAC3B,yCAAiC;IAAjC,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAoC;IAApC,oCAAoC;IACpC,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA,cAAc;;AAEd;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yDAAgD;IAChD,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,6DAAiD;;IAAjD,iDAAiD;;AAErD;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,cAAwB;IAAxB,wBAAwB;IACxB,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,mBAA+B;IAA/B,+BAA+B;IAC/B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,kBAAkB;;AAElB;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB;wBACoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAW;IAAX,aAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,8BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,0CAAkC;IAAlC,kCAAkC;IAClC,iDAA0C;IAA1C,0CAA0C;IAC1C,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,kBAAkB;IAClB,cAAsB;IAAtB,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;IAC1C,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,gDAA0C;IAC1C,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,8BAA8B;IAC9B,qBAAqB;IACrB,wDAAwD;IACxD,UAAU;IACV,4CAA4C;IAC5C,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA,kCAAkC;;AAElC,iBAAiB;;AAEjB;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,wCAAwC;;AAExC;IACI,mBAA+B;IAA/B,+BAA+B;IAC/B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gCAAwC;IAAxC,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAqB;IAArB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAmC;IAAnC,mCAAmC;IACnC,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,mBAA6B;IAA7B,6BAA6B;IAC7B,gCAAwC;IAAxC,wCAAwC;IACxC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;CACC,gCAAgC;CAChC,2CAA2C;IACxC,yvDAAyvD;CAC5vD,6BAA6B;CAC7B;eACc;CACd,wBAAwB;AACzB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;;AAEtB;AACA;KACK,kBAAkB;IACnB,iBAAiB;IACjB,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,mBAA0B;IAA1B,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;IACjD,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAmC;IAAnC,mCAAmC;IACnC,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,mBAAmB;;AAEnB;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,sDAAsD;IACtD,iBAAiB;IACjB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,eAAe;;AAEf;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,gBAAgB;;AAEhB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAElB,sBAAsB;IAGtB,kBAAkB;IAClB,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IAGV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAElB,gBAAgB;IAEhB,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IAEV,wBAAwB;IAExB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAA+B;IAA/B,+BAA+B;AACnC;;AAEA;IAEI,mBAAmB;AACvB;;AAEA;IAEI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,oCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IAEnB,sBAAsB;IACtB,UAAU;IAEV,yBAAyB;IAEzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IAET,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAmC;IAAnC,mCAAmC;IACnC,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,oCAA8B;IAA9B,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,yBAAiC;IAAjC,iCAAiC;IACjC,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mBAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,QAAQ;AACZ;;;AAGA;IACI,kEAAkE;IAClE,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAmC;IAAnC,mCAAmC;AACvC;;;AAGA;;IAEI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAoC;IAApC,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA,iBAAiB;;AAEjB;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,mBAA+B;IAA/B,+BAA+B;IAC/B,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,gBAAgB;;AAEhB;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,qDAAqD;AACzD;;AAEA;;IAEI,uCAA+C;IAA/C,+CAA+C;AACnD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAmC;IAAnC,mCAAmC;IACnC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;;;IAGI,+BAA+B;AACnC;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;;;;;;;;;;IAUI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,8BAAsC;IAAtC,sCAAsC;IACtC,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,+BAA+B;IAC/B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA0C;IAA1C,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;;;IAGI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,mBAA+B;IAA/B,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;;AAErB;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,4CAA4C;IAC5C,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAGlB,wBAAwB;IAGxB,8BAA8B;IAG9B,kCAAkC;IAClC,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,yDAAu9B;IACv9B,0BAA0B;AAC9B;;AAEA;IACI,yDAAisB;AACrsB;;AAEA;IACI,yDAAisB;AACrsB;AACA,gCAAgC;;AAEhC;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,2GAA2G;IAC3G,gBAAgB;IAChB,cAA0B;IAA1B,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAwB;IAAxB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAsB;IAAtB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAA+B;IAA/B,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA,4BAA4B;;AAE5B;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;;AAEnB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,cAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,cAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;IAC7B,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAW;IAAX,aAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;iBACa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;IACV,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,0BAA0B;;AAE1B;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,wBAAwB;IACxB,mBAA2B;IAA3B,2BAA2B;IAC3B,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;sBACkB;IAClB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,mBAA6B;IAA7B,6BAA6B;IAC7B,cAAsB;IAAtB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,oDAAoD;AACxD;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB;;kBAEc;IAGd,aAAa;IAGb,uBAAuB;IAGvB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oEAAoE;IACpE,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;;AAE9B;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAA+B;IAA/B,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAA+B;IAA/B,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAA0B;IAA1B,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA,kCAAkC;;AAElC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,0CAAkC;IAAlC,kCAAkC;IAClC,4DAAqD;IAArD,qDAAqD;IACrD,kBAAkB;IAClB,uCAAuC;IACvC,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,yBAAqC;IAArC,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA,wBAAwB;;AAExB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,mBAA+B;IAA/B,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA,gCAAgC;;AAEhC;IACI,sDAAsD;IACtD,oCAAoC;IACpC,yBAAqC;IAArC,qCAAqC;IACrC,oCAAyD;IAAzD,yDAAyD;AAC7D;;AAEA;IACI,yBAAyB;IACzB,yBAAqC;IAArC,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;;AAYA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,wBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAu9B;AAC39B;;AAEA;IACI,yDAAu9B;AAC39B;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,aAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAqB;IAArB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;;AAEvB;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAmC;IAAnC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,yBAAyB;;AAEzB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,yBAAyB;IACzB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,yBAAmC;IAAnC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAiC;IAAjC,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAiC;IAAjC,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAoC;IAApC,oCAAoC;IACpC,yBAA0C;IAA1C,0CAA0C;IAC1C,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAA0B;IAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAqC;IAArC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAmC;IAAnC,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,oCAA8C;IAA9C,8CAA8C;IAC9C,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8CAA0C;IAA1C,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,+BAA+B;IAC/B,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAA+B;IAA/B,+BAA+B;IAC/B,0CAAkC;IAAlC,kCAAkC;IAClC,8CAAyC;IAAzC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;QACQ,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,oBAAoB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;;kBAEc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAYA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IAEI,sBAAsB;IAEtB,sBAAsB;IAEtB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yDAAu9B;IACv9B,WAAW;AACf;;AAEA;IACI,yDAAu9B;IACv9B,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAgC;IAAhC,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,2CAA2C;IAC3C,0CAAkC;IAAlC,kCAAkC;IAClC,UAAU;AACd;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAU;IAAV,YAAU;IACV,UAAW;IAAX,aAAW;IACX,eAAgB;IAAhB,kBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAc;IAAd,gBAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,SAAU;IAAV,YAAU;IACV,UAAW;IAAX,aAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAQA;IACI;QACI,wBAAwB;QACxB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;AACJ;;AAmBA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,+BAA+B;IAC/B,QAAQ;IACR,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yDAAu8B;AAC38B;;AAEA;IACI,0DAA2jC;AAC/jC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,yBAAmC;IAAnC,mCAAmC;IACnC,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAGlB,wBAAwB;IACxB,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,yBAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,0DAAu9B;IACv9B,0BAA0B;IAC1B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,yDAAu9B;AAC39B;;AAEA;IACI,oCAAiD;IAAjD,iDAAiD;IACjD,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAA0B;IAA1B,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,mBAAoC;IAApC,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAiC;IAAjC,iCAAiC;IACjC,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,8BAAwC;IAAxC,wCAAwC;IACxC,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;CACC;IACG,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IAEb,WAAW;IACX,kCAAkC;AACtC;;AAEA,WAAW;;AAYX;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI;;;;mBAIe;IACf,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI;;;QAGI;IACJ;QACI,YAAY;IAChB;;IAEA;;;QAGI;IACJ;QACI,UAAU;IACd;;IAEA;;;QAGI;IACJ;QACI,YAAY;IAChB;AACJ;;AA6BA;IACI;;QAEI;IACJ,qBAAqB;IACrB;;QAEI;IACJ,wBAAwB;IACxB;;QAEI;IACJ,mCAAmC;IACnC;;;;;;QAMI;IACJ,yBAAyB;AAC7B;;AAEA;IACI;;;;QAII;IACJ,qBAAqB;AACzB;;AAEA;IACI;;;;QAII;IACJ,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,uFAA6F;IAA7F,6FAA6F;IAC7F,0CAAsC;IAAtC,sCAAsC;IACtC,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,kCAAkC;IAClC,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAqC;IAArC,qCAAqC;IACrC,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,cAAwB;IAAxB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;;IAKI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;AACf;;AAEA;;;;;IAKI,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAYA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,8BAAsC;IAAtC,sCAAsC;IACtC,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;;;;IAKI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAA2B;IAA3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAsC;IAAtC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,mBAA0B;IAA1B,0BAA0B;IAC1B,iDAAyC;IAAzC,yCAAyC;IACzC,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;IACnC,8BAA8B;IAC9B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,qDAAqD;IACrD,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,+BAA+B;IAC/B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,oDAAoD;IACpD,yBAAmC;IAAnC,mCAAmC;IACnC,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,+BAA+B;IAC/B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAA6B;IAA7B,6BAA6B;IAC7B,oCAA4C;IAA5C,4CAA4C;IAC5C,qDAAqD;IACrD,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,qDAAqD;IACrD,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,0BAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,yBAAmC;IAAnC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAA2B;IAA3B,2BAA2B;IAC3B,yBAAiC;IAAjC,iCAAiC;IACjC,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mBAA+B;IAA/B,+BAA+B;IAC/B,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,oCAA4C;IAA5C,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gDAAgD;IAChD,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,mBAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,SAAS;IACT,MAAM;IACN,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,oEAAgF;IAAhF,gFAAgF;IAChF,yBAAqC;IAArC,qCAAqC;IACrC,gDAAwC;IAAxC,wCAAwC;IACxC,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gDAAgD;IAChD,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;IAII,iDAAiD;AACrD;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAYA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,yBAAiC;IAAjC,iCAAiC;IACjC,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;IAC7B,yBAAiC;IAAjC,iCAAiC;IACjC,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAA6B;IAA7B,6BAA6B;IAC7B,yBAAiC;IAAjC,iCAAiC;IACjC,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;;;IAGI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0DAAu9B;AAC39B;;AAEA;IACI,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;;;;;GAKG;;AAEH;;IAEI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;;;GAGG;;AAEH;IACI,4BAA4B;AAChC;;AAEA;IACI,cAA2B;IAA3B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;GAIG;;AAEH;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,4CAA4C;IAC5C,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,2BAA2B;IAC3B,sBAAsB;IACtB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IAEI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,0CAAsC;IAAtC,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mDAAmD;IACnD,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;;AAEpB;;GAEG;;AAEH;IACI,wBAAoC;IAApC,oCAAoC;AACxC;;AAEA;;;;;;;;;;;;;;IAcI,wBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;;;;;;IAOI,qDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;;IAEI,yCAAqC;IAArC,qCAAqC;AACzC;;AAEA;;IAEI,oCAA4C;IAA5C,4CAA4C;AAChD;;AAEA;;;IAGI,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,eAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAA6B;IAA7B,6BAA6B;AACjC;;AAEA;;IAEI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;;;IAGI,2CAA2C;AAC/C;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;;IAEI,qDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;;;;IAII,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;;;IAGI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAkC;IAAlC,kCAAkC;AACtC;;AAEA;IACI,yBAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,qDAAqD;IACrD,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,wCAAwC;;AAExC;;;;;;;;;IASI,gCAA0C;IAA1C,0CAA0C;IAC1C,gDAA0D;IAA1D,0DAA0D;IAC1D,yDAAiD;IAAjD,iDAAiD;IACjD,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;;;;IAII,oCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,0CAAsC;IAAtC,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,MAAM;IACN,8BAA8B;IAC9B,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,MAAM;IACN,8BAA8B;IAC9B,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAgBA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;AAeA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IAEnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAAkC;IAAlC,kCAAkC;IAClC,kDAA2C;IAA3C,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,cAAc;IACd,mBAA+B;IAA/B,+BAA+B;IAC/B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,eAAe;;AAEf;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,SAAS;IACT,eAAe;IACf,cAAc;IACd,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,gDAAgD;IAChD,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAA0B;IAA1B,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,yBAAiC;IAAjC,iCAAiC;IACjC,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAmC;IAAnC,mCAAmC;IACnC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,4CAA4C;IAC5C,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+CAA2C;IAA3C,2CAA2C;AAC/C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,mBAA4B;IAA5B,4BAA4B;IAC5B,oCAAoC;IACpC,2CAA2C;IAC3C,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,UAAW;IAAX,aAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;;;;;;;;;IAWI,kDAAkD;IAClD,2DAA2D;IAC3D,qDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;;IAEI,qDAAiD;IAAjD,iDAAiD;IACjD,yCAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qDAAiD;IAAjD,iDAAiD;IACjD,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAwB;IAAxB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;AACrD;;AAEA;IACI,mBAA+B;IAA/B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;;;;;GAMG;;AAEH;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,cAAwB;IAAxB,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,iBAAiB;;AAEjB;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;;AAEvB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;;;;GAOG;;AAEH;IACI,6CAA6C;IAC7C,yBAAmC;IAAnC,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,UAAU;AACd;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,0BAA0B;;AAE1B;IACI,mBAA+B;IAA/B,+BAA+B;AACnC;;AAEA;;;;;GAKG;;AAEH;IACI,qDAAqD;IACrD,6DAA6D;IAC7D,0DAA0D;IAC1D,yDAAyD;IACzD,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;;;;GAMG;;AAEH;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;;;;;GAMG;;AAEH;;GAEG;;AAEH;;;;GAIG;;AAEH;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,sCAAsC;IACtC,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA,sBAAsB;;AAEtB;IACI,yCAAyC;IAGzC,kCAAkC;AACtC;;AAsCA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAkC;IAAlC,kCAAkC;IAClC,yBAAiC;IAAjC,iCAAiC;IACjC,cAAuB;IAAvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAA2B;IAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,kDAAkD;IAClD,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,gBAAgB;;AAEhB;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IAErB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,+CAA+C;AACnD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yBAAiC;IAAjC,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IAGV,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,oBAAoB;IACpB,4BAA4B;IAC5B,0DAA+xC;IAC/xC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;GAGG;;AAEH;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;QACQ,UAAU;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IAErB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yBAAiC;IAAjC,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IAGV,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,oBAAoB;IACpB,4BAA4B;IAC5B,0DAA+xC;IAC/xC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,8BAAwC;IAAxC,wCAAwC;IACxC,2CAAmD;IAAnD,mDAAmD;IACnD,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,oCAA8C;IAA9C,8CAA8C;IAC9C,yBAAmC;IAAnC,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,8BAAwC;IAAxC,wCAAwC;IACxC,qDAA6C;IAA7C,6CAA6C;IAC7C,6DAAsD;IAAtD,sDAAsD;IACtD,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,mCAAmC;IACnC,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4DAAwD;IAAxD,wDAAwD;AAC5D;;AAEA;IACI,gCAAwC;IAAxC,wCAAwC;IACxC,oCAAoC;IACpC,yBAAmC;IAAnC,mCAAmC;IACnC,mCAAmC;IACnC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;IACrC,mBAAmB;IACnB,cAAwB;IAAxB,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,yBAAqC;IAArC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAA0C;IAA1C,0CAA0C;IAC1C,cAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAElB,sBAAsB;IAGtB,kBAAkB;IAClB,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;AACb;;AAEA;IAEI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,yBAAqC;IAArC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,mDAAmD;IACnD,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;IAClB,yBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;;GAGG;;AAEH;IACI,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,yBAAqC;IAArC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,wBAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,iBAAiB;;AAEjB;IACI,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,2CAA2C;IAC3C,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,yBAAiC;IAAjC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,oCAA4C;IAA5C,4CAA4C;IAC5C,cAAwB;IAAxB,wBAAwB;IACxB,gCAAwC;IAAxC,wCAAwC;AAC5C;AACA;IACI,wCAAwC;IACxC,6BAA6B;AACjC;;;;AAIA;IACI,gCAA4C;IAA5C,4CAA4C;IAC5C,gBAAgB;IAChB,cAAwB;IAAxB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,mBAAgC;IAAhC,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI;AACJ;AACA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI;QACI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,4CAA4C;QAC5C,iCAAiC;QAEjC,2BAA2B;QAC3B,qCAAqC;QAErC,6BAA6B;QAC7B,sCAAsC;QACtC,4BAA4B;QAC5B,kBAAkB;QAClB,yBAAyB;QACzB,wBAAwB;QACxB,qBAAqB;QACrB,4BAA4B;QAC5B,6BAA6B;QAC7B,+BAA+B;IACnC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;AAEJ","sourcesContent":[":root {\n    --primaryColor: #000000;\n    --blackColor: #000000;\n    --successColor: #48d38a;\n    --negativeColor: #f7685b;\n    --textColor: #979797;\n    --theadColor: #f9f9f9;\n    --tdColor: #ffffff;\n    --whiteColor: #ffffff;\n    --whiteAlt: #ffffff;\n    --offWhite: #f9f9f9;\n    --offWhiteTrans: rgba(219, 220, 224, 0.3);\n    --borderOff: rgba(219, 220, 224, 0.5);\n    --offText: rgba(0, 0, 0, 0.5);\n    --bgOffset: #f4f4f4;\n    --placeHolder: #979797;\n    /* --offBlue: #eff1ff; */\n    --offBlue: #F4F4F4;\n    --boxShadow: rgba(64, 25, 109, 0.07);\n    --offBlueTran: rgba(223, 227, 255, 0.3);\n    --primaryAlt: #000000;\n    --offGreen: rgba(72, 211, 138, 0.5);\n    --ctaOffBlue: rgba(0, 0, 0, 0.3);\n    --overlay: rgba(0, 0, 0, 0.35);\n    --successColorTrans: #dcffec;\n    --lightBlue: #1dcbef;\n    --textColorLightGrey: #cacaca;\n    --tooltip-background-color: #fff;\n    --buttonBackgroundColor: #f9f9f9;\n    /* --tooltip-margin: 30px; */\n    --tooltip-arrow-size: 6px;\n    --manuge-user-heading: #979797;\n    --input-prefix-border: #121212;\n    --card-border: 1px solid rgba(219, 220, 224, 0.5);\n    --card-box-shadow: 15px 30px 40px rgba(0, 0, 0, 0.07);\n    --card-wrapper-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);\n    --card-mini-wrapper-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);\n}\n\n.kuda-dark--theme {\n    --primaryColor: #ffffff;\n    --blackColor: #ffffff;\n    --successColor: #48d38a;\n    --negativeColor: #f7685b;\n    --textColor: #ffffff;\n    --theadColor: rgba(219, 220, 224, 0.04);\n    --tdColor: rgba(219, 220, 224, 0.003);\n    --whiteColor: #121212;\n    --whiteAlt: #181818;\n    --offWhite: rgba(219, 220, 224, 0.03);\n    --offWhiteTrans: rgba(219, 220, 224, 0.04);\n    --borderOff: rgba(219, 220, 224, 0.13);\n    --offText: rgba(255, 255, 255, 0.8);\n    --bgOffset: rgba(244, 244, 244, 0.04);\n    --placeHolder: rgba(255, 255, 255, 0.25);\n    --offBlue: #181818;\n    --boxShadow: rgba(64, 25, 109, 0.02);\n    --offBlueTran: rgba(219, 220, 224, 0.05);\n    --primaryAlt: #000000;\n    --offGreen: rgba(72, 211, 138, 0.1);\n    --ctaOffBlue: rgba(64, 25, 109, 0.1);\n    --overlay: rgba(0, 0, 0, 0.6);\n    --successColorTrans: rgba(72, 211, 138, 0.1);\n    --buttonBackgroundColor: #000000;\n    --manuge-user-heading: #CBC3E3;\n}\n\n.kuda-dark--theme {\n    background-color: var(--whiteColor) !important;\n}\n\n.kuda-dark--theme .react-loading-skeleton {\n    background-color: #222222 !important;\n    background-image: linear-gradient(90deg, #222222, #242424, #262626) !important;\n}\n\n/* Anti Alias */\n\n* {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-tap-highlight-color: none !important;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -moz-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/* DOTS */\n\n@font-face {\n    font-family: \"dotsfont\";\n    src: url(\"../fonts/dots/dotsfont.eot\");\n    src: url(\"../fonts/dots/dotsfont.eot?#iefix\") format(\"embedded-opentype\"), url(\"../fonts/dots/dotsfont.ttf\") format(\"truetype\"), url(\"../fonts/dots/dotsfont.svg#dotsfontregular\") format(\"svg\");\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\n/* Body defaults */\n\nhtml,\nbody {\n    font-family: \"Muli\", sans-serif;\n    font-size: 16px;\n    color: var(--textColor);\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\ninput {\n    /* Remove First */\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    font-weight: 500 !important;\n}\n\n::-moz-placeholder {\n    /* Firefox 19+ */\n    font-weight: 500 !important;\n}\n\n:-ms-input-placeholder {\n    /* IE 10+ */\n    font-weight: 500 !important;\n}\n\n:-moz-placeholder {\n    /* Firefox 18- */\n    font-weight: 500 !important;\n}\n\n/* CONTAINER */\n\n.container {\n    width: 100%;\n    padding-right: 20px;\n    padding-left: 20px;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@media (min-width: 576px) {\n    .container {\n        max-width: 580px;\n    }\n}\n\n\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 700px;\n    }\n}\n\n@media (min-width: 992px) {\n    .container {\n        max-width: 789px;\n    }\n\n    .payments-container {\n        max-width: 900px;\n    }\n\n    .shareholders-container {\n        max-width: 831px;\n    }\n\n    .kuda-signup--container {\n        max-width: 957px !important;\n    }\n\n    .c-apps {\n        margin-top: 35px;\n    }\n}\n\n.new-container {\n    width: 100%;\n}\n@media (min-width: 992px) {\n    .new-container{\n       max-width: 100%;\n    }\n\n}\n@media (min-width: 768px) {\n    .new-container{\n       max-width: 100%;\n    }\n}\n\n@media (min-width: 576px) {\n    .new-container{\n       max-width: 100%;\n    }\n}\n\n.increase-max--width {\n    max-width: 950px;\n}\n\n.max-width-lg {\n    max-width: 900px;\n}\n\n.max-width-full {\n    max-width: 100% !important;\n}\n\n.auth-layout--header+.kuda-preview {\n    max-width: 1420px;\n    padding-left: 60px;\n    padding-right: 60px;\n    min-height: calc(100vh - 90px);\n    position: relative;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n}\n\n.row {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n}\n\n/* Text font sizing */\n\nh1 {\n    font-size: 2.375rem;\n    line-height: 1.2;\n}\n\nh2 {\n    font-size: 2rem;\n    line-height: 1.4;\n}\n\nh3 {\n    font-size: 1.8rem;\n    line-height: 1.5;\n}\n\nh4 {\n    font-size: 1.42rem;\n    line-height: 1.5;\n}\n\nh5 {\n    font-size: 1.32rem;\n    line-height: 1.5;\n}\n\nh6 {\n    font-size: 1.2rem;\n    line-height: 1.5;\n}\n\np {\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.text-lg {\n    font-size: 2.5rem !important;\n    line-height: 1.38;\n}\n\n.text-md {\n    font-size: 2.15rem;\n    line-height: 1.4;\n}\n\n.text-smd {\n    font-size: 0.9375rem;\n    line-height: 20px;\n}\n\n.text-sm {\n    font-size: 0.8125rem;\n}\n\n.text-xlxs {\n    font-size: 0.75rem;\n}\n\n.text-xs {\n    font-size: 0.64rem !important;\n}\n\n.text-subheading {\n    font-size: 1.13rem;\n    line-height: 1.5;\n}\n\n.text-subheading-md {\n    font-size: 1.25rem;\n    line-height: 1.35;\n}\n\n.text-subheading-sm {\n    font-size: 1.05rem;\n    line-height: 1.35;\n}\n\n.page-heading-title {\n    color: var(--primaryColor);\n    font-size: 28px;\n    font-weight: 800;\n}\n\n.text-normal {\n    font-weight: 400 !important;\n}\n\n.text-underline {\n    text-decoration: underline;\n}\n\n.color-primary {\n    color: var(--primaryColor);\n}\n\n.color-negative {\n    color: var(--negativeColor);\n}\n\n.color-secondary {\n    color: var(--successColor) !important;\n}\n\n.color-white {\n    color: var(--whiteColor);\n}\n\n.color-black {\n    color: var(--blackColor) !important;\n}\n\n.color-normal {\n    color: #333333;\n}\n\n.color-faded {\n    color: var(--offText);\n}\n\n.color-light {\n    color: rgb(0, 0, 0, 0.7);\n}\n\n.color-green {\n    color: var(--successColor);\n}\n\n.color-light--text {\n    color: var(--textColor);\n}\n\n.color-cream {\n    color: #fff5db;\n}\n\n.bg-cream {\n    background-color: #fff5db;\n}\n\n.bg-green {\n    background: var(--successColor) !important;\n}\n.bg-blue {\n    background: var(--lightBlue);\n}\n.bg-red {\n    background: var(--negativeColor);\n}\n.bg-black {\n    background: var(--primaryColor);\n}\n.bg-offWhite {\n    background: var(--offWhite);\n}\n\n.bg-yellow {\n    background: #FFC83E;\n}\n\n.text-semi-bold {\n    font-weight: 600;\n}\n\n.text-bold {\n    font-weight: 700;\n}\n\n.text-xbold {\n    font-weight: 800;\n}\n\n.text-xlbold {\n    font-weight: 900;\n}\n\n.text-light {\n    font-weight: 300;\n}\n\n.text-normal {\n    font-weight: 400;\n}\n\n.no-box--shadow {\n    box-shadow: none !important;\n}\n\n/* BUTTON */\n\nbutton {\n    /* outline: none; */\n    border: 0;\n}\n\n.invoice-icon svg {\n    height: 24.99px !important;\n}\n\n.disabled {\n    opacity: 0.73;\n    pointer-events: none;\n}\n\n.disabled-opacity--low {\n    opacity: 0.33;\n    pointer-events: none;\n}\n\n.disabled-grey {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.disabled-color--grey {\n    color: #979797 !important;\n}\n\n.disabled-color--grey svg {\n    fill: rgb(151, 151, 151, 1) !important;\n}\n\n.kuda-nav {\n    margin-left: -30px;\n}\n\n.kuda-cta {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    padding: 15px 15px;\n    border-radius: 10px;\n    justify-content: center;\n    cursor: pointer;\n    background: var(--primaryColor);\n    color: var(--whiteAlt);\n    height: 48px;\n    transition: transform 0.6s;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n\n.addAction {\n    margin-bottom: 8px;\n}\n\n.kuda-cta--table {\n    /* max-width: 64px; */\n    height: 24px;\n    font-size: 13px;\n}\n\n.kuda-cta-sm {\n    font-size: 10px;\n    padding: 3px 13px !important;\n    height: 19px;\n}\n\n.kuda-cta-md {\n    max-width: 135px;\n    width: 100%;\n}\n\n.kuda-cta--fit {\n    max-width: fit-content !important;\n}\n\n.kuda-cta-lg {\n    max-width: 152px;\n    width: 100%;\n}\n\n.kuda-cta-long {\n    width: 100%;\n    max-width: 242px;\n}\n\n.kuda-cta-wide {\n    width: 100% !important;\n    max-width: 100% !important;\n}\n\n.kuda-cta-white {\n    background: var(--offWhite);\n    border: 1px solid var(--primaryColor);\n    color: var(--primaryColor);\n}\n\n.kuda-cta-red {\n    background: var(--whiteAlt);\n    border: 1px solid var(--negativeColor);\n    color: var(--negativeColor);\n}\n\n.kuda-cta-bgRed {\n    background: var(--negativeColor);\n    border: 1px solid transparent;\n    color: var(--whiteAlt);\n}\n\n.kuda-primary-cta {\n    background-color: var(--successColor);\n}\n\n.kuda-tertiary-cta {\n    background-color: var(--offBlue);\n    color: var(--primaryColor);\n}\n\n.transaction-right .kuda-dropdown {\n    position: static;\n}\n\n.white-cta {\n    background: var(--offWhite);\n    border: 1px solid var(--ctaOffBlue);\n    color: var(--primaryColor);\n}\n\n.kuda-cta:hover {\n    transform: translate3d(0px, -3px, 0px);\n}\n\n.kuda-cta-primary-light {\n    background: var(--offBlue);\n    color: var(--primaryColor);\n}\n\n.kuda-cta-loan {\n    background: var(--lightBlue);\n    color: var(--whiteColor);\n}\n\n.kuda-cta-loan-light {\n    background: var(--offLoan);\n    color: var(--lightBlue);\n    border: 1px solid var(--lightBlue);\n}\n\n.kuda-cta-secondary-light {\n    background: var(--successColorTrans);\n    color: var(--successColor);\n}\n\n.kuda-cta-warning-light {\n    background: var(--offWhite);\n    border: 1px solid rgba(247, 104, 91, 0.3);\n    color: var(--negativeColor) !important;\n}\n\n.kuda-cta-warning {\n    background: var(--negativeColor) !important;\n    color: var(--whiteColor);\n}\n\n.kuda-cta-xl {\n    max-width: 255px;\n}\n\n.goal-actions .kuda-cta:not(:last-child) {\n    margin-right: 20px;\n}\n\n.goal-actions {\n    margin-top: 22px;\n}\n\n.single-savings .goal-actions {\n    margin-top: 15px;\n}\n\n/* HEADER LAYOUT */\n\n.kuda-header {\n    position: fixed;\n    width: 100%;\n    height: 70px;\n    left: 0;\n    top: 0px;\n    background: var(--whiteAlt);\n    box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.05);\n    /* z-index: 99; */\n}\n\n.kuda-header--wrap {\n    max-width: 1500px;\n    margin: 0 auto;\n    display: block;\n    padding-left: 60px;\n    padding-right: 60px;\n}\n\n.kuda-nav--icon a,\n.kuda-nav--icon p {\n    display: flex;\n    align-items: center;\n    margin-right: 55px;\n    color: var(--textColor);\n    font-size: 0.875rem;\n}\n\n.kuda-nav--icon a span,\n.kuda-nav--icon p span {\n    display: flex;\n}\n\n.kuda-nav--icon:last-child a,\n.kuda-nav--icon:last-child p {\n    margin-right: 0;\n    /* cursor: not-allowed; */\n}\n\n.kuda-nav--icon svg {\n    margin-right: 10px;\n    width: 25px;\n    height: auto;\n}\n.kuda-nav--icon-api{\n    cursor: pointer;\n}\n.kuda-nav--icon-api svg{\n    width: auto;\n}\n.kuda-nav--icon-api .drop-icon {\n    margin-bottom: 3px;\n}\n.kuda-brand svg {\n    height: 20px;\n    width: auto;\n}\n\n.kuda-brand,\n.kuda-account {\n    min-width: 100px;\n}\n\nimg,\n.balance-summary {\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n/********** PROFILE IMAGE ***********/\n\n.member-profile img {\n    border-radius: 100px;\n    background: #e8e8e8;\n    object-fit: fill;\n}\n\n.member-profile {\n    margin-right: 15px;\n    height: 30px;\n    width: 30px;\n    background-size: cover;\n    border-radius: 100px;\n    background-position: top;\n    background-color: #e8e8e8;\n}\n\n.kuda-menu--text {\n    font-size: 0.875rem;\n}\n\n/* COMPONENT SIZING */\n\n.h-100 {\n    height: 100%;\n}\n\n.column--100 {\n    width: 100% !important;\n}\n\n.column--90 {\n    width: 90%;\n}\n\n.column--80 {\n    width: 80%;\n}\n\n.column--50 {\n    width: 50%;\n}\n\n.column--33 {\n    width: 33.33333%;\n}\n\n/* kudabank Sections */\n\n.kuda-preview {\n    margin-top: 70px;\n    /* padding: 63px 40px; */\n    padding: 34px 24px;\n}\n\n.balance-icon {\n    margin-right: 10px;\n}\n\n.balance-summary {\n    height: 60px;\n}\n\n.denomination-icon {\n    position: relative;\n    top: -8px;\n    margin-right: 3px;\n}\n\n/* Tab animations */\n\n@-webkit-keyframes kudaFadeInUp {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(18px);\n    }\n\n    100% {\n        opacity: 1;\n        -webkit-transform: translateY(0);\n    }\n}\n\n@-moz-keyframes kudaFadeInUp {\n    0% {\n        opacity: 0;\n        -moz-transform: translateY(18px);\n    }\n\n    100% {\n        opacity: 1;\n        -moz-transform: translateY(0);\n    }\n}\n\n@-o-keyframes kudaFadeInUp {\n    0% {\n        opacity: 0;\n        -o-transform: translateY(18px);\n    }\n\n    100% {\n        opacity: 1;\n        -o-transform: translateY(0);\n    }\n}\n\n@keyframes kudaFadeInUp {\n    0% {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@-webkit-keyframes kudaFadeInUpMini {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(9px);\n    }\n\n    100% {\n        opacity: 1;\n        -webkit-transform: translateY(0);\n    }\n}\n\n@-moz-keyframes kudaFadeInUpMini {\n    0% {\n        opacity: 0;\n        -moz-transform: translateY(9px);\n    }\n\n    100% {\n        opacity: 1;\n        -moz-transform: translateY(0);\n    }\n}\n\n@-o-keyframes kudaFadeInUpMini {\n    0% {\n        opacity: 0;\n        -o-transform: translateY(9px);\n    }\n\n    100% {\n        opacity: 1;\n        -o-transform: translateY(0);\n    }\n}\n\n@keyframes kudaFadeInUpMini {\n    0% {\n        transform: translateY(9px);\n        -webkit-transform: translateY(9px);\n        -moz-transform: translateY(9px);\n        -ms-transform: translateY(9px);\n        -o-transform: translateY(9px);\n    }\n\n    100% {\n        transform: translateY(0);\n    }\n}\n\n.fadeIn {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    animation-duration: 0.3s !important;\n}\n\n.kudaFadeInUp {\n    -webkit-animation-name: kudaFadeInUp;\n    -moz-animation-name: kudaFadeInUp;\n    -o-animation-name: kudaFadeInUp;\n    animation-name: kudaFadeInUp;\n}\n\n.kudaFadeInUpMini {\n    -webkit-animation-name: kudaFadeInUpMini;\n    -moz-animation-name: kudaFadeInUpMini;\n    -o-animation-name: kudaFadeInUpMini;\n    animation-name: kudaFadeInUpMini;\n}\n\nbody {\n    -webkit-backface-visibility: hidden;\n    counter-reset: Count-Value;\n}\n\n.animated {\n    -webkit-animation-duration: 0.8s;\n    -moz-animation-duration: 0.8s;\n    -o-animation-duration: 0.8s;\n    animation-duration: 0.8s;\n    -webkit-animation-fill-mode: both;\n    -moz-animation-fill-mode: both;\n    -o-animation-fill-mode: both;\n    animation-fill-mode: both;\n    position: relative;\n}\n\n.dropdown-menu {\n    animation-duration: 0.3s;\n}\n\n.kuda-dark--theme .animated {\n    -webkit-animation-fill-mode: none;\n    -moz-animation-fill-mode: none;\n    -o-animation-fill-mode: none;\n    animation-fill-mode: none;\n}\n\n.kuda-transaction--tabs {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    display: flex;\n    height: 52px;\n    min-height: 48px;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 35px;\n    padding-right: 3px;\n    padding-left: 3px;\n}\n\n.kuda-transaction--tabs>li {\n    min-width: 33.33%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 1rem;\n    color: var(--blackColor);\n    height: calc(100% + 2px);\n    position: relative;\n    cursor: pointer;\n    width: 50%;\n}\n\n.payoneerTab li {\n    min-width: 50%;\n}\n\n.kuda-payment--tabs>li {\n    min-width: 25%;\n}\n\n.kuda-transaction--tabs>li:after {\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.kuda-transaction--tabs>li[aria-selected=\"true\"]:after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 2px;\n    display: block;\n    background: var(--primaryColor);\n    bottom: 1px;\n    opacity: 1;\n    border-radius: 5px;\n    left: 0;\n}\n\n.link:after {\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.link.active:after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 2px;\n    display: block;\n    background: var(--primaryColor);\n    bottom: 1px;\n    opacity: 1;\n    border-top-right-radius: 5px;\n    border-top-left-radius: 5px;\n    left: 0;\n}\n\n.kuda-search {\n    width: 100%;\n    margin-top: 23px;\n    position: relative;\n}\n\n.kuda-search--field {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    width: 100%;\n    height: 52px;\n    outline: 0;\n    padding: 10px 20px 10px 52px;\n    display: flex;\n    align-items: center;\n    color: var(--blackColor);\n}\n\n.search-toggle--icon {\n    width: calc(100% - 110px) !important;\n}\n\n.toggle-icon--button {\n    background: var(--whiteAlt);\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    transition: transform 0.6s;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgb(0 0 0 / 5%);\n    padding-left: 12px;\n    padding-right: 12px;\n    font-size: 0.925rem;\n}\n\n.toggle-icon--button.active {\n    background: var(--primaryAlt);\n    color: var(--whiteAlt);\n    border-color: var(--primaryAlt);\n}\n\n.toggle-icon--button.active svg path {\n    fill: var(--whiteAlt) !important;\n}\n\n.toggle-icon--button:hover {\n    transform: translate3d(0px, -3px, 0px);\n}\n\n/* TABLE DROPDOWN */\n\n.dropbtn {\n    border: none;\n    cursor: pointer;\n}\n\n.dropdown {\n    position: relative;\n    display: block;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background: #ffffff;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    z-index: 1;\n}\n\n.dropdown-content div {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n    border-bottom: 1px solid #eee;\n}\n\n.dropdown-content a:hover {\n    background-color: #f1f1f1;\n}\n\n.dropdown.show .dropdown-content {\n    display: block;\n}\n\n/* .dropdown.show .dropbtn {\n  background-color: #3e8e41;\n} */\n\n/* TABLE DROPDOWN END */\n\n/* Icons */\n\n.bulk-payments--link,\n.request-payment--link {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n\n.request-payment--link a {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0px 18px;\n    font-size: 1rem;\n}\n\n.request-payment--link a span {\n    font-size: 1rem;\n}\n\n.searchIcon svg {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 20px;\n}\n\n.toggleIcon {\n    width: auto;\n    margin-left: 12px;\n    margin-top: 23px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.kuda-search--field::placeholder {\n    font-weight: 600;\n    color: var(--placeHolder);\n}\n\n.kuda-result--heading {\n    background: var(--offWhite);\n    width: 100%;\n    height: 23px;\n    font-size: 0.6875rem;\n    display: flex;\n    align-items: center;\n}\n\n.displayResults {\n    margin-top: 23px;\n}\n\n.displayWrap>* {\n    padding-left: 38px;\n    padding-right: 38px;\n}\n\n.displayWrap>.bank-summary--result {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.viewSavingsSummary .displayWrap>div>* {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.viewSavingsSummary .displayWrap>* {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.transaction-avatar {\n    width: 40px;\n    height: 40px;\n    display: block;\n    min-width: 40px;\n    background: #e8e8e8;\n    border-radius: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.kuda-transaction--details {\n    display: flex;\n    align-items: center;\n    height: 40px;\n    width: 100%;\n    padding: 0 20px 0 0;\n}\n\n.transaction-title {\n    margin-left: 14px;\n}\n\n.transaction-title {\n    color: var(--blackColor);\n    font-size: 0.815rem;\n    font-weight: 700;\n    height: 100%;\n    padding: 1px 0px;\n}\n\n.transaction-narration--wrap {\n    width: 70%;\n}\n\n.kuda-result--item {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid var(--offWhiteTrans);\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n    position: relative;\n}\n\n.transaction-result--item {\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n}\n\n.transaction-pin--wrap .pin-input {\n    margin-top: 10px !important;\n    margin-bottom: 5px !important;\n    margin-left: unset !important;\n    margin-right: unset !important;\n}\n\n.transaction-date {\n    font-weight: 300;\n    color: #bebebe;\n    font-size: 0.7rem;\n}\n\n.kuda-nav--icon a.active,\n.kuda-nav--icon a[aria-current=\"page\"] {\n    color: var(--primaryColor) !important;\n}\n\n.kuda-result--item {\n    align-items: center;\n}\n\n.transaction-amount {\n    display: flex;\n    align-items: center;\n}\n\n.transaction-price {\n    margin-right: 25px;\n    position: relative;\n    top: -1px;\n    color: var(--blackColor);\n    font-weight: 700;\n    display: flex;\n    transform: translateY(-0.35px);\n    -webkit-transform: translateY(-0.35px);\n    -moz-transform: translateY(-0.35px);\n    -ms-transform: translateY(-0.35px);\n    -o-transform: translateY(-0.35px);\n}\n\n.positive {\n    color: var(--successColor);\n}\n\n.positive:before {\n    content: \"+\";\n}\n\n.savings--inner .positive:before,\n.single-savings .positive:before {\n    content: none;\n}\n\n.summary-card {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    padding: 20px 20px 32px;\n    width: calc(50% - 10px);\n    margin-bottom: 20px;\n    cursor: pointer;\n    position: relative;\n}\n\n.savings-progress {\n    width: calc(100% - 40px);\n    height: 2px;\n    background: var(--offWhiteTrans);\n    position: absolute;\n    bottom: 17px;\n    left: 20px;\n    border-radius: 5px;\n}\n\n.saving-summary {\n    margin-top: 23px;\n}\n\n.summary-card>div {\n    display: flex;\n    justify-content: space-between;\n}\n\n.summary-card>div:first-child {\n    margin-bottom: 20px;\n}\n\n.saving-plan {\n    background: var(--offBlue);\n    border-radius: 5px;\n    height: 23px;\n    font-size: 0.6875rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 81px;\n    font-weight: 600;\n    color: var(--primaryAlt);\n}\n\n.save-cta {\n    font-weight: 800;\n    font-size: 1.25rem;\n    color: var(--primaryColor);\n    margin-top: 15px;\n}\n\n.save-title {\n    font-size: 0.815rem;\n}\n\n.react-tabs__tab-panel {\n    opacity: 0;\n    transform: translateY(18px);\n}\n\n.kuda-signup--wrap {\n    display: flex;\n    width: 100% !important;\n    padding: 46px 0px 49px !important;\n    align-items: center;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n}\n\n.signup-app--heading {\n    max-width: 454px;\n}\n\n.kuda-signup--right {\n    max-width: 509.3px;\n    margin-left: auto;\n}\n\n.kuda-signup--left {\n    padding: 50px 50px 50px 78px;\n}\n\n.kuda-preview {\n    transition: transform 0.8s;\n    transform: translateY(18px) !important;\n    min-height: calc(100vh - 120px);\n    -webkit-transform: translateY(18px) !important;\n    -moz-transform: translateY(18px) !important;\n    -ms-transform: translateY(18px) !important;\n    -o-transform: translateY(18px) !important;\n}\n\n.kuda-page--transition .kuda-preview {\n    transform: translateY(0px) !important;\n    transition: transform 0.8s;\n    -webkit-transform: translateY(0px) !important;\n    -moz-transform: translateY(0px) !important;\n    -ms-transform: translateY(0px) !important;\n    -o-transform: translateY(0px) !important;\n    -webkit-transition: transform 0.8s;\n    -moz-transition: transform 0.8s;\n    -ms-transition: transform 0.8s;\n    -o-transition: transform 0.8s;\n}\n\n.react-tabs__tab-panel--selected {\n    opacity: 1;\n    transform: translateY(0px);\n    transition: transform 0.8s, opacity 0.6s;\n}\n\n\n.kuda-nav--icon .filled {\n    display: none;\n}\n\n.kuda-nav--icon .active .kuda-nav--icon svg,\n.kuda-nav--icon a[aria-current=\"page\"] .kuda-nav--icon svg {\n    display: none;\n}\n\n.kuda-nav--icon .active .filled,\n.kuda-nav--icon a[aria-current=\"page\"] .filled {\n    display: inline-flex;\n}\n\n.kuda-nav--icon .active svg:not(.filled),\n.kuda-nav--icon a[aria-current=\"page\"] svg:not(.filled) {\n    display: none;\n}\n.kuda-nav--icon-api-active{\n    color: #000000;\n}\n.menu-wrap--disabled {\n    opacity: 0.5;\n}\n.kuda-nav--account-active{\n    border-bottom: 6px solid #000000;\n    color: #000000;\n\n}\n.kuda-onboarding--home {\n    /* border: 1px solid red; */\n    max-width: 450px;\n    margin: auto;\n    text-align: center;\n}\n\n.kuda-layout---card {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    padding: 60px;\n    position: relative;\n}\n\n.kuda-add--options>* {\n    background: var(--whiteAlt);\n    border: 1px solid;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    padding: 20px 25px;\n    max-width: 370px;\n    margin-left: auto;\n    margin-right: auto;\n    cursor: pointer;\n    display: block;\n    border-color: transparent;\n    transition: border 0.2s;\n    -webkit-transition: border 0.2s;\n    -moz-transition: border 0.2s;\n    -ms-transition: border 0.2s;\n    -o-transition: border 0.2s;\n}\n\n.kuda-dark--theme .kuda-add--options>* {\n    transition: none !important;\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -ms-transition: none !important;\n    -o-transition: none !important;\n}\n\n.kuda-add--options>*:hover {\n    border-color: #d5d8f2;\n}\n\n.kuda-add--options>* {\n    margin-bottom: 20px;\n}\n\n.kuda-add--options {\n    margin-top: 35px;\n}\n\n.add-icon {\n    margin-bottom: 17px;\n}\n\n.card-heading {\n    font-size: 0.98rem;\n}\n\n.back,\n.back-to {\n    cursor: pointer;\n}\n\n.back p {\n    display: flex;\n    align-items: center;\n    color: var(--primaryAlt);\n}\n\n.back svg {\n    margin-right: 9px;\n    height: 11px;\n    width: auto;\n    position: relative;\n    top: -1px;\n    transform: translateY(0.7px);\n}\n\n.kuda-add--options p {\n    font-size: 0.825rem;\n}\n\n.kuda-layout---card .back {\n    position: absolute;\n    top: 30px;\n    left: 30px;\n}\n\n.kuda-subtext {\n    max-width: 336px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    margin-top: 20px;\n}\n\n.formCard,\n.kuda-deposit--wrap,\n.kuda-card--wrap {\n    border: var(--card-border);\n    box-shadow: var(--card-box-shadow);\n    border-radius: 5px;\n    padding: 35px 55px 40px;\n    max-width: 380px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n}\n\n.kuda-transfer--form,\n.kuda-deposit--wrap {\n    margin-top: 25px;\n}\n\n.kuda-card--wrap {\n    margin-top: 35px;\n    background-color: var(--whiteAlt);\n}\n\n.mobile-input {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.formInput {\n    border: 0;\n    /* border-bottom: 1px solid var(--offWhiteTrans); */\n    outline: none;\n    padding-top: 13px;\n    padding-bottom: 13px;\n    padding-left: 13px;\n    font-weight: 600;\n    border-radius: 0;\n    background: none;\n    width: 100%;\n}\n\n.mobile-input .formInput {\n    border-bottom: 1px solid var(--offWhiteTrans);\n}\n\n.deposit--icons img {\n    width: 38px;\n    height: 38px;\n    object-fit: cover;\n    border-radius: 100px;\n}\n\n.kuda-deposit--text {\n    margin-top: 15px;\n}\n\n.kuda-deposit--wrap,\n.kuda-card--wrap {\n    max-width: 420px;\n    padding-left: 40px;\n    padding-right: 40px;\n}\n\n.kuda-deposit--options:not(:last-child) {\n    padding-bottom: 25px;\n    border-bottom: 1px solid var(--offWhiteTrans);\n}\n\n.kuda-deposit--options:not(:first-child) {\n    padding-top: 25px;\n}\n\n.kuda-deposit--text * {\n    font-size: 0.938rem;\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    height: 100vh;\n    background: var(--overlay);\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    width: 100vw;\n    margin-left: -50vw !important;\n    left: 50% !important;\n    z-index: 1000;\n    -webkit-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;\n    transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;\n    visibility: hidden;\n    padding: 25px 20px;\n    /* padding-left: 280px; */\n    -moz-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;\n    -ms-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;\n    -o-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0, 1) !important;\n}\n\n.modal-content {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    padding: 42px 48px 54px;\n    width: 100%;\n    max-width: 517px;\n    position: relative;\n    -ms-overflow-style: none;\n    /* Internet Explorer 10+ */\n    scrollbar-width: none;\n    /* Firefox */\n}\n\n.modal-content::-webkit-scrollbar {\n    display: none;\n    /* Safari and Chrome */\n}\n\n.small-modal .modal-content {\n    max-width: 455px;\n}\n\n.modal-content.sm {\n    max-width: 560px;\n}\n\n.transaction-header {\n    background: #F4F4F4 !important;\n    border-radius: 4px;\n    padding: 20px;\n    margin-top: 38px;\n    display: flex;\n    margin-bottom: 23px;\n}\n\n.transaction-icon {\n    margin-right: 15px;\n    width: 43px;\n    height: 43px;\n    min-width: 43px;\n    overflow: hidden;\n    border-radius: 100px;\n}\n\n.transaction-additional--details {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 15px;\n    border-bottom: 1px solid var(--offWhiteTrans);\n    padding-top: 15px;\n}\n\n.transaction-right {\n    text-align: right;\n    position: relative;\n}\n\n.generateReceipt {\n    margin-top: 37px;\n    max-width: 192px;\n    margin-bottom: 0;\n}\n\n.closeModal svg {\n    height: 29px;\n    width: auto;\n}\n\n.balance-title {\n    margin-top: 2px;\n}\n\n.kuda-heading--illustration svg {\n    width: 98px;\n    height: 98px;\n    display: block;\n    margin: 0 auto;\n}\n\n.kuda-card-content {\n    margin-top: 25px;\n}\n\n.card-fields {\n    margin-top: 30px;\n}\n\n.card-fields>div {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    height: 60px;\n    border-bottom: 1px solid var(--offWhiteTrans);\n    align-items: center;\n}\n\n.card-text {\n    font-size: 0.82rem;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n    color: var(--blackColor);\n    pointer-events: none;\n}\n\n.card-fields .card-type {\n    width: 100%;\n    border: 0;\n    outline: none;\n    padding-right: calc(50% + 15px);\n    font-size: 0.82rem;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.accept {\n    margin: 60px 0 0;\n}\n\n.card-fields+.accept {\n    margin-top: 50px;\n}\n\n.add-amount {\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    margin-top: 10px;\n    position: relative;\n}\n\n.add-amount.sm {\n    max-width: 300px;\n}\n\n.denomination {\n    background: var(--offBlue);\n    border: 1px solid var(--input-prefix-border);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    height: 100%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 42px;\n    font-weight: 600;\n    color: var(--blackColor);\n    font-size: 1rem;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n}\n\n.amount-input {\n    height: 100%;\n    width: calc(100%);\n    border: none;\n    outline: none;\n    padding: 9px 12px;\n    border-radius: 5px;\n    padding-left: 54px;\n    min-height: 46px;\n    background-color: var(--whiteColor);\n    color: var(--blackColor);\n}\n\n.amount-input::placeholder {\n    font-weight: 600;\n    color: var(--placeHolder) !important;\n}\n\n.card-group:not(:last-child) {\n    margin-bottom: 24px;\n}\n\n.kuda-add--cardForm {\n    margin-bottom: 52px;\n}\n\n.kuda-dropdown-header {\n    display: flex;\n    align-items: center;\n    height: 46px;\n    cursor: pointer;\n}\n\n.kuda-dropdown-title, .kuda-dropdown-placeholder {\n    width: calc(100% - 42px);\n    color: var(--blackColor);\n    font-weight: 600;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding-left: 12px;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n    margin-top: 0;\n    -webkit-hyphens: auto;\n    -moz-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n    padding-right: 20px;\n    height: auto;\n    line-height: 1.5;\n}\n\n.kuda-bank-dropdown-title, .kuda-bank-dropdown-placeholder {\n    width: calc(100% - 42px);\n    color: var(--blackColor);\n    font-weight: 600;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding-left: 2px;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n    margin-top: 0;\n    -webkit-hyphens: auto;\n    -moz-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n    padding-right: 20px;\n    height: auto;\n    line-height: 1.5;\n}\n\n.kuda-dropdown-placeholder, .kuda-bank-dropdown-placeholder {\n    color: var(--textColor)\n}\n.kuda-dropdown-icon {\n    width: 42px;\n    display: flex;\n    justify-content: center;\n}\n.kuda-dropdown-bank-logo{\n    height: 32px;\n    width: 32px;\n}\n.kuda-dropdown-bank-logo img{\n    max-width: 100%;\n    max-height: 100%;\n}\n.kuda-dropdown-icon {\n    width: 42px;\n    display: flex;\n    justify-content: center;\n}\n\n.kuda-dropdown-list {\n    background: var(--whiteColor);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    padding: 11px 16px 5px;\n    margin-top: 5px;\n    cursor: pointer;\n    top: -6px;\n    width: calc(100% + 4px);\n    left: -2px;\n    position: absolute;\n    z-index: 9999;\n}\n\n.kuda-dropdown-item {\n    padding: 15px 0;\n    color: var(--blackColor);\n    display: flex;\n    align-items: center;\n}\n\ninput {\n    font-weight: 600;\n}\n\n.savings-active .color-primary {\n    color: var(--successColor) !important;\n}\n\n.savings-active .kuda-cta {\n    background: var(--successColor) !important;\n}\n\n.savings-active .kuda-transaction--tabs>li[aria-selected=\"true\"]:after {\n    background: var(--successColor) !important;\n}\n\n.savings-active .denomination-icon path {\n    fill: var(--successColor) !important;\n}\n\n.save-now {\n    min-height: 162px;\n    background: var(--whiteAlt);\n    border: 1px solid var(--offGreen);\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.other-card .saving-plan {\n    background: var(--successColorTrans);\n    color: var(--successColor);\n}\n\n.other-card .save-cta {\n    color: var(--successColor) !important;\n}\n\n/* AUTH PAGE */\n\n.kuda-auth--wrap {\n    max-width: 440px;\n    width: 100%;\n}\n\n.kuda-auth--layout {\n    height: 100%;\n}\n\n.kuda-auth--wrap p {\n    font-size: 0.925rem;\n}\n\n.margin-bottom--spacer {\n    margin-bottom: 12px;\n}\n\n.kuda-auth--layout {\n    width: 100%;\n}\n\n.kuda-auth--illustration {\n    position: relative;\n    width: 50%;\n    height: 100vh;\n    display: grid;\n    place-items: center;\n}\n\n.kuda-auth--illustration div {\n    background-image: url(\"../img/LoginBgImage.svg\");\n    background-size: cover;\n    background-size: contain;\n    background-repeat: no-repeat;\n    height: 100%;\n    height: 604px;\n    width: 503px;\n}\n\n/* .kuda-auth--illustration svg {\n  width: 100%;\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n} */\n\n.auth-layout-wrap>div:last-child {\n    width: calc(100% - 530px);\n}\n\n.saveAction,\n.savings-active .addAction {\n    display: none;\n}\n\n.savings-active .saveAction {\n    display: flex;\n}\n\n.kuda-savingsIcon,\n.savings-active .kuda-bankIcon {\n    display: none;\n}\n\n.savings-active .kuda-savingsIcon {\n    display: inline-flex;\n}\n\n.auth-wrap {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    padding: 50px 70px 70px;\n}\n\n.business-reg-card {\n\n    box-shadow: 15px 30px 40px var(--card-box-shadow);\n\n}\n\n\n.kuda-auth--tabs {\n    display: flex;\n    width: auto;\n    position: relative;\n    left: 4px;\n}\n\n.kuda-auth--tabs li {\n    background: var(--whiteColor);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    padding: 8px 20px;\n    color: var(--blackColor);\n    cursor: pointer;\n    border-bottom: 0 !important;\n    font-size: 11px;\n}\n\n.kuda-auth--tabs li[aria-selected=\"true\"] {\n    background: var(--primaryColor);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    color: var(--whiteColor);\n}\n\n.kuda-auth--tabs li:first-child {\n    margin-right: 3px;\n}\n\n.kuda-form--layout {\n    margin-top: 29px;\n}\n\n.kuda-form--layout .add-amount.md {\n    max-width: 320px;\n}\n\n.mobile-input.sm {\n    max-width: 359px;\n}\n\n.kuda-form--layout ::placeholder {\n    color: var(--placeHolder);\n}\n\n.forgot-label {\n    font-size: 13px;\n    margin-top: 24px;\n}\n\n.login-button {\n    margin-top: 27px;\n    font-size: 1rem;\n    max-width: 152px;\n}\n\n.register-link {\n    font-size: 0.9375rem;\n    color: var(--successColor);\n}\n\n.kuda-inner--heading {\n    font-size: 1.75rem;\n}\n\n.normal-input {\n    padding-left: 12px;\n}\n\n.kuda-dropdown {\n    position: relative;\n    z-index: 9;\n}\n\n/* KUDA PAYMENTS */\n\n.kuda-payment--tabs li {\n    min-width: 33.33%;\n    outline: none;\n}\n\n.kuda-payment--tabs.sme-payments--tabs li {\n    min-width: 20%;\n    outline: none;\n}\n\n.schedule-payment--switch {\n    width: 100%;\n}\n\n.schedule-payment--item {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.schedule-option--wrapper {\n    height: auto !important;\n    /* border-top: 1px solid rgba(0, 0, 0, 0.1);\n    padding-top: 20px; */\n}\n\n.schedule-option {\n    margin-left: 0 !important;\n}\n\n.payment-request--title {\n    max-width: 300px;\n    margin: auto;\n}\n\n.payment-request--title h5 {\n    margin-bottom: 10px;\n    font-size: 17px;\n}\n\n.make-payment--link {\n    margin-top: 20px !important;\n    border: 1px solid #000000 !important;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    padding: 15px;\n    max-width: 327px !important;\n}\n\n.copy-link--wrap {\n    background: #f9f9f9;\n    border-radius: 4px;\n    padding: 22px 32px;\n    max-width: 335px;\n    margin: auto;\n}\n\n.single-recent--link {\n    border-bottom: none;\n}\n\n.single-recent--link .transaction-price {\n    background: var(--whiteAlt);\n    font-size: 11px;\n    padding: 5px 19px;\n    margin-right: 0px;\n    border-radius: 4px;\n}\n\n.single-recent--link .transaction-price.canceled {\n    color: #f7685b;\n    border: 1px solid #f7685b;\n}\n\n.single-recent--link .transaction-price.expired {\n    color: #979797;\n    border: 1px solid #979797;\n}\n\n.single-recent--link .transaction-price.pending {\n    color: #ffc83e;\n    border: 1px solid #ffc83e;\n}\n\n.single-recent--link .transaction-price.claimed {\n    color: #000000;\n    border: 1px solid #000000;\n}\n\n.divider {\n    opacity: 0.2;\n    border-bottom: 1px solid #dbdce0;\n    width: auto;\n    height: 0px;\n}\n\n.recent-links--wrap {\n    margin-top: 50px;\n}\n\n.confirm-payment--link {\n    max-width: 320px;\n    margin: auto;\n}\n\n.confirm-payment--link .transaction-additional--details {\n    border-bottom: none;\n}\n\n.confirm-payment--link .divider {\n    opacity: 0.25;\n    border: 1px solid #000000;\n}\n\n.pin-details--wrap {\n    max-width: 90px;\n    margin: auto;\n}\n\n.modal-message--img {\n    max-width: 100px;\n    margin: auto;\n}\n\n.bulk-select--radio {\n    height: auto !important;\n}\n\n.bulk-select--radio .kuda-radio--wrapper {\n    width: 100% !important;\n}\n\n.bulk-additional--details {\n    border-bottom: none !important;\n    margin-bottom: 2px !important;\n    padding-bottom: 0px;\n    padding-left: 9px;\n    background: #f9f9f9;\n}\n\n.bulk-confirm-item {\n    border-bottom: 1px solid #dbdce0;\n    padding-bottom: 8px;\n}\n\n.csv-upload--span {\n    right: -1px;\n    left: unset;\n}\n\n.upload-csv--wrap {\n    margin-bottom: 15px !important;\n}\n\n.upload-csv--wrap .add-amount {\n    min-width: 342px;\n    max-width: 342px;\n}\n\n.upload-csv--wrap .add-amount span {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n}\n\n.view-bank--code a {\n    font-weight: 700;\n    color: var(--offGreen);\n}\n\ntable.bulk-beneficiary--table {\n    font-family: Arial, Helvetica, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n    font-size: 12px;\n    margin-top: 40px;\n}\n\n.bulk-beneficiary--table td {\n    border-bottom: 1px solid #ddd;\n    padding: 11px;\n    color: var(--blackColor);\n}\n\n.bulk-beneficiary--table th {\n    border-bottom: none;\n    padding: 11px;\n}\n\n.bulk-beneficiary--table tr:nth-child(even) {\n    background: #f9fafe;\n}\n\n.bulk-beneficiary--table tbody tr:nth-child(1) {\n    border-bottom: 1px solid #ddd;\n}\n\n.bulk-beneficiary--table th {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    text-align: left;\n    background-color: #fff;\n    color: #000000;\n    font-weight: 700;\n    font-size: 12px;\n}\n\n.payment-success--info {\n    border-top: 1px solid #ddd;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 30px;\n    margin-top: 40px;\n}\n\n.bulk-success-modal {\n    height: auto;\n    overflow-y: scroll;\n    /* padding-right: 20px; */\n}\n\n.kuda-failure--modal .kuda-modal-illustration {\n    margin-bottom: 20px !important;\n}\n\n.failure-response--message {\n    max-width: 300px;\n    line-height: 20px;\n}\n\n.kuda-failure--modal .failure-response--message {\n    margin-bottom: 41px;\n    max-width: 300px;\n}\n\n.invoice-card--wrap {\n    max-width: 100% !important;\n    padding-left: 27px !important;\n    padding-right: 27px !important;\n}\n\n.invoice-details--card {\n    background: #ffffff;\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    padding: 0px 0px 43px;\n    max-width: 657px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    margin-top: 39px;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n}\n\n.lavendar-background {\n    background: rgb(223, 227, 255, 0.3);\n}\n\n.lavendar-background p {\n    font-size: 0.75rem;\n}\n\n.invoice-details--card>div {\n    padding: 10px 25px;\n}\n\n.invoice-table--wrap table {\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.invoice-logo--wrap {\n    padding: 25px 10px;\n    border: 2px dashed rgb(0, 0, 0, 0.2);\n    border-radius: 5px;\n    max-width: 205px;\n}\n\n.invoice-logo--wrap p {\n    font-size: 0.625rem;\n}\n\n.invoice-table--wrap table thead,\n.invoice-table--wrap table tbody tr {\n    padding: 30px 0px;\n    text-align: left;\n    border-bottom: 1px solid #dbdce0;\n}\n\n.invoice-header--left h4 {\n    font-size: 1.75rem;\n}\n\n.invoice-count--wrap div.flex {\n    max-width: 172.2px;\n}\n\n.invoice-count--wrap .invoice-count-sn {\n    background: var(--primaryAlt);\n    padding: 14px 16px;\n    color: var(--whiteAlt);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n}\n\n.invoice-count--wrap .invoice-count-num {\n    background: #ffffff;\n    border: 1px solid #f4f4f4;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    padding: 14px 16px 16px 40px;\n    text-align: right;\n}\n\n.invoice-personal-left {\n    padding: 26px 40px;\n    max-width: 50%;\n    border-right: 1px solid #ddd;\n}\n\n.invoice-personal--details ul {\n    list-style: none;\n    width: 50%;\n    max-width: 50%;\n}\n\n.invoice-personal-right {\n    padding: 26px 10px 26px 40px;\n    max-width: 50%;\n}\n\n.invoice-personal--details ul li::before {\n    content: url(\"../img/list-style-icon.svg\");\n    color: #000000;\n    /* Change the color */\n    font-weight: bold;\n    /* If you want it to be bold */\n    display: inline-block;\n    /* Needed to add space between the bullet and the text */\n    width: 1em;\n    /* Also needed for space (tweak if needed) */\n    margin-left: -1em;\n    /* Also needed for space (tweak if needed) */\n}\n\n.invoice-add--customer {\n    border: none !important;\n    padding: 41px 14px !important;\n}\n\n/* .invoice-personal--details ul */\n\n/* PAYMENTS END */\n\n.transaction-pin {\n    width: auto;\n    max-width: none !important;\n}\n\n.transaction-pin input {\n    margin-right: 5px;\n    color: var(--blackColor);\n    font-weight: 400;\n    width: auto !important;\n}\n\n.transaction-name.text-smd {\n    color: #979797;\n}\n\n.schedule-payment--switch .toggle {\n    height: 32px !important;\n}\n\n.toggle-state--wrapper {\n    padding-right: 15px;\n    padding-left: 10px;\n}\n\n.card-main--heading {\n    font-size: 1.25rem;\n    margin-bottom: 35px;\n}\n\n.card-payment-heading {\n    font-size: 1.25rem;\n    margin-bottom: 40px;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n/********* BENEFICIARY DROPDOWN ********/\n\n.no-avatar {\n    background: var(--successColor);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 8px;\n    border-radius: 100px;\n    border: 0.5px solid #fff;\n    position: relative;\n    z-index: 99;\n    width: 100%;\n    height: 100%;\n}\n\n.avatar-wrap {\n    border: 1px solid var(--successColor);\n    width: 24px;\n    height: 24px;\n    min-width: 24px;\n    min-height: 24px;\n    margin-right: 17px;\n    border-radius: 100px;\n}\n\n.kuda-dropdown-item:not(:last-child) {\n    border-bottom: 1px solid var(--bgOffset);\n    padding-bottom: 15px;\n}\n\n.modal-active .kuda-dropdown-list {\n    top: -6px;\n    position: absolute;\n    width: calc(100% + 4px);\n    left: -2px;\n}\n\n.dropdown-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.dropdown-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.dropdown-item--title {\n    font-size: 0.925rem;\n}\n\n.dropdown-item--subtitle {\n    font-size: 0.78rem;\n    color: var(--offText);\n}\n\n.kuda-searchbox input {\n    height: 40px;\n    border: 0;\n    padding-left: 40px;\n    width: 100%;\n    outline: none;\n    background-color: var(--whiteColor);\n    color: var(--blackColor);\n}\n\n.kuda-searchbox {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 99999;\n    width: 100%;\n    padding: 7px 15px;\n    background: var(--whiteColor);\n    border-bottom: 1px solid var(--bgOffset);\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.kuda-searchbox svg {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    object-fit: cover;\n}\n\ninput[type = 'search']::-webkit-search-cancel-button{\n\t/* color: var(--primaryColor); */\n\t/* background-color: var(--primaryColor); */\n    /* background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMjIxNzggOC4yMjE4M0M3LjYzNTk5IDguODA3NjEgNy42MzU5OSA5Ljc1NzM2IDguMjIxNzggMTAuMzQzMUwxMy44Nzg2IDE2TDguMjIxNzggMjEuNjU2OUM3LjYzNTk5IDIyLjI0MjYgNy42MzU5OSAyMy4xOTI0IDguMjIxNzggMjMuNzc4MkM4LjgwNzU2IDI0LjM2NCA5Ljc1NzMxIDI0LjM2NCAxMC4zNDMxIDIzLjc3ODJMMTYgMTguMTIxM0wyMS42NTY4IDIzLjc3ODJDMjIuMjQyNiAyNC4zNjQgMjMuMTkyMyAyNC4zNjQgMjMuNzc4MSAyMy43NzgyQzI0LjM2MzkgMjMuMTkyNCAyNC4zNjM5IDIyLjI0MjYgMjMuNzc4MSAyMS42NTY5TDE4LjEyMTMgMTZMMjMuNzc4MSAxMC4zNDMxQzI0LjM2MzkgOS43NTczNiAyNC4zNjM5IDguODA3NjEgMjMuNzc4MSA4LjIyMTgzQzIzLjE5MjMgNy42MzYwNCAyMi4yNDI2IDcuNjM2MDQgMjEuNjU2OCA4LjIyMTgzTDE2IDEzLjg3ODdMMTAuMzQzMSA4LjIyMTgzQzkuNzU3MzEgNy42MzYwNCA4LjgwNzU2IDcuNjM2MDQgOC4yMjE3OCA4LjIyMTgzWiIgZmlsbD0iIzRENEQ0RCIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmNvbG9yLWJ1cm4iLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMjIxNzggOC4yMjE4M0M3LjYzNTk5IDguODA3NjEgNy42MzU5OSA5Ljc1NzM2IDguMjIxNzggMTAuMzQzMUwxMy44Nzg2IDE2TDguMjIxNzggMjEuNjU2OUM3LjYzNTk5IDIyLjI0MjYgNy42MzU5OSAyMy4xOTI0IDguMjIxNzggMjMuNzc4MkM4LjgwNzU2IDI0LjM2NCA5Ljc1NzMxIDI0LjM2NCAxMC4zNDMxIDIzLjc3ODJMMTYgMTguMTIxM0wyMS42NTY4IDIzLjc3ODJDMjIuMjQyNiAyNC4zNjQgMjMuMTkyMyAyNC4zNjQgMjMuNzc4MSAyMy43NzgyQzI0LjM2MzkgMjMuMTkyNCAyNC4zNjM5IDIyLjI0MjYgMjMuNzc4MSAyMS42NTY5TDE4LjEyMTMgMTZMMjMuNzc4MSAxMC4zNDMxQzI0LjM2MzkgOS43NTczNiAyNC4zNjM5IDguODA3NjEgMjMuNzc4MSA4LjIyMTgzQzIzLjE5MjMgNy42MzYwNCAyMi4yNDI2IDcuNjM2MDQgMjEuNjU2OCA4LjIyMTgzTDE2IDEzLjg3ODdMMTAuMzQzMSA4LjIyMTgzQzkuNzU3MzEgNy42MzYwNCA4LjgwNzU2IDcuNjM2MDQgOC4yMjE3OCA4LjIyMTgzWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC40Ii8+PC9zdmc+\"); */\n\t/* background-color: black; */\n\t/* height: 10px;\n\twidth: 10px; */\n\t-webkit-appearance: none;\n}\n\n\n.avatar-wrap.has-image {\n    border: none;\n}\n\n.payment-wrap .kuda-card--wrap {\n    max-width: 533px;\n    padding-left: 57px;\n    padding-right: 57px;\n    padding-top: 40px;\n    position: relative;\n}\n\n.payment-wrap .kuda-card--wrap.kuda-bill--wrap {\n    padding-left: 85px;\n    padding-right: 85px;\n}\n\n.kuda-savings .kuda-card--wrap,\n.kuda-cards .kuda-card--wrap {\n    max-width: 533px;\n    padding: 45px 77px;\n}\n\n.kuda-cards .kuda-card--wrap .kuda-add--cardForm:not(.kuda-inner--cardFix) {\n    margin-bottom: 0;\n}\n\n.kuda-cards .kuda-card--wrap:not(.kuda-activate--wrap) {\n    padding-top: 54px;\n    padding-bottom: 75px;\n}\n\n.main-modal-active .kuda-header {\n    z-index: -1 !important;\n}\n\n.transaction-confirm-action {\n    margin: 40px auto 47px;\n    max-width: 289px;\n}\n\n.transaction-create--pin {\n    max-width: 225px;\n}\n\n.upload-docs--wrap {\n    max-width: 600px;\n    margin: auto;\n}\n\n.upload-docs--wrap.sm {\n    max-width: 300px;\n}\n\n.upload-item {\n    width: 100%;\n}\n\n.upload-item-md {\n    width: 100%;\n    max-width: 300px;\n}\n\n.upload-btn--item {\n    width: 100%;\n}\n\n.upload-item>.label-wrap {\n    margin-bottom: 10px !important;\n}\n\n.upload-btn-wrap {\n    border-radius: 5px;\n    padding: 14px 18px;\n    width: 100%;\n    border: 1px dashed rgb(0, 0, 0, 0.2);\n    min-height: 46px;\n    max-height: 46px;\n    font-size: 0.925rem;\n    font-weight: 600;\n    position: relative;\n\n}\n.upload-btn-wrap.file-uploaded {\n    padding: 14px 46px;\n\n}\n.smaller-upload-btn-wrap{\n     border-radius: 5px;\n    padding: 7px 19px;\n    width: 100%;\n    border: 1px dashed rgb(0, 0, 0, 0.2);\n    min-height: 48px;\n    font-size: 0.925rem;\n    font-weight: 600;\n}\n.upload-btn__disabled-state{\n    opacity: 0.3;\n}\n\n.no-border--upload {\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    /* width: 0; */\n}\n\n#myProgress {\n    width: 100%;\n    background-color: #ddd;\n    /* max-width: 218px; */\n    margin-right: 5px;\n}\n\n#myBar {\n    width: 37%;\n    /* max-width: 218px; */\n    height: 2px;\n    background: rgb(72, 211, 138);\n}\n\n#myBar.green {\n    background-color: #48d38a !important;\n}\n\n#myBar.purple {\n    background-color: #000000 !important;\n}\n\n#myBar.red {\n    background-color: #f7685b !important;\n}\n\n.upload-btn-wrap div:nth-child(1) {\n    /* max-width: 218px; */\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.5;\n}\n\n.upload-btn-wrap label.color-green {\n    cursor: pointer;\n}\n\n.add-signatory--wrap {\n    background: var(--whiteColor);\n    box-shadow: none !important;\n    border-radius: 10px !important;\n    border: 2px dashed #000000 !important;\n    max-width: 342px;\n    margin: auto;\n    height: 48px !important;\n}\n\ntable.kuda-signatory--table {\n    border-collapse: collapse;\n    width: 100%;\n    padding: 0rem 0rem 0rem 1rem;\n}\n\n.kuda-signatory--table td {\n    padding: 16px 0px;\n    background: var(--tdColor);\n    border-bottom: none;\n    color: #000000;\n    text-align: left;\n    /* vertical-align: middle; */\n}\n\n.kuda-signatory--table tr.table-row--border {\n    /* background-color: #f2f2f2; */\n    border-bottom: 1px solid rgba(219, 220, 224, 0.5);\n    /* box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05); */\n}\n\n.kuda-signatory--table th {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    text-align: left;\n    background-color: var(--theadColor);\n    border: none;\n    color: #000000;\n}\n\ntr.table-row--border td:nth-child(1),\ntable.kuda-signatory--table thead tr th:nth-child(1) {\n    padding-left: 15px;\n}\n\ntr.table-row--border td:nth-child(5),\ntable.kuda-signatory--table thead tr th:nth-child(5) {\n    padding-right: 15px;\n}\n\ntr.table-row--border td:nth-child(2) {\n    color: var(--primaryAlt);\n}\n\n.kuda-signatory--table tr td:first-child:before {\n    counter-increment: Count-Value;\n    content: counter(Count-Value);\n}\n\n.kuda-limit-table tr td:first-child:before {\n    counter-increment: none !important;\n    content: \"\" !important;\n}\n\n.kuda-signatory--table.no-numbering tr td:first-child:before {\n    counter-increment: none;\n    content: none;\n    display: table-header-group;\n}\n\n.signatory-input--wrap {\n    max-width: 460px;\n    justify-content: space-between;\n    margin: auto;\n}\n\n.signatory-input--wrap div.card-group {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n\n.pin-input input {\n    background: var(--offWhite);\n    border-radius: 3px;\n    border: 0;\n    width: calc(25% - 5px);\n    height: 44px;\n    max-width: 44px;\n    outline: none;\n    text-align: center;\n}\n\n.pin-input {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 15px;\n    max-width: 196px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Analytics Card */\n\n.analytics-card--section {\n    box-shadow: none !important;\n    border: none !important;\n    padding: 0 !important;\n}\n\n.analytics-card--section p>span {\n    color: rgb(0, 0, 0, 0.3) !important;\n}\n\n.analytics-percentage {\n    display: flex;\n    justify-content: center;\n    margin-top: 0.5rem;\n    font-weight: 700;\n}\n\n.analytics-progress--bar {\n    position: relative;\n    display: block;\n    height: 100%;\n    overflow: hidden;\n}\n\n.analytics-color--wrapper {\n    position: absolute;\n    /* border: 1px solid red; */\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.analytics-transaction--price {\n    font-weight: 400 !important;\n}\n\n.analytics-spending--wrap,\n.analytics-others--wrap {\n    /* max-width: 358px; */\n    max-width: 100%;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05) !important;\n    padding: 10px 0px;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    border-radius: 5px;\n    width: 358px;\n    margin-right: 13px;\n}\n\n.analytics-others--wrap {\n    /* max-width: 345px; */\n    /* width: 345px; */\n    max-width: 100%;\n    width: 100%;\n    margin-right: 0px;\n    padding: 20px;\n}\n\n.analytics-transaction--details {\n    padding-bottom: 15px !important;\n    padding-top: 15px !important;\n}\n\n.analytics-card--item {\n    padding-top: 0;\n    padding-bottom: 0;\n    box-sizing: content-box;\n    position: relative;\n}\n\n/* KUDA MODAL */\n\n.message-response {\n    max-width: 190px;\n    text-align: center;\n    margin: 0 auto;\n    line-height: 1.5;\n}\n\n.withdrawal-response {\n    max-width: 320px;\n    line-height: 1.5;\n}\n\n.notice-content {\n    max-width: 315px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* .withdrawal-response {\n  max-width: 180px;\n} */\n\n.spend-response {\n    max-width: 256px;\n}\n\n.withdrawal-auth--code {\n    font-size: 1.63rem;\n    text-align: center;\n    letter-spacing: 5px;\n    margin: 20px auto -16px;\n}\n\n.withdrawal-illustration {\n    margin-top: 8px !important;\n    margin-bottom: 21px !important;\n}\n\n.recharge-response {\n    margin-bottom: 65px;\n}\n\n.kuda-modal-illustration {\n    display: flex;\n    justify-content: center;\n    margin: 42px auto 38px;\n}\n\n/* KUDA TOGGLE */\n\n.toggle {\n    display: inline-block;\n    vertical-align: middle;\n    position: relative;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-align-self: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.toggle input[type=\"checkbox\"] {\n    display: none;\n}\n\n.toggle input[disabled]~.toggle-icon {\n    pointer-events: none;\n}\n\n.toggle-icon {\n    z-index: 0;\n    margin: 0;\n    padding: 0;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    position: relative;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    display: block;\n    cursor: pointer;\n}\n\n.toggle-icon:after,\n.toggle-icon:before {\n    content: \"\";\n}\n\n.toggle-icon:after {\n    background: #fff;\n    position: absolute;\n    z-index: 2;\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n    -webkit-transition-duration: 0.3s;\n    transition-duration: 0.3s;\n}\n\n.toggle {\n    width: 52px;\n    border-radius: 16px;\n    height: 32px;\n}\n\n.toggle input[type=\"checkbox\"]:checked+.toggle-icon {\n    background: var(--successColor);\n}\n\n.toggle input[type=\"checkbox\"]:checked+.toggle-icon:before {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n\n.toggle input[type=\"checkbox\"]:checked+.toggle-icon:after {\n    -webkit-transform: translateX(24px);\n    transform: translateX(24px);\n}\n\n.toggle-icon {\n    width: 56px;\n    border-radius: 16px;\n    height: 32px;\n    background: var(--offWhiteTrans);\n}\n\n.toggle-icon:before {\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    width: 48px;\n    height: 28px;\n    border-radius: 16px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    z-index: 1;\n    -webkit-transition-duration: 0.3s;\n    transition-duration: 0.3s;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n\n.toggle-icon:after {\n    height: 24px;\n    width: 24px;\n    top: 4px;\n    left: 4px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n    border-radius: 14px;\n}\n\n.kuda-savings--header .toggle-icon:after {\n    height: 16px;\n    width: 16px;\n}\n\n.kuda-savings--header .toggle-icon,\n.toggle {\n    height: 20px;\n    width: 38px;\n}\n\n.kuda-savings--header .toggle-icon {\n    width: 38px;\n}\n\n.kuda-savings--header .toggle input[type=\"checkbox\"]:checked+.toggle-icon:after {\n    transform: translateX(15.5px);\n}\n\n.kuda-savings--header .toggle-icon:after {\n    top: 2px;\n    left: 3px;\n}\n\n.kuda-savings--header .toggle {\n    margin-left: 20px;\n}\n\n.optional-heading {\n    margin: 25px 0;\n    display: flex;\n    align-items: center;\n}\n\n.optional-title {\n    font-size: 0.93rem;\n}\n\n.payment-wrap .modal-backdrop {\n    margin-top: -300px;\n}\n\n.bill-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 5px;\n    height: 60px;\n    padding: 10px 25px;\n    background-color: var(--whiteColor);\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border: 1px solid gray;\n}\n\n.bill-item:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.bill-item-wrap {\n    display: flex;\n    align-items: center;\n}\n\n.bill-item--icon {\n    margin-right: 18px;\n    display: flex;\n}\n\n.kuda-bills--nav {\n    margin-top: 35px;\n}\n\n.hasImage img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.hasImage {\n    background: none !important;\n    border-radius: 100px;\n    overflow: hidden;\n    border: none;\n    padding: 4px;\n}\n\n.card-label {\n    font-size: 13px;\n}\n\n/* BACK TO */\n\n.backArrow {\n    margin-right: 9px;\n}\n\n.card-nav {\n    position: relative;\n}\n\n.back-to {\n    position: absolute;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    top: 24px;\n    left: 32px;\n    cursor: pointer;\n}\n\n.has--subheading h5 {\n    margin-bottom: 15px;\n}\n\n.backArrow {\n    margin-right: 9px;\n    display: flex;\n}\n\n.svg-wrap--md {\n    width: 35px !important;\n    height: 35px !important;\n}\n\n.backArrow svg {\n    height: 11px;\n    width: auto;\n    position: relative;\n    transform: translateY(-0.8px);\n}\n\n.card-account--summary {\n    padding: 18px;\n    background: var(--offBlueTran);\n    border-radius: 10px;\n    margin-bottom: 28px;\n}\n\nh5.text-xs {\n    font-size: 0.6rem;\n}\n\n.card-50 {\n    width: 50%;\n}\n\n.card-summary--icon {\n    margin-right: 8px;\n}\n\n.card-account--summary>div:not(:last-child) {\n    border-right: 0.7px solid rgba(0, 0, 0, 0.2);\n    align-items: center;\n}\n\n.card-account--summary>div:last-child {\n    padding-left: 10%;\n}\n\n.card-summary-text h5.text-xs {\n    line-height: 1;\n}\n\n.kuda-savings .savings--inner {\n    max-width: 490px;\n    margin: 0 auto;\n}\n\n.percentage-summary {\n    background: var(--whiteAlt);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    height: 46px;\n    position: relative;\n    min-height: 46px;\n    top: -1px;\n    overflow: hidden;\n}\n\n.percentage-input {\n    text-align: center;\n    height: 100%;\n    width: 100%;\n    border: none;\n    outline: 0;\n    border-radius: 0px;\n    background: var(--whiteAlt);\n}\n\n.percentage-toggle {\n    position: absolute;\n    left: 10px;\n    top: calc(50% + 2px);\n    height: auto;\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.next {\n    left: auto;\n    right: 10px;\n}\n\n.percentage-save {\n    width: 100%;\n    margin-right: 25px;\n    height: auto;\n}\n\n.main-modal-active {\n    overflow: hidden;\n}\n\n.kuda-savings .transaction-price {\n    margin-right: 0;\n}\n\n.transaction-name {\n    margin-top: 3px;\n}\n\n.transaction-date {\n    margin-bottom: 1px;\n}\n\n.kuda-savings .transaction-avatar svg {\n    width: 100%;\n    height: 100%;\n}\n\n.spendSave-response {\n    margin-bottom: 25px;\n    max-width: 255px;\n}\n\n.kuda-hamburger {\n    position: relative;\n    display: inline-block;\n    width: 23px;\n    height: auto;\n    top: 3px;\n}\n\n\n.kuda-hamburger .kuda-hamburger--inner {\n    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    transition-duration: 75ms;\n}\n\n.kuda-hamburger .kuda-hamburger--inner:after,\n.kuda-hamburger .kuda-hamburger--inner:before {\n    position: absolute;\n    width: 20px;\n    height: 2px;\n    transition-timing-function: ease;\n    transition-duration: 0.15s;\n    transition-property: transform;\n    border-radius: 4px;\n    background-color: var(--primaryAlt);\n}\n\n\n.kuda-hamburger .kuda-hamburger--inner:after,\n.kuda-hamburger .kuda-hamburger--inner:before {\n    display: block;\n    content: \"\";\n}\n\n.kuda-hamburger .kuda-hamburger--inner:before {\n    top: -9px;\n}\n\n.kuda-hamburger .kuda-hamburger--inner:before {\n    transition: top 75ms ease 0.12s, opacity 75ms ease;\n}\n\n.inner-savings--panel {\n    max-width: 312px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-savings .kuda-card--wrap .card-main--heading {\n    margin-bottom: 32px;\n}\n\n.kuda-image--drop {\n    background: var(--successColorTrans);\n    border-radius: 10px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.kuda-image--drop svg {\n    height: 71px;\n    width: auto;\n}\n\n.fileInput {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 9;\n}\n\n.kuda-personalize--card {\n    position: relative;\n}\n\n.imgPreview {\n    position: relative;\n    height: 170px;\n}\n\n.personalize-text {\n    font-size: 1.07rem;\n    margin-top: 29px;\n    font-weight: 600;\n}\n\n.imgPreview img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 10px;\n}\n\n.flexible-summary {\n    margin-top: 35px;\n}\n\n.review-summary {\n    margin-top: 20px;\n}\n\n.single-fixed {\n    margin-top: 8px;\n}\n\n.review-summary .card-type,\n.review-summary .card-text {\n    font-size: 1rem;\n}\n\n.review-summary.card-fields>div {\n    height: 56px;\n}\n\n.review-summary {\n    max-width: 335px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-prev span {\n    display: flex;\n    align-items: center;\n    font-size: 0.875rem;\n    line-height: 1;\n}\n\n.view-goal .kuda-inner--heading {\n    display: none;\n}\n\n.view-goal .kuda-savings .kuda-card--wrap {\n    margin-top: 0;\n}\n\n.react-datepicker-wrapper {\n    width: 100%;\n}\n\n.kuda-savings--header {\n    max-width: 381px;\n    margin: 0 auto;\n}\n\n.single-savings .review-summary,\n.single-savings .displayResults {\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.single-saving--header {\n    font-size: 1.08rem;\n    margin-bottom: 3px;\n}\n\n.single-savings .review-summary.card-fields>div {\n    height: 64px;\n    margin-bottom: 22px;\n}\n\n.single-saving--subheader {\n    font-size: 0.75rem;\n    color: var(--textColor);\n}\n\n.single-savings .displayResults {\n    margin-top: 26px;\n}\n\n.summary-progress {\n    border-bottom: 0 !important;\n    height: auto !important;\n}\n\n/* PROGRESS BAR */\n\n.summary-progress--bar {\n    background: var(--offWhite);\n    height: 4px !important;\n    border: none !important;\n    border-radius: 7px;\n}\n\n.summary-progress--bg {\n    width: 0;\n    background: var(--successColor);\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    border-radius: 7px;\n    transition: width 1.5s;\n    max-width: 100%;\n}\n\n.summary-progress {\n    margin-bottom: 7px !important;\n    margin-top: 32px;\n}\n\n.savings-total--summary {\n    margin-bottom: 26px !important;\n}\n\n/* DATE PICKER */\n\n.react-datepicker__day,\n.react-datepicker__time-name {\n    color: #444444 !important;\n}\n\n.react-datepicker-popper {\n    width: 100% !important;\n}\n\n.react-datepicker,\n.react-datepicker__month-container {\n    width: calc(100% + 4px) !important;\n    position: relative;\n    left: -2px;\n}\n\n.react-datepicker {\n    font-family: \"Muli\", sans-serif !important;\n    font-size: 0.9rem !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n    line-height: 2.5rem !important;\n}\n\n.react-datepicker__header {\n    background: none !important;\n    border-bottom: 0 !important;\n}\n\n.react-datepicker__current-month {\n    margin-bottom: 7px !important;\n}\n\n.react-datepicker {\n    border: 1px solid var(--bgOffset) !important;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n    border-bottom-color: var(--bgOffset) !important;\n}\n\n.react-datepicker__navigation--previous {\n    border-right-color: #000 !important;\n}\n\n.react-datepicker__navigation--next {\n    border-left-color: #000 !important;\n}\n\n.react-datepicker__header {\n    padding-top: 20px !important;\n}\n\n.react-datepicker__day-name {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    color: var(--blackColor) !important;\n    margin-top: 15px !important;\n    line-height: 1rem !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day:hover,\n.react-datepicker__time-name {\n    border-radius: 100px !important;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n    background: none !important;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range {\n    border-radius: 100px !important;\n    background: none !important;\n}\n\n.react-datepicker__navigation {\n    outline: none !important;\n}\n\n.react-datepicker__day {\n    position: relative !important;\n    z-index: 2 !important;\n}\n\n.react-datepicker__day:before {\n    background: var(--bgOffset) !important;\n    content: \"\" !important;\n    position: absolute !important;\n    width: 34px !important;\n    height: 34px !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    border-radius: 100px !important;\n    z-index: -1 !important;\n    opacity: 0 !important;\n}\n\n.react-datepicker__day:hover:before {\n    opacity: 1 !important;\n}\n\n.react-datepicker__day.react-datepicker__day--selected:before {\n    opacity: 1 !important;\n}\n\n.react-datepicker__day.react-datepicker__day--selected:before {\n    background: var(--successColor) !important;\n}\n\n.react-datepicker__navigation {\n    top: 20px !important;\n}\n\n.react-datepicker__day--outside-month {\n    opacity: 0.09 !important;\n    pointer-events: none !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n    width: 13% !important;\n}\n.edit-savings--form {\n    max-width: 420px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.date-picker--field {\n    z-index: 999;\n}\n\n.kuda-savings .kuda-card--wrap .card-main--heading+.card-main--subheading {\n    margin-bottom: 32px;\n    margin-top: -22px;\n}\n\n.single-fixed:last-child {\n    margin-bottom: 44px;\n}\n\n.fixed-separator {\n    justify-content: center !important;\n    height: 75px !important;\n    border-bottom: 0 !important;\n    margin-bottom: -28px !important;\n}\n\n.fixed-summary {\n    margin-top: -10px;\n}\n\n.kuda-card--progress {\n    position: absolute;\n    top: 0;\n    height: 3px;\n    left: 2.4px;\n    background: var(--primaryColor);\n    border-radius: 3px;\n    display: flex;\n    width: 10%;\n    transition: width 1s;\n    max-width: calc(100% - 2.4px);\n}\n\n.wrap-has--progress {\n    position: relative;\n}\n\n/* ACCOUNT DROPDOWN */\n\n.kuda-account--dropdown {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: -50px;\n    padding: 15px;\n    background: #fff;\n    box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.05);\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    visibility: hidden;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.kuda-account {\n    position: relative;\n    cursor: pointer;\n    height: 70px;\n}\n\nli.kuda-account--item {\n    text-align: center;\n    cursor: pointer;\n}\n\n.kuda-account:hover .kuda-account--dropdown {\n    bottom: -46px;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.5s;\n}\n\n.form-loading {\n    position: relative;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n    opacity: 0.8;\n    pointer-events: none;\n}\n\n.form-loading span {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.kuda-cta span {\n    pointer-events: none;\n}\n\n.form-loading:after {\n    position: absolute;\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    display: inline-block;\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n    background-size: 30px 30px;\n}\n\n.secondary-button.form-loading:after {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto; background: none; display: block; shape-rendering: auto;' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3E%3Ccircle cx='50' cy='50' r='32' stroke-width='8' stroke='%23000' stroke-dasharray='50.26548245743669 50.26548245743669' fill='none' stroke-linecap='round' transform='rotate(311.967 50 50)'%3E%3CanimateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='0.72s' keyTimes='0;1' values='0 50 50;360 50 50'/%3E%3C/circle%3E%3C!-- %5Bldio%5D generated by https://loading.io/ --%3E%3C/svg%3E\");\n}\n\n.secondary-button-no-border.form-loading:after {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto; background: none; display: block; shape-rendering: auto;' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3E%3Ccircle cx='50' cy='50' r='32' stroke-width='8' stroke='%23000' stroke-dasharray='50.26548245743669 50.26548245743669' fill='none' stroke-linecap='round' transform='rotate(311.967 50 50)'%3E%3CanimateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='0.72s' keyTimes='0;1' values='0 50 50;360 50 50'/%3E%3C/circle%3E%3C!-- %5Bldio%5D generated by https://loading.io/ --%3E%3C/svg%3E\");\n}\n/******* KUDA ATM LAYOUT *******/\n\n.kuda-atm--wrap {\n    display: block;\n    width: 100%;\n    background: #40196D;\n    border-radius: 10px;\n    height: 172px;\n    max-width: 250px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: hidden;\n}\n\n.black-strip {\n    width: 100%;\n    height: 30px;\n    position: absolute;\n    top: 25px;\n    background-color: #0b0e00;\n}\n\n.kuda-atm--details {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: calc(100% - 55px);\n    padding-top: 10px;\n    padding-left: 15px;\n}\n\n.cvc-strip {\n    height: 18px;\n    background: linear-gradient(180deg, #b3b3b3 -21486%, #cdcdcd -15412.82%, #dfdfdf -9339.64%, #e6e6e6 -5072%);\n    max-width: 132px;\n    color: var(--primaryColor);\n    font-size: 11px;\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 3px;\n    font-weight: 700;\n    padding-right: 5px;\n}\n\n.card-pin {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--whiteColor);\n    margin-top: 9px;\n    max-width: 146px;\n}\n\n.card-expiry {\n    max-width: 144px;\n    font-size: 12px;\n    color: var(--whiteColor);\n    font-weight: 700;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 7px;\n}\n\n.valid-thru svg {\n    height: calc(100% - 3px);\n    width: auto;\n    margin-right: 5px;\n}\n\n.valid-thru {\n    display: block;\n    width: 22px;\n    margin-right: 5px;\n}\n\n.asterisks {\n    margin-right: 6px;\n}\n\n.badge {\n    padding: 3px 10px;\n    border-radius: 5px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.badge.incomplete {\n    color: var(--whiteAlt);\n    background: #7ee1f6;\n    border: 1px solid #1dcbef;\n    max-height: 20px;\n}\n\n.badge.green {\n    background: #dcffec;\n    color: #48d38a;\n}\n\n.card-badge {\n    background: var(--primaryColor);\n    height: 99px;\n    right: -22px;\n    position: absolute;\n    width: 54px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: rotate(45deg);\n    bottom: -40px;\n}\n\n.card-badge svg {\n    transform: rotate(-45deg);\n    position: relative;\n    top: 1px;\n    left: -12px;\n    height: 11px;\n    width: auto;\n}\n\n/******* CARD LIMITS *******/\n\n.kuda-cards .percentage-save {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.set-card--Limit {\n    margin-top: 42px;\n}\n\n.cards-inner--wrap {\n    padding-left: 100px !important;\n    padding-right: 100px !important;\n}\n\n.kuda-cards .kuda-cta-lg {\n    max-width: 180px;\n}\n\n.channels-toggle .toggle-icon {\n    width: 42px;\n    height: 22px;\n    margin-right: 34px;\n}\n\n.channels-toggle .toggle-icon:after {\n    height: 14px;\n    width: 14px;\n}\n\n.channels-toggle .toggle input[type=\"checkbox\"]:checked+.toggle-icon:after {\n    transform: translateX(20px);\n}\n\n.cards-inner--wrap .optional-title {\n    position: relative;\n    top: 5px;\n    font-size: 1.06rem;\n}\n\n.channels-toggle {\n    margin-top: 35px;\n}\n\n.channels-toggle toggle-icon,\n.channels-toggle .toggle {\n    width: auto;\n}\n\n.channels-toggle .toggle {\n    display: flex;\n    align-items: center;\n}\n\n.toggle-state {\n    position: absolute;\n    right: 0;\n    font-weight: 700;\n    font-size: 14px;\n}\n\n.mt-32 {\n    margin-top: 32px;\n}\n\n.mt-40 {\n    margin-top: 2.5rem;\n}\n\n.card-indicatior {\n    position: absolute;\n    right: -32px;\n    top: -3px;\n}\n\n.card-indicatior svg {\n    height: 18px;\n    width: auto;\n}\n\n.activate--wrap .card-group {\n    margin-top: 35px;\n}\n\n/****** PIN *******/\n\n.instructions {\n    max-width: 319px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.instructions p {\n    font-size: 0.95rem;\n}\n\n.default-pin--badge {\n    background: var(--offWhite);\n    border-radius: 4px;\n    height: 73px;\n    max-width: 238px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.default-pin--badge span {\n    font-size: 30px;\n    line-height: 28px;\n    letter-spacing: 30px;\n    width: 100%;\n    color: var(--blackColor);\n    text-align: center;\n    margin-left: 30px;\n}\n\n.default-pin--badge {\n    background: var(--offWhite);\n    border-radius: 4px;\n    height: 73px;\n    max-width: 238px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.default-pin--badge span {\n    font-size: 30px;\n    line-height: 28px;\n    letter-spacing: 30px;\n    width: 100%;\n    color: var(--blackColor);\n    text-align: center;\n    margin-left: 30px;\n}\n\n.activate--wrap+.addAction {\n    margin-top: 52px !important;\n}\n\n.kuda-activate--wrap {\n    padding-bottom: 75px !important;\n}\n\n.add-amount.pin {\n    height: 48px;\n    padding: 15px;\n    font-weight: 600 !important;\n}\n\n.transaction-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.searchIcon {\n    pointer-events: none;\n}\n\n.saving-icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.saving-icon {\n    height: 38px;\n    width: 38px;\n    border-radius: 100px;\n    overflow: hidden;\n}\n\n.saving-details.text-right {\n    min-width: 80px;\n}\n\n.kuda-entry.entry-top {\n    position: relative;\n    z-index: 1;\n}\n\n.kuda-entry .kuda-entry--wrap {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.kuda-entry.kuda-page--transition .kuda-entry--wrap {\n    opacity: 1;\n    transition: opacity 1s;\n    visibility: visible;\n}\n\n.kuda-page--loader {\n    display: flex;\n    justify-items: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.kuda-page--loader img,\n.kuda-page--loader svg {\n    width: 230px !important;\n    height: auto !important;\n    margin-left: 23px;\n}\n\n.kuda-loader {\n    opacity: 1;\n    visibility: visible;\n    position: fixed;\n    z-index: 9999999;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--whiteColor);\n}\n\n.kuda-page--transition .kuda-loader {\n    display: none;\n}\n\n.kuda-loader:not(.payoneer-loader) path {\n    fill: var(--primaryAlt) !important;\n}\n\n.save-title {\n    width: auto !important;\n    overflow-x: hidden !important;\n    overflow-y: hidden !important;\n    text-overflow: ellipsis !important;\n    height: auto;\n    line-height: 1.2;\n}\n\n.transaction-additional--details .save-title {\n    font-size: 0.875rem;\n    margin-bottom: 5px !important;\n}\n\n.summary-card>div:last-child .saving-details:not(.text-right) {\n    width: auto !important;\n    white-space: nowrap;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    padding-right: 10px;\n}\n\n.transaction-icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.closeModal {\n    cursor: pointer;\n    position: absolute;\n    top: 17px;\n    left: 17px;\n}\n\n.closeModal.align-right {\n    right: 17px;\n    left: unset;\n}\n\n.inactivity-buttons .kuda-cta-lg {\n    max-width: 166px;\n}\n\n.kuda-account--wrap {\n    max-width: 890px !important;\n    padding: 45px 61px !important;\n    margin-left: -98px;\n    margin-right: -98px;\n}\n\n.kuda-user--wrap {\n    max-width: 752px !important;\n    padding: 45px 61px !important;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-limit--pad {\n    padding-left: 26px;\n    padding-right: 26px;\n    padding-bottom: 26px;\n}\n\n/* BLOCK ITEM */\n\n.block-item-wrap {\n    display: flex;\n    align-items: center;\n}\n\n.block-item {\n    background: var(--whiteColor);\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 60px;\n    padding: 10px 25px;\n    position: relative;\n}\n\n.status-icon {\n    /* width: 20px;\n  height: 20px; */\n    /* background: #ffc83e; */\n    position: absolute;\n    /* border-radius: 50%; */\n    right: -1%;\n    top: -8%;\n    /* font-size: 14px; */\n}\n\n.block-item.onboarding-item {\n    border: 1px solid rgba(219, 220, 224, 0.5);\n}\n\n.block-item:not(:last-child) {\n    margin-bottom: 15px;\n}\n\n.block-item--icon {\n    min-width: 30px;\n    margin-right: 15px;\n}\n\n.kuda-block--navWrapper {\n    display: flex;\n    justify-content: space-between;\n}\n\n.kuda-block--nav {\n    width: calc(50% - 25px);\n}\n\n.block-item-wrap {\n    font-size: 0.9rem;\n}\n\n/***** ACCOUNT IMAGE *****/\n\n.account-image {\n    width: 95px;\n    height: 95px;\n    min-width: 95px;\n    min-height: 95px;\n    border-radius: 100px;\n    position: relative;\n    background-size: cover !important;\n    background-position: top;\n    background: var(--whiteAlt);\n    /* border: 1px solid #411a6e; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #e8e8e8;\n}\n\n.account-image>div {\n    width: 100%;\n    height: 100%;\n    /* min-width: 100px;\n  min-height: 100px; */\n    display: flex;\n    border-radius: 100px;\n    position: relative;\n    background-size: cover;\n    background-position: top;\n    background: var(--primaryAlt);\n    color: var(--whiteAlt);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 39px;\n}\n\n#edit-item {\n    position: absolute;\n    left: auto;\n    right: 12px;\n    bottom: -10px;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    border-radius: 100px;\n    margin-left: 15px;\n    cursor: pointer;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08) !important;\n}\n\n.account-image img {\n    border-radius: 100px;\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n}\n\n.kuda-account--summary {\n    margin-bottom: 36px;\n}\n\n.edit-item {\n    /* position: absolute; */\n    /* left: auto;\n  right: 12px;\n  bottom: -10px; */\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    /* margin-left: 15px; */\n    cursor: pointer;\n    /* -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08) !important; */\n    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08) !important; */\n}\n\n.sme-info--card {\n    background: #ffffff;\n    border: 1px solid #dfe3ff;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    max-width: 100%;\n    margin: 0 auto 50px;\n    padding: 20px 40px;\n}\n\n.company-profile {\n    max-width: 752px !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n\n}\n.sme-info--card>ul {\n    width: 50%;\n}\n\n.vertical-divider {\n    width: 1px;\n    opacity: 0.2;\n    border-right: 1px solid #000000;\n    margin: 0px 32px;\n}\n\n.sme-info--card ul li {\n    font-size: 13px;\n}\n\n.sme-info--card ul li:not(:last-child) {\n    margin-bottom: 15px;\n}\n\n.edit-item svg {\n    width: 24px;\n    height: 24px;\n}\n\n.profile-account {\n    display: flex;\n    align-items: center;\n    /* width: 50%; */\n    margin: auto;\n    margin-bottom: 20px;\n}\n\n.profile-account.md {\n    width: 50%;\n}\n\n.kuda-account--summary {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.kuda-account--summary>div {\n    width: calc(50% - 23px);\n}\n\n.kuda-account--summary---lg>div {\n    width: auto !important;\n    margin-bottom: 0;\n}\n\n.copy-account {\n    margin-top: 10px;\n}\n\n.copy-account p {\n    margin-top: 7px;\n    display: flex;\n}\n\n.summary-labels .text-sm {\n    font-size: 0.78rem;\n}\n\n.kuda-tier--holder {\n    display: inline-flex;\n    align-items: center;\n}\n\n.summary-labels {\n    width: 100%;\n    position: relative;\n    margin-left: 23px;\n    padding-top: 4px;\n}\n\n.summary-labels h1 {\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.kuda-tier--holder span {\n    display: inline-flex;\n}\n\n.account-name {\n    font-size: 1.25rem;\n    /* width: 100%; */\n    margin-right: 0.5rem;\n}\n\n.kuda-share--earn {\n    display: flex;\n    background: var(--primaryColor);\n    align-items: center;\n    padding: 22px 27px 25px;\n    justify-content: space-between;\n    border-radius: 4px;\n}\n\n.earn-heading {\n    font-size: 1.1rem;\n    margin-bottom: 8px;\n}\n\n.kuda-invite--cta {\n    background: var(--successColor);\n    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 700;\n    height: 20px;\n    color: var(--primaryColor);\n    width: 112px;\n}\n\n.text-mxs {\n    font-size: 0.6875rem;\n}\n\n.share-earn--50 {\n    width: calc(55% - 7px);\n}\n\n.share-earn--100 {\n    width: 100%;\n}\n\n.earn-denominator {\n    font-size: 1rem;\n    position: relative;\n    top: 4px;\n    margin-right: 3px;\n}\n\n.earnings {\n    display: flex;\n    align-items: flex-start;\n    font-weight: 800;\n    font-size: 2.1rem;\n}\n\n.tier-value {\n    margin-left: 2px;\n}\n\n.kuda-menu--text.active {\n    color: var(--primaryColor) !important;\n}\n\n/******* KUDA PROFILE PAGE *******/\n\n.kuda-profile--center {\n    max-width: 325px;\n    margin-right: auto;\n    margin-left: auto;\n    margin-bottom: 40px;\n}\n\n.kuda-profile--form .profile-block {\n    margin-bottom: 40px;\n}\n\n.no-border {\n    border: none;\n}\n\n.no-border .hasImage {\n    padding: 0;\n}\n\n.is-iframe {\n    max-width: 435px !important;\n    background: none;\n    padding: 0;\n    border: 0;\n    box-shadow: none;\n}\n\n.Toaster__alert {\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 30px 40px var(--boxShadow) !important;\n    border-radius: 5px;\n    padding: 15px 30px 15px 25px !important;\n    max-width: 480px !important;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.Toaster__manager-bottom {\n    bottom: 45px !important;\n}\n\n.Toaster__alert_text {\n    font-size: 14px;\n}\n\n.Toaster__alert_close {\n    top: 48% !important;\n    transform: translateY(-50%);\n    font-size: 1.4rem !important;\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    -o-transform: translateY(-50%);\n    color: var(--primaryColor) !important;\n    opacity: 1 !important;\n}\n\n.Toaster__message-wrapper {\n    width: 100%;\n    padding: 0 14px !important;\n}\n\n.Toaster__manager-top-right{\n    top: 101px !important;\n    right: 20px !important;\n}\n/***** EDIT BUTTON *****/\n\n.edit-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 13px;\n    background: var(--primaryColor);\n    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n    height: 26px;\n    width: 49px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: #fff;\n    cursor: pointer;\n}\n\n/******* SECONDARY BUTTON  *****/\n\n.secondary-button {\n    /* border: 1px solid var(--primaryColor) !important; */\n    border: 1px solid #000000 !important;\n    color: var(--primaryColor) !important;\n    background-color: var(--buttonBackgroundColor) !important;\n}\n\n.secondary-button-updated {\n    border: 1px solid #000000;\n    color: var(--primaryColor) !important;\n    background-color: #f9f9f9 !important;\n}\n\n.profile-block .amount-input {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    padding-right: 75px;\n}\n\n.empty-summary {\n    margin-top: 53px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.empty-heading {\n    margin-top: 22px;\n    margin-bottom: 10px;\n    font-size: 1rem;\n    font-weight: 900;\n}\n\n.payButton {\n    display: none;\n}\n\niframe {\n    background: none !important;\n}\n\n.loading {\n    position: relative;\n    align-items: center;\n    justify-content: center;\n}\n\n.loading:after {\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    border-top-color: #fff;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    animation: spin 1s linear infinite;\n    display: flex;\n    content: \"\";\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    to {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n    }\n}\n\n.kuda-dropdown-list {\n    max-height: 381px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-top: 56px;\n}\n\n.kuda-dropdown-list.no-search {\n    padding-top: 20px !important;\n}\n\n.kuda-budget--illustration {\n    margin-bottom: 25px;\n    margin-top: 37px;\n}\n\n.budget-response {\n    margin-bottom: -0.5rem;\n}\n\n.backdrop-init .modal-backdrop {\n    visibility: visible;\n}\n\n.kuda-duration--summary p {\n    font-size: 0.8rem;\n}\n\n.kuda-duration--summary {\n    margin: -5px auto 45px;\n}\n\n.react-datepicker__day--disabled {\n    opacity: 0.2;\n    pointer-events: none;\n}\n\n.react-datepicker__day.react-datepicker__day--selected {\n    color: #fff !important;\n}\n\n.summary-naira--icon .denomination-icon svg {\n    height: 13px;\n    margin-right: 2px;\n}\n\n.summary-naira--icon .denomination-icon svg path {\n    fill: var(--blackColor) !important;\n}\n\n.noTransaction {\n    margin-bottom: 0 !important;\n}\n\n.noTransaction .review-summary.card-fields>div:last-child {\n    margin-bottom: 10px !important;\n}\n\n.hasTransaction {\n    margin-bottom: 25px !important;\n}\n\n.single-savings .singleTransaction .transaction-price {\n    margin-right: 0 !important;\n    top: 1.5px !important;\n}\n\n.single-savings .kuda-personalize--card+.flexible-summary {\n    margin-top: 22px !important;\n}\n\n.kuda-skeleton--loader .card-fields>div {\n    border-bottom: 0;\n}\n\n.kuda-skeleton--loader .card-text {\n    width: 50%;\n}\n\n.white-cta.form-loading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiM0MDE5NmQiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n}\n\n.kuda-dark--theme .white-cta.form-loading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n}\n\n#react-toast .Toaster__alert_text {\n    font-family: \"Muli\", sans-serif !important;\n    font-size: 0.9rem;\n    font-weight: 600;\n    text-align: left !important;\n}\n\n.locked svg {\n    height: 19px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 12px;\n    width: auto;\n    fill: var(--textColor);\n}\n\n.edit-savings--form input {\n    cursor: default;\n}\n\n.single-savings .kuda-transaction--details {\n    min-height: 100% !important;\n    height: auto !important;\n    align-items: flex-start;\n}\n\n.single-savings .transaction-date {\n    margin-top: 8px;\n}\n\n.single-savings .transaction-name {\n    line-height: 1.4;\n    margin-top: -0.5px;\n    padding-right: 25px;\n}\n\n.percentageSave-wrap {\n    margin-top: 38px;\n}\n\n.transaction-avatar.hasImage {\n    padding: 0;\n}\n\n.backdrop-init {\n    overflow: hidden;\n}\n\n.empty-text {\n    max-width: 306px;\n    text-align: center;\n}\n\n.empty-savings--card {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    margin-top: 25px;\n    max-width: 490px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.empty-savings--card .empty-summary {\n    margin-top: 30px;\n    padding-bottom: 48px;\n}\n\n.empty-savings--card .empty-illustration {\n    margin-top: 60px;\n    margin-bottom: 44px;\n}\n\n.empty-text .card-main-subheading {\n    color: var(--offText);\n}\n\n.kuda-set--status {\n    opacity: 0.2;\n    pointer-events: none;\n}\n\n.kuda-activate--badge {\n    max-width: 185px;\n    margin-top: 20px;\n    font-size: 13px;\n    height: 30px;\n    border-radius: 5px;\n}\n\n.kuda-payment--wrap .react-tabs__tab-panel--selected {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n}\n\n.card-subheading--boxed {\n    margin-top: 15px;\n    max-width: 319px;\n    line-height: 1.4;\n    color: #333333 !important;\n}\n\n.card-subheading--boxed-lg {\n    max-width: 350px;\n}\n\n.kuda-edit--layout {\n    max-width: 420px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.edit-account--wrap {\n    margin-top: 35px;\n}\n\n.saveFields {\n    margin-top: 53px;\n    margin-bottom: 20px;\n}\n\n.boxed-width {\n    max-width: 340px;\n}\n\n.phone-placeholder {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 15px;\n    color: var(--blackColor);\n    font-weight: 600;\n    pointer-events: none;\n}\n\n.edit-phone {\n    padding-left: 65px;\n}\n\n.kuda-split--wrap {\n    display: flex;\n    justify-content: space-between;\n}\n\n.kuda-split--wrap>div {\n    width: calc(50% - 6px);\n}\n\n.kuda-select--radio {\n    width: 100%;\n    display: flex;\n    height: 46px;\n    justify-content: space-between;\n    margin-top: 17px;\n}\n\n.radio-select--lg {\n    max-width: 306px;\n    background: #ffffff;\n    padding: 11px 0px !important;\n}\n\n.radio-select--lg input {\n    display: none;\n}\n\n/* RADIO SELECT LARGE */\n\n.radio-select--lg input:not(:checked)+label {\n    background-color: var(--whiteColor) !important;\n    color: var(--blackColor);\n}\n\n.radio-select--lg label {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    padding-left: 40px;\n    position: relative;\n    color: var(--successColor);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.radio-select--lg input:not(:checked)+label .outer {\n    background-color: var(--whiteAlt) !important;\n    border: 1px solid var(--whiteAlt);\n}\n\n.radio-select--lg .outer {\n    width: 30px;\n    height: 30px;\n    border-radius: 100px;\n    background-color: var(--primaryAlt);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: -7px !important;\n}\n\n.radio-select--lg .inner {\n    width: 22px;\n    height: 22px;\n    border-radius: 100px;\n    background-color: white;\n    position: absolute;\n    border: 2px solid #000000;\n}\n\n/* RADIO SELECT OUTLINE */\n\n.radio-select--outline {\n    max-width: 186px;\n    background: #ffffff;\n    padding: 11px 0px !important;\n    border: 1px solid #dcffec;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n}\n\n.radio-select--outline input {\n    display: none;\n}\n\n.radio-select--outline input:not(:checked)+label {\n    background-color: var(--whiteColor) !important;\n    color: var(--blackColor);\n}\n\n.radio-select--outline label {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding-left: 50px;\n    position: relative;\n    color: var(--successColor);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.radio-select--outline input:not(:checked)+label .outer {\n    background-color: var(--whiteAlt) !important;\n    border: 1px solid var(--whiteAlt);\n}\n\n.radio-select--outline .outer {\n    width: 17.1px;\n    height: 17.1px;\n    border-radius: 100px;\n    background-color: var(--primaryAlt);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    /* left: -7px !important; */\n}\n\n.radio-select--outline .inner {\n    width: 17.1px;\n    height: 17.1px;\n    border-radius: 100px;\n    background-color: white;\n    position: absolute;\n    border: 1px solid #48d38a;\n}\n\n.kuda-radio--wrapper {\n    display: flex;\n    width: calc(50% - 30px);\n}\n\n.kuda-radio--column {\n    flex-direction: column;\n    height: auto;\n}\n\n.radio-height--md {\n    height: 45px;\n    width: 186px;\n    max-width: 186px;\n}\n\n.new-account--wrap .outer {\n    left: 0px !important;\n}\n\n.new-account--wrap label .column-100 {\n    width: 100% !important;\n}\n\n.kuda-radio--lgWrap,\n.business-radio--wrap {\n    width: 391px;\n    padding: 11px 15px !important;\n}\n\n.kuda-radio--smWrap {\n    width: fit-content;\n    padding: 11px 0px !important;\n}\n\n.kuda-radio--lgWrap input {\n    display: none;\n}\n\n.kuda-radio--lgWrap label {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding-left: 35px;\n    position: relative;\n    color: var(--successColor);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.kuda-radio--lgWrap .outer {\n    width: 24px;\n    height: 24px;\n    border-radius: 100px;\n    background-color: var(--whiteAlt);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 16px;\n}\n\n.kuda-radio--account {\n    display: flex;\n}\n\n.kuda-radio--account label {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding-left: 35px;\n    position: relative;\n    color: var(--successColor);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.kuda-radio--account input {\n    display: none;\n}\n\n.outer-business {\n    width: 13px;\n    height: 13px;\n    border-radius: 100px;\n    background-color: #48d38a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 0px;\n    border: 1px solid #48d38a;\n}\n\n.inner-business {\n    width: 16px;\n    height: 16px;\n    border-radius: 100px;\n    background-color: #48d38a;\n    position: absolute;\n}\n\n.inner-business,\n.outer-business {\n    border-radius: 100px;\n    position: absolute;\n}\n\n.kuda-radio--account input:not(:checked)+label {\n    /* background-color: var(--whiteColor) !important; */\n    color: var(--blackColor);\n}\n\n.kuda-radio--account input:not(:checked)+label .outer-business {\n    background-color: var(--whiteColor) !important;\n    border: 1px solid var(--successColor);\n}\n\n.kuda-radio--account input:not(:checked)+label .inner-business {\n    background-color: var(--whiteColor) !important;\n    border: 1px solid var(--successColor);\n}\n\n.kuda-radio--smWrap .outer-green {\n    width: 13px;\n    height: 13px;\n    border-radius: 100px;\n    background-color: var(--whiteAlt);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 16px;\n}\n\n.outer-start {\n    left: 0px !important;\n}\n\n.kuda-radio--lgWrap .inner-green {\n    width: 10px;\n    height: 10px;\n    background-color: #48d38a !important;\n    position: absolute;\n    border: 1px solid #48d38a !important;\n}\n\n.kuda-radio--lgWrap input:checked+label .outer .inner {\n    width: 16px;\n    height: 16px;\n    border-radius: 100px;\n    background: #48d38a;\n    border: 1px solid #48d38a;\n    position: absolute;\n}\n\n.kuda-radio--lgWrap input:not(:checked)+label {\n    background-color: var(--whiteColor) !important;\n    color: var(--blackColor);\n}\n\n.kuda-radio--lgWrap input:not(:checked)+label .outer {\n    background-color: var(--whiteAlt) !important;\n    border: 1px solid var(--whiteAlt);\n}\n\n.kuda-radio--lgWrap input:not(:checked)+label .outer .inner {\n    background-color: var(--whiteAlt) !important;\n    border: 1px solid #48d38a;\n}\n\n.account-avatar-sm {\n    background: var(--primaryAlt);\n    border-radius: 100px;\n    min-width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.new-account--btn {\n    background: #DBDCE0 !important;\n}\n\n.account-avatar-sm svg {\n    width: 50px;\n    height: 50px;\n}\n\n.kuda-select--radio.justify-content-end {\n    justify-content: unset !important;\n}\n\n.kuda-radio--wrapper label {\n    height: 100%;\n    width: 100%;\n    background: var(--successColorTrans);\n    border: 1px solid var(--successColorTrans);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    padding-left: 55px;\n    position: relative;\n    color: var(--successColor);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.kuda-radio--wrapper label.font-weight-400 {\n    font-weight: 400;\n}\n\n.kuda-radio--wrapper input {\n    display: none;\n}\n\n.outer {\n    width: 24px;\n    height: 24px;\n    border-radius: 100px;\n    background-color: var(--successColor);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 16px;\n}\n\n.outer-small {\n    width: 18px;\n    height: 18px;\n}\n\n.inner {\n    width: 10px;\n    height: 10px;\n    border-radius: 100px;\n    background-color: var(--whiteColor);\n    position: absolute;\n}\n\n.kuda-radio--wrapper input:not(:checked)+label {\n    background-color: var(--whiteColor) !important;\n    color: var(--blackColor);\n}\n\n.kuda-radio--wrapper input:not(:checked)+label .outer {\n    background-color: var(--whiteColor) !important;\n    border: 1px solid var(--successColor);\n}\n\n.limit-fields .card-type,\n.limit-fields .card-text {\n    font-size: 0.9375rem;\n}\n\n.limit-fields>div {\n    height: 50px;\n}\n\n.limit-fields {\n    margin-top: 19px;\n}\n\n.limit-fields>div:first-child {\n    border-top: 1px solid var(--offWhiteTrans);\n}\n\n.kuda-limit--item:not(:first-of-type) {\n    margin-top: 30px;\n}\n\n.kuda-inline--button {\n    font-weight: bold;\n    font-size: 0.9375rem;\n    text-align: center;\n    text-decoration-line: underline;\n    color: var(--primaryColor);\n}\n\n.top-spacing {\n    margin-top: 47px;\n}\n\n.top-spacing--md {\n    margin-top: 35px;\n}\n\n.increase-limit {\n    margin-top: 56px;\n    background: var(--primaryColor);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--overlay);\n    border-radius: 10px;\n    padding: 30px 72px;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.increase-limit h1 {\n    display: inline-flex;\n}\n\n.cta-boxed--btn {\n    background: #dfe3ff;\n    border-radius: 10px;\n}\n\n.kuda-cta--open {\n    margin-top: 20px;\n}\n\n.cta-boxed--btn>span {\n    display: flex;\n    align-items: center;\n}\n\n.cta-separator {\n    margin-left: 11px;\n}\n\n.referral-icon {\n    display: flex;\n    justify-content: center;\n}\n\n.share-header--wrap {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 47px;\n    margin-bottom: 35px;\n}\n\n.share-header--wrap>div {\n    width: calc(50% - 24px);\n}\n\n.share-header {\n    margin-bottom: 14px;\n}\n\n.invite-requirements {\n    margin: 23px 0;\n}\n\nul.invite-requirements li {\n    margin: 9px 0;\n}\n\n.kuda-share--earnAlt {\n    margin-top: 20px;\n    background: var(--offBlue);\n}\n\n.referral-entry .earn-status {\n    margin-bottom: 12px !important;\n}\n\n.referral-entry>div {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.share-items {\n    margin-bottom: 12px;\n}\n\n.share-icon {\n    margin-left: 20px;\n}\n\n.share-icon:first-child {\n    margin-left: 0;\n}\n\n.kuda-cta-full {\n    max-width: 100%;\n    margin-bottom: 44px;\n}\n\n.kuda-referral--card .empty-savings--card {\n    max-width: 555px;\n    border: 1px solid #dfe3ff;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n}\n\n.kuda-referral--card .empty-summary {\n    margin-top: 38px;\n    padding-bottom: 70px;\n}\n\n.kuda-referral--card .empty-illustration {\n    margin-top: 40px;\n    margin-bottom: 35px;\n}\n\n.kuda-referral--card .kuda-result--item {\n    width: calc(100% - 40px);\n}\n\n.kuda-referral--card .kuda-transaction--details {\n    height: auto;\n}\n\n.referral-summary {\n    padding-left: 110px;\n    padding-right: 110px;\n}\n\n.referral-summary .transaction-title {\n    margin-left: 0;\n}\n\n.kuda-result--heading {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.referral-summary .kuda-result--heading {\n    margin-top: -1px;\n}\n\n.referral-friends--heading {\n    margin-bottom: 33px;\n}\n\n.panel__label {\n    width: 100%;\n    text-align: left;\n    padding: 0;\n    font-weight: 900;\n    cursor: pointer;\n    margin-bottom: 15px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.panel__content {\n    padding-bottom: 25px;\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n}\n\n.panel[aria-expanded=\"true\"] .panel__content {\n    opacity: 1;\n    transition: opacity 0.8s, max-height 2s;\n    max-height: 100vh;\n    white-space: pre-line;\n}\n\n.panel__label svg {\n    transition: all 0.4s;\n}\n\n.panel[aria-expanded=\"true\"] .panel__label svg {\n    transform: rotate(90deg);\n}\n\n.accordion {\n    max-width: 456px;\n    margin-right: auto;\n    margin-left: auto;\n    margin-top: 50px;\n}\n\n.accordion-two {\n    background-color: #fff;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border-bottom: 1px solid #ddd !important;\n    text-align: left;\n    outline: none;\n    font-size: 15px;\n    transition: 0.4s;\n    border: none;\n}\n\n.accordion-two:after {\n    content: \"\\002B\";\n    color: #777;\n    font-weight: bold;\n    float: right;\n    margin-left: 5px;\n}\n\n.accordion-active:after {\n    content: \"\\2212\";\n}\n\n.accordion-panel {\n    padding: 0 18px;\n    background-color: white;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.2s ease-out;\n}\n\n.accordion-grey {\n    background-color: #fff;\n    color: #444;\n    cursor: pointer;\n    padding: 18px;\n    width: 100%;\n    border-bottom: 1px solid #ddd !important;\n    text-align: left;\n    outline: none;\n    font-size: 13px;\n    transition: 0.4s;\n    border: none;\n}\n\n.sign-out {\n    margin-top: 56px;\n    margin-bottom: 15px;\n}\n\n.signup-form--wrap {\n    max-width: 359px;\n    width: 100%;\n}\n\n.signup-form--wrap.lg {\n    max-width: 400px;\n}\n\n.isMigrated-wrap {\n    width: 241px;\n}\n\n.signup-form--md {\n    max-width: 420px;\n}\n\n.auth-header--full {\n    max-width: 100% !important;\n}\n\n.auth-header--md {\n    max-width: 285px;\n    font-weight: 800 !important;\n}\n\n.auth-header--lg {\n    max-width: 338px;\n    font-weight: 800 !important;\n}\n\n.confirm-otp--form .transaction-pin {\n    max-width: 268px !important;\n    margin-top: 30px;\n    margin-bottom: 45px;\n    width: 100%\n}\n\n.confirm-otp--form .transaction-pin input {\n    max-width: 49px !important;\n    background: #ffffff;\n    border: 1px solid #f4f4f4;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n}\n\n.next-step--checker {\n    display: flex;\n    justify-content: space-evenly;\n    /* max-width: 132px; */\n    align-items: center;\n    height: fit-content;\n    margin-right: 0px;\n    margin-top: 5px;\n}\n\n.next-step--checker span {\n    color: #000000;\n    opacity: 0.5;\n    font-size: 15px;\n}\n\n.step-count--circle {\n    width: 11px;\n    height: 11px;\n    background: #eff1ff;\n    border-radius: 50%;\n    /* transform: rotate(-90deg); */\n    margin-right: 13.6px;\n}\n\n.page-icon {\n    margin-top: 5rem;\n}\n\n.password-set--message {\n    max-width: 300px;\n    margin: 1rem auto;\n    color: #000000;\n}\n\n.card-modal-success-message p{\n        width: 335px;\n        max-width: 100%;\n        margin: 1rem auto;\n        color: #000000;\n        font-size: 0.9375rem;\n}\n\n.new-account--wrap {\n    /* max-width: 391px; */\n    max-width: 100%;\n    background: #ffffff;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    border-radius: 5px;\n    padding: 11px 19px;\n    min-height: 51px;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n    margin-top: 17px !important;\n}\n\n.add-btn {\n    width: 50px;\n    height: 50px;\n    background: #dfe3ff;\n    border-radius: 50%;\n    padding: 12px 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.kuda-radio--lg {\n    display: flex;\n}\n\n.text-red {\n    color: var(--negativeColor) !important;\n}\n\n.request-wrap {\n    display: flex;\n    justify-content: center;\n}\n\n.request-text {\n    margin-top: 30px;\n    margin-bottom: 32px;\n}\n\n.kuda-request--wrap.animated {\n    padding-bottom: 4\n\n    8px !important;\n}\n\n.deliver-wrap {\n    padding-left: 55px !important;\n    padding-right: 55px !important;\n}\n\n.deliver-wrap .saveFields {\n    margin-top: 45px;\n    margin-bottom: 0;\n}\n\n.no-plus:before {\n    content: none;\n}\n\n.kuda-activate--wrap h1 {\n    margin-bottom: 30px;\n}\n\n.kuda-activate--wrap .request-text {\n    max-width: 290px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.hasErrorMessage .message {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 14px;\n}\n\n.hasErrorMessage {\n    position: relative;\n}\n\n.card-group .message {\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n@-webkit-keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.hasErrorMessage .message {\n    -webkit-animation-name: fadeIn;\n    animation-name: fadeIn;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n.kuda-request--wrap {\n    padding-left: 70px !important;\n    padding-right: 70px !important;\n}\n\n.request-edge--fix>div {\n    margin-left: -70px;\n    margin-right: -70px;\n    padding-left: 70px;\n    padding-right: 70px;\n}\n\n.request-edge--fix .card-text {\n    right: 70px;\n}\n\n.panel__label span {\n    line-height: 1.35;\n}\n\n.block-spacer {\n    margin-bottom: 35px;\n    max-width: 300px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.block-buttons .addAction {\n    margin-bottom: 0;\n}\n\n.notice-modal {\n    max-width: 420px !important;\n}\n\n.card-blocked .kuda-atm--wrap {\n    background: var(--negativeColor);\n}\n\n.bill-item {\n    cursor: pointer;\n}\n\n.blocked {\n    opacity: 0.2;\n    pointer-events: none;\n}\n\n.bill-item.form-loading span {\n    opacity: 1;\n    display: block;\n    visibility: visible !important;\n}\n\n.bill-item.form-loading {\n    justify-content: space-between !important;\n}\n\n.bill-item .form-loading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiM0MDE5NmQiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n    right: -7px;\n}\n\n.kuda-dark--theme .bill-item .form-loading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n    right: -7px;\n}\n\n.bill-item * {\n    pointer-events: none;\n}\n\n.redUnblock {\n    border-color: var(--negativeColor);\n}\n\n.deactivate-card {\n    position: relative;\n    margin-top: 25px;\n    height: 24px;\n    align-items: center;\n    justify-content: center;\n    background: var(--negativeColor);\n    border-radius: 4px;\n    color: #fff;\n    padding-left: 16px;\n    padding-right: 16px;\n    font-size: 0.75rem;\n    cursor: pointer;\n    display: inline-flex;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.sign-out span {\n    cursor: pointer;\n}\n\na.link {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.error-message {\n    max-width: 300px;\n}\n\n.subscribe-message {\n    max-width: 250px !important;\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.spinner-wrap {\n    position: absolute;\n    top: 68px;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 7px;\n    background: #fff;\n    border-radius: 100px;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border: 1px solid var(--borderOff);\n    z-index: 1;\n}\n.open-api-table-spinner-wrap {\n    position: static !important;\n}\n\n.table-spinner--wrap {\n    position: relative;\n    top: unset;\n    left: unset;\n    transform: unset;\n    padding: 0px;\n    background: transparent;\n    border-radius: 0;\n    box-shadow: none;\n    border: none;\n    z-index: unset;\n}\n\n.loader-inner .spinner-wrap {\n    position: relative;\n    background: inherit;\n    box-shadow: none;\n    top: unset;\n    left: unset;\n    transform: none;\n}\n\n.spinner {\n    width: 22px;\n    height: 22px;\n    display: block;\n    color: var(--primaryColor);\n}\n\n.table-spinner {\n    color: #48d38a !important;\n}\n\n/* .table-spinner:after {\n  border: 4px solid currentColor;\n} */\n\n.spinner:after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    border: 2px solid currentColor;\n    border-bottom-color: transparent;\n    border-radius: 100%;\n    background: transparent;\n    animation: rotate 0.75s linear infinite;\n}\n\n@keyframes rotate {\n    100% {\n        transform: rotate(359deg);\n    }\n}\n\n@-webkit-keyframes rotate {\n    100% {\n        transform: rotate(359deg);\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dasharray: 1, 250;\n        stroke-dashoffset: 0;\n    }\n\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35;\n    }\n\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -140;\n    }\n}\n\n@-webkit-keyframes dash {\n    0% {\n        stroke-dasharray: 1, 250;\n        stroke-dashoffset: 0;\n    }\n\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35;\n    }\n\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -140;\n    }\n}\n\n.reloadActive {\n    pointer-events: none;\n}\n\n.margin-bottom--spacer-sm {\n    margin-bottom: 23px;\n}\n\n.single-timeline h3 {\n    font-size: 0.9375rem;\n}\n\n.single-timeline p {\n    font-size: 0.8rem;\n}\n\n.single-timeline {\n    margin-bottom: 40px;\n}\n\n.request-timeline {\n    position: relative;\n    margin-top: 32px;\n}\n\n.timeline-wrap {\n    height: calc(100% - 35px);\n    display: block;\n    position: absolute;\n    width: 1px;\n    border-left: 1px dashed #DBDCE0;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 7px;\n}\n\n.timeline-items {\n    margin-left: 40px;\n}\n\n.timeline-items:last-child .single-timeline {\n    margin-bottom: 0;\n}\n\n.timeline-items {\n    position: relative;\n}\n\n.timeline-items:before {\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMi42MDY3IiByPSIxMS41IiBzdHJva2U9IiM0OEQzOEEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDEyLjgwNjZDMyA3LjgzNjA4IDcuMDI5NDQgMy44MDY2NCAxMiAzLjgwNjY0QzE2Ljk3MDYgMy44MDY2NCAyMSA3LjgzNjA4IDIxIDEyLjgwNjZDMjEgMTcuNzc3MiAxNi45NzA2IDIxLjgwNjYgMTIgMjEuODA2NkM3LjAyOTQ0IDIxLjgwNjYgMyAxNy43NzcyIDMgMTIuODA2NloiIGZpbGw9IiM0OEQzOEEiLz4KPHBhdGggZD0iTTEwLjkxNSAxNC43MjYxTDE1Ljc1MzUgOS42NjAwM0MxNi4wNDQ0IDkuMzU1NTEgMTYuNTE1OSA5LjM1NTUxIDE2LjgwNjggOS42NjAwM0MxNy4wOTc2IDkuOTY0NTUgMTcuMDk3NiAxMC40NTgzIDE2LjgwNjggMTAuNzYyOEwxMC45MTUgMTYuOTMxNkw3LjQ5MzAzIDEzLjM0ODdDNy4yMDIxOSAxMy4wNDQyIDcuMjAyMTkgMTIuNTUwNSA3LjQ5MzAzIDEyLjI0NTlDNy43ODM4OCAxMS45NDE0IDguMjU1NDIgMTEuOTQxNCA4LjU0NjI3IDEyLjI0NTlMMTAuOTE1IDE0LjcyNjFaIiBmaWxsPSIjRENGRkVDIi8+Cjwvc3ZnPgo=\");\n}\n\n.timeline-disabled:before {\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjEyIiBjeT0iMTEuODI1NiIgcng9IjYiIHJ5PSI1Ljg4NDA3IiBmaWxsPSIjQ0FDQUNBIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMyIgeT0iMiIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE5Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDIuOTk5NTFWMjAuOTk5NUgyMVYyLjk5OTUxSDNaTTEwLjYyMTQgMTUuOTY1Mkw3LjI2NzA5IDEyLjYxMDlMOC4wNjI2MSAxMS44MTU0TDEwLjU3ODUgMTQuMzMxM0wxNi4xNzcyIDguMTExNDVMMTcuMDEzNCA4Ljg2NDA3TDEwLjYyMTYgMTUuOTY1M0wxMC42MjE0IDE1Ljk2NTJaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggZD0iTTEyIDIwLjk5OTVDMTYuOTcwNiAyMC45OTk1IDIxIDE2Ljk3MDEgMjEgMTEuOTk5NUMyMSA3LjAyODk1IDE2Ljk3MDYgMi45OTk1MSAxMiAyLjk5OTUxQzcuMDI5NDQgMi45OTk1MSAzIDcuMDI4OTUgMyAxMS45OTk1QzMgMTYuOTcwMSA3LjAyOTQ0IDIwLjk5OTUgMTIgMjAuOTk5NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPC9nPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNDQUNBQ0EiLz4KPC9zdmc+Cg==\");\n}\n\n.timeline-items:before {\n    content: \"\";\n    height: 24px;\n    width: 24px;\n    background-size: 23px;\n    background-position: center;\n    background-repeat: no-repeat;\n    display: inline-block;\n    top: -1px;\n    left: -44px;\n    position: absolute;\n    background-color: var(--whiteColor);\n    z-index: 9;\n    border-radius: 100px;\n}\n\n.timeline-disabled .single-timeline {\n    opacity: 0.3;\n}\n\n.copy-icon svg {\n    height: 100%;\n}\n\n.inputLoading {\n    position: relative;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center;\n    opacity: 0.8;\n    pointer-events: none;\n}\n\n.inputLoadingSpaced {\n    justify-content: space-between !important;\n}\n\n.dropdown-border--error {\n    box-shadow: none;\n    border: 1px solid var(--negativeColor);\n}\n\n.inputLoading {\n    pointer-events: none;\n}\n\n.inputLoading:after {\n    position: absolute;\n    content: \"\";\n    width: 26px;\n    height: 26px;\n    display: inline-block;\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n    background-size: 26px 26px;\n    right: 15px;\n    z-index: 33;\n}\n\n.kuda-dark--theme .inputLoading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n}\n\n.error-field {\n    border: 1px solid var(--negativeColor) !important;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;\n    border-radius: 5px;\n}\n\n.addNewIcon {\n    margin-right: 17px;\n}\n\n.addNewIcon svg {\n    min-width: 24px;\n    min-height: 24px;\n}\n\n.beneficiary-wrap {\n    color: var(--successColor);\n    padding: 7px 17px;\n    display: inline-flex;\n    background: var(--successColorTrans);\n    font-weight: 700;\n    border-radius: 5px;\n}\n\n.kuda-beneficiary--name {\n    display: flex;\n    justify-content: center;\n    margin-bottom: -15px;\n}\n\n.otp-input input {\n    border: 1px solid var(--bgOffset);\n    box-sizing: border-box;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    background: var(--whiteColor) !important;\n    max-width: 49px;\n    height: 46px !important;\n}\n\n.otp-input {\n    max-width: 220px;\n}\n\n.resendCode {\n    text-align: center;\n    color: var(--blackColor);\n}\n\n.resendCode span {\n    font-weight: 900;\n}\n\n.mobile-header--wrap {\n    display: none !important;\n}\n\n.desktop-header .kuda-menu--text {\n    display: flex;\n    align-items: center;\n    height: 100%;\n}\n\n.transaction-additional--details .kuda-dropdown-header {\n    height: auto;\n}\n\n.transaction-additional--details .kuda-dropdown-title {\n    line-height: 1.5;\n    font-weight: 800;\n    width: 100%;\n    padding-left: 0;\n    padding-right: 9px;\n}\n\n.transaction-additional--details .kuda-dropdown-icon {\n    width: auto;\n}\n\n.transaction-additional--details .kuda-dropdown-icon svg {\n    width: 10px;\n    height: auto;\n    position: relative;\n    top: 2px;\n}\n\n.transaction-right .kuda-dropdown-list {\n    width: auto;\n    left: auto;\n    right: 0;\n    min-width: 190px;\n    max-height: 260px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.transaction-additional--details .kuda-dropdown-item {\n    padding: 10px 0;\n}\n\n.transaction-additional--details .dropdown-item--title {\n    font-size: 0.8rem;\n}\n\n.transaction-additional--details .avatar-wrap {\n    margin-right: 13px;\n}\n\n.kuda-nav--icon p {\n    cursor: pointer;\n}\n .kuda-menu--text {\n    white-space: nowrap;\n}\n\n.kuda-entry {\n    /* overflow: hidden; */\n    -webkit-overflow-scrolling: touch;\n    height: 100%;\n}\n\n.loader {\n    border: 16px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 16px solid #000000;\n    width: 120px;\n    height: 120px;\n    -webkit-animation: spin 2s linear infinite;\n    /* Safari */\n    animation: spin 2s linear infinite;\n}\n\n/* Safari */\n\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.transaction-additional--details p {\n    font-size: 0.9375rem;\n}\n\n.modal-transactions .modal-content {\n    max-width: 517px;\n    background-color: var(--whiteAlt);\n}\n\n.modal {\n    /* position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; */\n    background: rgba(0, 0, 0, 0.35);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n\n}\n\n.modal-main {\n    position: fixed;\n    background: white;\n    width: 80%;\n    height: auto;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.display-block {\n    display: block;\n}\n\n.display-none {\n    display: none;\n}\n\n.loanAction {\n    background: #1dcbef;\n    opacity: 0.4;\n}\n\n@keyframes blink {\n\n    /**\n       * At the start of the animation the dot\n       * has an opacity of .2\n       */\n    0% {\n        opacity: 0.2;\n    }\n\n    /**\n       * At 20% the dot is fully visible and\n       * then fades out slowly\n       */\n    20% {\n        opacity: 1;\n    }\n\n    /**\n       * Until it reaches an opacity of .2 and\n       * the animation can start again\n       */\n    100% {\n        opacity: 0.2;\n    }\n}\n\n@-webkit-keyframes blink {\n\n    /**\n       * At the start of the animation the dot\n       * has an opacity of .2\n       */\n    0% {\n        opacity: 0.2;\n    }\n\n    /**\n       * At 20% the dot is fully visible and\n       * then fades out slowly\n       */\n    20% {\n        opacity: 1;\n    }\n\n    /**\n       * Until it reaches an opacity of .2 and\n       * the animation can start again\n       */\n    100% {\n        opacity: 0.2;\n    }\n}\n\n.savings-dot span {\n    /**\n       * Use the blink animation, which is defined above\n       */\n    animation-name: blink;\n    /**\n       * The animation should take 1.2 seconds\n       */\n    animation-duration: 1.2s;\n    /**\n       * It will repeat itself forever\n       */\n    animation-iteration-count: infinite;\n    /**\n       * This makes sure that the starting style (opacity: .2)\n       * of the animation is applied before the animation starts.\n       * Otherwise we would see a short flash or would have\n       * to set the default styling of the dots to the same\n       * as the animation. Same applies for the ending styles.\n       */\n    animation-fill-mode: both;\n}\n\n.savings-dot span:nth-child(2) {\n    /**\n       * Starts the animation of the third dot\n       * with a delay of .2s, otherwise all dots\n       * would animate at the same time\n       */\n    animation-delay: 0.2s;\n}\n\n.savings-dot span:nth-child(3) {\n    /**\n       * Starts the animation of the third dot\n       * with a delay of .4s, otherwise all dots\n       * would animate at the same time\n       */\n    animation-delay: 0.4s;\n}\n\n.copy span,\n.copy svg {\n    cursor: copy;\n}\n\n.kuda-account--no {\n    margin-left: 10px;\n}\n\n.no-network .kuda-page--loader {\n    display: none;\n}\n\n.beneficairy-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 35px;\n}\n\n.beneficairy-wrap .toggle-init {\n    position: relative;\n    left: -20px;\n    top: -6px;\n}\n\n.beneficairy-wrap .card-main--heading {\n    font-size: 1rem;\n    color: var(--blackColor);\n}\n\n.beneficiary-wrap--form {\n    margin-top: 25px;\n}\n\n.savedCard {\n    position: relative;\n}\n\n.kuda-form--cards {\n    max-width: 100%;\n}\n\n.savedIllustration img {\n    width: 100%;\n    position: relative;\n    top: 9px;\n}\n\n.savedCards {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.savedCard {\n    width: calc(50% - 22px);\n    margin-bottom: 45px;\n}\n\n.savedCard img {\n    border-radius: 12px;\n}\n\n.empty-card--icon {\n    margin-bottom: 36px;\n}\n\n.empty-cards {\n    max-width: 301px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    min-height: 340px;\n}\n\n.kuda-savedCard--items {\n    position: absolute;\n    bottom: 0;\n    padding: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.kuda-savedCard--items p {\n    font-size: 0.925rem;\n}\n\n.kuda-savedCard--items svg {\n    width: auto;\n    max-height: 40px;\n    margin-left: auto;\n    min-height: 21px;\n}\n\n.kuda-savedCard--items .no-avatar {\n    overflow: visible;\n    position: absolute;\n    bottom: 5px;\n    right: 21px;\n    width: auto;\n}\n\n.kuda-card--cvc {\n    position: absolute;\n    top: calc(50% - 10px);\n    left: 50%;\n    width: calc(100% - 41px);\n    display: flex;\n    justify-content: space-between;\n    transform: translate(-50%, -50%);\n}\n\n.savedIllustration {\n    background: linear-gradient(292.01deg, var(--offWhiteTrans) 12.33%, var(--whiteColor) 91.26%);\n    border: 1px solid var(--offWhiteTrans);\n    box-shadow: 2px 11px 22px rgba(64, 25, 109, 0.1);\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.kuda-card--cvc span {\n    font-size: 1rem;\n}\n\n.kuda-card--actions {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    border-radius: 12px;\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s;\n}\n\n.savedCard:hover .kuda-card--actions {\n    opacity: 1;\n    visibility: visible;\n}\n\n.savedCard:hover {\n    cursor: pointer;\n}\n\n.kuda-card--actions {\n    padding: 30px 35px 40px;\n    cursor: default;\n    border: 1px solid #d2d6db;\n}\n\n.action-items {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 0;\n    border-bottom: 1px solid rgba(23, 34, 60, 0.1);\n}\n\n.card-delete {\n    text-align: center;\n    margin-top: 22px;\n}\n\n.action-items .color-black {\n    text-transform: capitalize;\n}\n\n.card-delete span {\n    cursor: pointer;\n}\n\n.action-items p {\n    font-size: 0.92rem;\n}\n\n.account-image .fileInput {\n    height: calc(100% + 10px);\n}\n\n.loan-color * {\n    color: #1dcbef !important;\n}\n\n.loan-color path {\n    fill: #1dcbef !important;\n}\n\n.kuda-entry--wrap {\n    min-height: calc(100vh - 70px);\n}\n\n.share-header--wrap .kuda-share--earn {\n    padding-bottom: 38px !important;\n    padding-top: 28px;\n}\n\n.share-header--wrap .kuda-share--earnAlt {\n    padding-bottom: 34px !important;\n}\n\n.share-header--wrap .earnings.color-white {\n    margin-top: 4px;\n}\n\n.edit-item.loading {\n    position: absolute;\n}\n\n.edit-item.loading>svg {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.edit-item.loading:after {\n    position: absolute;\n    content: \"\";\n    width: calc(100% - 8px);\n    height: calc(100% - 8px);\n    display: inline-block;\n    border: 2px solid rgb(63, 24, 109);\n    border-bottom-color: transparent;\n    border-radius: 100%;\n    background: transparent;\n    animation: rotate 0.75s linear infinite;\n}\n\n.kuda-notification--panel {\n    display: block;\n    width: 100%;\n    background: #fff;\n    height: 100%;\n    max-width: 450px;\n    margin-left: auto;\n}\n\n.emptySearch {\n    margin-bottom: -25px;\n    max-width: 250px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.basic-dropdown {\n    padding-top: 2px;\n    padding-bottom: 2px;\n}\n\n.flex-skeleton {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 30px;\n}\n\n.fully-rounded {\n    width: 70px !important;\n    height: 50px;\n}\n\n.bg--width {\n    width: 50%;\n}\n\n.fully-rounded .react-loading-skeleton {\n    border-radius: 100px;\n    overflow: hidden;\n}\n\n.bg--width:not(.fully-rounded) .react-loading-skeleton {\n    width: calc(100% - 20px) !important;\n    margin-left: auto;\n    display: block;\n}\n\n.bg--width>span {\n    width: 100%;\n    display: block;\n}\n\n.savings-width {\n    height: 100%;\n    background-color: var(--successColor);\n    border-radius: 5px;\n    width: 0;\n    transition: width 1s;\n}\n\n.closeMenu {\n    position: absolute;\n    right: 25px;\n    top: 24px;\n    z-index: 1;\n    animation-delay: 0.35s;\n    animation-duration: 0.8s !important;\n}\n\n.no-result {\n    padding: 20px 5px 15px;\n    font-size: 0.9rem;\n    color: var(--blackColor);\n    font-weight: 700;\n    margin: 20px;\n    text-align: center;\n}\n\n#RealPassword,\n#newPassword,\n#confirmPassword,\n#TaxNo,\n#CacNo {\n    position: absolute;\n    opacity: 0;\n    z-index: 99;\n    bottom: 0;\n    width: 100%;\n}\n\n#RealPassword.active:focus,\n#newPassword.active:focus,\n#confirmPassword.active:focus,\n#TaxNo.active:focus,\n#CacNo.active:focus {\n    animation-name: blink;\n    animation-duration: 800ms;\n    animation-iteration-count: infinite;\n    opacity: 1;\n}\n\n@keyframes blink {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n\n@-webkit-keyframes blink {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n\n.center-maturity .text-right {\n    display: none;\n}\n\n.center-maturity .text-left {\n    width: 100%;\n    text-align: center;\n}\n\n.passwordToggle {\n    position: absolute;\n    right: 12px;\n    top: calc(50% + 2.5px);\n    transform: translateY(-50%);\n    z-index: 999;\n    cursor: pointer;\n}\n\n.sme-cta--secondarybutton {\n    border: 1px solid #000000 !important;\n    background: var(--whiteAlt) !important;\n    color: var(--primaryColor) !important;\n}\n\n.passwordToggle svg {\n    height: auto;\n    width: 20px;\n}\n\n.showPassword #RealPassword,\n.showPassword #newPassword,\n.showPassword #confirmPassword,\n.showPassword #TaxNo,\n.showPassword #CacNo {\n    opacity: 1;\n}\n\n.tokenExpired .kuda-loader {\n    display: none !important;\n}\n\n.kuda-home-loader--wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loader-30 {\n    width: 78.6px;\n}\n\n.loader-40 {\n    width: calc(45% - 15px);\n    height: 32px;\n}\n\n.loader-100 {\n    width: 100%;\n    height: 32px;\n}\n\n.kuda-home-loader--wrap {\n    margin-bottom: 30px;\n}\n\n.skel-right>span>span {\n    display: block;\n    margin-left: auto;\n}\n\n.loader-40>span:last-child {\n    margin-top: 6px !important;\n    display: block;\n}\n\n.inactive-wrap {\n    max-width: 280px;\n}\n\n.otp-auth .otp-input {\n    max-width: 325px;\n}\n\n.otp-auth {\n    max-width: 330px;\n}\n\n.otp-auth .otp-input input {\n    max-width: 46px;\n}\n\n.reset-form .kuda-cta.kuda-cta-lg {\n    max-width: 200px;\n}\n\n.forgot-label .color-primary {\n    cursor: pointer;\n    font-weight: 700;\n}\n\n.kuda-error--icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 40px;\n}\n\n.error-seperator {\n    margin-bottom: 40px;\n}\n\n.error-seperator+.addAction {\n    margin-bottom: -10px;\n}\n\n.notice-icon {\n    position: relative;\n    display: none;\n}\n\n.showNotice .notice-icon {\n    display: flex;\n}\n\n.notice-icon svg {\n    height: 19px;\n    width: auto;\n    margin-left: 7px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.full-label {\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.badgeError .beneficiary-wrap {\n    color: var(--negativeColor);\n    background: #ffdbdb;\n}\n\n.fileError {\n    border: 1px solid var(--negativeColor);\n    border-radius: 5px;\n}\n\n.card-illustration svg {\n    width: auto;\n    height: 145px;\n}\n\n.budgetTab {\n    margin-top: 0;\n}\n\n.budget-heading--summary {\n    margin-top: 30px;\n    margin-bottom: 25px;\n    display: block;\n    margin-right: -220px;\n    margin-left: -220px;\n}\n\n.budget-cards {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.budget-card {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    padding: 20px;\n    width: 25%;\n    position: relative;\n    min-height: 80px;\n}\n\n.budget-card:not(:last-child) {\n    margin-right: 20px;\n}\n\n.budget-create--bg {\n    position: absolute;\n    left: 0;\n    bottom: -2px;\n}\n\n.create-card {\n    background: var(--offBlue);\n    border-color: var(--borderOff) !important;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    padding-right: 8px;\n    cursor: pointer;\n    overflow: hidden;\n}\n\n.create-card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.budget-create--icon {\n    margin-left: 11px;\n}\n\n.budget-heading {\n    font-size: 0.95rem;\n    position: relative;\n    z-index: 1;\n}\n\n.budget-card .card-main--heading {\n    margin-bottom: 0 !important;\n    line-height: 1;\n}\n\n.budget-card--semiHeading {\n    color: var(--blackColor);\n    font-size: 0.95rem;\n    margin-bottom: 9px;\n    display: block;\n}\n\n.kuda-budgeting .kuda-result--item {\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n    z-index: 1;\n}\n\n.DateInput_input {\n    color: var(--blackColor) !important;\n    font-size: 0.935rem !important;\n    font-weight: 600 !important;\n    border: 0 !important;\n}\n\n.CalendarDay {\n    vertical-align: middle !important;\n    border: none !important;\n}\n\n.CalendarDay__selected {\n    background: rgb(230, 248, 238) !important;\n    position: relative;\n    z-index: 2;\n    font-weight: 700;\n}\n\n.CalendarDay__selected_span,\n.CalendarDay__hovered_span {\n    background-color: rgba(72, 211, 138, 0.15) !important;\n    color: var(--blackColor) !important;\n}\n\n.CalendarDay__selected:before {\n    background: rgba(72, 211, 138, 1) !important;\n    content: \"\" !important;\n    position: absolute !important;\n    width: 100% !important;\n    height: 100% !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    border-radius: 100px !important;\n    z-index: -1 !important;\n    opacity: 1 !important;\n}\n\n.CalendarDay__selected:hover:before {\n    background: rgba(72, 211, 138, 1) !important;\n    color: #fff !important;\n}\n\n.CalendarDay__selected_end {\n    border-top-right-radius: 100px;\n    border-bottom-right-radius: 100px;\n}\n\n.CalendarDay__selected_start {\n    border-top-left-radius: 100px;\n    border-bottom-left-radius: 100px;\n}\n\n.CalendarDay__default {\n    position: relative !important;\n    z-index: 9;\n}\n\n.CalendarDay__default:hover {\n    background: rgb(230, 248, 238) !important;\n    color: var(--blackColor) !important;\n}\n\n.CalendarDay__default:hover:before {\n    background-color: rgba(72, 211, 138, 0.1) !important;\n    color: var(--blackColor) !important;\n    content: \"\" !important;\n    position: absolute !important;\n    width: 100% !important;\n    height: 100% !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    border-radius: 100px !important;\n    z-index: -1 !important;\n    opacity: 1 !important;\n}\n\n.DateRangePickerInput {\n    display: flex !important;\n    align-items: center !important;\n    width: auto !important;\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset) !important;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;\n    border-radius: 5px;\n    padding-right: 10px;\n    border-radius: 5px !important;\n}\n\n.DateRangePickerInput>* {\n    width: auto !important;\n    display: flex !important;\n}\n\n.DateInput_input {\n    width: 113px !important;\n}\n\n.DateInput_input {\n    padding-right: 0;\n}\n\n.DateInput_input {\n    padding-right: 0 !important;\n}\n\n.DateRangePicker_picker {\n    border: 1px solid var(--bgOffset) !important;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;\n    padding-bottom: 25px;\n    border-radius: 3px;\n    z-index: 9 !important;\n}\n\n.DateInput_fangStroke {\n    stroke: var(--bgOffset) !important;\n}\n\n.DateInput_fang {\n    margin-top: -12px;\n}\n\n.DateInput_input__focused {\n    border-bottom: 0 !important;\n}\n\n.DateRangePicker_picker {\n    margin-top: -13px;\n}\n\n.CalendarMonth_table {\n    margin-top: 18px;\n}\n\n.CalendarMonth_caption {\n    font-size: 0.9rem !important;\n    color: var(--blackColor) !important;\n    font-weight: 700 !important;\n}\n\n.kuda-budget--filter {\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.CalendarDay__lastDayOfWeek.CalendarDay__selected_start {\n    border-top-right-radius: 100px !important;\n    border-bottom-left-radius: 0 !important;\n}\n\n.CalendarDay__firstDayOfWeek.CalendarDay__selected_end {\n    border-bottom-left-radius: 100px !important;\n    border-top-right-radius: 0 !important;\n}\n\n.CalendarDay__firstDayOfWeek.CalendarDay__selected_start {\n    border-radius: 0px !important;\n    border-top-left-radius: 20px !important;\n}\n\n.CalendarDay__selected_start_no_selected_end.CalendarDay__selected_start:not(.CalendarDay__selected_start_in_hovered_span) {\n    border-radius: 100px !important;\n}\n\n.CalendarDay__selected:hover {\n    color: var(--whiteColor) !important;\n}\n\n.CalendarDay__selected:hover:before {\n    background: rgba(72, 211, 138, 1) !important;\n}\n\n.CalendarDay__firstDayOfWeek.CalendarDay__selected_start.CalendarDay__firstDayOfWeek_3 {\n    border-bottom-left-radius: 20px !important;\n}\n\n/* .CalendarDay__default[aria-label*=\"It’s available\"]:not(:hover) {\n    border-radius: 100px!important\n} */\n\n.customIcon {\n    display: flex;\n    align-items: center;\n    position: relative;\n    top: 1px;\n    height: 100%;\n}\n\n.DateRangePickerInput_calendarIcon {\n    height: 100%;\n    padding-left: 10px !important;\n    padding-right: 0 !important;\n}\n\n.kuda-budget--filter .kuda-search--field {\n    height: 48px;\n    background: var(--whiteAlt);\n    border: 1px solid var(--bgOffset);\n    box-sizing: border-box;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n}\n\n.kuda-budget--filter .DateRangePickerInput {\n    height: 48px;\n    display: flex;\n    align-items: center !important;\n    width: 350px !important;\n}\n\n.kuda-analytics--filter .DateRangePickerInput {\n    height: 48px;\n    display: flex;\n    align-items: center !important;\n    width: 613px !important;\n}\n\n.filter-field {\n    width: calc(100% - 294px);\n    position: relative;\n}\n\n.DayPickerKeyboardShortcuts_show {\n    display: none;\n}\n\n.is-timeline--active:after {\n    content: \"\";\n    height: 55px;\n    width: 1px;\n    position: absolute;\n    background: var(--successColor);\n    top: 15px;\n    left: -33px;\n    z-index: 0;\n}\n\n.DateRangePickerInput,\n.DateInput_input {\n    background-color: var(--whiteAlt) !important;\n}\n\n.text-center br {\n    content: \"\";\n    margin: 2em;\n    display: block;\n    font-size: 24%;\n}\n\n.save-categories span {\n    box-shadow: 0px 4px 14px rgba(64, 25, 109, 0.15);\n    border-radius: 100px;\n    background: none;\n    width: 85px;\n    height: 85px;\n}\n\n.save-categories span svg {\n    width: 100%;\n    height: 100%;\n}\n\n.save-categories span:not(:last-child) {\n    margin-right: 20px;\n}\n\n.icons--kuda span {\n    width: 70px;\n    height: 70px;\n    display: flex;\n}\n\n.icons--kuda a:not(:last-child) {\n    margin-right: 20px;\n}\n\n.icons--kuda {\n    margin-top: 40px;\n    justify-content: center;\n}\n\n.kuda-flex {\n    display: flex;\n}\n\n.share-modal--width .modal-content {\n    max-width: 520px;\n}\n\n.DayPicker__withBorder {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.setBudget-card {\n    background: var(--offBlue);\n}\n\n.kuda-budgeting:not(.category-budget) .transaction-price {\n    top: 0;\n    text-align: right;\n}\n\n.kuda-budgeting:not(.category-budget) .transaction-percentage {\n    font-size: 0.7rem;\n    color: var(--textColor);\n}\n\n.kuda-budgeting:not(.category-budget) .transaction-price {\n    height: 38px;\n    flex-direction: column;\n    justify-content: space-between;\n    display: flex;\n}\n\n.budget-percentage--color {\n    position: absolute;\n    height: calc(100% - 0px);\n    z-index: -1;\n    left: 0px;\n    top: 0;\n    width: 0;\n    transition: width 1s;\n}\n\n.budget-card--header {\n    display: flex;\n    justify-content: center;\n}\n\n.budget-card--header .card-main--heading {\n    display: flex;\n    align-items: center;\n    margin: 33px 0 0;\n}\n\n.budget-card--header .card-main--heading img {\n    height: 39px;\n    margin-right: 13px;\n    width: 39px;\n}\n\n.budget-card--header+.budget-heading--summary .budget-card {\n    width: 33.33%;\n}\n\n.budget-card--header+.budget-heading--summary {\n    margin-right: -90px;\n    margin-left: -90px;\n}\n\n.budget-heading--summary .category-budget--highlighted .card-main--heading {\n    font-size: 0.9rem !important;\n}\n\n.card-overspent {\n    background: #ffdbdb;\n}\n\n.card-overspent * {\n    color: var(--negativeColor);\n}\n\n.budget-card .savings-progress {\n    bottom: 15px;\n}\n\n.category-budget--highlighted .card-main--heading {\n    margin-top: -1px !important;\n}\n\n.category-budget--highlighted .budget-card--semiHeading {\n    margin-top: -1px !important;\n}\n\n.kuda-budget--filter.single-budget--view .DateRangePickerInput,\n.kuda-budget--filter.single-budget--view .DateRangePicker {\n    width: 100% !important;\n}\n\n.plan-budget--wrap {\n    max-width: 100%;\n}\n\n.plan-budget--wrap .card-main--heading {\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.spend-progress--box {\n    width: 100%;\n    margin-top: 61px;\n    background: var(--bgOffset);\n    border: 1px solid var(--borderOff);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    min-height: 40px;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.spend-progress--bg {\n    position: absolute;\n    width: 0;\n    transition: width 1s;\n    background: linear-gradient(180deg, var(--successColor) 11.25%, #78ecbe 138.75%);\n    border: 1px solid var(--successColor);\n    box-shadow: 0px 5px 10px var(--offGreen);\n    border-radius: 5px;\n    height: calc(100% + 2px);\n    top: -1px;\n    left: -1px;\n}\n\nspan.progressVaue {\n    position: relative;\n    z-index: 1;\n    padding-left: 10px;\n    padding-right: 10px;\n    color: #fff;\n    font-weight: 900;\n}\n\n.spend-day--tick {\n    position: absolute;\n    right: 0;\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.spend-day--tick {\n    width: 75px;\n    height: 26px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: -20px;\n}\n\n.spend-progress--bg {\n    max-width: calc(100% + 2px);\n}\n\n.create-budget--button {\n    max-width: 240px;\n    margin-top: 30px;\n}\n\n.spend-progress--label {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.text-uppercase {\n    text-transform: uppercase;\n}\n\n.plan-budget--wrap .recharts-wrapper {\n    width: auto !important;\n}\n\n.plan-budget--wrap .recharts-wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.plan-budget--wrap .recharts-wrapper {\n    width: 100% !important;\n    height: 100% !important;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 50px;\n}\n\n.plan-budget--wrap svg.recharts-surface {\n    margin-left: 0 !important;\n    min-width: 260px;\n}\n\n.plan-budget--wrap svg.recharts-surface {\n    width: calc(80% - 250px);\n    margin-left: -50px !important;\n    overflow: visible;\n}\n\n.plan-budget--wrap .recharts-layer image {\n    width: 40px;\n    height: 40px;\n}\n\n.plan-budget--wrap .recharts-pie-labels text {\n    font-weight: 700;\n    font-size: 1rem;\n}\n\n.plan-budget--wrap text.fake {\n    opacity: 0;\n}\n\n.image-tracker {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n}\n\n.chart-holder {\n    position: relative;\n}\n\n.freeTransfer--wrap {\n    width: 100%;\n    border: 1px solid #DBDCE0;\n    box-shadow: 5px 7px 10px 0px rgba(0, 0, 0, 0.10);\n    border-radius: 5px;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 0.7rem;\n    justify-content: center;\n    padding: 7px 12px;\n    display: flex;\n    align-items: center;\n    margin-top: -15px;\n    margin-bottom: 10px;\n    max-width: 203px;\n    font-weight: 600;\n}\n\n.freeTransfer--wrap span {\n    font-size: 0.875rem;\n    margin-left: 6px;\n    line-height: 1.09;\n}\n\n.kuda-payment--balance {\n    font-size: 0.6875rem;\n    margin-top: 10px;\n}\n\n.recharts-layer image,\n.recharts-pie-labels text {\n    -webkit-animation: fadein 0.7s ease-in alternate forwards;\n    -moz-animation: fadein 0.7s ease-in alternate forwards;\n    animation: fadein 0.7s ease-in alternate forwards;\n}\n\n@keyframes fadein {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@-webkit-keyframes fadein {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.kuda-tran--holder {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.kuda-item--chart .savings-progress {\n    margin-top: 0px !important;\n    height: 5px;\n    margin-left: auto;\n    width: calc(100% - 65px);\n    display: block;\n    position: static;\n    margin-right: 0;\n}\n\n.kuda-item--chart {\n    flex-direction: column;\n}\n\n.kuda-item--chart .transaction-price {\n    margin-right: 0;\n}\n\n.kuda-item--chart .transaction-avatar {\n    position: relative;\n    top: 7px;\n}\n\n.edit-budget {\n    margin-top: 30px;\n    display: flex;\n    width: 100%;\n    max-width: 132px;\n    height: 41px;\n}\n\n.edit-budget--wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.kuda-calendar--control {\n    background: var(--whiteAlt);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 37px;\n    min-height: 48px;\n    margin-right: 8px;\n    min-width: 37px;\n    cursor: pointer;\n}\n\n.next-calendar--control {\n    margin-right: 0;\n    margin-left: 8px;\n}\n\n.create-budget--modal .modal-content {\n    max-width: 700px !important;\n}\n\n.create-budget--modal h4 {\n    font-size: 1.25rem;\n}\n\n.create-budget--modal .block-spacer {\n    margin-bottom: 11px;\n    max-width: 420px;\n}\n\n.create-budget--modal .kuda-cta {\n    max-width: 220px !important;\n}\n\n.create-budget--modal .createBalance {\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    max-width: 210px;\n    height: 46px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 21px;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.create-budget--modal .transaction-title {\n    justify-content: center !important;\n    margin-top: 0;\n    margin-left: 17px;\n}\n\n.create-budget--modal .transaction-name {\n    margin-top: 0;\n    font-size: 0.9375rem;\n    font-weight: 400;\n}\n\n.kuda-budget--form .kuda-result--heading {\n    text-align: center !important;\n    justify-content: center;\n    color: var(--blackColor);\n}\n\n.kuda-budget--form {\n    max-width: 424px;\n    margin-left: auto;\n    margin-right: auto;\n    height: calc(100vh - 485px) !important;\n}\n\n.create-budget--modal .modal-content {\n    height: calc(100vh - 140px);\n}\n\n.kuda-budget--form .transaction-amount input {\n    width: 120px;\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset);\n    box-sizing: border-box;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    text-align: center;\n    padding: 5px;\n}\n\n.kuda-budget--form+.block-buttons {\n    margin-top: 25px !important;\n}\n\n.create-budget--modal .kuda-result--heading {\n    max-width: 426px;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    margin-top: 30px;\n    justify-content: center;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n    background: rgba(151, 151, 151, 0.22) !important;\n}\n\n.ps__thumb-y {\n    background: rgba(151, 151, 151, 0.22) !important;\n    right: 0 !important;\n}\n\n.ps__rail-y:hover>.ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    width: 6px !important;\n    background: rgba(151, 151, 151, 0.22) !important;\n}\n\n.ps__rail-y {\n    width: 6px !important;\n    right: 0 !important;\n    left: auto !important;\n}\n\n.budget-skeleton .budget-cards>span {\n    border-radius: 5px;\n    margin-right: 20px;\n    width: 25%;\n    position: relative;\n    min-height: 80px;\n}\n\n.edit--budget .block-buttons {\n    max-width: 360px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.edit--budget .kuda-cta {\n    max-width: 156px !important;\n}\n\n.kuda-cta-warning-light.form-loading:after {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiBub25lOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2U9IiNGNzY4NUIiIHN0cm9rZS1kYXNoYXJyYXk9IjUwLjI2NTQ4MjQ1NzQzNjY5IDUwLjI2NTQ4MjQ1NzQzNjY5IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHRyYW5zZm9ybT0icm90YXRlKDMxMS45NjcgNTAgNTApIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC43MnMiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==\");\n}\n\n.overview-budget--wrap {\n    max-width: 100%;\n}\n\n/* .overview-budget--wrap .recharts-surface, .overview-budget--wrap .recharts-wrapper {\n    width: 100%!important;\n    height: 100%!important;\n} */\n\n/* .recharts-responsive-container {\n    height: 100%;\n    max-height: 276px;\n} */\n\n.highlight-bar-charts {\n    height: 276px;\n    min-height: 276px;\n}\n\n.recharts-text {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--textColor);\n}\n\n/* .recharts-default-tooltip {\n    background: var(--whiteColor) !important;\n    border: 1px solid var(--borderOff) !important;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05) !important;\n    border-radius: 5px !important;\n} */\n\n.recharts-cartesian-axis-tick line,\n.recharts-cartesian-grid-vertical line {\n    visibility: hidden;\n}\n\n.recharts-tooltip-label {\n    font-size: 11px;\n    font-weight: 900;\n    color: var(--blackColor);\n}\n\n.recharts-tooltip-item-list {\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.recharts-tooltip-item-list .recharts-tooltip-item-value {\n    font-weight: 700;\n}\n\n.kuda-wrap--wrap--holder {\n    display: flex;\n    justify-content: space-between;\n}\n\n.kuda-wrap--wrap--holder>div {\n    width: calc(50% - 10px);\n    margin: 0;\n}\n\n.history {\n    margin-bottom: 40px;\n}\n\n.recharts-surface {\n    overflow: visible;\n}\n\n.history {\n    display: flex;\n    justify-content: space-between;\n}\n\n.budget-heading--summary .history .card-main--heading {\n    margin-bottom: 0px;\n    font-size: 1rem !important;\n    font-weight: 900;\n}\n\n.history .card-main-subheading {\n    font-size: 0.7rem;\n}\n\n.history-text * {\n    text-align: left;\n}\n\n.kuda-history--items .kuda-transaction--tabs {\n    margin-top: 0;\n    min-width: 185px;\n    margin-left: auto;\n    height: 38px;\n    min-height: 38px;\n    box-shadow: none;\n    border-radius: 5px;\n}\n\n.kuda-history--items .kuda-transaction--tabs>li {\n    font-size: 0.7rem;\n}\n\n.kuda-history--items .kuda-transaction--tabs>li:not(.active) {\n    color: var(--textColor) !important;\n}\n\n.recharts-tooltip-item-name,\n.recharts-tooltip-item-separator {\n    display: none;\n}\n\n.history line[stroke-dasharray=\"0 0\"] {\n    stroke: rgba(151, 151, 151, 0.2) !important;\n}\n\n.recharts-yAxis .recharts-cartesian-axis-tick:last-child {\n    transform: translateY(-8px);\n}\n\n/* .recharts-tooltip-cursor {\n    stroke: var(--successColor);\n} */\n\n/* .lineChart .recharts-tooltip-cursor {\n    stroke: none !important;\n    fill: var(--borderOff) !important;\n} */\n\n.plan-budget--wrap .history {\n    margin-bottom: 0;\n}\n\n.category-budget .budget-card {\n    width: 50%;\n}\n\n.category-budget .budget-cards {\n    margin-top: 30px;\n    margin-bottom: 25px;\n}\n\n.carteGrid {\n    stroke: rgba(151, 151, 151, 0.2);\n}\n\n.lineChart .recharts-tooltip-item-name,\n.lineChart .recharts-tooltip-item-separator {\n    display: inline-block !important;\n    text-transform: capitalize;\n}\n\n/* .lineChart .recharts-tooltip-item-list li:first-child .recharts-tooltip-item-value {\n    color: var(--successColor);\n    margin-left: 3px;\n} */\n\n.lineChart .recharts-tooltip-item-list li:first-child {\n    padding-bottom: 0 !important;\n}\n\n.lineChart .recharts-tooltip-item-list li:last-child .recharts-tooltip-item-value {\n    color: var(--negativeColor);\n    margin-left: 3px;\n}\n\n.lineChart .recharts-tooltip-item-list li:last-child .recharts-tooltip-item-value:before {\n    content: \"-\";\n}\n\n.budgeting-home .next-calendar--control {\n    margin-right: 8px;\n}\n\n.yAxis .recharts-cartesian-axis-tick:first-child {\n    visibility: hidden;\n}\n\n/* .recharts-dot {\n    fill: #fff;\n    stroke: var(--successColor);\n    stroke-width: 2.5px;\n} */\n\n.DayPickerNavigation_button {\n    background: none !important;\n    line-height: 1.7rem;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 21px;\n    padding: 0;\n    border: 0.45rem solid transparent !important;\n    z-index: 1;\n    height: 10px !important;\n    width: 10px !important;\n    text-indent: -999em;\n    overflow: hidden;\n    border-left-color: #cccccc !important;\n    border-radius: 0 !important;\n    right: 26px !important;\n    outline: 0;\n    padding: 0 !important;\n}\n\n.DayPickerNavigation_leftButton__horizontalDefault {\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1);\n    left: 26px !important;\n}\n\n.kuda-history--items .kuda-transaction--tabs li.preventDefault {\n    color: var(--offWhiteTrans) !important;\n    pointer-events: none;\n}\n\n.tabs {\n    position: relative;\n    z-index: 1;\n}\n\n.date-wrap {\n    display: flex;\n    width: 100%;\n}\n\n.DateRangePicker_picker__portal {\n    background-color: rgba(64, 25, 109, 0.4) !important;\n    z-index: 99 !important;\n}\n\n.kuda-budgeting .kuda-card--wrap {\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n}\n\n.closeCreateModal {\n    position: absolute;\n    top: 17px;\n    left: 17px;\n    cursor: pointer;\n}\n\n.pin-input input:not(:placeholder-shown) {\n    font-family: \"dotsfont\";\n}\n\n.not-pin-input input:not(:placeholder-shown) {\n    font-family: inherit !important;\n}\n\n.has-checkBox .toggle {\n    top: -6px;\n    right: 15px;\n}\n\n.kuda-mask--balance .balance-summary:not(.percentage-save) {\n    filter: blur(10.5px);\n}\n\n.kuda-mask--balance .kuda-payment--balance,\n.kuda-mask--balance .balance-cardless {\n    filter: blur(6px);\n    cursor: pointer;\n}\n\n.balance-summary {\n    cursor: pointer;\n}\n\n.balance-summary {\n    transition-duration: 250ms;\n    transition-property: filter, filter, opacity;\n}\n\n.skeleton-ui .balance-summary {\n    filter: blur(0) !important;\n}\n\n.kuda-prev path {\n    fill: var(--primaryAlt);\n}\n\n.profile-block .amount-input {\n    background-color: var(--whiteAlt);\n}\n\n.showPassword input[readonly] {\n    opacity: 0;\n}\n\n.kuda-dayLight--toggle {\n    position: absolute;\n    left: -32px;\n    width: auto;\n    display: flex;\n}\n\n.kuda-header--actions .kuda-dayLight--toggle {\n    left: -38px;\n}\n\n.kuda-dayLight--toggle svg {\n    height: 18px;\n    width: auto;\n    pointer-events: none;\n}\n\n.kuda-dayLight--toggle>span {\n    display: flex;\n}\n\n.overview-budget--wrap .empty-summary {\n    margin-bottom: 50px;\n}\n\n/**** DARK MODE ****/\n\n/* .kuda-dark--theme .color-primary, .kuda-dark--theme .kuda-cta:not(.kuda-cta-warning-light), .kuda-dark--theme .save-cta, .kuda-dark--theme .DateRangePickerInput_arrow, .kuda-dark--theme .kuda-nav--icon a.active, .kuda-dark--theme .kuda-nav--icon a[aria-current=\"page\"], .kuda-dark--theme .kuda-menu--text.active, .kuda-dark--theme .react-datepicker__day, .kuda-dark--theme .react-datepicker__time-name {\n    color: var(--blackColor) !important;\n} */\n\n.kuda-dark--theme .savings-active .denomination-icon path {\n    fill: var(--successColor) !important;\n}\n\n.kuda-dark--theme .kuda-brand path,\n.kuda-dark--theme .searchIcon path,\n.kuda-dark--theme .kuda-nav-arrow path,\n.kuda-dark--theme .customIcon path,\n.kuda-dark--theme .kuda-calendar--control path,\n.kuda-dark--theme header .kuda-nav--icon path[fill=\"#000000\"],\n.kuda-dark--theme .kuda-nav--icon circle[fill=\"#000000\"],\n.kuda-dark--theme .kuda-nav--icon rect[fill=\"#000000\"],\n.kuda-dark--theme .denomination-icon path,\n.kuda-dark--theme .closeModal path,\n.kuda-dark--theme .kuda-dropdown-icon path,\n.kuda-dark--theme .closeCreateModal path,\n.kuda-dark--theme .closeMenu rect,\n.kuda-dark--theme .kuda-card--cvc span ellipse {\n    fill: var(--blackColor) !important;\n}\n\n.kuda-dark--theme .kuda-nav--icon path[fill=\"white\"],\n.kuda-dark--theme .kuda-nav--icon circle[stroke=\"white\"],\n.kuda-dark--theme .kuda-nav--icon rect[fill=\"white\"] {\n    fill: #000000;\n}\n\n.kuda-dark--theme .kuda-nav--icon circle[fill=\"white\"].kd-no-c {\n    fill: #000;\n}\n\n.kuda-dark--theme .kuda-nav--icon [d=\"M13 1V13L23.5 19\"] {\n    stroke: #000000;\n}\n\n.kuda-dark--theme .link.active:after,\n.kuda-dark--theme .kuda-transaction--tabs>li[aria-selected=\"true\"]:after,\n.kuda-dark--theme .account-title.active:after {\n    background: rgba(255, 255, 255, 0.9);\n}\n\n.kuda-dark--theme .bill-item {\n    border-color: rgba(244, 244, 244, 0.04);\n}\n\n.kuda-dark--theme .bill-item,\n.kuda-dark--theme .block-item,\n.kuda-dark--theme .kuda-share--earn,\n.kuda-dark--theme .profile-block .add-amount,\n.kuda-dark--theme .budget-percentage--color,\n.kuda-dark--theme .transaction-header,\n.kuda-dark--theme .percentage-input {\n    background-color: var(--offWhiteTrans) !important;\n}\n\n.kuda-dark--theme circle[fill=\"#DBDCE0\"],\n.kuda-dark--theme circle[fill=\"#F5F5F8\"] {\n    fill: var(--offWhiteTrans) !important;\n}\n\n.kuda-dark--theme .setBudget-card,\n.kuda-dark--theme .DateRangePicker_picker {\n    background-color: var(--whiteAlt) !important;\n}\n\n.kuda-dark--theme .kuda-share--earn *,\n.kuda-dark--theme .formInput,\n.kuda-dark--theme .percentage-input {\n    color: var(--blackColor);\n}\n\n.kuda-dark--theme .whiteStroke {\n    stroke: var(--blackColor);\n}\n\n.kuda-dark--theme .color-normal,\n.kuda-dark--theme .card-subheading--boxed {\n    color: rgba(255, 255, 255, 0.8) !important;\n}\n\n.kuda-dark--theme .passwordToggle svg {\n    stroke: rgba(255, 255, 255, 0.8) !important;\n}\n\n.kuda-dark--theme .Toaster__alert {\n    background-color: #222222 !important;\n}\n\n.kuda-dark--theme .Toaster__alert * {\n    color: #ffffff !important;\n}\n\n.kuda-dark--theme .savedIllustration {\n    background: none;\n}\n\n.kuda-dark--theme .back-to path,\n.kuda-dark--theme .back path {\n    fill: #ffffff;\n}\n\n.kuda-dark--theme .react-datepicker {\n    background: var(--whiteColor);\n}\n\n.kuda-dark--theme .kuda-card--actions,\n.kuda-dark--theme .action-items {\n    background: #222222;\n    border-color: rgba(219, 220, 224, 0.03);\n}\n\n.kuda-dark--theme .kuda-tertiary-cta,\n.kuda-dark--theme .white-cta,\n.kuda-dark--theme .kuda-cta-white {\n    border: 1px solid rgba(219, 220, 224, 0.03);\n}\n\n.kuda-dark--theme .kuda-mobile--menu ul.kuda-menu--wrap {\n    background: var(--whiteAlt);\n}\n\n.kuda-dark--theme .kuda-tertiary-cta,\n.kuda-dark--theme .saving-plan {\n    background-color: var(--offWhiteTrans) !important;\n}\n\n.kuda-dark--theme .DayPicker__horizontal,\n.kuda-dark--theme .CalendarMonth,\n.kuda-dark--theme .CalendarMonthGrid,\n.kuda-dark--theme .CalendarDay__default {\n    background: none !important;\n}\n\n.kuda-dark--theme .DateInput_fangShape {\n    fill: #292929;\n}\n\n.kuda-dark--theme .react-datepicker__current-month,\n.kuda-dark--theme .react-datepicker-time__header,\n.kuda-dark--theme .react-datepicker-year-header {\n    color: var(--blackColor);\n}\n\n.kuda-dark--theme .kuda-dayLight--toggle path,\n.kuda-dark--theme .kuda-dayLight--toggle line,\n.kuda-dark--theme .kuda-dayLight--toggle circle {\n    stroke: #ffffff !important;\n    opacity: 0.5;\n}\n\n.kuda-dark--theme .CalendarDay__selected {\n    background: rgb(33, 51, 41) !important;\n}\n\n.kuda-dark--theme .kuda-nav--icon path[fill=\"#000000\"],\n.kuda-dark--theme .plan-budget--wrap .recharts-pie-labels text {\n    fill: #ffffff;\n}\n\n.kuda-tran--items {\n    max-width: 202px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.kuda-dark--theme .loan-color path {\n    fill: #1dcbef !important;\n}\n\n.kuda-dark--theme .transaction-percentage span {\n    color: var(--textColor) !important;\n}\n\n.kuda-dark--theme .card-overspent * {\n    color: var(--negativeColor) !important;\n}\n\n.kuda-quick--statement {\n    display: flex;\n    margin-bottom: 8px;\n}\n\n.kuda-dark--theme .savings-active .color-primary {\n    color: var(--successColor) !important;\n}\n\n.kuda-dark--theme .pin-input input {\n    color: var(--blackColor);\n}\n\n.kuda-dark--theme .kuda-modal-illustration g[clip-path=\"url(#__lottie_element_50)\"] path[fill=\"rgb(64,24,108)\"],\n.kuda-dark--theme .kuda-modal-illustration g[clip-path=\"url(#__lottie_element_69)\"] path[fill=\"rgb(64,24,108)\"] {\n    fill: #fff;\n}\n\n.kuda-dark--theme .CalendarDay__selected_span,\n.kuda-dark--theme .CalendarDay__hovered_span {\n    background-color: rgba(72, 211, 138, 0.15) !important;\n    color: var(--blackColor) !important;\n}\n\n.kuda-dark--theme .CalendarDay {\n    color: var(--blackColor) !important;\n}\n\n.kuda-modal-illustration>div svg {\n    height: 93px !important;\n    width: auto !important;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n\n/* Change Autocomplete styles in Chrome*/\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n    -webkit-text-fill-color: var(--blackColor);\n    -webkit-box-shadow: 0 0 0px 1000px var(--whiteColor) inset;\n    transition: background-color 5000s ease-in-out 0s;\n    color: var(--blackColor);\n}\n\n.kuda-dark--theme .kuda-layout---card .kuda-card--wrap,\n.kuda-dark--theme .kuda-layout---card .formCard,\n.kuda-dark--theme .kuda-layout---card .kuda-deposit--wrap,\n.kuda-dark--theme .profile-block .amount-input {\n    background: var(--offWhiteTrans);\n}\n\n.kuda-dark--theme .CalendarDay__blocked_out_of_range {\n    opacity: 0.2;\n}\n\n.progressRing circle {\n    transition: stroke-dashoffset 1.4s;\n    transform: rotate(-90deg);\n    transform-origin: 50% 50%;\n}\n\n.progressRing {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    transform: scale(1.225);\n}\n\n.event-none {\n    pointer-events: none;\n}\n\n.kuda-dark--theme .progressRing circle {\n    stroke: #ffffff;\n}\n\n.kuda-dark--theme .progressRing {\n    transform: scale(1.26);\n}\n\n.add-card--layout {\n    max-width: 450px;\n}\n\n.add-card--layout .kuda-radio--wrapper {\n    width: calc(50% - 8px);\n}\n\n.add-card--layout .kuda-radio--wrapper label {\n    padding-left: 51px;\n}\n\n.add-card--layout .outer {\n    left: 14px;\n}\n\n.bottom-spacer {\n    margin-bottom: 29px;\n}\n\n.bottom-spacer--lg {\n    margin-bottom: 48px;\n}\n\n.bottom-spacer--xl {\n    margin-bottom: 56px !important;\n}\n\n.bottom-spacer--md {\n    margin-bottom: 40px !important;\n}\n.top-spacer--md {\n    margin-top: 40px !important;\n}\n\n.fund-card--modal .transaction-additional--details {\n    align-items: flex-end;\n}\n\n.kuda-card--brand {\n    padding-bottom: 5px;\n    display: flex;\n}\n\n.fund-card--modal .modal-content {\n    max-width: 450px;\n}\n\n.kuda-card--brand svg {\n    width: 33px;\n    height: auto;\n}\n\n.color-blue {\n    color: var(--lightBlue);\n}\n\n.kuda-budget--illustration svg {\n    height: 86px;\n    width: 86px;\n}\n\n.payoneerLoader {\n    flex-direction: column;\n    justify-content: center;\n}\n\n.payoneerLoader>div {\n    display: flex;\n    justify-content: center;\n}\n\n.infinite-path {\n    position: relative;\n    overflow: hidden;\n    /* width: 230px; */\n    width: 100%;\n    /* max-width: 230px; */\n    height: 3px;\n    background-color: var(--offWhiteTrans);\n    margin: auto;\n    border-radius: 10px;\n    margin-top: 35px;\n    margin-bottom: 0px;\n}\n\n.shape {\n    position: absolute;\n    left: 0;\n    background-color: #000000;\n    width: 100px;\n    height: 3px;\n    display: block;\n    top: 0;\n    transition: all 1s ease-in-out;\n    animation: ani 1.7s infinite;\n    animation-delay: 1s;\n}\n.shape-modal {\n    position: absolute;\n    left: 0;\n    background-color: #000000;\n    width: 100px;\n    height: 3px;\n    display: block;\n    top: 0;\n    transition: all 1s ease-in-out;\n    animation: aniModal 1.7s infinite;\n    animation-delay: 1s;\n}\n\n.kuda-dark--theme .shape {\n    background-color: #ffffff;\n}\n\n@keyframes ani {\n    0% {\n        left: -70px;\n    }\n\n    50% {\n        left: 210px;\n    }\n\n    100% {\n        left: -70px;\n    }\n}\n\n@-webkit-keyframes ani {\n    0% {\n        left: -70px;\n    }\n\n    50% {\n        left: 210px;\n    }\n\n    100% {\n        left: -70px;\n    }\n}\n\n@keyframes aniModal {\n    0% {\n        left: -70px;\n    }\n\n    50% {\n        left: 484px;\n    }\n\n    100% {\n        left: -70px;\n    }\n}\n\n@-webkit-keyframes aniModal {\n    0% {\n        left: -70px;\n    }\n\n    50% {\n        left: 484px;\n    }\n\n    100% {\n        left: -70px;\n    }\n}\n.payoneerLoader h5 {\n    font-size: 1.25rem;\n}\n\n.kuda-default--radio [type=\"radio\"]:checked,\n.kuda-default--radio [type=\"radio\"]:not(:checked) {\n    position: absolute;\n    left: -9999px;\n}\n\n.kuda-default--radio [type=\"radio\"]:checked+label,\n.kuda-default--radio [type=\"radio\"]:not(:checked)+label {\n    position: relative;\n    padding-left: 42px;\n    cursor: pointer;\n    line-height: 28px;\n    display: inline-block;\n}\n\n.kuda-default--radio [type=\"radio\"]:checked+label:before,\n.kuda-default--radio [type=\"radio\"]:not(:checked)+label:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 27px;\n    height: 27px;\n    border: 1px solid #c4c4c4;\n    border-radius: 100%;\n    background: #c4c4c4;\n}\n\n.kuda-default--radio [type=\"radio\"]:checked+label:after,\n.kuda-default--radio [type=\"radio\"]:not(:checked)+label:after {\n    content: \"\";\n    width: 27px;\n    height: 27px;\n    background: #48d38a;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n}\n\n.kuda-default--radio [type=\"radio\"]:not(:checked)+label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n\n.kuda-default--radio [type=\"radio\"]:checked+label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n\n.kuda-default--radio {\n    width: 100%;\n    display: flex;\n    margin-top: 14px;\n}\n\n.kuda-select--currency {\n    margin-bottom: 30px;\n    margin-top: 35px;\n}\n\n.kuda-default--radio label {\n    font-size: 0.935rem;\n}\n\n.back span {\n    display: flex;\n    font-size: 13px;\n}\n\n.modal-description--icon {\n    margin-right: 10px;\n    margin-top: 3px;\n}\n\n.kuda-no--pin {\n    margin-top: 35px;\n}\n\n.payoneer-loader {\n    display: flex !important;\n}\n\n.payoneer-linked--svg svg {\n    margin: 0;\n    height: 78px !important;\n    width: auto;\n}\n\n.payoneer-linked--svg {\n    margin-bottom: 35px;\n}\n\n.payoneer-loader {\n    background-color: var(--whiteColor);\n}\n\n.kuda-no--pin .addAction {\n    margin-bottom: 0;\n}\n\n.margin-top--none {\n    margin-top: 0 !important;\n}\n\n.payoneer-loader {\n    align-items: flex-start;\n    padding-top: 15%;\n}\n\n.add-payoneer {\n    position: relative;\n}\n\n.payoneerCheck {\n    top: 20px;\n    left: auto;\n    right: 20px;\n    transform: none;\n    padding: 4px;\n    background-color: none !important;\n    box-shadow: none;\n    border: none;\n}\n\n.spinner {\n    width: 19px;\n    height: 19px;\n}\n\n.addInactive {\n    pointer-events: none;\n}\n\n.call-active .modal .kuda-cta,\n.call-active .modal-backdrop {\n    pointer-events: none;\n}\n\n.kuda-add--cardForm input[readonly] {\n    color: rgba(151, 151, 151, 0.75);\n    pointer-events: none;\n}\n\n.kuda-card {\n    background: var(--whiteAlt);\n    border: 1px solid var(--borderOff);\n    box-shadow: 15px 30px 40px var(--boxShadow);\n    border-radius: 5px;\n    padding: 60px 70px 65px;\n}\n\n.kuda-404--wrap {\n    max-width: 501px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-404--illustration {\n    margin: 0 auto 43px;\n}\n\n.kuda-404--heading {\n    font-size: 1.5rem;\n}\n\n.kuda-card .inactivity-buttons .addAction {\n    max-width: 200px;\n}\n\n.has-bottom--margin {\n    margin-bottom: 45px;\n}\n\na.transaction-tab[aria-current=\"page\"]:after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 2px;\n    display: block;\n    background: var(--primaryColor);\n    bottom: 1px;\n    opacity: 1;\n    border-radius: 5px;\n    left: 0;\n}\n\n.copyAccount {\n    display: flex;\n    position: absolute;\n    right: 0;\n    bottom: 17px;\n}\n\n.copyField input {\n    padding-right: 59px;\n}\n\n.kuda-transfer--form .formInput {\n    width: 100%;\n}\n\n/*** FOOTER ***/\n\n.kuda-footer--conditions p {\n    font-size: 12px;\n}\n\n.kuda-socials svg {\n    width: 18px;\n    height: auto;\n}\n\n.kuda-facebook svg {\n    width: auto;\n    height: 19px;\n    position: relative;\n    top: -2px;\n}\n\n.kuda-medium svg {\n    width: auto;\n    height: 14px;\n}\n\n.kuda-instagram svg {\n    width: auto;\n    height: 15px;\n}\n\n.kuda-socials li a {\n    margin-right: 20px;\n    height: 100%;\n}\n\n.kuda-socials li {\n    display: flex;\n    align-items: center;\n}\n\n.coming-soon--downloads img {\n    height: 35px;\n    width: auto;\n    margin-right: 10px;\n    opacity: 0.2;\n}\n\n.coming-soon {\n    font-size: 15px;\n    font-weight: 700;\n    color: #000000;\n}\n\nfooter .container {\n    max-width: 1180px;\n    padding-left: 60px;\n    padding-right: 60px;\n}\n\n.available {\n    opacity: 1 !important;\n}\n\nfooter {\n    border-top: 1px solid rgba(58, 36, 82, 0.04);\n    margin-top: 50px;\n}\n\n.anonymous {\n    position: absolute;\n    top: 0px;\n    right: 0;\n    border-bottom: 1px solid #000000;\n    padding-bottom: 1px;\n    cursor: pointer;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    /* Non-prefixed version, currently*/\n}\n\n.kuda-dark--theme .kuda-footer--conditions p {\n    color: rgba(219, 220, 224, 0.53);\n}\n\n.kuda-dark--theme footer {\n    border-color: rgba(219, 220, 224, 0.03);\n}\n\n.kuda-bills--nav {\n    margin-bottom: -10px;\n}\n\n.budget-skeleton .budget-cards>span:last-child {\n    margin-right: 0;\n}\n\n.budget-skeleton .budget-cards {\n    padding-bottom: 0;\n}\n\n.stealthy {\n    left: 0;\n    margin: 0;\n    max-height: 1px;\n    max-width: 1px;\n    opacity: 0;\n    outline: none;\n    overflow: hidden;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    z-index: -1;\n}\n\n.kuda-card--wrap.payment-wrap {\n    padding: 40px 57px 43px !important;\n    position: relative;\n}\n\n.kuda-nav-arrow {\n    display: flex;\n    align-items: center;\n}\n\n.kuda-nav-arrow>* {\n    display: flex;\n}\n\n.redUnblock .toggle input[type=\"checkbox\"]:checked+.toggle-icon {\n    background: #f7685b;\n}\n\n.bottom-fix {\n    margin-bottom: 35px;\n}\n\n.kuda-login--wrap .formInput {\n    padding-left: 13px;\n    padding-right: 20px;\n    line-height: 1;\n}\n\n.skeleton-card--top {\n    margin-top: 36px;\n}\n\n.skeleton-card--top .input-skeleton>span {\n    width: 100%;\n    display: flex;\n}\n\n.account-skeleton .balance-icon {\n    overflow: hidden;\n    border-radius: 100px;\n}\n\n.account-skel--items {\n    margin-bottom: 20px;\n}\n\n.account-skeleton .balance-icon {\n    min-width: 92px;\n}\n\n.budget-skeleton .kuda-transaction--tabs li>span {\n    display: block;\n    height: 10px;\n    width: 100%;\n    max-width: 130px;\n}\n\n.payoneer-content .message-response {\n    max-width: 100%;\n}\n\n.payoneer-content h4 {\n    font-size: 1.25rem;\n    max-width: 250px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.1875rem !important;\n}\n\n.payoneer-content .kuda-modal-illustration svg {\n    width: auto !important;\n    height: 52px !important;\n}\n\n.payoneer-content .kuda-budget--illustration {\n    margin-top: 10px;\n    margin-bottom: 2rem;\n}\n\n.transaction-additional--details .save-title {\n    font-size: 0.875rem;\n    margin-bottom: 5px !important;\n}\n\n.linked {\n    width: 62px !important;\n    background: #dcffec;\n    border: 1px solid #48d38a;\n    box-sizing: border-box;\n    box-shadow: 5px 7px 10px rgba(72, 211, 138, 0.1);\n    border-radius: 5px;\n    color: #48d38a;\n    font-weight: bold;\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 21px;\n    position: absolute;\n    right: 25px;\n    top: 27px;\n}\n\n.no-link--text {\n    margin-bottom: 0 !important;\n}\n\n.kuda-balance--wrap {\n    background: var(--whiteAlt);\n    border: 1px solid;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    padding: 20px 25px;\n    width: calc(50% - 10px);\n    cursor: pointer;\n    display: block;\n    border-color: #ffffff;\n    transition: all 0.2s;\n    -webkit-transition: all 0.2s;\n    -moz-transition: all 0.2s;\n    -ms-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    margin-bottom: 20px;\n    min-height: 158px;\n}\n\n.kuda-balance--wrap .add-icon svg {\n    height: 37px;\n    width: auto;\n}\n\n.currency-wrap {\n    width: 37px;\n    height: 37px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #eff1ff;\n    border: 1px solid #000000;\n    border-radius: 100px;\n    -webkit-border-radius: 100px;\n    -moz-border-radius: 100px;\n    -ms-border-radius: 100px;\n    -o-border-radius: 100px;\n    padding: 3px;\n}\n\n.currency-summary--wrap {\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.is-balance {\n    display: flex;\n    flex-direction: column;\n    background: var(--whiteAlt);\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    cursor: default;\n}\n\n.currency-item {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: var(--primaryColor);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.52);\n    border-radius: 100px;\n}\n\n.kuda-balance--wrap .add-icon {\n    margin-bottom: 13px;\n}\n\n.payoneer-modal .modal-content {\n    max-width: 417px;\n}\n\n.payoneer-modal .generateReceipt {\n    max-width: 212px;\n}\n\n.modal-content>h4.text-xbold {\n    font-size: 1.275rem;\n}\n\n.payoneer-modal-heading {\n    display: flex;\n    margin-top: 1.7rem;\n    margin-bottom: 2.2rem;\n    align-items: center;\n}\n\n.collection-icon {\n    margin-right: 18px;\n}\n\n.collection-text p {\n    line-height: 1.3;\n    font-size: 0.9rem;\n    color: var(--blackColor);\n}\n\n.payoneer-dropDown {\n    background-color: var(--whiteAlt);\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    height: 40px;\n    width: 74px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 14px;\n    cursor: pointer;\n}\n\n.kuda-dark--theme .payoneer-dropDown {\n    background: #222222 !important;\n}\n\n.payoneer-dropDown span {\n    display: flex;\n}\n\n.more-arrow svg {\n    height: 14px;\n    width: auto;\n}\n\n.kuda-dark--theme .more-arrow path[fill=\"#000000\"] {\n    fill: #fff;\n}\n\n.pop {\n    position: absolute;\n    right: 0;\n    width: auto;\n    height: auto;\n    z-index: 1;\n    align-items: flex-start;\n    top: 0;\n}\n\n.position-relative {\n    position: relative;\n    z-index: 1;\n}\n\n.pop>span {\n    position: absolute;\n    left: 14px;\n    top: 12px;\n}\n\n.pop .user-icon {\n    right: 14px;\n    left: auto;\n    top: 10px;\n}\n\n.other-payoneer--information {\n    padding-top: 11px;\n    text-align: center;\n    margin-left: 40px;\n    margin-right: 45px;\n}\n\n.unlink {\n    margin-left: -54px;\n    margin-right: -59px;\n    border-top: 1px solid rgba(219, 220, 224, 0.5);\n    padding: 13.4px 20px;\n    margin-top: 20px;\n}\n\n.kuda-dark--theme .unlink {\n    border-color: rgba(219, 220, 224, 0.05);\n}\n\n.product-skeleton .kuda-search {\n    margin-bottom: 25px;\n    margin-top: 0;\n}\n\n.product-skeleton .kuda-account--summary>div {\n    width: calc(50% - 10px) !important;\n}\n\n.kuda-card--wrap .kuda-budgeting {\n    margin-bottom: auto;\n}\n\n.modal-content>.closeModal+h4.text-center {\n    font-size: 1.25rem;\n}\n\n.isEmpty {\n    margin-top: auto;\n}\n\n.emptyWrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.mini-card--heading {\n    font-size: 0.875rem;\n}\n\n.copy-title {\n    font-size: 0.7rem;\n}\n\n.copy-excerpt {\n    font-size: 0.7rem;\n}\n\n.kuda-form--ussd {\n    margin-bottom: 1.5rem;\n}\n\n.copy-account--wrap {\n    margin-top: -7px;\n}\n\n.cursor-copy {\n    cursor: copy;\n}\n\n.kuda-beneficiary--name {\n    margin-top: -20px;\n    margin-bottom: 28px;\n    display: block;\n}\n\n.kuda-beneficiary--name.no-mt {\n    margin-top: 5px !important;\n}\n\n.beneficiary-wrap {\n    background: none !important;\n    padding: 0;\n    font-size: 0.8rem;\n}\n\n.kuda-dropdown-header.inputLoading {\n    padding-right: 50px;\n}\n\n.kuda-header--wrap .kuda-cta {\n    font-size: 15px;\n    height: 46px;\n    border: 1px solid var(--primaryAlt);\n    width: 175px;\n    max-width: 175px;\n}\n\n.kuda-dark--theme .skeleton-card--top .kuda-card--wrap {\n    background-color: rgba(219, 220, 224, 0);\n}\n\n.viewSavingsSummary .transaction-avatar svg {\n    width: 100%;\n    height: 100%;\n}\n\n.viewSavingsSummary .kuda-result--item {\n    cursor: default;\n}\n\n.intercom-launcher-frame {\n    background: #401a6e !important;\n}\n\n.break-right {\n    flex-grow: 1;\n    flex-shrink: 0;\n    flex-basis: auto;\n}\n\n.payment-bold--wrap {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.budget-result--holder .transaction-avatar img,\n.overview-budget--wrap .transaction-avatar img,\n.transaction-icon {\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.07);\n    border-radius: 100px;\n}\n\n.share-earn--50:first-child {\n    width: calc(45% - 7px);\n    min-width: 118px;\n}\n\n.add-product--wrap {\n    background: var(--whiteAlt);\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 10px;\n    padding: 1px 25px 55px;\n    max-width: 350px;\n    margin: 0 auto;\n    margin-top: 40px;\n    position: relative;\n}\n\n.kuda-dark--theme .add-product--wrap {\n    background: var(--offWhiteTrans) !important;\n}\n\n.add-product--wrap h4 {\n    font-size: 1rem;\n}\n\n.add-product--wrap .kuda-budget--illustration svg {\n    width: 70px;\n    height: 70px;\n}\n\n.add-product--wrap .margin-bottom--spacer {\n    margin-bottom: 8px;\n}\n\n.linked-active {\n    padding-bottom: 65px !important;\n}\n\n.revoke-content .kuda-modal-illustration svg {\n    width: 86px !important;\n    height: 86px !important;\n}\n\n.revoke-content h4 {\n    max-width: 100%;\n    line-height: 1.5;\n    margin-top: 1.9rem !important;\n}\n\n.no-bottom--margin {\n    margin-bottom: 0px !important;\n}\n\n.small-bottom--margin {\n    margin-bottom: 8px;\n}\n\n.payoneer-heading {\n    max-width: 336px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n\n.kuda-dark--theme .payoneer-content svg path[fill=\"black\"] {\n    fill: #fff;\n}\n\n.kuda-dark--theme .collection-icon circle,\n.kuda-dark--theme .kuda-balance--wrap .add-icon circle {\n    opacity: 0.4;\n}\n\n.collection-info {\n    color: var(--blackColor) !important;\n}\n\n.Toaster__message:not(:last-child) {\n    margin-bottom: 15px;\n}\n\n.kuda-dark--theme .copyAccount path {\n    fill: #fff;\n}\n\n.kuda-dark--theme .Toaster__alert {\n    background-color: #222222 !important;\n}\n\n.kuda-dark--theme .Toaster__alert * {\n    color: #ffffff !important;\n}\n\n.kuda-dark--theme .transaction-avatar {\n    background: #191919;\n}\n\n.kuda-dark--theme .animated.closeMenu {\n    animation-fill-mode: both;\n}\n\n.verifiedName {\n    display: flex;\n    align-items: center;\n}\n\n.verifiedIcon svg {\n    height: 13px;\n    width: auto;\n    margin-left: 6px;\n    position: relative;\n    top: 1px;\n}\n\n.kuda-header--actions {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.kuda-dayLight--toggle {\n    cursor: pointer;\n}\n\n.DayPickerNavigation_button__disabled {\n    opacity: 0.1;\n}\n\n.logout-active {\n    opacity: 0.3;\n}\n\n.kuda-tran--holder .transaction-price {\n    transform: none !important;\n    -webkit-transform: none !important;\n    -moz-transform: none !important;\n    -ms-transform: none !important;\n    -o-transform: none !important;\n}\n\n.error-auth--label {\n    padding: 12px 20px;\n    background: #ffdbdb;\n    display: flex;\n    align-items: center;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    margin-top: -10px;\n    justify-content: flex-start;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n}\n\n.error-auth--label span {\n    display: inline-flex;\n}\n\n.auth-error-text {\n    color: #f7685b;\n    font-weight: 700;\n    font-size: 0.8rem;\n    margin-left: 7px;\n    line-height: 1.3;\n}\n\n.auth-error-icon svg {\n    height: 18px;\n    width: 18px;\n}\n\n.kuda-announcement--card,\n.kuda-login--header {\n    background: #dfe3ff;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    padding: 16px 20px;\n    margin-bottom: 18px;\n}\n\n.kuda-login--header {\n    background: none !important;\n    border: none !important;\n    box-shadow: none !important;\n    max-width: 390px;\n    padding: 10px 0 !important;\n}\n\n.kuda-announcement--card h1 {\n    color: #000000;\n    font-weight: 900;\n    font-size: 2.5rem !important;\n}\n\n.kuda-login--header p {\n    font-weight: normal;\n    font-size: 15px !important;\n    line-height: 20px;\n    margin-top: 11px;\n}\n\n.attempt-response {\n    max-width: 330px;\n}\n\n.disclaimer {\n    margin-top: 21px;\n    font-size: 0.785rem !important;\n    max-width: 315px;\n}\n\n.signout-button {\n    margin-top: auto;\n}\n\n.kuda-error--wrap .inactive-wrap {\n    max-width: 280px;\n}\n\n.kuda-error--wrap .kuda-modal-illustration {\n    margin: 32px auto 35px;\n}\n\n.kuda-error--page {\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.kuda-error--page .kuda-404--wrap {\n    width: 100%;\n}\n\n.kuda-error--wrap {\n    width: 100%;\n}\n\n.kuda-loader--wrap {\n    display: flex;\n    justify-content: center;\n}\n\n.payoneer-failed {\n    position: absolute;\n    top: 20px;\n    right: 22px;\n}\n\n.payoneer-failed svg {\n    width: 22px;\n    height: 22px;\n}\n\n.kuda-external--link svg {\n    height: 14px;\n    width: auto;\n    position: relative;\n    transform: translateY(-0.5px);\n    margin-left: 5px;\n}\n\n.kuda-external--link {\n    display: flex;\n    align-items: center;\n}\n\n.kuda-is--cursor {\n    cursor: pointer;\n}\n\n.kuda-max--cardWidth {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 300px;\n}\n\n.kuda-request--wrap .bill-item {\n    height: 65px;\n}\n\n.bill-item .text-xs {\n    margin-top: 3px;\n}\n\n.kuda-small--modal-md {\n    max-width: 485px !important;\n}\n\n.kuda-small--modal-lg {\n    max-width: 500px !important;\n}\n\n.card-check,\n.analytics-card--section {\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    padding: 25px;\n    margin-bottom: 50px;\n}\n\n.kuda-dark--theme .card-check {\n    border-color: rgba(219, 220, 224, 0.03);\n}\n\n.card-check li {\n    font-size: 0.875rem;\n    line-height: 1.4;\n}\n\n.flex.justify-between .kuda-cta-lg-sm {\n    max-width: 161px;\n}\n\n.card-check li svg {\n    margin-right: 10px;\n}\n\n.card-check li:not(:last-child) {\n    margin-bottom: 6px;\n}\n\n.block-item .payoneer-failed {\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n}\n\n.block-item .payoneerCheck {\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.overdraft-text {\n    max-width: 360px;\n}\n\n.overdraft-wrap .block-buttons {\n    margin-top: 25px;\n}\n\n.modal-overdraft .modal-content {\n    max-width: 517px !important;\n}\n\n.modal-overdraft .kuda-budget--form {\n    height: calc(100vh - 355px) !important;\n}\n\n.modal-overdraft .kuda-modal-illustration svg {\n    max-height: 128px;\n    width: auto;\n}\n\n.modal-overdraft .kuda-modal-illustration {\n    margin: 42px auto 20px;\n}\n\n.overdraft-other--text {\n    font-size: 0.935rem;\n}\n\n.overdraft-onboarding {\n    max-width: 307px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.overdraft-other--text:not(:last-child) {\n    margin-bottom: 30px;\n}\n\n.no-border--top {\n    border-top: 0 !important;\n}\n\n.block-md {\n    max-width: 250px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.overdraft-terms {\n    margin-top: 30px;\n}\n\n.overdraft-wrap .denomination-icon svg {\n    height: 12px;\n    width: auto;\n}\n\n.borrow-progress {\n    position: static !important;\n    height: 6px;\n    margin-top: 25px;\n    width: 100%;\n}\n\n.borrow-progress .savings-width {\n    background-color: #1dcbef;\n    position: relative;\n}\n\n.kuda-bank--section {\n    position: relative;\n}\n\n.loan-progress--value {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: var(--lightBlue);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n    border-radius: 100px;\n    width: 33px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 8px;\n    font-weight: 900;\n    color: #fff;\n    right: -15px;\n}\n\n.overdraftResults {\n    margin-left: -57px;\n    margin-right: -57px;\n}\n\n.overdraftResults>div>* {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n.overdraftResults .transaction-price {\n    margin-right: 0;\n}\n\n.overdraftResults .transaction-avatar {\n    background: none;\n}\n\n.overdraftResults .accept {\n    margin-top: 45px;\n    margin-bottom: 10px;\n}\n\n.overdraft-load--more {\n    margin: 50px 0px 10px;\n}\n\n.kuda-borrow-card--content .disabled {\n    opacity: 0.4;\n}\n\n.overdraft-subtext {\n    max-width: 308px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.overdraft-summary--card {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ffffff;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    padding: 12px 20px;\n}\n\n.overdraft-summary--title {\n    display: flex;\n    align-items: center;\n}\n\n.overdraft-summary--icon {\n    margin: 12px auto;\n    display: flex;\n    justify-content: center;\n}\n\n.overdraft-summary--icon svg {\n    background: #ffffff;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 200px;\n}\n\n.new-badge {\n    background: #48d38a;\n    border: 1px solid #dcffec;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.625rem;\n    padding: 1px 5px 1px;\n    margin-left: 7px;\n}\n\n.text-decoration--underline {\n    text-decoration: underline;\n    filter: none !important;\n    -webkit-filter: none !important;\n}\n\n.call-active .modal-content .addAction {\n    opacity: 0.9;\n}\n\n.kuda-success--modal .addAction {\n    opacity: 1 !important;\n    pointer-events: auto !important;\n}\n\n.kuda-success--modal {\n    pointer-events: auto !important;\n    left: unset;\n}\n\n.overdraft-terms .accordion {\n    padding-left: 10px;\n    padding-right: 15px;\n}\n\n.kuda-dark--theme .freeTransfer--wrap,\n.kuda-dark--theme .kuda-cta-primary-light,\n.kuda-dark--theme .kuda-add--options>*,\n.kuda-dark--theme .is-balance,\n.kuda-dark--theme .Toaster__alert,\n.kuda-dark--theme .kuda-balance--wrap,\n.kuda-dark--theme .kuda-referral--card .empty-savings--card,\n.kuda-dark--theme .kuda-history--items .kuda-transaction--tabs,\n.kuda-dark--theme .savedIllustration,\n.kuda-dark--theme .payoneer-dropDown,\n.kuda-dark--theme .overdraft-summary--card {\n    border-color: rgba(219, 220, 224, 0.03) !important;\n    box-shadow: 5px 7px 10px rgba(64, 25, 109, 0.02) !important;\n    background-color: var(--offWhiteTrans) !important;\n}\n\n.kuda-dark--theme .overdraft-summary--icon svg,\n.kuda-dark--theme .overdraft-summary--icon svg circle {\n    background-color: var(--offWhiteTrans) !important;\n    fill: var(--offWhiteTrans) !important;\n}\n\n.kuda-dark--theme .new-badge {\n    border: 1px solid rgb(220 255 236 / 0.3);\n}\n\n.kuda-dark--theme .kuda-cta-loan-light {\n    background-color: var(--offWhiteTrans) !important;\n    border-color: rgba(219, 220, 224, 0.06) !important;\n}\n\n.maintenance-illustration {\n    width: 100%;\n    margin: 10px 0 30px;\n}\n\n.maintenance-modal .error-message {\n    max-width: 380px;\n}\n\n.maintenance-modal .modal-content {\n    max-width: 520px !important;\n}\n\n.kuda-card--badge {\n    font-size: 0.75rem;\n    background: #48d38a;\n    color: var(--whiteColor);\n    padding: 6px 32px;\n    border-radius: 4px;\n    position: relative;\n    top: -2px;\n}\n\n.card-check .bottom-spacer {\n    margin-bottom: 30px !important;\n}\n\n.kuda-cta-lg-md {\n    max-width: 170px;\n}\n\n.other-delivery--wrap.disabled {\n    opacity: 0.38;\n}\n\n.kuda-dropdown-list:empty {\n    display: none;\n}\n\n.kuda-google--search .kuda-dropdown-header {\n    z-index: 99999;\n    position: relative;\n}\n\n.kuda-google--search .kuda-dropdown-list {\n    padding-top: 46px;\n}\n\n.modal-active .kuda-google--search .kuda-dropdown-header {\n    z-index: 999 !important;\n}\n\n.bottom-spacer--sm {\n    margin-bottom: 20px !important;\n}\n\n.block-card--illustration svg {\n    width: 60px;\n    height: auto;\n    box-shadow: 20px 15px 12px rgba(64, 25, 109, 0.1);\n}\n\n.card-bg-primary {\n    background: var(--primaryColor);\n}\n\n.card {\n    position: relative;\n    width: 120px;\n    height: 189px;\n    perspective: 800px;\n}\n\n.card .flippy {\n    width: 100%;\n    height: 100%;\n    perspective: 1000px;\n    transform-style: preserve-3d;\n    transition: all 1s;\n}\n\n.card .front,\n.card .back {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.card .front {\n    transform: rotateX(0);\n}\n\n.card .back {\n    transform: rotateX(180deg);\n    transform: rotateY(180deg);\n}\n\n/* .physical-card svg {\n    width: 100%;\n    margin: 0;\n    position: static;\n    transform: none;\n    top: auto;\n} */\n\n.active-card .card {\n    transform: translate3d(-60px, 0, 0);\n}\n\n.card {\n    transition: transform 0.8s;\n    transition-delay: 0.5s;\n    z-index: 1;\n}\n\n.card-animation--wrap {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.card-animation--wrap {\n    height: 189px;\n    position: relative;\n}\n\n\n.physical-card .flippy svg {\n    /* width: 120px; */\n    /* height: auto; */\n    width: 241.245px;\n    height: 379.999px;\n    position: absolute;\n}\n\n.physical-card .flippy svg.card-back {\n    visibility: hidden;\n    transition: 0.2s;\n    transform: rotateY(-180deg) translate3d(0, 0, 0);\n}\n\n.secret-icon {\n    margin-left: 12px;\n}\n\n.kuda-google--search .dropdown-item--title {\n    line-height: 1.5;\n    font-size: 0.875rem;\n}\n\n.physical-card>svg {\n    height: 189px;\n    width: auto;\n}\n\n.bill-item.disabled {\n    opacity: 0.55;\n}\n\n.secret-icon svg {\n    height: auto;\n}\n\n.kuda-google--search .kuda-dropdown-item {\n    background-color: transparent !important;\n}\n\n.secret-icon svg {\n    width: 17px;\n    height: auto;\n}\n\n.kuda-customer--options {\n    border-bottom: 1px solid #dbdce0;\n    padding: 15px 0;\n}\n\n.c-apps {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    margin: 0 -8px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.c-apps__item {\n    margin-bottom: 12px;\n    padding: 0 8px;\n}\n\n.c-apps__link {\n    display: block;\n    text-decoration: none;\n}\n\n.c-apps__link svg,\n.c-apps__link img {\n    height: 46px;\n    width: auto;\n    display: block;\n}\n\n.briefcase-icon {\n    margin-top: 50px;\n}\n\n.kuda-get--app {\n    min-height: calc(100vh - 70px);\n    transform: none !important;\n    margin-top: 0;\n    padding-top: 140px;\n}\n\n.kuda-is--centered {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-preview--signup .kuda-auth--layout {\n    max-width: 752px;\n}\n\n.confirm-card--wrap {\n    max-width: 500px;\n    margin: auto;\n}\n\n.authenticate-card--wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.authenticate-acc--wrap {\n    margin: 100px 0;\n}\n\n.authenticate-icons--wrap {\n    max-width: 200px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n.manage-users--add {\n    max-width: 150px;\n    /* margin-left: auto; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.manage-users--add a {\n    background: #ffffff;\n    border: 1px solid #dfe3ff;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    color: var(--primaryAlt);\n    font-size: 0.875rem;\n    padding: 10px;\n    width: 100%;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.users-avatar-sm {\n    background: #dfe3ff;\n    border-radius: 100px;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--primaryAlt);\n    text-align: center;\n}\n\n.access-level--badge {\n    border-radius: 100px;\n    padding: 6px 19px;\n    width: 78px;\n    font-size: 0.925rem;\n    max-width: 78px;\n}\n\n.homepage-error-wrap {\n    display: flex;\n    margin-top: 200px;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.form-group-row {\n    display: flex;\n    width: 100%;\n}\n\n.form-group-row .card-group {\n    margin-bottom: 0;\n}\n\n.form-group-row .card-group {\n    width: calc(50% - 8px);\n    margin: 0 !important;\n}\n\n.form-group-row {\n    display: flex;\n    justify-content: space-between;\n}\n\n/* MANAGE USERS */\n\n.signatory-header--wrap p {\n    font-weight: 800;\n    font-size: 20px;\n    text-align: center;\n    margin-top: 15px;\n    color: #000000;\n}\n\n.signatory-avatar--wrap {\n    background: #dfe3ff;\n    border: 0.964286px solid #000000;\n    color: #000000;\n    font-size: 30px;\n    box-shadow: 30px rgba(31, 45, 138, 0.15);\n    width: 80px;\n    height: 80px;\n    border-radius: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.signatory-header--wrap {\n    width: 50%;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.signatory-user--contents {\n    justify-content: space-around;\n}\n\n.signatory-user--item div {\n    margin-bottom: 20px;\n}\n\n/* MOVING LOADING BAR */\n\n.page-overlay .loader-review {\n    position: absolute;\n    top: calc(50% + 60px);\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 300px;\n    font-family: Arial;\n    font-size: 13px;\n    text-align: center;\n}\n\n/* .loading {\n    background-color: \"#2e6da4\";\n    height: 2px;\n    margin: 1em;\n    overflow: hidden;\n    position: relative;\n    width: 12em;\n} */\n\n.loading-bar {\n    animation: sideToside 2s ease-in-out infinite;\n    background-color: var(--primaryAlt);\n    height: 100%;\n    position: absolute;\n    width: 50%;\n}\n\n@keyframes sideToside {\n\n    0%,\n    100% {\n        transform: translateX(-50%);\n    }\n\n    50% {\n        transform: translateX(150%);\n    }\n}\n\n.center {\n    left: 50%;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n}\n\n.upload-btn-wrap input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    opacity: 0;\n}\n\n/* Invited Signatory */\n\n.invite-link--error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 284px;\n    margin: auto;\n}\n\n.text-opaque {\n    color: #979797;\n}\n\n.company-profile .summary-labels {\n    margin-left: 0;\n}\n\n.company-profile .account-name {\n    margin: 0;\n}\n\n.dot {\n    margin-right: 10px;\n}\n\n.no-card--check {\n    border: 0;\n    padding: 0;\n    box-shadow: none;\n    margin-bottom: 25px;\n}\n\n.isTrue {\n    color: #48d38a;\n}\n\n.card-check li>span {\n    width: 20px;\n}\n\n.profile-full--block .amount-input {\n    padding-right: 15px;\n}\n\n.kuda-nav--icon.disabled *,\n.kuda-nav--icon.disabled {\n    pointer-events: none !important;\n    cursor: default;\n}\n\n.transaction-pin .pin-input {\n    max-width: 100%;\n}\n\n.no-margin {\n    margin: 0 !important;\n}\n\n/* Added New Card Styling*/\n\n.card-bg-primary {\n    background: var(--primaryColor);\n}\n\n/* .card {\n    position: relative;\n    width: 120px;\n    height: 189px;\n    perspective: 800px;\n} */\n\n.active-card .flippy {\n    transform: rotateY(-180deg) translate3d(-100px, 0, 0);\n    -webkit-transform: rotateY(-180deg) translate3d(-100px, 0, 0);\n    -moz-transform: rotateY(-180deg) translate3d(-100px, 0, 0);\n    -ms-transform: rotateY(-180deg) translate3d(-100px, 0, 0);\n    -o-transform: rotateY(-180deg) translate3d(-100px, 0, 0);\n}\n\n.active-card .flippy svg.card-face {\n    visibility: hidden;\n    transition-delay: 0.2s;\n}\n\n.active-card .flippy svg.card-back {\n    visibility: visible;\n    transition-delay: 0.2s;\n}\n\n/* .card .flippy {\n    width: 100%;\n    height: 100%;\n    perspective: 1000px;\n    transform-style: preserve-3d;\n    transition: all 1s;\n} */\n\n.card .front,\n.card .back {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.card .front {\n    transform: rotateX(0);\n}\n\n.card .back {\n    transform: rotateX(180deg);\n    transform: rotateY(180deg);\n}\n\n/* .physical-card svg {\n    width: 100%;\n    margin: 0;\n    position: static;\n    transform: none;\n    top: auto;\n} */\n\n/* .active-card .card {\n    transform: translate3d(-60px, 0, 0);\n} */\n\n/* .card {\n    transition: transform 0.8s;\n    transition-delay: 0.5s;\n    z-index: 1;\n} */\n\n.card-animation--wrap {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.card-animation--wrap {\n    height: 189px;\n    position: relative;\n}\n\n.card-secret-details {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.2s, transform 1s;\n    transition-delay: 0.6s;\n    z-index: 0;\n}\n\n.secret-wrap:not(:last-child) {\n    margin-bottom: 16px;\n}\n\n.active-card .card-secret-details {\n    transform: translateX(40%);\n    opacity: 1;\n}\n\n.secret-icon {\n    margin-left: 12px;\n}\n\n.kuda-google--search .dropdown-item--title {\n    line-height: 1.5;\n    font-size: 0.875rem;\n}\n\n.physical-card>svg {\n    height: 189px;\n    width: auto;\n}\n\n.bill-item.disabled {\n    opacity: 0.55;\n}\n\n.secret-icon svg {\n    height: auto;\n}\n\n.kuda-google--search .kuda-dropdown-item {\n    background-color: transparent !important;\n}\n\n.secret-icon svg {\n    width: 17px;\n    height: auto;\n}\n\n.kuda-no--bg {\n    padding: 0 !important;\n    background: none !important;\n    border: 0 !important;\n    box-shadow: none !important;\n    margin-top: 0 !important;\n}\n\n.kuda-single--slide {\n    padding-right: 20%;\n}\n\n.kuda-single--slide {\n    display: flex;\n    flex-direction: column;\n    min-width: 80%;\n}\n\n.kuda__container {\n    display: flex;\n}\n\n.kuda-single--slide:first-child {\n    padding-left: 20%;\n    padding-right: 0;\n}\n\n.kuda-overflow--hidden {\n    overflow-x: hidden;\n}\n\n.kuda__viewport {\n    position: relative;\n}\n\n.carousel-pagination--wrap .kuda__button {\n    position: absolute;\n    top: calc(50% - 50px);\n    transform: translateY(-50%);\n    left: -40px;\n    right: auto;\n    cursor: pointer;\n}\n\n.kuda__button--next {\n    left: auto !important;\n    right: -40px !important;\n}\n\n.kuda-single--slide .request-text {\n    opacity: 0;\n    transition: opacity 0.3s;\n    -webkit-transition: opacity 0.3s;\n    -moz-transition: opacity 0.3s;\n    -ms-transition: opacity 0.3s;\n    -o-transition: opacity 0.3s;\n}\n\n.kuda-single--slide.is-selected .request-text {\n    opacity: 1;\n    transition: opacity 0.6s !important;\n    -webkit-transition: opacity 0.6s !important;\n    -moz-transition: opacity 0.6s !important;\n    -ms-transition: opacity 0.6s !important;\n    -o-transition: opacity 0.6s !important;\n    transition-delay: 100ms !important;\n}\n\n.kuda-single--slide:only-child {\n    padding: 0;\n}\n\n.kuda-full--slide {\n    padding: 0 !important;\n    min-width: 100%;\n    padding-left: 70px !important;\n    padding-right: 70px !important;\n}\n\n.kuda-full--slide.is-selected .request-wrap {\n    justify-content: center;\n}\n\n.select-card--wrap .kuda__button {\n    top: 72px;\n    transform: none;\n    -webkit-transform: none;\n    -moz-transform: none;\n    -ms-transform: none;\n    -o-transform: none;\n    z-index: 9;\n}\n\n.kuda__button svg {\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    display: flex;\n    border-radius: 5px;\n}\n\n.kuda__button[disabled] {\n    opacity: 0.4;\n    pointer-events: none;\n}\n\n.kuda-no-sidePadding {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.kuda-no-sidePadding .kuda__button {\n    left: 30px;\n}\n\n.kuda-no-sidePadding .kuda__button--next {\n    right: 30px !important;\n    left: auto;\n}\n\n.kuda__dots {\n    position: absolute;\n    top: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    cursor: pointer;\n}\n\n.kuda__dot {\n    width: 8px;\n    height: 8px;\n    display: flex;\n    background-color: #dbdce0;\n    border-radius: 100px;\n    transition: all 0.6s;\n    -webkit-transition: all 0.6s;\n    -moz-transition: all 0.6s;\n    -ms-transition: all 0.6s;\n    -o-transition: all 0.6s;\n}\n\n.kuda__dot:not(:last-child) {\n    margin-right: 8px;\n}\n\n.dot-active {\n    background-color: var(--primaryColor);\n}\n\n.kuda-arrow--helper {\n    position: absolute;\n    background-size: contain;\n    background-repeat: no-repeat;\n    color: #fff;\n    height: 38px;\n    width: 240px;\n    font-size: 0.8125rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 110px;\n    left: calc(50% - 7px);\n    transform: translateX(-50%);\n    z-index: 3;\n}\n\n.helper-illustration svg {\n    width: 100%;\n    height: auto;\n    transform: scale(1.4);\n    position: relative;\n    left: 10%;\n    -webkit-transform: scale(1.4);\n    -moz-transform: scale(1.4);\n    -ms-transform: scale(1.4);\n    -o-transform: scale(1.4);\n}\n\n.kuda-arrow--helper span {\n    position: absolute;\n    top: -22px;\n    align-items: center;\n}\n\n/* Helper animations */\n\n.kudaFadeInUpHelper {\n    webkit-animation-name: kudaFadeInUpHelper;\n    -moz-animation-name: kudaFadeInUpHelper;\n    -o-animation-name: kudaFadeInUpHelper;\n    animation-name: kudaFadeInUpHelper;\n}\n\n@-webkit-keyframes kudaFadeInUpHelper {\n    0% {\n        opacity: 0;\n        margin-top: 10px;\n    }\n\n    100% {\n        opacity: 1;\n        margin-top: 0px;\n    }\n}\n\n@-moz-keyframes kudaFadeInUpHelper {\n    0% {\n        opacity: 0;\n        margin-top: 10px;\n    }\n\n    100% {\n        opacity: 1;\n        margin-top: 0px;\n    }\n}\n\n@-o-keyframes kudaFadeInUpHelper {\n    0% {\n        opacity: 0;\n        margin-top: 10px;\n    }\n\n    100% {\n        opacity: 1;\n        margin-top: 0px;\n    }\n}\n\n@keyframes kudaFadeInUpHelper {\n    0% {\n        opacity: 0;\n        margin-top: 10px;\n    }\n\n    100% {\n        opacity: 1;\n        margin-top: 0px;\n    }\n}\n\n.loan-icon svg {\n    height: 34px;\n    width: auto;\n}\n\n.owe-tab {\n    margin-top: 25px;\n    padding-left: 20px;\n    padding-right: 20px;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    height: 63px !important;\n    border: 0;\n}\n\n.kuda-loan--wrap {\n    display: flex;\n    align-items: center;\n}\n\n.loan-icon {\n    margin-right: 20px;\n    display: flex;\n}\n\n.kuda-no--bottom {\n    margin-bottom: 0;\n}\n\n.channels-toggle.disabled {\n    opacity: 0.35;\n}\n\n.channels-toggle {\n    margin-top: 45px;\n}\n\n.channels-toggle .optional-title {\n    top: 0;\n}\n\n.kuda-no-add--details {\n    padding-bottom: 0;\n    padding-top: 38px;\n    display: flex;\n    justify-content: center;\n    border-bottom: 0;\n}\n\n.virtual-extra--details {\n    position: absolute;\n    z-index: 1;\n    bottom: 11px;\n    left: 10px;\n}\n\n.card-xs {\n    font-size: 0.5rem;\n}\n\n.kuda-dark--theme .kuda__button path[fill=\"#979797\"] {\n    fill: #ffffff !important;\n}\n\n.kuda-dark--theme .kuda__button path[stroke=\"#F4F4F4\"] {\n    fill: #212121;\n    stroke: #212121;\n}\n\n.virtual-extra--details .color-primary {\n    color: var(--primaryColor) !important;\n}\n\n.owe-tab .borrow-progress {\n    margin-top: 11px;\n    height: 4px;\n    margin-bottom: 2px;\n}\n\n.no-padding {\n    height: auto !important;\n    border-bottom: 0 !important;\n    margin-bottom: 40px;\n}\n\n.margin-right--spacer {\n    width: 100%;\n    margin-right: 15px;\n}\n\n.excerpt {\n    max-width: 300px;\n    line-height: 1.5;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 15px;\n    margin-bottom: 20px;\n}\n\n.kuda-cta-loanAlt {\n    border: 1px solid var(--lightBlue);\n    background-color: var(--offWhite);\n    color: var(--lightBlue);\n}\n\n.header-left {\n    cursor: pointer;\n}\n\n.percentage-toggle {\n    background: none;\n    outline: 0;\n}\n\n.percentage-toggle.disabled {\n    opacity: 0.5;\n}\n\n.left-seperator {\n    margin-left: 23px;\n}\n\n.call-active.backdrop-init * {\n    pointer-events: none;\n}\n\n.always-active {\n    pointer-events: auto !important;\n    opacity: 1 !important;\n}\n\n.percentage-summary.disabled {\n    opacity: 0.4;\n}\n\n.virtual-extra--details .text-xs {\n    font-size: 0.6rem;\n}\n\n.kuda-single--slide .bill-item-wrap {\n    padding-right: 10px;\n}\n\n.kuda-borrow-card--content {\n    margin-top: 25px;\n}\n\n.overdraft-borrow--wrap .kuda-modal-illustration {\n    margin-top: 35px;\n}\n\n.loan-skeleton {\n    margin-top: 25px !important;\n}\n\n.kuda-reset--card {\n    background: var(--whiteAlt);\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    max-width: 480px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 50px;\n    border-radius: 5px;\n}\n\n.kuda-reset--password {\n    width: 100%;\n}\n\n.kuda-reset--wrap .kuda-card--wrap {\n    max-width: 533px;\n    padding: 56px 77px;\n    margin-top: 0;\n}\n\n.kuda-reset--wrap .kuda-text--top {\n    margin-top: 12px;\n    max-width: 350px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-reset--wrap .kuda-buttons {\n    margin-top: 35px;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 198px !important;\n}\n\n.kuda-dark--theme .kuda-reset--card {\n    border-color: rgba(219, 220, 224, 0.03);\n}\n\n.no-card--check {\n    border: 0;\n    padding: 0;\n    box-shadow: none;\n    margin-bottom: 25px;\n}\n\n.isTrue {\n    color: #48d38a;\n}\n\n.secret-wrap {\n    cursor: copy;\n    /* margin: 0 !important; */\n}\n\n.migrate-modal--img {\n    width: 59px;\n    height: 59px;\n}\n\n.migrate-modal--img svg {\n    width: 100%;\n    height: 100%;\n}\n\n/*** GENERAL ***/\n\n.is-centered {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-has--ellipsis {\n    padding-right: 10px;\n}\n\n.kuda-has--ellipsis>* {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n    -webkit-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n}\n\n.kuda-plus--inner {\n    font-size: 1.875rem;\n    line-height: 1;\n    display: block;\n    padding-bottom: 5px;\n}\n\n.tier-inner--wrap {\n    padding-top: 5px;\n}\n\n.has-flag {\n    border: 0 !important;\n    border-radius: 100px;\n    overflow: hidden;\n    background: rgb(1 33 105 / 0.1);\n    padding: 4px;\n}\n\n.has-flag img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 100px;\n}\n\n.onboarding-info--wrap .utility-upload-wrap {\n    min-height: 48px;\n}\n\n.kuda-ignore--container {\n    width: 100vw;\n    position: relative;\n    margin-left: -50vw;\n    left: 50%;\n}\n\n.kuda-started--container {\n    max-width: 860px;\n}\n\n.kuda-started--container .block-item {\n    max-width: 585px;\n    margin-left: auto;\n    margin-right: auto;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64 25 109 / 7%);\n}\n\n.kuda-started--container .auth-wrap {\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n}\n\n.heading-spacer {\n    margin-bottom: 2.1rem;\n}\n\n.kuda-started--container .onboarding-info--wrap {\n    max-width: 606px;\n    width: 100%;\n}\n\n.boxed-width--lg {\n    max-width: 460px;\n}\n\n.react-datepicker__header__dropdown--select {\n    padding: 20px 18px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.react-datepicker__header__dropdown>* {\n    width: calc(50% - 8px);\n}\n\n.react-datepicker__header__dropdown>* select {\n    width: 100% !important;\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0 2px 2px rgb(0 0 0 / 10%);\n    border-radius: 5px;\n    height: 35px;\n    padding: 8px 10px;\n    outline: 0;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    background-position: calc(100% - 10px) 50%;\n    background-size: 9px;\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yOTI3ODcgMC4zMDUyODhDMC40ODAzMTQgMC4xMTc4MTcgMC43MzQ2MjIgMC4wMTI1MDE4IDAuOTk5Nzg2IDAuMDEyNTAxOEMxLjI2NDk1IDAuMDEyNTAxOCAxLjUxOTI2IDAuMTE3ODE3IDEuNzA2NzkgMC4zMDUyODhMNC45OTk3OSAzLjU5ODI5TDguMjkyNzkgMC4zMDUyODhDOC4zODUwMyAwLjIwOTc3OCA4LjQ5NTM4IDAuMTMzNTk2IDguNjE3MzggMC4wODExODY5QzguNzM5MzkgMC4wMjg3Nzc5IDguODcwNjEgMC4wMDExOTE1NyA5LjAwMzM5IDMuNzc1NzFlLTA1QzkuMTM2MTYgLTAuMDAxMTE2MDYgOS4yNjc4NCAwLjAyNDE4NTQgOS4zOTA3NCAwLjA3NDQ2NjNDOS41MTM2NCAwLjEyNDc0NyA5LjYyNTI5IDAuMTk5IDkuNzE5MTggMC4yOTI4OTNDOS44MTMwNyAwLjM4Njc4NiA5Ljg4NzMzIDAuNDk4NDM4IDkuOTM3NjEgMC42MjEzMzRDOS45ODc4OSAwLjc0NDIzMSAxMC4wMTMyIDAuODc1OTEgMTAuMDEyIDEuMDA4NjlDMTAuMDEwOSAxLjE0MTQ3IDkuOTgzMyAxLjI3MjY5IDkuOTMwODkgMS4zOTQ2OUM5Ljg3ODQ4IDEuNTE2NyA5LjgwMjMgMS42MjcwNCA5LjcwNjc5IDEuNzE5MjlMNS43MDY3OSA1LjcxOTI5QzUuNTE5MjYgNS45MDY3NiA1LjI2NDk1IDYuMDEyMDcgNC45OTk3OSA2LjAxMjA3QzQuNzM0NjIgNi4wMTIwNyA0LjQ4MDMxIDUuOTA2NzYgNC4yOTI3OSA1LjcxOTI5TDAuMjkyNzg3IDEuNzE5MjlDMC4xMDUzMTYgMS41MzE3NiAwIDEuMjc3NDUgMCAxLjAxMjI5QzAgMC43NDcxMjQgMC4xMDUzMTYgMC40OTI4MTYgMC4yOTI3ODcgMC4zMDUyODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K\");\n    padding-right: 30px !important;\n}\n\n.upload-limited--docs {\n    max-width: 620px;\n}\n\n/* .upload-docs--wrap .upload-btn-wrap {\n    min-height: 46px;\n    max-height: 46px;\n} */\n\n.inner-max-label {\n    max-width: 220px !important;\n    margin: 0 auto;\n}\n\n.upload-item .text-smd {\n    font-size: 0.915rem;\n}\n\n.icon-is--absolute {\n    position: absolute;\n    right: -38px;\n    display: flex;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.is-remove--icon {\n    right: 18px;\n}\n\n.is-success--icon {\n        left: 18px;\n}\n\n.hasUpload {\n    /* padding-right: 30px; */\n}\n\n.utility-upload-wrap .hasUpload {\n    padding-right: 0;\n}\n\n.hasUpload>a,\n.hasUpload>p {\n    width: 100%;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n    -webkit-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n    font-size: 0.8125rem;\n}\n\n.hasUpload>p {\n    padding: 0 22px;\n}\n\n.failure-bg {\n    height: 2px;\n    width: 100%;\n    margin-top: 4px;\n}\n\n.react-datepicker__header__dropdown--select {\n    padding: 20px 18px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.react-datepicker__header__dropdown>* {\n    width: calc(50% - 8px);\n}\n\n.react-datepicker__header__dropdown>* select {\n    width: 100% !important;\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0 2px 2px rgb(0 0 0 / 10%);\n    border-radius: 5px;\n    height: 35px;\n    padding: 8px 10px;\n    outline: 0;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    background-position: calc(100% - 10px) 50%;\n    background-size: 9px;\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yOTI3ODcgMC4zMDUyODhDMC40ODAzMTQgMC4xMTc4MTcgMC43MzQ2MjIgMC4wMTI1MDE4IDAuOTk5Nzg2IDAuMDEyNTAxOEMxLjI2NDk1IDAuMDEyNTAxOCAxLjUxOTI2IDAuMTE3ODE3IDEuNzA2NzkgMC4zMDUyODhMNC45OTk3OSAzLjU5ODI5TDguMjkyNzkgMC4zMDUyODhDOC4zODUwMyAwLjIwOTc3OCA4LjQ5NTM4IDAuMTMzNTk2IDguNjE3MzggMC4wODExODY5QzguNzM5MzkgMC4wMjg3Nzc5IDguODcwNjEgMC4wMDExOTE1NyA5LjAwMzM5IDMuNzc1NzFlLTA1QzkuMTM2MTYgLTAuMDAxMTE2MDYgOS4yNjc4NCAwLjAyNDE4NTQgOS4zOTA3NCAwLjA3NDQ2NjNDOS41MTM2NCAwLjEyNDc0NyA5LjYyNTI5IDAuMTk5IDkuNzE5MTggMC4yOTI4OTNDOS44MTMwNyAwLjM4Njc4NiA5Ljg4NzMzIDAuNDk4NDM4IDkuOTM3NjEgMC42MjEzMzRDOS45ODc4OSAwLjc0NDIzMSAxMC4wMTMyIDAuODc1OTEgMTAuMDEyIDEuMDA4NjlDMTAuMDEwOSAxLjE0MTQ3IDkuOTgzMyAxLjI3MjY5IDkuOTMwODkgMS4zOTQ2OUM5Ljg3ODQ4IDEuNTE2NyA5LjgwMjMgMS42MjcwNCA5LjcwNjc5IDEuNzE5MjlMNS43MDY3OSA1LjcxOTI5QzUuNTE5MjYgNS45MDY3NiA1LjI2NDk1IDYuMDEyMDcgNC45OTk3OSA2LjAxMjA3QzQuNzM0NjIgNi4wMTIwNyA0LjQ4MDMxIDUuOTA2NzYgNC4yOTI3OSA1LjcxOTI5TDAuMjkyNzg3IDEuNzE5MjlDMC4xMDUzMTYgMS41MzE3NiAwIDEuMjc3NDUgMCAxLjAxMjI5QzAgMC43NDcxMjQgMC4xMDUzMTYgMC40OTI4MTYgMC4yOTI3ODcgMC4zMDUyODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K\");\n    padding-right: 30px !important;\n}\n\n.kuda-has--flag .kuda-flag {\n    position: absolute;\n    bottom: 16px;\n    pointer-events: none;\n}\n\n.kuda-phone--heading {\n    margin-bottom: 5px;\n}\n\n.react-tel-input .selected-flag {\n    padding-left: 0 !important;\n}\n\n.react-tel-input {\n    font-family: \"Muli\", sans-serif !important;\n    z-index: 10;\n}\n\n.react-tel-input .country-list .search {\n    padding: 7px 15px !important;\n    background: var(--whiteColor) !important;\n    border-bottom: 1px solid var(--bgOffset) !important;\n    border-top-left-radius: 5px !important;\n    border-top-right-radius: 5px !important;\n}\n\n.react-tel-input .country-list .search-box {\n    height: 40px !important;\n    border: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n    outline: none !important;\n    background-color: var(--whiteColor) !important;\n    color: var(--blackColor) !important;\n    text-transform: capitalize !important;\n}\n\n.react-tel-input .country-list {\n    background: var(--whiteColor) !important;\n    border: 1px solid var(--borderOff) !important;\n    box-shadow: 15px 30px 40px var(--boxShadow) !important;\n    border-radius: 5px !important;\n    margin-top: -2px !important;\n    width: 100% !important;\n}\n\n.react-tel-input .flag-dropdown {\n    width: 100% !important;\n}\n\n.kuda-has--flag input {\n    padding-left: 10px !important;\n    /* position: relative !important; */\n    z-index: 9 !important;\n    margin-left: 40px !important;\n    border-bottom: 0 !important;\n}\n\n.react-tel-input {\n    border-bottom: 1px solid var(--offWhiteTrans) !important;\n}\n\n.react-tel-input .country-list .country {\n    border-bottom: 1px solid var(--bgOffset);\n    padding: 15px 0 15px 38px !important;\n    color: var(--blackColor) !important;\n    width: calc(100% - 32px) !important;\n    margin: 0 auto !important;\n    background: none !important;\n}\n\n.react-tel-input .country-list .flag {\n    left: 0 !important;\n}\n\n.react-tel-input .country-list .divider {\n    border: none !important;\n}\n\n.react-datepicker-popper {\n    z-index: 99 !important;\n}\n\n.react-tel-input .country-list {\n    max-height: 250px !important;\n}\n\n.block {\n    display: block;\n}\n\n.kuda-reset--password input {\n    padding-left: 0;\n}\n\n.kuda-report--transaction {\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    padding: 14px 27px;\n}\n\n.color-red {\n    color: var(--negativeColor) !important;\n}\n\n.transaction-icon svg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.transaction-avatar svg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.report-icon {\n    min-width: 130px;\n}\n\n.toggle-icon--button svg {\n    height: 20px;\n    width: 18px;\n    display: flex;\n}\n\n.export-modal .modal-content {\n    max-width: 530px;\n    padding: 42px 50px 54px;\n}\n\n.export-modal .kuda-radio--wrapper label {\n    padding-left: 42px;\n}\n\n.export-modal .kuda-radio--wrapper p {\n    font-size: 0.875rem !important;\n    line-height: 1;\n}\n\n.header-bottom--spacing {\n    margin-bottom: 2.5rem;\n}\n\n.export-modal .kuda-radio--wrapper .outer {\n    left: 13px;\n    width: 20px;\n    height: 20px;\n}\n\n.export-modal .react-datepicker,\n.export-modal .react-datepicker__month-container {\n    min-width: 380px;\n}\n\n.kuda-bulk--table svg {\n    height: 17px;\n    width: auto;\n    display: flex;\n}\n\n.kuda-bulk--table td,\n.kuda-bulk--table th {\n    vertical-align: middle !important;\n}\n\n.kuda-signatory--table td {\n    font-size: 0.9375rem !important;\n    height: 100%;\n}\n\n.kuda-bulk--table tr td:first-child:before {\n    display: none;\n}\n\n.min-id {\n    padding-right: 22px;\n}\n\n.table-spinner .spinner {\n    height: 17px;\n    width: 17px;\n}\n\n.min-loader--item {\n    width: 24px;\n    min-width: 24px;\n}\n\n.scheduled-empty--state .empty-summary {\n    margin: 48px 20px;\n}\n\n.analytics-others--wrap .account-avatar-sm {\n    background-color: var(--successColor);\n    font-size: 0.875rem;\n    color: var(--whiteColor);\n    min-width: 40px;\n    height: 40px;\n}\n\n.no-top--margin {\n    margin-top: 0 !important;\n}\n\n.kuda-cta-md--alt {\n    height: 30px !important;\n    padding: 0 !important;\n    font-size: 0.825rem;\n    max-width: 90px !important;\n    border-radius: 5px;\n    width: 100%;\n}\n\n.schedule-payment--switch .toggle {\n    width: auto;\n}\n\n.kuda-cta-md--alt {\n    height: 30px !important;\n    padding: 0 !important;\n    font-size: 0.825rem;\n    max-width: 90px !important;\n    border-radius: 5px;\n    width: 100%;\n}\n\n.scheduled-icon svg {\n    width: 20px !important;\n}\n\n.kuda-badge {\n    height: 22px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    width: 60px;\n    max-width: 100%;\n    background-color: var(--primaryColor);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    border-radius: 10px;\n}\n\n.badge-is--success {\n    background-color: var(--successColorTrans);\n    color: var(--successColor);\n}\n\n.badge-is--pending {\n    color: #ffc83e;\n    background-color: #fff5db;\n}\n\n.badge-is--failed {\n    color: #979797;\n    background-color: #f9f9f9;\n}\n\n.transaction-price {\n    position: static;\n}\n\n.action-item:not(:last-child) {\n    margin-right: 6px;\n}\n\n.actions-wrap {\n    min-width: 78px;\n    justify-content: flex-end;\n}\n\n.action-item svg {\n    display: flex;\n}\n\n.kuda-multi--radio label {\n    box-shadow: none !important;\n    background-color: none !important;\n    background: none !important;\n    border-top: none !important;\n    border-left: none !important;\n    border-right: none !important;\n    border-color: #dbdce0;\n}\n\n.top-toggle-button {\n    position: absolute;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    top: 25px;\n    right: 30px;\n}\n\n.toggle-top {\n    width: 42px;\n    border-radius: 16px;\n    height: 22px;\n    display: inline-block;\n    vertical-align: middle;\n    position: relative;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-align-self: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.toggle-top:after {\n    height: 15px;\n    width: 15px;\n    top: 4px;\n    left: 4px;\n}\n\n.toggle input[type=\"checkbox\"]:checked+.toggle-top:after {\n    -webkit-transform: translateX(20px);\n    transform: translateX(20px);\n}\n\n.old-account--wrap {\n    /* max-width: 391px; */\n    max-width: 100%;\n    background: #ffffff;\n    /* border: 1px solid rgba(219, 220, 224, 0.5); */\n    border-radius: 5px;\n    padding: 11px 19px;\n    min-height: 51px;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n}\n\n.add-users-outer {\n    width: 14px !important;\n    height: 14px !important;\n    border-radius: 100px;\n    background-color: var(--successColor);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 16px;\n}\n\n.phoneInput {\n    border: 0;\n    /* border-bottom: 1px solid var(--offWhiteTrans); */\n    outline: none;\n    padding-top: 13px;\n    padding-bottom: 13px;\n    padding-left: 13px;\n    font-weight: 600;\n    border-radius: 0;\n    background: none;\n    width: 100%;\n}\n\n.phoneInput .selected-flag {\n    margin-left: 5px;\n}\n\n.users-avatar-nw {\n    background: #DBDCE0;\n    border-radius: 100px;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--primaryAlt);\n    text-align: center;\n    border: 1px solid var(--primaryAlt);\n}\n\n.kuda-search-manage-users {\n    width: 100%;\n    position: relative;\n}\n\n.height-52 {\n    height: 52px !important;\n}\n\n.width-120 {\n    width: 120px !important;\n}\n\n.nobackground-noborder {\n    background: none !important;\n    border: none !important;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.addBtn-signatory--wrap .add-signatory--label {\n    border-radius: 0 !important;\n    padding-left: 20px;\n}\n\n.addBtn-signatory--wrap .add-signatory--label .outer {\n    left: 0\n}\n\n.kuda-multi--radio {\n    padding: 15px 5px 0\n}\n\n.payment-active .kuda-preview {\n    /* max-width: 900px; */\n}\n\n.kuda-payment--request {\n    max-width: 740px !important;\n}\n\n.request-item--wrap {\n    width: 100%;\n}\n\n.kuda-payment--item---wrap>* {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n.has-paymentRequest--list .kuda-card--wrap {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.width-100 {\n    width: 100%\n}\n\n/* .kuda-result--body .request-item--wrap {\n    padding: 15px 0px;\n    border-bottom: 1px solid rgba(219, 220, 224, 0.3);\n} */\n\n.request-items--parent {\n    padding: 20px 0px;\n    border-bottom: 1px solid rgba(219, 220, 224, 0.3);\n}\n\n.request-action {\n    display: block;\n    min-width: 90px;\n    max-width: 90px;\n    width: 90px;\n}\n\n.request-amount {\n    display: block;\n    min-width: 120px;\n    max-width: 120px;\n    width: 120px;\n}\n\n.request-payment {\n    display: block;\n    width: 100%;\n}\n\n.request-item--wrap p:not(.text-sm) {\n    font-size: 0.9rem;\n}\n\n.request-item--wrap {\n    padding: 0 10px;\n}\n\n.right-separator--15 {\n    margin-right: 15px;\n}\n\n.right-separator--20 {\n    margin-right: 20px;\n}\n\n.kuda-success--modal .card-check {\n    margin-bottom: 30px;\n    margin-top: 30px;\n    padding: 15px;\n}\n\n.kuda-success--modal .card-check li {\n    font-size: 0.875rem;\n}\n\n.request-date {\n    display: block;\n    min-width: 120px;\n    max-width: 120px;\n    width: 120px;\n}\n\n.request-action {\n    text-align: center;\n}\n\n.kuda-signatory--table th {\n    font-size: 0.875rem;\n}\n\n.manage-users--add {\n    width: 150px;\n    height: 48px;\n    max-height: 48px;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    border-radius: 10px !important;\n    -webkit-border-radius: 10px !important;\n    -moz-border-radius: 10px !important;\n    -ms-border-radius: 10px !important;\n    -o-border-radius: 10px !important;\n}\n\n.manage-users--add.color-primary {\n    background-color: var(--primaryColor);\n    color: #ffffff;\n}\n\n.restricted-image {\n    padding-top: 24px;\n    background: #F4E6FF;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    margin-bottom: 3rem\n}\n\n.displayResults {\n    position: relative;\n}\n\n.displayResults .spinner-wrap {\n    top: -6px;\n}\n\n.no-prefix:before {\n    display: none;\n}\n\n.kuda-terms--tab {\n    height: 25px;\n    min-height: 35px;\n}\n\n.kuda-terms--tab>li[aria-selected=\"true\"]:after {\n    display: none\n}\n\n.kuda-terms--tab>li {\n    font-size: 0.875rem !important\n}\n\n.kuda-terms--tab {\n    background-color: rgba(118, 118, 128, 0.12);\n    border-radius: 10px !important;\n    align-items: center;\n}\n\n.kuda-terms--tab>li[aria-selected=\"true\"] {\n    height: 29px;\n    background-color: #ffffff;\n    border-radius: 8px;\n}\n\n.modal-terms .modal-content {\n    max-width: 550px\n}\n\n.modal-terms .modal-content {\n    max-height: calc(100vh - 120px);\n    height: 100vh;\n}\n\n.modal-terms .kuda-modal--content {\n    height: 100%;\n}\n\n.no-top--spacing {\n    margin-top: 0px !important;\n}\n\n.no-top--spacing---10 {\n    margin-top: 10px !important;\n}\n\n.kuda-terms--wrap {\n    margin-top: 30px;\n    max-height: calc(100vh - 573px);\n    overflow-y: scroll;\n}\n\n.kuda-section--heading {\n    margin-bottom: 10px;\n}\n\n.kuda-spacing--inner {\n    margin-bottom: 20px;\n}\n\n.kuda-terms--wrap p {\n    font-size: 0.825rem;\n}\n\n.kuda-terms--wrap .kuda-section--heading {\n    font-size: 0.925rem !important;\n}\n\n.kuda-terms--wrap .card-main--heading {\n    font-size: 0.925rem !important;\n}\n\n.kuda-terms--wrap .kuda-spacing--inner:not(:first-child) {\n    margin-top: 20px;\n}\n\n.bottom--spacing {\n    margin-bottom: 20px;\n}\n\n.kuda-single--term {\n    overflow-x: hidden;\n}\n\n.kuda-table table th,\n.kuda-table table td {\n    border-top: 1px solid #dfe2e5;\n    padding: 14px 20px;\n    font-size: 0.825rem;\n    font-weight: 500;\n    vertical-align: initial;\n    text-align: left;\n    color: #000 !important;\n    line-height: 1.4;\n}\n\n.kuda-table {\n    border: 1px solid #dfe2e5;\n    border-radius: 4px;\n}\n\n.kuda-table table {\n    width: 100%;\n}\n\n.kuda-table thead tr {\n    background: #ece8f0;\n}\n\n.kuda-table thead tr th,\n.kuda-table thead tr td {\n    border-top: 0;\n}\n\n.kuda-table thead td,\n.kuda-table thead th {\n    vertical-align: initial;\n    text-align: left;\n    font-weight: 800;\n    color: #000;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.diclaimer-list li {\n    list-style-type: disc;\n    margin-left: 22px;\n}\n\n.diclaimer-list li:not(:last-child) {\n    margin-bottom: 5px;\n}\n\n.pin-input input:last-child {\n    margin-right: 0;\n}\n\n.modal-terms .kuda-radio--wrapper label {\n    font-size: 0.925rem !important;\n}\n\n.business-account--heading {\n    margin-bottom: 25px;\n}\n\n.kuda-login--wrap .card-group:not(:last-child) {\n    margin-bottom: 20px\n}\n\n.kuda-login--wrap .kuda-customer--options:first-child {\n    border-top: 1px solid #dbdce0\n}\n\n/*** DROP DOWN **/\n\n.dropdown-menu {\n    top: 58px !important;\n    opacity: 1;\n    visibility: visible;\n    display: block !important;\n    position: absolute;\n    padding-top: 0px;\n    width: max-content;\n    right: 0px;\n}\n\n[data-toggle=\"dropdown\"]:hover .dropdown-menu {\n    opacity: 1;\n    visibility: visible;\n    top: 38px !important;\n}\n\n.kuda-dropdown--menu {\n    border-radius: 10px;\n    white-space: nowrap;\n    background: #FFFFFF;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    min-width: 350px;\n}\n\n.kuda-nav--menu {\n    position: relative;\n}\n\n.kuda-nav--menu {\n    position: relative;\n}\n\n.kuda-dropdown--menu li .menu-link {\n    border-radius: 5px;\n    padding: 19px 25px;\n    font-weight: 500;\n    color: #000000;\n    font-size: 0.875rem !important;\n    display: inline-flex;\n    align-items: center;\n    font-weight: 600;\n}\n\n.kuda-dropdown--menu li {\n    margin: 0 !important;\n}\n\n.menu-state--active .dropdown-menu {\n    opacity: 0 !important;\n    visibility: hidden !important;\n    top: 44px !important;\n}\n\n[data-toggle=dropdown]>.no-link,\n[data-toggle=dropdown]>a {\n    height: 40px;\n    cursor: pointer;\n}\n\n.dropDown {\n    margin-left: 7px;\n}\n\n.kuda-icon--separator svg {\n    margin-right: 12px;\n    display: block;\n    min-width: 22px;\n}\n\n.kuda-dropdown--menu li:not(:last-child) {\n    border-bottom: 1px solid rgb(219, 220, 224, 50%);\n}\n\n.kuda-dropdown--menu .profile-account {\n    margin-bottom: 0;\n    width: 100%;\n}\n\n.kuda-dropdown--menu .kuda-account--summary {\n    margin-bottom: 0;\n}\n\n.kuda-dropdown--menu .account-image {\n    width: 42px;\n    height: 42px;\n    min-height: 42px;\n    min-width: 42px;\n    margin-top: 0;\n}\n\n.kuda-dropdown--menu .account-image>div {\n    font-size: 1.5rem;\n}\n\n.kuda-dropdown--menu .summary-labels {\n    margin-left: 12px;\n}\n\n.kuda-dropdown--menu .account-name {\n    font-size: 1.1rem\n}\n\n.sign-in--button {\n    width: 125px !important;\n}\n\n.account-switch--list {\n    max-height: calc(100vh - 485px);\n    overflow-y: scroll;\n}\n\n.kuda-switch--icon---wrap svg {\n    height: 30px;\n    width: auto;\n}\n\n.drop-icon {\n    margin-left: 10px;\n}\n\n.upload-in--progess {\n    padding-right: 48px !important;\n}\n\n.disabled-90 {\n    opacity: 0.4 !important;\n    pointer-events: none;\n}\n\n.z-index-1 {\n    z-index: 1;\n}\n\n.kuda-no--padding {\n    padding: 0;\n}\n\n.kuda-sample--wrap {\n    width: 100%;\n}\n\n.kuda-sample--tabs {\n    width: 270px;\n}\n\n.kuda-sample--body {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 640px;\n    width: calc(100% - 270px);\n}\n\n.kuda-sample--body .react-tabs__tab-panel {\n    width: 100%;\n}\n\n.kuda-sample--content---holder {\n    max-width: 800px !important;\n}\n\n.kuda-sample--tabs {\n    background-color: #F9F9F9;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n.kuda-sample--body img {\n    width: 100%;\n    height: 100%;\n    display: block;\n    object-fit: contain;\n    max-height: 550px;\n}\n\n.kuda-label--regular {\n    font-size: 0.935rem;\n}\n\n.reset-pin--wrap .transaction-create--pin {\n    max-width: 320px;\n}\n\n.doc-button--wrap {\n    display: flex;\n    width: 100%;\n    margin-top: auto;\n    padding: 48px 31px 55px;\n    justify-content: center;\n    height: 100%;\n    align-items: flex-end;\n    border-top: 1px solid rgb(0, 0, 0, 0.05)\n}\n\n.card-padding {\n    padding: 0 50px;\n}\n\n.no-border--radius {\n    border-radius: 0 !important;\n}\n\n.payment-skeleton--table>div:not(:last-child) {\n    margin-right: 30px;\n}\n\n.min-wrap {\n    min-width: 45%;\n}\n\n.min-wrap span {\n    border-radius: 100px;\n    display: flex;\n}\n\n.kuda-tab--card {\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    margin-top: 22px;\n    background-color: var(--whiteAlt);\n}\n\n.request-status {\n    width: 90px;\n    min-width: 90px;\n}\n\n.kuda-scheduled--item---wrap .request-date {\n    min-width: 125px;\n    max-width: 125px;\n    width: 125px;\n}\n\n.kuda-scheduled--item---wrap .request-action {\n    display: block;\n    min-width: 54px;\n    max-width: 54px;\n    width: 54px;\n}\n\n.kuda-scheduled--item---wrap .request-amount {\n    min-width: 105px;\n    max-width: 105px;\n    width: 105px;\n}\n\n.document-is--sided {\n    flex-wrap: wrap;\n    margin-right: -20px;\n}\n\n.document-is--sided>div {\n    width: calc(50% - 20px);\n    margin-right: 20px\n}\n\n.document-is--sided .hasUpload {\n    padding-right: 55px;\n}\n\n.document-is--sided .is-success--icon {\n    right: 48px\n}\n\n.document-is--sided .is-remove--icon {\n    right: 15px\n}\n\n.inline-sample--wrap {\n    border: 1px dashed rgb(0, 0, 0, 0.2);\n    min-height: 52px;\n    font-size: 0.925rem;\n    text-align: center;\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border-radius: 5px;\n    position: relative;\n}\n\n.inline-sample--text {\n    max-width: 240px;\n}\n\n.inline-sample--wrap:before {\n    content: \"\";\n    display: block;\n    width: 20px;\n    position: absolute;\n    left: -21px;\n    height: 1px;\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.kuda-auth--wrap .kuda-login--wrap .kuda-customer--option .signup-dropdown {\n    font-size: 0.875rem !important;\n}\n\n.edit-moreOptions--wrap .card-group:not(:last-child) {\n    margin-bottom: 21px\n}\n\n.edit-moreOptions--wrap .kuda-radio--wrapper input:not(:checked)+label {\n    background-color: var(--offWhite) !important;\n    color: var(--blackColor);\n    border-color: var(--offWhite) !important;\n}\n.edit-moreOptions--wrap .payments__single-transfer-modal__check-box input:not(:checked)+label{\n    background-color: transparent !important;\n    border-color: #fff !important;\n}\n\n\n\n.edit-moreOptions--wrap .kuda-radio--wrapper label {\n    border-color: var(--successColor) !important;\n    box-shadow: none;\n    color: var(--blackColor);\n}\n\n.edit-moreOptions--wrap .inner {\n    width: 100%;\n    height: 100%;\n    background-color: transparent !important;\n}\n\n.edit-moreOptions--wrap .inner svg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover\n}\n\n.edit-moreOptions--wrap .kuda-radio--wrapper input:not(:checked)+label .inner {\n    display: none;\n}\n\n.edit-moreOptions--wrap .kuda-select--radio {\n    height: 50px;\n}\n\n.kuda-get--app .kuda-signup--wrap {\n    max-width: 957px !important;\n    margin: 0 auto;\n}\n\n.kuda-reports--radio .radio-height--md {\n    max-width: 50%;\n    width: 50%\n}\n\n.tier-wrap {\n    width: 90px;\n    height: 90px;\n    border-radius: 200px;\n    background: #F4F4F4;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.tier-warning {\n    position: absolute;\n    top: 0;\n    right: 0;\n    border-radius: 200px;\n    box-shadow: 0px 20px 25px rgba(247, 104, 91, 0.3);\n}\n\n.kuda-no--transition {\n    transform: none !important;\n    position: relative;\n}\n\n.text-sm--md {\n    font-size: 0.9rem;\n}\n\n.bottom-spacer--sm---x2 {\n    margin-bottom: 26px;\n}\n\n.payment-confirmation .edit-moreOptions--wrap .kuda-radio--wrapper {\n    width: 100%\n}\n\n.bottom-spacer--xs {\n    margin-bottom: 12px;\n}\n\n.payment-confirmation .kuda-radio--wrapper label {\n    font-size: 0.95rem;\n    padding-left: 55px;\n    height: 50px;\n}\n\n.verifiedName.block {\n    line-height: 1.25;\n}\n\n.analytics-income--expense .analytics-income--item {\n    padding: 12px 0 !important;\n}\n\n.analytics-income--expense .analytics-income--item:last-child {\n    padding-bottom: 0 !important;\n}\n\n.analytics-income--expense .analytics-income--item:first-of-type {\n    padding-top: 0 !important;\n}\n\n.kuda-mask--balance .transaction-price,\n.kuda-mask--balance .request-amount {\n    filter: blur(3.5px);\n    -webkit-filter: blur(3.5px);\n}\n\n.profile-disabled {\n    position: relative;\n    border: 1px solid rgba(247, 104, 91, 0.2);\n    cursor: pointer;\n}\n\n.kuda-badge--disabled {\n    background: var(--negativeColor);\n    color: #ffffff;\n    font-size: 0.625rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    padding: 5px 5px 3.5px;\n    border-radius: 5px;\n    line-height: 1;\n    display: block;\n    position: absolute;\n    top: -8px;\n    right: 20px;\n    cursor: pointer;\n}\n\n.signup-form--wrap,\n.account-setup--right {\n    padding-top: 12px\n}\n.approver--tab>li{\n    width: 100% !important\n}\n\n.width-100-i {\n    width: 100% !important;\n}\n\n@media only screen and (max-width: 571px) {\n\n    .payment-types-flex:before {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .payment-types-flex:after {\n        padding-left: 10px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .payment-types-flex {\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        -webkit-overflow-scrolling: touch;\n        -ms-scroll-snap-type: mandatory;\n        scroll-snap-type: mandatory;\n        -ms-scroll-snap-points-y: repeat(50%);\n        -ms-scroll-snap-type: x mandatory;\n        scroll-snap-type: x mandatory;\n        justify-content: flex-start !important;\n        flex-wrap: nowrap !important;\n        overflow-y: scroll;\n        scroll-padding-left: 20px;\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        padding-left: 0px !important;\n        padding-right: 0px !important;\n        padding-bottom: 10px !important;\n    }\n\n    .payment-types-flex::-webkit-scrollbar {\n        display: none;\n    }\n\n    .payment-types-flex nav {\n        min-width: max-content;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
